/* eslint-disable */

export const AllTypesProps: Record<string,any> = {
	Query:{
		getContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContent:{
			data:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentReference:{
			data:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEvent:{
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEvent:{
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEvent:{
			data:{
				type:"EventCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EventUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFallbackSeo:{
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FallbackSeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFallbackSeo:{
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FallbackSeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFallbackSeo:{
			data:{
				type:"FallbackSeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FallbackSeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooter:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooter:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooter:{
			data:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHeader:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHeader:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHeader:{
			data:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHeaderLink:{
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHeaderLink:{
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHeaderLink:{
			data:{
				type:"HeaderLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HeaderLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFrontPage:{
			by:{
				type:"FrontPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFrontPage:{
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FrontPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFrontPage:{
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FrontPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFrontPage:{
			data:{
				type:"FrontPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFrontPage:{
			by:{
				type:"FrontPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FrontPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSpecialEvent:{
			by:{
				type:"SpecialEventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SpecialEventWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSpecialEvent:{
			filter:{
				type:"SpecialEventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SpecialEventOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSpecialEvent:{
			filter:{
				type:"SpecialEventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SpecialEventOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSpecialEvent:{
			data:{
				type:"SpecialEventCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSpecialEvent:{
			by:{
				type:"SpecialEventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SpecialEventUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTimelinePage:{
			by:{
				type:"TimelinePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TimelinePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTimelinePage:{
			filter:{
				type:"TimelinePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TimelinePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTimelinePage:{
			filter:{
				type:"TimelinePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TimelinePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTimelinePage:{
			data:{
				type:"TimelinePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTimelinePage:{
			by:{
				type:"TimelinePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TimelinePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTimelinePost:{
			by:{
				type:"TimelinePostUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TimelinePostWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTimelinePost:{
			filter:{
				type:"TimelinePostWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TimelinePostOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTimelinePost:{
			filter:{
				type:"TimelinePostWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TimelinePostOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTimelinePost:{
			data:{
				type:"TimelinePostCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTimelinePost:{
			by:{
				type:"TimelinePostUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TimelinePostUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSourcePage:{
			by:{
				type:"SourcePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SourcePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSourcePage:{
			filter:{
				type:"SourcePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SourcePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSourcePage:{
			filter:{
				type:"SourcePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SourcePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSourcePage:{
			data:{
				type:"SourcePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSourcePage:{
			by:{
				type:"SourcePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SourcePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSourcePostLink:{
			by:{
				type:"SourcePostLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SourcePostLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSourcePostLink:{
			filter:{
				type:"SourcePostLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SourcePostLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSourcePostLink:{
			filter:{
				type:"SourcePostLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SourcePostLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSourcePostLink:{
			data:{
				type:"SourcePostLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSourcePostLink:{
			by:{
				type:"SourcePostLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SourcePostLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listGallery:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateGallery:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateGallery:{
			data:{
				type:"GalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"GalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listGalleryItem:{
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateGalleryItem:{
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateGalleryItem:{
			data:{
				type:"GalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"GalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getCardMedia:{
			by:{
				type:"CardMediaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listCardMedia:{
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CardMediaOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateCardMedia:{
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CardMediaOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateCardMedia:{
			data:{
				type:"CardMediaCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateCardMedia:{
			by:{
				type:"CardMediaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"CardMediaUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listRedirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RedirectOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateRedirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RedirectOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateRedirect:{
			data:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getVenue:{
			by:{
				type:"VenueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VenueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listVenue:{
			filter:{
				type:"VenueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"VenueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateVenue:{
			filter:{
				type:"VenueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"VenueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateVenue:{
			data:{
				type:"VenueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateVenue:{
			by:{
				type:"VenueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"VenueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEventLabel:{
			by:{
				type:"EventLabelUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLabelWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEventLabel:{
			filter:{
				type:"EventLabelWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventLabelOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEventLabel:{
			filter:{
				type:"EventLabelWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventLabelOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEventLabel:{
			data:{
				type:"EventLabelCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEventLabel:{
			by:{
				type:"EventLabelUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EventLabelUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPage:{
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePage:{
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePage:{
			data:{
				type:"PageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	Content:{
		blocks:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		blocksByReferences:{
			by:{
				type:"ContentBlocksByReferencesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBlocks:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	UUID: "String",
	ContentBlock:{
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		references:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByLink:{
			by:{
				type:"ContentBlockReferencesByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateReferences:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContentWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"ContentBlockWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContentWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContentWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UUIDCondition:{
		and:{
			type:"UUIDCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"UUIDCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"UUID",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"UUID",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContentBlockWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContentBlockWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContentBlockWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IntCondition:{
		and:{
			type:"IntCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"IntCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Int",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Int",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StringCondition:{
		and:{
			type:"StringCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"StringCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"String",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"String",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contains:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		startsWith:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		endsWith:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		containsCI:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		startsWithCI:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		endsWithCI:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentBlockWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		cardMedia:{
			type:"CardMediaWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContentReferenceWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContentReferenceWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceTypeCondition:{
		and:{
			type:"ContentReferenceTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ContentReferenceTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ContentReferenceTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"ContentReferenceType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"ContentReferenceType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceType: "enum",
	ImageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ImageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ImageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"LinkTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkTypeCondition:{
		and:{
			type:"LinkTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"LinkTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"LinkTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"LinkType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"LinkType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkType: "enum",
	LinkableWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"EventWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPage:{
			type:"FrontPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		specialEvent:{
			type:"SpecialEventWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		timelinePage:{
			type:"TimelinePageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		sourcePage:{
			type:"SourcePageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"RedirectWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"PageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LinkableWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LinkableWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		place:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		entrance:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkForEvent:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		venue:{
			type:"VenueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		pastEvent:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		eventLabels:{
			type:"EventLabelWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"EventWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"EventWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"EventWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SeoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SeoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VenueWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"VenueWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"VenueWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"VenueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BooleanCondition:{
		and:{
			type:"BooleanCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"BooleanCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Boolean",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Boolean",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLabelWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"EventWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"EventLabelWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"EventLabelWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"EventLabelWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingText:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		eventsTitle:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		firstLink:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondLink:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		projectSupport:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		projectAuspices:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"GalleryWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FrontPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FrontPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FrontPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OneCondition:{
		and:{
			type:"OneCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"OneCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"One",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"One",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	One: "enum",
	GalleryWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"GalleryItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"GalleryWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"GalleryWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"GalleryWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"GalleryWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"GalleryItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"GalleryItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"GalleryItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SpecialEventWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageNote:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingText:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SpecialEventWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SpecialEventWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SpecialEventWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"TimelinePageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"TimelinePageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"TimelinePageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SourcePageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"SourcePostLinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SourcePageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SourcePageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SourcePageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SourcePostLinkWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SourcePostLinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SourcePostLinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SourcePostLinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		targetUrl:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"RedirectWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"RedirectWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"RedirectWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"PageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"PageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"PageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CardMediaWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageNote:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"CardMediaWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"CardMediaWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"CardMediaWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReference:{
		block:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		cardMedia:{
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Link:{
		internalLink:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Linkable:{
		event:{
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		frontPage:{
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		specialEvent:{
			filter:{
				type:"SpecialEventWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		timelinePage:{
			filter:{
				type:"TimelinePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		sourcePage:{
			filter:{
				type:"SourcePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		redirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		page:{
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Event:{
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		linkForEvent:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		venue:{
			filter:{
				type:"VenueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		eventLabels:{
			filter:{
				type:"EventLabelWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventLabelOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEventLabels:{
			filter:{
				type:"EventLabelWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventLabelOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Seo:{
		ogImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	EventLabel:{
		event:{
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	EventLabelOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"EventOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OrderDirection: "enum",
	EventOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		place:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		entrance:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkForEvent:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		venue:{
			type:"VenueOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		pastEvent:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"EventOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPage:{
			type:"FrontPageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		specialEvent:{
			type:"SpecialEventOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		timelinePage:{
			type:"TimelinePageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		sourcePage:{
			type:"SourcePageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"RedirectOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"PageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingText:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		eventsTitle:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		firstLink:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondLink:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		projectSupport:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		projectAuspices:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"GalleryOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SpecialEventOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageNote:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingText:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SourcePageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		targetUrl:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VenueOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPage:{
		firstLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		secondLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		gallery:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Gallery:{
		items:{
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	GalleryItem:{
		list:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	GalleryItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"GalleryOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SpecialEvent:{
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	TimelinePage:{
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SourcePage:{
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		links:{
			filter:{
				type:"SourcePostLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SourcePostLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinks:{
			filter:{
				type:"SourcePostLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SourcePostLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SourcePostLink:{
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SourcePostLinkOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Redirect:{
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		target:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Page:{
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	CardMedia:{
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContentReferenceOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentBlockOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		cardMedia:{
			type:"CardMediaOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CardMediaOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageNote:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockReferencesByLinkUniqueWhere:{
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlocksByReferencesUniqueWhere:{
		references:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"ContentCreateBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentCreateBlocksEntityRelationInput:{
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutContentCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentBlockCreateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateReferencesEntityRelationInput:{
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutBlockCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutBlockCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		cardMedia:{
			type:"ContentReferenceCreateCardMediaEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkCreateInternalLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkCreateInternalLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"EventUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPage:{
			type:"FrontPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		specialEvent:{
			type:"SpecialEventUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		timelinePage:{
			type:"TimelinePageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		sourcePage:{
			type:"SourcePageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"RedirectUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"PageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkForEvent:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		eventLabels:{
			type:"EventLabelUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLabelUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		firstLink:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondLink:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"GalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SpecialEventUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SourcePageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableCreateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPage:{
			type:"LinkableCreateFrontPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		specialEvent:{
			type:"LinkableCreateSpecialEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		timelinePage:{
			type:"LinkableCreateTimelinePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		sourcePage:{
			type:"LinkableCreateSourcePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableCreatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateEventEntityRelationInput:{
		connect:{
			type:"EventUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		place:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		entrance:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"EventCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"EventCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"EventCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkForEvent:{
			type:"EventCreateLinkForEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		venue:{
			type:"EventCreateVenueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		pastEvent:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eventLabels:{
			type:"EventCreateEventLabelsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"SeoCreateOgImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoCreateOgImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventCreateLinkForEventEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventCreateVenueEntityRelationInput:{
		connect:{
			type:"VenueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"VenueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VenueUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VenueCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventCreateEventLabelsEntityRelationInput:{
		connect:{
			type:"EventLabelUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventLabelWithoutEventCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLabelWithoutEventCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateFrontPageEntityRelationInput:{
		connect:{
			type:"FrontPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FrontPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		eventsTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		firstLink:{
			type:"FrontPageCreateFirstLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondLink:{
			type:"FrontPageCreateSecondLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"FrontPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		projectSupport:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		projectAuspices:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"FrontPageCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"FrontPageCreateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageCreateFirstLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageCreateSecondLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageCreateGalleryEntityRelationInput:{
		connect:{
			type:"GalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"GalleryCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryCreateItemsEntityRelationInput:{
		connect:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"GalleryItemCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateSpecialEventEntityRelationInput:{
		connect:{
			type:"SpecialEventUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SpecialEventWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SpecialEventWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"SpecialEventCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SpecialEventCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"SpecialEventCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SpecialEventCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SpecialEventCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SpecialEventCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateTimelinePageEntityRelationInput:{
		connect:{
			type:"TimelinePageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TimelinePageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePageWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"TimelinePageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePageCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateSourcePageEntityRelationInput:{
		connect:{
			type:"SourcePageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SourcePageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SourcePageWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"SourcePageCreateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seo:{
			type:"SourcePageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SourcePageCreateLinksEntityRelationInput:{
		connect:{
			type:"SourcePostLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SourcePostLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SourcePostLinkUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SourcePostLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"SourcePostLinkCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SourcePostLinkCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SourcePageCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateRedirectEntityRelationInput:{
		connect:{
			type:"RedirectUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RedirectWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		targetUrl:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"RedirectCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectCreateTargetEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreatePageEntityRelationInput:{
		connect:{
			type:"PageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateCardMediaEntityRelationInput:{
		connect:{
			type:"CardMediaUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"CardMediaCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CardMediaUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CardMediaCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"CardMediaCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CardMediaCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUpdateInput:{
		blocks:{
			type:"ContentUpdateBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUpdateBlocksEntityRelationInput:{
		create:{
			type:"ContentBlockWithoutContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateBlocksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentUpsertBlocksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUpdateBlocksRelationInput:{
		by:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContentBlockWithoutContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutContentUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentBlockUpdateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateReferencesEntityRelationInput:{
		create:{
			type:"ContentReferenceWithoutBlockCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentBlockUpdateReferencesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentBlockUpsertReferencesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateReferencesRelationInput:{
		by:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContentReferenceWithoutBlockUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutBlockUpdateInput:{
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		cardMedia:{
			type:"ContentReferenceUpdateCardMediaEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUpdateInput:{
		type:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkUpdateInternalLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUpdateInternalLinkEntityRelationInput:{
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkUpsertInternalLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableUpdateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPage:{
			type:"LinkableUpdateFrontPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		specialEvent:{
			type:"LinkableUpdateSpecialEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		timelinePage:{
			type:"LinkableUpdateTimelinePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		sourcePage:{
			type:"LinkableUpdateSourcePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableUpdatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateEventEntityRelationInput:{
		create:{
			type:"EventWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EventWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertEventRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EventUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventWithoutLinkUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		place:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		entrance:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"EventUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"EventUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"EventUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkForEvent:{
			type:"EventUpdateLinkForEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		venue:{
			type:"EventUpdateVenueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		pastEvent:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eventLabels:{
			type:"EventUpdateEventLabelsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"SeoUpdateOgImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpdateOgImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SeoUpsertOgImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpsertOgImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUpdateContentEntityRelationInput:{
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUpsertContentRelationInput:{
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUpdateLinkForEventEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventUpsertLinkForEventRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUpsertLinkForEventRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUpdateVenueEntityRelationInput:{
		create:{
			type:"VenueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"VenueUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventUpsertVenueRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"VenueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VenueUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUpsertVenueRelationInput:{
		update:{
			type:"VenueUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"VenueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUpdateEventLabelsEntityRelationInput:{
		create:{
			type:"EventLabelWithoutEventCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EventUpdateEventLabelsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventUpsertEventLabelsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EventLabelUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"EventLabelUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"EventLabelUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUpdateEventLabelsRelationInput:{
		by:{
			type:"EventLabelUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"EventLabelWithoutEventUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLabelWithoutEventUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUpsertEventLabelsRelationInput:{
		by:{
			type:"EventLabelUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EventLabelWithoutEventUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventLabelWithoutEventCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertEventRelationInput:{
		update:{
			type:"EventWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateFrontPageEntityRelationInput:{
		create:{
			type:"FrontPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FrontPageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertFrontPageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FrontPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageWithoutLinkUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		eventsTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		firstLink:{
			type:"FrontPageUpdateFirstLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondLink:{
			type:"FrontPageUpdateSecondLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"FrontPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		projectSupport:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		projectAuspices:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"FrontPageUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"FrontPageUpdateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageUpdateFirstLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FrontPageUpsertFirstLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageUpsertFirstLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageUpdateSecondLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FrontPageUpsertSecondLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageUpsertSecondLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FrontPageUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FrontPageUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageUpdateGalleryEntityRelationInput:{
		create:{
			type:"GalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"GalleryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FrontPageUpsertGalleryRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"GalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryUpdateInput:{
		items:{
			type:"GalleryUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryUpdateItemsEntityRelationInput:{
		create:{
			type:"GalleryItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"GalleryUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"GalleryUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryUpdateItemsRelationInput:{
		by:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"GalleryItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"GalleryItemUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"GalleryItemUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryUpsertItemsRelationInput:{
		by:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"GalleryItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageUpsertGalleryRelationInput:{
		update:{
			type:"GalleryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertFrontPageRelationInput:{
		update:{
			type:"FrontPageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FrontPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateSpecialEventEntityRelationInput:{
		create:{
			type:"SpecialEventWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SpecialEventWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertSpecialEventRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SpecialEventUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SpecialEventWithoutLinkUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"SpecialEventUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SpecialEventUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"SpecialEventUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SpecialEventUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SpecialEventUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SpecialEventUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SpecialEventUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SpecialEventUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SpecialEventUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SpecialEventUpdateContentEntityRelationInput:{
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SpecialEventUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SpecialEventUpsertContentRelationInput:{
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertSpecialEventRelationInput:{
		update:{
			type:"SpecialEventWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SpecialEventWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateTimelinePageEntityRelationInput:{
		create:{
			type:"TimelinePageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TimelinePageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertTimelinePageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TimelinePageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePageWithoutLinkUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"TimelinePageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePageUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TimelinePageUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePageUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertTimelinePageRelationInput:{
		update:{
			type:"TimelinePageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TimelinePageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateSourcePageEntityRelationInput:{
		create:{
			type:"SourcePageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SourcePageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertSourcePageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SourcePageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SourcePageWithoutLinkUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"SourcePageUpdateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seo:{
			type:"SourcePageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SourcePageUpdateLinksEntityRelationInput:{
		create:{
			type:"SourcePostLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SourcePageUpdateLinksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SourcePageUpsertLinksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SourcePostLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"SourcePostLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"SourcePostLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SourcePageUpdateLinksRelationInput:{
		by:{
			type:"SourcePostLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"SourcePostLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SourcePostLinkUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"SourcePostLinkUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SourcePostLinkUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SourcePostLinkUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SourcePostLinkUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SourcePageUpsertLinksRelationInput:{
		by:{
			type:"SourcePostLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SourcePostLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SourcePostLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SourcePageUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SourcePageUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SourcePageUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertSourcePageRelationInput:{
		update:{
			type:"SourcePageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SourcePageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateRedirectEntityRelationInput:{
		create:{
			type:"RedirectWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RedirectWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertRedirectRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"RedirectUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectWithoutLinkUpdateInput:{
		targetUrl:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"RedirectUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpdateTargetEntityRelationInput:{
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"RedirectUpsertTargetRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpsertTargetRelationInput:{
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertRedirectRelationInput:{
		update:{
			type:"RedirectWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RedirectWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdatePageEntityRelationInput:{
		create:{
			type:"PageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertPageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageWithoutLinkUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUpdateContentEntityRelationInput:{
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PageUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUpsertContentRelationInput:{
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PageUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertPageRelationInput:{
		update:{
			type:"PageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUpsertInternalLinkRelationInput:{
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateCardMediaEntityRelationInput:{
		create:{
			type:"CardMediaCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"CardMediaUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertCardMediaRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"CardMediaUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CardMediaUpdateInput:{
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"CardMediaUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CardMediaUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"CardMediaUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CardMediaUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertCardMediaRelationInput:{
		update:{
			type:"CardMediaUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"CardMediaCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpsertReferencesRelationInput:{
		by:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceWithoutBlockUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutBlockCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUpsertBlocksRelationInput:{
		by:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentBlockWithoutContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentBlockCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentBlockCreateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentWithoutBlocksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentWithoutBlocksCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentBlockUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentBlockUpdateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateContentEntityRelationInput:{
		create:{
			type:"ContentWithoutBlocksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentWithoutBlocksUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentBlockUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentWithoutBlocksUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpsertContentRelationInput:{
		update:{
			type:"ContentWithoutBlocksUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentWithoutBlocksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentReferenceCreateBlockEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		cardMedia:{
			type:"ContentReferenceCreateCardMediaEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateBlockEntityRelationInput:{
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutReferencesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutReferencesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentBlockCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateInput:{
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentReferenceUpdateBlockEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		cardMedia:{
			type:"ContentReferenceUpdateCardMediaEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateBlockEntityRelationInput:{
		create:{
			type:"ContentBlockWithoutReferencesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentBlockWithoutReferencesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertBlockRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutReferencesUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentBlockUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertBlockRelationInput:{
		update:{
			type:"ContentBlockWithoutReferencesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutReferencesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		place:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		entrance:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"EventCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"EventCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"EventCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"EventCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkForEvent:{
			type:"EventCreateLinkForEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		venue:{
			type:"EventCreateVenueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		pastEvent:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eventLabels:{
			type:"EventCreateEventLabelsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutEventCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutEventCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPage:{
			type:"LinkableCreateFrontPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		specialEvent:{
			type:"LinkableCreateSpecialEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		timelinePage:{
			type:"LinkableCreateTimelinePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		sourcePage:{
			type:"LinkableCreateSourcePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableCreatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		place:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		entrance:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"EventUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"EventUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"EventUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"EventUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkForEvent:{
			type:"EventUpdateLinkForEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		venue:{
			type:"EventUpdateVenueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		pastEvent:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eventLabels:{
			type:"EventUpdateEventLabelsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutEventCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutEventUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutEventUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPage:{
			type:"LinkableUpdateFrontPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		specialEvent:{
			type:"LinkableUpdateSpecialEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		timelinePage:{
			type:"LinkableUpdateTimelinePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		sourcePage:{
			type:"LinkableUpdateSourcePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableUpdatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutEventUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutEventCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FallbackSeo:{
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	FallbackSeoUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FallbackSeoWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FallbackSeoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FallbackSeoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FallbackSeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FallbackSeoOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FallbackSeoCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"FallbackSeoCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FallbackSeoCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FallbackSeoUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"FallbackSeoUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FallbackSeoUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FallbackSeoUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FallbackSeoUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Footer:{
		gallery:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	FooterUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"GalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		projectSupport:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		projectAuspices:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"GalleryWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FooterWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FooterWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FooterWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		projectSupport:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		projectAuspices:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"GalleryOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		projectSupport:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		projectAuspices:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"FooterCreateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterCreateGalleryEntityRelationInput:{
		connect:{
			type:"GalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		projectSupport:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		projectAuspices:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"FooterUpdateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateGalleryEntityRelationInput:{
		create:{
			type:"GalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"GalleryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterUpsertGalleryRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"GalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpsertGalleryRelationInput:{
		update:{
			type:"GalleryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Header:{
		links:{
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinks:{
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	HeaderLink:{
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	HeaderLinkWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HeaderLinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HeaderLinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HeaderLinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLinkOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"HeaderLinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HeaderWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HeaderWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HeaderWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"HeaderCreateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderCreateLinksEntityRelationInput:{
		connect:{
			type:"HeaderLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HeaderLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLinkUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"HeaderLinkCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLinkCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"HeaderUpdateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpdateLinksEntityRelationInput:{
		create:{
			type:"HeaderLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HeaderUpdateLinksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderUpsertLinksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HeaderLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"HeaderLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"HeaderLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpdateLinksRelationInput:{
		by:{
			type:"HeaderLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"HeaderLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLinkUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"HeaderLinkUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLinkUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderLinkUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLinkUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpsertLinksRelationInput:{
		by:{
			type:"HeaderLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HeaderLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HeaderLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		eventsTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		firstLink:{
			type:"FrontPageCreateFirstLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondLink:{
			type:"FrontPageCreateSecondLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"FrontPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"FrontPageCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		projectSupport:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		projectAuspices:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"FrontPageCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"FrontPageCreateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutFrontPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutFrontPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableCreateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		specialEvent:{
			type:"LinkableCreateSpecialEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		timelinePage:{
			type:"LinkableCreateTimelinePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		sourcePage:{
			type:"LinkableCreateSourcePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableCreatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		eventsTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		firstLink:{
			type:"FrontPageUpdateFirstLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondLink:{
			type:"FrontPageUpdateSecondLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"FrontPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"FrontPageUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		projectSupport:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		projectAuspices:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"FrontPageUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"FrontPageUpdateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutFrontPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutFrontPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FrontPageUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutFrontPageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableUpdateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		specialEvent:{
			type:"LinkableUpdateSpecialEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		timelinePage:{
			type:"LinkableUpdateTimelinePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		sourcePage:{
			type:"LinkableUpdateSourcePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableUpdatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutFrontPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutFrontPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SpecialEventCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"SpecialEventCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"SpecialEventCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SpecialEventCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"SpecialEventCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SpecialEventCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutSpecialEventCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutSpecialEventCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableCreateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPage:{
			type:"LinkableCreateFrontPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		timelinePage:{
			type:"LinkableCreateTimelinePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		sourcePage:{
			type:"LinkableCreateSourcePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableCreatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SpecialEventUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"SpecialEventUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"SpecialEventUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SpecialEventUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"SpecialEventUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SpecialEventUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutSpecialEventCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutSpecialEventUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SpecialEventUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutSpecialEventUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableUpdateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPage:{
			type:"LinkableUpdateFrontPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		timelinePage:{
			type:"LinkableUpdateTimelinePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		sourcePage:{
			type:"LinkableUpdateSourcePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableUpdatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SpecialEventUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutSpecialEventUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutSpecialEventCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"TimelinePageCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"TimelinePageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePageCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutTimelinePageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutTimelinePageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableCreateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPage:{
			type:"LinkableCreateFrontPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		specialEvent:{
			type:"LinkableCreateSpecialEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		sourcePage:{
			type:"LinkableCreateSourcePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableCreatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePageUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"TimelinePageUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"TimelinePageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePageUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutTimelinePageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutTimelinePageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TimelinePageUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutTimelinePageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableUpdateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPage:{
			type:"LinkableUpdateFrontPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		specialEvent:{
			type:"LinkableUpdateSpecialEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		sourcePage:{
			type:"LinkableUpdateSourcePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableUpdatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePageUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutTimelinePageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutTimelinePageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePost:{
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	TimelinePostUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePostWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		additionalInfo:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"TimelinePostWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"TimelinePostWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"TimelinePostWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePostOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		additionalInfo:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePostCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"TimelinePostCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"TimelinePostCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		additionalInfo:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"TimelinePostCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePostCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePostCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePostCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePostUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"TimelinePostUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"TimelinePostUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		additionalInfo:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"TimelinePostUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePostUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TimelinePostUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePostUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePostUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TimelinePostUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePostUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePostUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TimelinePostUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TimelinePostUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SourcePageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"SourcePageCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"SourcePageCreateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seo:{
			type:"SourcePageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SourcePageCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutSourcePageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutSourcePageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableCreateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPage:{
			type:"LinkableCreateFrontPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		specialEvent:{
			type:"LinkableCreateSpecialEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		timelinePage:{
			type:"LinkableCreateTimelinePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableCreatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SourcePageUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"SourcePageUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"SourcePageUpdateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seo:{
			type:"SourcePageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SourcePageUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutSourcePageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutSourcePageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SourcePageUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutSourcePageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableUpdateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPage:{
			type:"LinkableUpdateFrontPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		specialEvent:{
			type:"LinkableUpdateSpecialEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		timelinePage:{
			type:"LinkableUpdateTimelinePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableUpdatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SourcePageUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutSourcePageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutSourcePageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"GalleryItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"GalleryItemCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemCreateListEntityRelationInput:{
		connect:{
			type:"GalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"GalleryItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"GalleryItemUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemUpdateListEntityRelationInput:{
		create:{
			type:"GalleryWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"GalleryWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"GalleryItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"GalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemUpsertListRelationInput:{
		update:{
			type:"GalleryWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		targetUrl:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"RedirectCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"RedirectCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutRedirectCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutRedirectCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableCreateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPage:{
			type:"LinkableCreateFrontPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		specialEvent:{
			type:"LinkableCreateSpecialEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		timelinePage:{
			type:"LinkableCreateTimelinePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		sourcePage:{
			type:"LinkableCreateSourcePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableCreatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpdateInput:{
		targetUrl:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"RedirectUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"RedirectUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutRedirectCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutRedirectUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"RedirectUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutRedirectUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableUpdateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPage:{
			type:"LinkableUpdateFrontPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		specialEvent:{
			type:"LinkableUpdateSpecialEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		timelinePage:{
			type:"LinkableUpdateTimelinePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		sourcePage:{
			type:"LinkableUpdateSourcePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableUpdatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutRedirectUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutRedirectCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLabelCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"EventLabelCreateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLabelCreateEventEntityRelationInput:{
		connect:{
			type:"EventUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventWithoutEventLabelsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventWithoutEventLabelsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		place:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		entrance:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"EventCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"EventCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"EventCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"EventCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkForEvent:{
			type:"EventCreateLinkForEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		venue:{
			type:"EventCreateVenueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		pastEvent:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLabelUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"EventLabelUpdateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLabelUpdateEventEntityRelationInput:{
		create:{
			type:"EventWithoutEventLabelsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EventWithoutEventLabelsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventLabelUpsertEventRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EventUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventWithoutEventLabelsUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		place:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		entrance:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"EventUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"EventUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"EventUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"EventUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkForEvent:{
			type:"EventUpdateLinkForEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		venue:{
			type:"EventUpdateVenueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		pastEvent:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLabelUpsertEventRelationInput:{
		update:{
			type:"EventWithoutEventLabelsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventWithoutEventLabelsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PageCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableCreateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPage:{
			type:"LinkableCreateFrontPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		specialEvent:{
			type:"LinkableCreateSpecialEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		timelinePage:{
			type:"LinkableCreateTimelinePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		sourcePage:{
			type:"LinkableCreateSourcePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PageUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PageUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutPageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableUpdateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPage:{
			type:"LinkableUpdateFrontPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		specialEvent:{
			type:"LinkableUpdateSpecialEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		timelinePage:{
			type:"LinkableUpdateTimelinePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		sourcePage:{
			type:"LinkableUpdateSourcePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	QueryTransaction:{
		getContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContent:{
			data:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentReference:{
			data:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEvent:{
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEvent:{
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEvent:{
			data:{
				type:"EventCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EventUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFallbackSeo:{
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FallbackSeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFallbackSeo:{
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FallbackSeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFallbackSeo:{
			data:{
				type:"FallbackSeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FallbackSeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooter:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooter:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooter:{
			data:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHeader:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHeader:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHeader:{
			data:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHeaderLink:{
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHeaderLink:{
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHeaderLink:{
			data:{
				type:"HeaderLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HeaderLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFrontPage:{
			by:{
				type:"FrontPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFrontPage:{
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FrontPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFrontPage:{
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FrontPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFrontPage:{
			data:{
				type:"FrontPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFrontPage:{
			by:{
				type:"FrontPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FrontPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSpecialEvent:{
			by:{
				type:"SpecialEventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SpecialEventWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSpecialEvent:{
			filter:{
				type:"SpecialEventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SpecialEventOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSpecialEvent:{
			filter:{
				type:"SpecialEventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SpecialEventOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSpecialEvent:{
			data:{
				type:"SpecialEventCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSpecialEvent:{
			by:{
				type:"SpecialEventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SpecialEventUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTimelinePage:{
			by:{
				type:"TimelinePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TimelinePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTimelinePage:{
			filter:{
				type:"TimelinePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TimelinePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTimelinePage:{
			filter:{
				type:"TimelinePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TimelinePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTimelinePage:{
			data:{
				type:"TimelinePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTimelinePage:{
			by:{
				type:"TimelinePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TimelinePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTimelinePost:{
			by:{
				type:"TimelinePostUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TimelinePostWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTimelinePost:{
			filter:{
				type:"TimelinePostWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TimelinePostOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTimelinePost:{
			filter:{
				type:"TimelinePostWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TimelinePostOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTimelinePost:{
			data:{
				type:"TimelinePostCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTimelinePost:{
			by:{
				type:"TimelinePostUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TimelinePostUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSourcePage:{
			by:{
				type:"SourcePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SourcePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSourcePage:{
			filter:{
				type:"SourcePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SourcePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSourcePage:{
			filter:{
				type:"SourcePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SourcePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSourcePage:{
			data:{
				type:"SourcePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSourcePage:{
			by:{
				type:"SourcePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SourcePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSourcePostLink:{
			by:{
				type:"SourcePostLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SourcePostLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSourcePostLink:{
			filter:{
				type:"SourcePostLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SourcePostLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSourcePostLink:{
			filter:{
				type:"SourcePostLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SourcePostLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSourcePostLink:{
			data:{
				type:"SourcePostLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSourcePostLink:{
			by:{
				type:"SourcePostLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SourcePostLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listGallery:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateGallery:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateGallery:{
			data:{
				type:"GalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"GalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listGalleryItem:{
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateGalleryItem:{
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateGalleryItem:{
			data:{
				type:"GalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"GalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getCardMedia:{
			by:{
				type:"CardMediaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listCardMedia:{
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CardMediaOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateCardMedia:{
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CardMediaOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateCardMedia:{
			data:{
				type:"CardMediaCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateCardMedia:{
			by:{
				type:"CardMediaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"CardMediaUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listRedirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RedirectOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateRedirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RedirectOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateRedirect:{
			data:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getVenue:{
			by:{
				type:"VenueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VenueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listVenue:{
			filter:{
				type:"VenueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"VenueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateVenue:{
			filter:{
				type:"VenueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"VenueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateVenue:{
			data:{
				type:"VenueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateVenue:{
			by:{
				type:"VenueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"VenueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEventLabel:{
			by:{
				type:"EventLabelUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLabelWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEventLabel:{
			filter:{
				type:"EventLabelWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventLabelOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEventLabel:{
			filter:{
				type:"EventLabelWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventLabelOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEventLabel:{
			data:{
				type:"EventLabelCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEventLabel:{
			by:{
				type:"EventLabelUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EventLabelUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPage:{
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePage:{
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePage:{
			data:{
				type:"PageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	Mutation:{
		createContent:{
			data:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentReference:{
			data:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEvent:{
			data:{
				type:"EventCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EventUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EventUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EventCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFallbackSeo:{
			data:{
				type:"FallbackSeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FallbackSeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FallbackSeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FallbackSeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooter:{
			data:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHeader:{
			data:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHeaderLink:{
			data:{
				type:"HeaderLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HeaderLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HeaderLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HeaderLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFrontPage:{
			data:{
				type:"FrontPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFrontPage:{
			by:{
				type:"FrontPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFrontPage:{
			by:{
				type:"FrontPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FrontPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFrontPage:{
			by:{
				type:"FrontPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FrontPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FrontPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSpecialEvent:{
			data:{
				type:"SpecialEventCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSpecialEvent:{
			by:{
				type:"SpecialEventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SpecialEventWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSpecialEvent:{
			by:{
				type:"SpecialEventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SpecialEventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SpecialEventUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSpecialEvent:{
			by:{
				type:"SpecialEventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SpecialEventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SpecialEventUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SpecialEventCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTimelinePage:{
			data:{
				type:"TimelinePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTimelinePage:{
			by:{
				type:"TimelinePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TimelinePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTimelinePage:{
			by:{
				type:"TimelinePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TimelinePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TimelinePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTimelinePage:{
			by:{
				type:"TimelinePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TimelinePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TimelinePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TimelinePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTimelinePost:{
			data:{
				type:"TimelinePostCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTimelinePost:{
			by:{
				type:"TimelinePostUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TimelinePostWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTimelinePost:{
			by:{
				type:"TimelinePostUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TimelinePostWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TimelinePostUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTimelinePost:{
			by:{
				type:"TimelinePostUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TimelinePostWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TimelinePostUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TimelinePostCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSourcePage:{
			data:{
				type:"SourcePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSourcePage:{
			by:{
				type:"SourcePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SourcePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSourcePage:{
			by:{
				type:"SourcePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SourcePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SourcePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSourcePage:{
			by:{
				type:"SourcePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SourcePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SourcePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SourcePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSourcePostLink:{
			data:{
				type:"SourcePostLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSourcePostLink:{
			by:{
				type:"SourcePostLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SourcePostLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSourcePostLink:{
			by:{
				type:"SourcePostLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SourcePostLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SourcePostLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSourcePostLink:{
			by:{
				type:"SourcePostLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SourcePostLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SourcePostLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SourcePostLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createGallery:{
			data:{
				type:"GalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"GalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"GalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"GalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createGalleryItem:{
			data:{
				type:"GalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"GalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"GalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"GalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createCardMedia:{
			data:{
				type:"CardMediaCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteCardMedia:{
			by:{
				type:"CardMediaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateCardMedia:{
			by:{
				type:"CardMediaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"CardMediaUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertCardMedia:{
			by:{
				type:"CardMediaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"CardMediaUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"CardMediaCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createRedirect:{
			data:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createVenue:{
			data:{
				type:"VenueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteVenue:{
			by:{
				type:"VenueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VenueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateVenue:{
			by:{
				type:"VenueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VenueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"VenueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertVenue:{
			by:{
				type:"VenueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VenueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"VenueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"VenueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEventLabel:{
			data:{
				type:"EventLabelCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEventLabel:{
			by:{
				type:"EventLabelUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLabelWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEventLabel:{
			by:{
				type:"EventLabelUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLabelWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EventLabelUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEventLabel:{
			by:{
				type:"EventLabelUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLabelWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EventLabelUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EventLabelCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPage:{
			data:{
				type:"PageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		transaction:{
			options:{
				type:"MutationTransactionOptions",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		generateUploadUrl:{
			contentType:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			expiration:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			prefix:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		generateReadUrl:{
			objectKey:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			expiration:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	_MutationErrorType: "enum",
	MutationTransaction:{
		createContent:{
			data:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentReference:{
			data:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEvent:{
			data:{
				type:"EventCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EventUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EventUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EventCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFallbackSeo:{
			data:{
				type:"FallbackSeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FallbackSeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFallbackSeo:{
			by:{
				type:"FallbackSeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FallbackSeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FallbackSeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FallbackSeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooter:{
			data:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHeader:{
			data:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHeaderLink:{
			data:{
				type:"HeaderLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HeaderLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HeaderLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HeaderLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFrontPage:{
			data:{
				type:"FrontPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFrontPage:{
			by:{
				type:"FrontPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFrontPage:{
			by:{
				type:"FrontPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FrontPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFrontPage:{
			by:{
				type:"FrontPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FrontPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FrontPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSpecialEvent:{
			data:{
				type:"SpecialEventCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSpecialEvent:{
			by:{
				type:"SpecialEventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SpecialEventWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSpecialEvent:{
			by:{
				type:"SpecialEventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SpecialEventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SpecialEventUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSpecialEvent:{
			by:{
				type:"SpecialEventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SpecialEventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SpecialEventUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SpecialEventCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTimelinePage:{
			data:{
				type:"TimelinePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTimelinePage:{
			by:{
				type:"TimelinePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TimelinePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTimelinePage:{
			by:{
				type:"TimelinePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TimelinePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TimelinePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTimelinePage:{
			by:{
				type:"TimelinePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TimelinePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TimelinePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TimelinePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTimelinePost:{
			data:{
				type:"TimelinePostCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTimelinePost:{
			by:{
				type:"TimelinePostUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TimelinePostWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTimelinePost:{
			by:{
				type:"TimelinePostUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TimelinePostWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TimelinePostUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTimelinePost:{
			by:{
				type:"TimelinePostUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TimelinePostWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TimelinePostUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TimelinePostCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSourcePage:{
			data:{
				type:"SourcePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSourcePage:{
			by:{
				type:"SourcePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SourcePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSourcePage:{
			by:{
				type:"SourcePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SourcePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SourcePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSourcePage:{
			by:{
				type:"SourcePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SourcePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SourcePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SourcePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSourcePostLink:{
			data:{
				type:"SourcePostLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSourcePostLink:{
			by:{
				type:"SourcePostLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SourcePostLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSourcePostLink:{
			by:{
				type:"SourcePostLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SourcePostLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SourcePostLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSourcePostLink:{
			by:{
				type:"SourcePostLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SourcePostLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SourcePostLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SourcePostLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createGallery:{
			data:{
				type:"GalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"GalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"GalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"GalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createGalleryItem:{
			data:{
				type:"GalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"GalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"GalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"GalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createCardMedia:{
			data:{
				type:"CardMediaCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteCardMedia:{
			by:{
				type:"CardMediaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateCardMedia:{
			by:{
				type:"CardMediaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"CardMediaUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertCardMedia:{
			by:{
				type:"CardMediaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CardMediaWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"CardMediaUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"CardMediaCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createRedirect:{
			data:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createVenue:{
			data:{
				type:"VenueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteVenue:{
			by:{
				type:"VenueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VenueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateVenue:{
			by:{
				type:"VenueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VenueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"VenueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertVenue:{
			by:{
				type:"VenueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VenueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"VenueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"VenueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEventLabel:{
			data:{
				type:"EventLabelCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEventLabel:{
			by:{
				type:"EventLabelUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLabelWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEventLabel:{
			by:{
				type:"EventLabelUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLabelWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EventLabelUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEventLabel:{
			by:{
				type:"EventLabelUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLabelWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EventLabelUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EventLabelCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPage:{
			data:{
				type:"PageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	MutationTransactionOptions:{
		deferForeignKeyConstraints:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Json: "String",
	_OnDeleteBehaviour: "enum",
	_RelationSide: "enum",
	_OrderByDirection: "enum"
}

export const ReturnTypes: Record<string,any> = {
	Query:{
		getContent:"Content",
		listContent:"Content",
		paginateContent:"ContentConnection",
		validateCreateContent:"_ValidationResult",
		validateUpdateContent:"_ValidationResult",
		getContentBlock:"ContentBlock",
		listContentBlock:"ContentBlock",
		paginateContentBlock:"ContentBlockConnection",
		validateCreateContentBlock:"_ValidationResult",
		validateUpdateContentBlock:"_ValidationResult",
		getContentReference:"ContentReference",
		listContentReference:"ContentReference",
		paginateContentReference:"ContentReferenceConnection",
		validateCreateContentReference:"_ValidationResult",
		validateUpdateContentReference:"_ValidationResult",
		getEvent:"Event",
		listEvent:"Event",
		paginateEvent:"EventConnection",
		validateCreateEvent:"_ValidationResult",
		validateUpdateEvent:"_ValidationResult",
		getFallbackSeo:"FallbackSeo",
		listFallbackSeo:"FallbackSeo",
		paginateFallbackSeo:"FallbackSeoConnection",
		validateCreateFallbackSeo:"_ValidationResult",
		validateUpdateFallbackSeo:"_ValidationResult",
		getFooter:"Footer",
		listFooter:"Footer",
		paginateFooter:"FooterConnection",
		validateCreateFooter:"_ValidationResult",
		validateUpdateFooter:"_ValidationResult",
		getHeader:"Header",
		listHeader:"Header",
		paginateHeader:"HeaderConnection",
		validateCreateHeader:"_ValidationResult",
		validateUpdateHeader:"_ValidationResult",
		getHeaderLink:"HeaderLink",
		listHeaderLink:"HeaderLink",
		paginateHeaderLink:"HeaderLinkConnection",
		validateCreateHeaderLink:"_ValidationResult",
		validateUpdateHeaderLink:"_ValidationResult",
		getFrontPage:"FrontPage",
		listFrontPage:"FrontPage",
		paginateFrontPage:"FrontPageConnection",
		validateCreateFrontPage:"_ValidationResult",
		validateUpdateFrontPage:"_ValidationResult",
		getImage:"Image",
		listImage:"Image",
		paginateImage:"ImageConnection",
		validateCreateImage:"_ValidationResult",
		validateUpdateImage:"_ValidationResult",
		getLink:"Link",
		listLink:"Link",
		paginateLink:"LinkConnection",
		validateCreateLink:"_ValidationResult",
		validateUpdateLink:"_ValidationResult",
		getLinkable:"Linkable",
		listLinkable:"Linkable",
		paginateLinkable:"LinkableConnection",
		validateCreateLinkable:"_ValidationResult",
		validateUpdateLinkable:"_ValidationResult",
		getSeo:"Seo",
		listSeo:"Seo",
		paginateSeo:"SeoConnection",
		validateCreateSeo:"_ValidationResult",
		validateUpdateSeo:"_ValidationResult",
		getSpecialEvent:"SpecialEvent",
		listSpecialEvent:"SpecialEvent",
		paginateSpecialEvent:"SpecialEventConnection",
		validateCreateSpecialEvent:"_ValidationResult",
		validateUpdateSpecialEvent:"_ValidationResult",
		getTimelinePage:"TimelinePage",
		listTimelinePage:"TimelinePage",
		paginateTimelinePage:"TimelinePageConnection",
		validateCreateTimelinePage:"_ValidationResult",
		validateUpdateTimelinePage:"_ValidationResult",
		getTimelinePost:"TimelinePost",
		listTimelinePost:"TimelinePost",
		paginateTimelinePost:"TimelinePostConnection",
		validateCreateTimelinePost:"_ValidationResult",
		validateUpdateTimelinePost:"_ValidationResult",
		getSourcePage:"SourcePage",
		listSourcePage:"SourcePage",
		paginateSourcePage:"SourcePageConnection",
		validateCreateSourcePage:"_ValidationResult",
		validateUpdateSourcePage:"_ValidationResult",
		getSourcePostLink:"SourcePostLink",
		listSourcePostLink:"SourcePostLink",
		paginateSourcePostLink:"SourcePostLinkConnection",
		validateCreateSourcePostLink:"_ValidationResult",
		validateUpdateSourcePostLink:"_ValidationResult",
		getGallery:"Gallery",
		listGallery:"Gallery",
		paginateGallery:"GalleryConnection",
		validateCreateGallery:"_ValidationResult",
		validateUpdateGallery:"_ValidationResult",
		getGalleryItem:"GalleryItem",
		listGalleryItem:"GalleryItem",
		paginateGalleryItem:"GalleryItemConnection",
		validateCreateGalleryItem:"_ValidationResult",
		validateUpdateGalleryItem:"_ValidationResult",
		getCardMedia:"CardMedia",
		listCardMedia:"CardMedia",
		paginateCardMedia:"CardMediaConnection",
		validateCreateCardMedia:"_ValidationResult",
		validateUpdateCardMedia:"_ValidationResult",
		getRedirect:"Redirect",
		listRedirect:"Redirect",
		paginateRedirect:"RedirectConnection",
		validateCreateRedirect:"_ValidationResult",
		validateUpdateRedirect:"_ValidationResult",
		getVenue:"Venue",
		listVenue:"Venue",
		paginateVenue:"VenueConnection",
		validateCreateVenue:"_ValidationResult",
		validateUpdateVenue:"_ValidationResult",
		getEventLabel:"EventLabel",
		listEventLabel:"EventLabel",
		paginateEventLabel:"EventLabelConnection",
		validateCreateEventLabel:"_ValidationResult",
		validateUpdateEventLabel:"_ValidationResult",
		getPage:"Page",
		listPage:"Page",
		paginatePage:"PageConnection",
		validateCreatePage:"_ValidationResult",
		validateUpdatePage:"_ValidationResult",
		transaction:"QueryTransaction",
		_info:"Info",
		schema:"_Schema",
		s3DummyQuery:"String"
	},
	Content:{
		_meta:"ContentMeta",
		id:"UUID",
		blocks:"ContentBlock",
		blocksByReferences:"ContentBlock",
		paginateBlocks:"ContentBlockConnection"
	},
	ContentMeta:{
		id:"FieldMeta",
		blocks:"FieldMeta"
	},
	FieldMeta:{
		readable:"Boolean",
		updatable:"Boolean"
	},
	ContentBlock:{
		_meta:"ContentBlockMeta",
		id:"UUID",
		order:"Int",
		json:"String",
		content:"Content",
		references:"ContentReference",
		referencesByLink:"ContentReference",
		paginateReferences:"ContentReferenceConnection"
	},
	ContentBlockMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		json:"FieldMeta",
		content:"FieldMeta",
		references:"FieldMeta"
	},
	ContentReference:{
		_meta:"ContentReferenceMeta",
		id:"UUID",
		type:"ContentReferenceType",
		text:"String",
		block:"ContentBlock",
		image:"Image",
		link:"Link",
		cardMedia:"CardMedia"
	},
	ContentReferenceMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		text:"FieldMeta",
		block:"FieldMeta",
		image:"FieldMeta",
		link:"FieldMeta",
		cardMedia:"FieldMeta"
	},
	Image:{
		_meta:"ImageMeta",
		id:"UUID",
		url:"String",
		width:"Int",
		height:"Int",
		size:"Int",
		type:"String",
		alt:"String"
	},
	ImageMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		width:"FieldMeta",
		height:"FieldMeta",
		size:"FieldMeta",
		type:"FieldMeta",
		alt:"FieldMeta"
	},
	Link:{
		_meta:"LinkMeta",
		id:"UUID",
		type:"LinkType",
		title:"String",
		externalLink:"String",
		internalLink:"Linkable"
	},
	LinkMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		title:"FieldMeta",
		externalLink:"FieldMeta",
		internalLink:"FieldMeta"
	},
	Linkable:{
		_meta:"LinkableMeta",
		id:"UUID",
		url:"String",
		event:"Event",
		frontPage:"FrontPage",
		specialEvent:"SpecialEvent",
		timelinePage:"TimelinePage",
		sourcePage:"SourcePage",
		redirect:"Redirect",
		page:"Page"
	},
	LinkableMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		event:"FieldMeta",
		frontPage:"FieldMeta",
		specialEvent:"FieldMeta",
		timelinePage:"FieldMeta",
		sourcePage:"FieldMeta",
		redirect:"FieldMeta",
		page:"FieldMeta"
	},
	Event:{
		_meta:"EventMeta",
		id:"UUID",
		title:"String",
		place:"String",
		entrance:"String",
		image:"Image",
		seo:"Seo",
		link:"Linkable",
		content:"Content",
		date:"String",
		order:"Int",
		linkForEvent:"Link",
		venue:"Venue",
		pastEvent:"Boolean",
		eventLabels:"EventLabel",
		paginateEventLabels:"EventLabelConnection"
	},
	EventMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		place:"FieldMeta",
		entrance:"FieldMeta",
		image:"FieldMeta",
		seo:"FieldMeta",
		link:"FieldMeta",
		content:"FieldMeta",
		date:"FieldMeta",
		order:"FieldMeta",
		linkForEvent:"FieldMeta",
		venue:"FieldMeta",
		pastEvent:"FieldMeta",
		eventLabels:"FieldMeta"
	},
	Seo:{
		_meta:"SeoMeta",
		id:"UUID",
		title:"String",
		description:"String",
		ogTitle:"String",
		ogDescription:"String",
		ogImage:"Image"
	},
	SeoMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		description:"FieldMeta",
		ogTitle:"FieldMeta",
		ogDescription:"FieldMeta",
		ogImage:"FieldMeta"
	},
	Venue:{
		_meta:"VenueMeta",
		id:"UUID",
		name:"String",
		order:"Int"
	},
	VenueMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		order:"FieldMeta"
	},
	EventLabel:{
		_meta:"EventLabelMeta",
		id:"UUID",
		order:"Int",
		text:"String",
		event:"Event"
	},
	EventLabelMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		text:"FieldMeta",
		event:"FieldMeta"
	},
	EventLabelConnection:{
		pageInfo:"PageInfo",
		edges:"EventLabelEdge"
	},
	PageInfo:{
		totalCount:"Int"
	},
	EventLabelEdge:{
		node:"EventLabel"
	},
	FrontPage:{
		_meta:"FrontPageMeta",
		id:"UUID",
		unique:"One",
		title:"String",
		openingText:"String",
		eventsTitle:"String",
		firstLink:"Link",
		secondLink:"Link",
		seo:"Seo",
		link:"Linkable",
		subtitle:"String",
		projectSupport:"String",
		projectAuspices:"String",
		image:"Image",
		gallery:"Gallery"
	},
	FrontPageMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		title:"FieldMeta",
		openingText:"FieldMeta",
		eventsTitle:"FieldMeta",
		firstLink:"FieldMeta",
		secondLink:"FieldMeta",
		seo:"FieldMeta",
		link:"FieldMeta",
		subtitle:"FieldMeta",
		projectSupport:"FieldMeta",
		projectAuspices:"FieldMeta",
		image:"FieldMeta",
		gallery:"FieldMeta"
	},
	Gallery:{
		_meta:"GalleryMeta",
		id:"UUID",
		items:"GalleryItem",
		paginateItems:"GalleryItemConnection"
	},
	GalleryMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	GalleryItem:{
		_meta:"GalleryItemMeta",
		id:"UUID",
		order:"Int",
		list:"Gallery",
		image:"Image"
	},
	GalleryItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		image:"FieldMeta"
	},
	GalleryItemConnection:{
		pageInfo:"PageInfo",
		edges:"GalleryItemEdge"
	},
	GalleryItemEdge:{
		node:"GalleryItem"
	},
	SpecialEvent:{
		_meta:"SpecialEventMeta",
		id:"UUID",
		title:"String",
		link:"Linkable",
		image:"Image",
		seo:"Seo",
		imageNote:"String",
		openingText:"String",
		subtitle:"String",
		unique:"One",
		content:"Content"
	},
	SpecialEventMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		link:"FieldMeta",
		image:"FieldMeta",
		seo:"FieldMeta",
		imageNote:"FieldMeta",
		openingText:"FieldMeta",
		subtitle:"FieldMeta",
		unique:"FieldMeta",
		content:"FieldMeta"
	},
	TimelinePage:{
		_meta:"TimelinePageMeta",
		id:"UUID",
		title:"String",
		link:"Linkable",
		seo:"Seo",
		unique:"One"
	},
	TimelinePageMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		link:"FieldMeta",
		seo:"FieldMeta",
		unique:"FieldMeta"
	},
	SourcePage:{
		_meta:"SourcePageMeta",
		id:"UUID",
		unique:"One",
		title:"String",
		link:"Linkable",
		links:"SourcePostLink",
		seo:"Seo",
		paginateLinks:"SourcePostLinkConnection"
	},
	SourcePageMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		title:"FieldMeta",
		link:"FieldMeta",
		links:"FieldMeta",
		seo:"FieldMeta"
	},
	SourcePostLink:{
		_meta:"SourcePostLinkMeta",
		id:"UUID",
		title:"String",
		order:"Int",
		link:"Link"
	},
	SourcePostLinkMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		order:"FieldMeta",
		link:"FieldMeta"
	},
	SourcePostLinkConnection:{
		pageInfo:"PageInfo",
		edges:"SourcePostLinkEdge"
	},
	SourcePostLinkEdge:{
		node:"SourcePostLink"
	},
	Redirect:{
		_meta:"RedirectMeta",
		id:"UUID",
		targetUrl:"String",
		link:"Linkable",
		target:"Linkable"
	},
	RedirectMeta:{
		id:"FieldMeta",
		targetUrl:"FieldMeta",
		link:"FieldMeta",
		target:"FieldMeta"
	},
	Page:{
		_meta:"PageMeta",
		id:"UUID",
		order:"Int",
		title:"String",
		link:"Linkable",
		content:"Content",
		seo:"Seo"
	},
	PageMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		title:"FieldMeta",
		link:"FieldMeta",
		content:"FieldMeta",
		seo:"FieldMeta"
	},
	CardMedia:{
		_meta:"CardMediaMeta",
		id:"UUID",
		text:"String",
		imageNote:"String",
		image:"Image"
	},
	CardMediaMeta:{
		id:"FieldMeta",
		text:"FieldMeta",
		imageNote:"FieldMeta",
		image:"FieldMeta"
	},
	ContentReferenceConnection:{
		pageInfo:"PageInfo",
		edges:"ContentReferenceEdge"
	},
	ContentReferenceEdge:{
		node:"ContentReference"
	},
	ContentBlockConnection:{
		pageInfo:"PageInfo",
		edges:"ContentBlockEdge"
	},
	ContentBlockEdge:{
		node:"ContentBlock"
	},
	ContentConnection:{
		pageInfo:"PageInfo",
		edges:"ContentEdge"
	},
	ContentEdge:{
		node:"Content"
	},
	_ValidationResult:{
		valid:"Boolean",
		errors:"_ValidationError"
	},
	_ValidationError:{
		path:"_PathFragment",
		message:"_ValidationMessage"
	},
	_PathFragment:{
		"...on _FieldPathFragment":"_FieldPathFragment",
		"...on _IndexPathFragment":"_IndexPathFragment"
	},
	_FieldPathFragment:{
		field:"String"
	},
	_IndexPathFragment:{
		index:"Int",
		alias:"String"
	},
	_ValidationMessage:{
		text:"String"
	},
	EventConnection:{
		pageInfo:"PageInfo",
		edges:"EventEdge"
	},
	EventEdge:{
		node:"Event"
	},
	FallbackSeo:{
		_meta:"FallbackSeoMeta",
		id:"UUID",
		unique:"One",
		seo:"Seo"
	},
	FallbackSeoMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		seo:"FieldMeta"
	},
	FallbackSeoConnection:{
		pageInfo:"PageInfo",
		edges:"FallbackSeoEdge"
	},
	FallbackSeoEdge:{
		node:"FallbackSeo"
	},
	Footer:{
		_meta:"FooterMeta",
		id:"UUID",
		unique:"One",
		projectSupport:"String",
		projectAuspices:"String",
		gallery:"Gallery"
	},
	FooterMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		projectSupport:"FieldMeta",
		projectAuspices:"FieldMeta",
		gallery:"FieldMeta"
	},
	FooterConnection:{
		pageInfo:"PageInfo",
		edges:"FooterEdge"
	},
	FooterEdge:{
		node:"Footer"
	},
	Header:{
		_meta:"HeaderMeta",
		id:"UUID",
		unique:"One",
		links:"HeaderLink",
		paginateLinks:"HeaderLinkConnection"
	},
	HeaderMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		links:"FieldMeta"
	},
	HeaderLink:{
		_meta:"HeaderLinkMeta",
		id:"UUID",
		order:"Int",
		link:"Link"
	},
	HeaderLinkMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		link:"FieldMeta"
	},
	HeaderLinkConnection:{
		pageInfo:"PageInfo",
		edges:"HeaderLinkEdge"
	},
	HeaderLinkEdge:{
		node:"HeaderLink"
	},
	HeaderConnection:{
		pageInfo:"PageInfo",
		edges:"HeaderEdge"
	},
	HeaderEdge:{
		node:"Header"
	},
	FrontPageConnection:{
		pageInfo:"PageInfo",
		edges:"FrontPageEdge"
	},
	FrontPageEdge:{
		node:"FrontPage"
	},
	ImageConnection:{
		pageInfo:"PageInfo",
		edges:"ImageEdge"
	},
	ImageEdge:{
		node:"Image"
	},
	LinkConnection:{
		pageInfo:"PageInfo",
		edges:"LinkEdge"
	},
	LinkEdge:{
		node:"Link"
	},
	LinkableConnection:{
		pageInfo:"PageInfo",
		edges:"LinkableEdge"
	},
	LinkableEdge:{
		node:"Linkable"
	},
	SeoConnection:{
		pageInfo:"PageInfo",
		edges:"SeoEdge"
	},
	SeoEdge:{
		node:"Seo"
	},
	SpecialEventConnection:{
		pageInfo:"PageInfo",
		edges:"SpecialEventEdge"
	},
	SpecialEventEdge:{
		node:"SpecialEvent"
	},
	TimelinePageConnection:{
		pageInfo:"PageInfo",
		edges:"TimelinePageEdge"
	},
	TimelinePageEdge:{
		node:"TimelinePage"
	},
	TimelinePost:{
		_meta:"TimelinePostMeta",
		id:"UUID",
		title:"String",
		text:"String",
		image:"Image",
		seo:"Seo",
		date:"String",
		additionalInfo:"String",
		link:"Link",
		order:"Int"
	},
	TimelinePostMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		text:"FieldMeta",
		image:"FieldMeta",
		seo:"FieldMeta",
		date:"FieldMeta",
		additionalInfo:"FieldMeta",
		link:"FieldMeta",
		order:"FieldMeta"
	},
	TimelinePostConnection:{
		pageInfo:"PageInfo",
		edges:"TimelinePostEdge"
	},
	TimelinePostEdge:{
		node:"TimelinePost"
	},
	SourcePageConnection:{
		pageInfo:"PageInfo",
		edges:"SourcePageEdge"
	},
	SourcePageEdge:{
		node:"SourcePage"
	},
	GalleryConnection:{
		pageInfo:"PageInfo",
		edges:"GalleryEdge"
	},
	GalleryEdge:{
		node:"Gallery"
	},
	CardMediaConnection:{
		pageInfo:"PageInfo",
		edges:"CardMediaEdge"
	},
	CardMediaEdge:{
		node:"CardMedia"
	},
	RedirectConnection:{
		pageInfo:"PageInfo",
		edges:"RedirectEdge"
	},
	RedirectEdge:{
		node:"Redirect"
	},
	VenueConnection:{
		pageInfo:"PageInfo",
		edges:"VenueEdge"
	},
	VenueEdge:{
		node:"Venue"
	},
	PageConnection:{
		pageInfo:"PageInfo",
		edges:"PageEdge"
	},
	PageEdge:{
		node:"Page"
	},
	QueryTransaction:{
		getContent:"Content",
		listContent:"Content",
		paginateContent:"ContentConnection",
		validateCreateContent:"_ValidationResult",
		validateUpdateContent:"_ValidationResult",
		getContentBlock:"ContentBlock",
		listContentBlock:"ContentBlock",
		paginateContentBlock:"ContentBlockConnection",
		validateCreateContentBlock:"_ValidationResult",
		validateUpdateContentBlock:"_ValidationResult",
		getContentReference:"ContentReference",
		listContentReference:"ContentReference",
		paginateContentReference:"ContentReferenceConnection",
		validateCreateContentReference:"_ValidationResult",
		validateUpdateContentReference:"_ValidationResult",
		getEvent:"Event",
		listEvent:"Event",
		paginateEvent:"EventConnection",
		validateCreateEvent:"_ValidationResult",
		validateUpdateEvent:"_ValidationResult",
		getFallbackSeo:"FallbackSeo",
		listFallbackSeo:"FallbackSeo",
		paginateFallbackSeo:"FallbackSeoConnection",
		validateCreateFallbackSeo:"_ValidationResult",
		validateUpdateFallbackSeo:"_ValidationResult",
		getFooter:"Footer",
		listFooter:"Footer",
		paginateFooter:"FooterConnection",
		validateCreateFooter:"_ValidationResult",
		validateUpdateFooter:"_ValidationResult",
		getHeader:"Header",
		listHeader:"Header",
		paginateHeader:"HeaderConnection",
		validateCreateHeader:"_ValidationResult",
		validateUpdateHeader:"_ValidationResult",
		getHeaderLink:"HeaderLink",
		listHeaderLink:"HeaderLink",
		paginateHeaderLink:"HeaderLinkConnection",
		validateCreateHeaderLink:"_ValidationResult",
		validateUpdateHeaderLink:"_ValidationResult",
		getFrontPage:"FrontPage",
		listFrontPage:"FrontPage",
		paginateFrontPage:"FrontPageConnection",
		validateCreateFrontPage:"_ValidationResult",
		validateUpdateFrontPage:"_ValidationResult",
		getImage:"Image",
		listImage:"Image",
		paginateImage:"ImageConnection",
		validateCreateImage:"_ValidationResult",
		validateUpdateImage:"_ValidationResult",
		getLink:"Link",
		listLink:"Link",
		paginateLink:"LinkConnection",
		validateCreateLink:"_ValidationResult",
		validateUpdateLink:"_ValidationResult",
		getLinkable:"Linkable",
		listLinkable:"Linkable",
		paginateLinkable:"LinkableConnection",
		validateCreateLinkable:"_ValidationResult",
		validateUpdateLinkable:"_ValidationResult",
		getSeo:"Seo",
		listSeo:"Seo",
		paginateSeo:"SeoConnection",
		validateCreateSeo:"_ValidationResult",
		validateUpdateSeo:"_ValidationResult",
		getSpecialEvent:"SpecialEvent",
		listSpecialEvent:"SpecialEvent",
		paginateSpecialEvent:"SpecialEventConnection",
		validateCreateSpecialEvent:"_ValidationResult",
		validateUpdateSpecialEvent:"_ValidationResult",
		getTimelinePage:"TimelinePage",
		listTimelinePage:"TimelinePage",
		paginateTimelinePage:"TimelinePageConnection",
		validateCreateTimelinePage:"_ValidationResult",
		validateUpdateTimelinePage:"_ValidationResult",
		getTimelinePost:"TimelinePost",
		listTimelinePost:"TimelinePost",
		paginateTimelinePost:"TimelinePostConnection",
		validateCreateTimelinePost:"_ValidationResult",
		validateUpdateTimelinePost:"_ValidationResult",
		getSourcePage:"SourcePage",
		listSourcePage:"SourcePage",
		paginateSourcePage:"SourcePageConnection",
		validateCreateSourcePage:"_ValidationResult",
		validateUpdateSourcePage:"_ValidationResult",
		getSourcePostLink:"SourcePostLink",
		listSourcePostLink:"SourcePostLink",
		paginateSourcePostLink:"SourcePostLinkConnection",
		validateCreateSourcePostLink:"_ValidationResult",
		validateUpdateSourcePostLink:"_ValidationResult",
		getGallery:"Gallery",
		listGallery:"Gallery",
		paginateGallery:"GalleryConnection",
		validateCreateGallery:"_ValidationResult",
		validateUpdateGallery:"_ValidationResult",
		getGalleryItem:"GalleryItem",
		listGalleryItem:"GalleryItem",
		paginateGalleryItem:"GalleryItemConnection",
		validateCreateGalleryItem:"_ValidationResult",
		validateUpdateGalleryItem:"_ValidationResult",
		getCardMedia:"CardMedia",
		listCardMedia:"CardMedia",
		paginateCardMedia:"CardMediaConnection",
		validateCreateCardMedia:"_ValidationResult",
		validateUpdateCardMedia:"_ValidationResult",
		getRedirect:"Redirect",
		listRedirect:"Redirect",
		paginateRedirect:"RedirectConnection",
		validateCreateRedirect:"_ValidationResult",
		validateUpdateRedirect:"_ValidationResult",
		getVenue:"Venue",
		listVenue:"Venue",
		paginateVenue:"VenueConnection",
		validateCreateVenue:"_ValidationResult",
		validateUpdateVenue:"_ValidationResult",
		getEventLabel:"EventLabel",
		listEventLabel:"EventLabel",
		paginateEventLabel:"EventLabelConnection",
		validateCreateEventLabel:"_ValidationResult",
		validateUpdateEventLabel:"_ValidationResult",
		getPage:"Page",
		listPage:"Page",
		paginatePage:"PageConnection",
		validateCreatePage:"_ValidationResult",
		validateUpdatePage:"_ValidationResult"
	},
	Info:{
		description:"String"
	},
	Mutation:{
		createContent:"ContentCreateResult",
		deleteContent:"ContentDeleteResult",
		updateContent:"ContentUpdateResult",
		upsertContent:"ContentUpsertResult",
		createContentBlock:"ContentBlockCreateResult",
		deleteContentBlock:"ContentBlockDeleteResult",
		updateContentBlock:"ContentBlockUpdateResult",
		upsertContentBlock:"ContentBlockUpsertResult",
		createContentReference:"ContentReferenceCreateResult",
		deleteContentReference:"ContentReferenceDeleteResult",
		updateContentReference:"ContentReferenceUpdateResult",
		upsertContentReference:"ContentReferenceUpsertResult",
		createEvent:"EventCreateResult",
		deleteEvent:"EventDeleteResult",
		updateEvent:"EventUpdateResult",
		upsertEvent:"EventUpsertResult",
		createFallbackSeo:"FallbackSeoCreateResult",
		deleteFallbackSeo:"FallbackSeoDeleteResult",
		updateFallbackSeo:"FallbackSeoUpdateResult",
		upsertFallbackSeo:"FallbackSeoUpsertResult",
		createFooter:"FooterCreateResult",
		deleteFooter:"FooterDeleteResult",
		updateFooter:"FooterUpdateResult",
		upsertFooter:"FooterUpsertResult",
		createHeader:"HeaderCreateResult",
		deleteHeader:"HeaderDeleteResult",
		updateHeader:"HeaderUpdateResult",
		upsertHeader:"HeaderUpsertResult",
		createHeaderLink:"HeaderLinkCreateResult",
		deleteHeaderLink:"HeaderLinkDeleteResult",
		updateHeaderLink:"HeaderLinkUpdateResult",
		upsertHeaderLink:"HeaderLinkUpsertResult",
		createFrontPage:"FrontPageCreateResult",
		deleteFrontPage:"FrontPageDeleteResult",
		updateFrontPage:"FrontPageUpdateResult",
		upsertFrontPage:"FrontPageUpsertResult",
		createImage:"ImageCreateResult",
		deleteImage:"ImageDeleteResult",
		updateImage:"ImageUpdateResult",
		upsertImage:"ImageUpsertResult",
		createLink:"LinkCreateResult",
		deleteLink:"LinkDeleteResult",
		updateLink:"LinkUpdateResult",
		upsertLink:"LinkUpsertResult",
		createLinkable:"LinkableCreateResult",
		deleteLinkable:"LinkableDeleteResult",
		updateLinkable:"LinkableUpdateResult",
		upsertLinkable:"LinkableUpsertResult",
		createSeo:"SeoCreateResult",
		deleteSeo:"SeoDeleteResult",
		updateSeo:"SeoUpdateResult",
		upsertSeo:"SeoUpsertResult",
		createSpecialEvent:"SpecialEventCreateResult",
		deleteSpecialEvent:"SpecialEventDeleteResult",
		updateSpecialEvent:"SpecialEventUpdateResult",
		upsertSpecialEvent:"SpecialEventUpsertResult",
		createTimelinePage:"TimelinePageCreateResult",
		deleteTimelinePage:"TimelinePageDeleteResult",
		updateTimelinePage:"TimelinePageUpdateResult",
		upsertTimelinePage:"TimelinePageUpsertResult",
		createTimelinePost:"TimelinePostCreateResult",
		deleteTimelinePost:"TimelinePostDeleteResult",
		updateTimelinePost:"TimelinePostUpdateResult",
		upsertTimelinePost:"TimelinePostUpsertResult",
		createSourcePage:"SourcePageCreateResult",
		deleteSourcePage:"SourcePageDeleteResult",
		updateSourcePage:"SourcePageUpdateResult",
		upsertSourcePage:"SourcePageUpsertResult",
		createSourcePostLink:"SourcePostLinkCreateResult",
		deleteSourcePostLink:"SourcePostLinkDeleteResult",
		updateSourcePostLink:"SourcePostLinkUpdateResult",
		upsertSourcePostLink:"SourcePostLinkUpsertResult",
		createGallery:"GalleryCreateResult",
		deleteGallery:"GalleryDeleteResult",
		updateGallery:"GalleryUpdateResult",
		upsertGallery:"GalleryUpsertResult",
		createGalleryItem:"GalleryItemCreateResult",
		deleteGalleryItem:"GalleryItemDeleteResult",
		updateGalleryItem:"GalleryItemUpdateResult",
		upsertGalleryItem:"GalleryItemUpsertResult",
		createCardMedia:"CardMediaCreateResult",
		deleteCardMedia:"CardMediaDeleteResult",
		updateCardMedia:"CardMediaUpdateResult",
		upsertCardMedia:"CardMediaUpsertResult",
		createRedirect:"RedirectCreateResult",
		deleteRedirect:"RedirectDeleteResult",
		updateRedirect:"RedirectUpdateResult",
		upsertRedirect:"RedirectUpsertResult",
		createVenue:"VenueCreateResult",
		deleteVenue:"VenueDeleteResult",
		updateVenue:"VenueUpdateResult",
		upsertVenue:"VenueUpsertResult",
		createEventLabel:"EventLabelCreateResult",
		deleteEventLabel:"EventLabelDeleteResult",
		updateEventLabel:"EventLabelUpdateResult",
		upsertEventLabel:"EventLabelUpsertResult",
		createPage:"PageCreateResult",
		deletePage:"PageDeleteResult",
		updatePage:"PageUpdateResult",
		upsertPage:"PageUpsertResult",
		transaction:"MutationTransaction",
		query:"Query",
		generateUploadUrl:"S3SignedUpload",
		generateReadUrl:"S3SignedRead"
	},
	ContentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	MutationResult:{
		"...on ContentCreateResult": "ContentCreateResult",
		"...on ContentDeleteResult": "ContentDeleteResult",
		"...on ContentUpdateResult": "ContentUpdateResult",
		"...on ContentUpsertResult": "ContentUpsertResult",
		"...on ContentBlockCreateResult": "ContentBlockCreateResult",
		"...on ContentBlockDeleteResult": "ContentBlockDeleteResult",
		"...on ContentBlockUpdateResult": "ContentBlockUpdateResult",
		"...on ContentBlockUpsertResult": "ContentBlockUpsertResult",
		"...on ContentReferenceCreateResult": "ContentReferenceCreateResult",
		"...on ContentReferenceDeleteResult": "ContentReferenceDeleteResult",
		"...on ContentReferenceUpdateResult": "ContentReferenceUpdateResult",
		"...on ContentReferenceUpsertResult": "ContentReferenceUpsertResult",
		"...on EventCreateResult": "EventCreateResult",
		"...on EventDeleteResult": "EventDeleteResult",
		"...on EventUpdateResult": "EventUpdateResult",
		"...on EventUpsertResult": "EventUpsertResult",
		"...on FallbackSeoCreateResult": "FallbackSeoCreateResult",
		"...on FallbackSeoDeleteResult": "FallbackSeoDeleteResult",
		"...on FallbackSeoUpdateResult": "FallbackSeoUpdateResult",
		"...on FallbackSeoUpsertResult": "FallbackSeoUpsertResult",
		"...on FooterCreateResult": "FooterCreateResult",
		"...on FooterDeleteResult": "FooterDeleteResult",
		"...on FooterUpdateResult": "FooterUpdateResult",
		"...on FooterUpsertResult": "FooterUpsertResult",
		"...on HeaderCreateResult": "HeaderCreateResult",
		"...on HeaderDeleteResult": "HeaderDeleteResult",
		"...on HeaderUpdateResult": "HeaderUpdateResult",
		"...on HeaderUpsertResult": "HeaderUpsertResult",
		"...on HeaderLinkCreateResult": "HeaderLinkCreateResult",
		"...on HeaderLinkDeleteResult": "HeaderLinkDeleteResult",
		"...on HeaderLinkUpdateResult": "HeaderLinkUpdateResult",
		"...on HeaderLinkUpsertResult": "HeaderLinkUpsertResult",
		"...on FrontPageCreateResult": "FrontPageCreateResult",
		"...on FrontPageDeleteResult": "FrontPageDeleteResult",
		"...on FrontPageUpdateResult": "FrontPageUpdateResult",
		"...on FrontPageUpsertResult": "FrontPageUpsertResult",
		"...on ImageCreateResult": "ImageCreateResult",
		"...on ImageDeleteResult": "ImageDeleteResult",
		"...on ImageUpdateResult": "ImageUpdateResult",
		"...on ImageUpsertResult": "ImageUpsertResult",
		"...on LinkCreateResult": "LinkCreateResult",
		"...on LinkDeleteResult": "LinkDeleteResult",
		"...on LinkUpdateResult": "LinkUpdateResult",
		"...on LinkUpsertResult": "LinkUpsertResult",
		"...on LinkableCreateResult": "LinkableCreateResult",
		"...on LinkableDeleteResult": "LinkableDeleteResult",
		"...on LinkableUpdateResult": "LinkableUpdateResult",
		"...on LinkableUpsertResult": "LinkableUpsertResult",
		"...on SeoCreateResult": "SeoCreateResult",
		"...on SeoDeleteResult": "SeoDeleteResult",
		"...on SeoUpdateResult": "SeoUpdateResult",
		"...on SeoUpsertResult": "SeoUpsertResult",
		"...on SpecialEventCreateResult": "SpecialEventCreateResult",
		"...on SpecialEventDeleteResult": "SpecialEventDeleteResult",
		"...on SpecialEventUpdateResult": "SpecialEventUpdateResult",
		"...on SpecialEventUpsertResult": "SpecialEventUpsertResult",
		"...on TimelinePageCreateResult": "TimelinePageCreateResult",
		"...on TimelinePageDeleteResult": "TimelinePageDeleteResult",
		"...on TimelinePageUpdateResult": "TimelinePageUpdateResult",
		"...on TimelinePageUpsertResult": "TimelinePageUpsertResult",
		"...on TimelinePostCreateResult": "TimelinePostCreateResult",
		"...on TimelinePostDeleteResult": "TimelinePostDeleteResult",
		"...on TimelinePostUpdateResult": "TimelinePostUpdateResult",
		"...on TimelinePostUpsertResult": "TimelinePostUpsertResult",
		"...on SourcePageCreateResult": "SourcePageCreateResult",
		"...on SourcePageDeleteResult": "SourcePageDeleteResult",
		"...on SourcePageUpdateResult": "SourcePageUpdateResult",
		"...on SourcePageUpsertResult": "SourcePageUpsertResult",
		"...on SourcePostLinkCreateResult": "SourcePostLinkCreateResult",
		"...on SourcePostLinkDeleteResult": "SourcePostLinkDeleteResult",
		"...on SourcePostLinkUpdateResult": "SourcePostLinkUpdateResult",
		"...on SourcePostLinkUpsertResult": "SourcePostLinkUpsertResult",
		"...on GalleryCreateResult": "GalleryCreateResult",
		"...on GalleryDeleteResult": "GalleryDeleteResult",
		"...on GalleryUpdateResult": "GalleryUpdateResult",
		"...on GalleryUpsertResult": "GalleryUpsertResult",
		"...on GalleryItemCreateResult": "GalleryItemCreateResult",
		"...on GalleryItemDeleteResult": "GalleryItemDeleteResult",
		"...on GalleryItemUpdateResult": "GalleryItemUpdateResult",
		"...on GalleryItemUpsertResult": "GalleryItemUpsertResult",
		"...on CardMediaCreateResult": "CardMediaCreateResult",
		"...on CardMediaDeleteResult": "CardMediaDeleteResult",
		"...on CardMediaUpdateResult": "CardMediaUpdateResult",
		"...on CardMediaUpsertResult": "CardMediaUpsertResult",
		"...on RedirectCreateResult": "RedirectCreateResult",
		"...on RedirectDeleteResult": "RedirectDeleteResult",
		"...on RedirectUpdateResult": "RedirectUpdateResult",
		"...on RedirectUpsertResult": "RedirectUpsertResult",
		"...on VenueCreateResult": "VenueCreateResult",
		"...on VenueDeleteResult": "VenueDeleteResult",
		"...on VenueUpdateResult": "VenueUpdateResult",
		"...on VenueUpsertResult": "VenueUpsertResult",
		"...on EventLabelCreateResult": "EventLabelCreateResult",
		"...on EventLabelDeleteResult": "EventLabelDeleteResult",
		"...on EventLabelUpdateResult": "EventLabelUpdateResult",
		"...on EventLabelUpsertResult": "EventLabelUpsertResult",
		"...on PageCreateResult": "PageCreateResult",
		"...on PageDeleteResult": "PageDeleteResult",
		"...on PageUpdateResult": "PageUpdateResult",
		"...on PageUpsertResult": "PageUpsertResult",
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError"
	},
	_MutationError:{
		path:"_PathFragment",
		paths:"_PathFragment",
		type:"_MutationErrorType",
		message:"String"
	},
	ContentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content"
	},
	ContentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentBlockCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentBlockDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock"
	},
	ContentBlockUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentBlockUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentReferenceCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	ContentReferenceDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference"
	},
	ContentReferenceUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	ContentReferenceUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	EventCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Event",
		validation:"_ValidationResult"
	},
	EventDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Event"
	},
	EventUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Event",
		validation:"_ValidationResult"
	},
	EventUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Event",
		validation:"_ValidationResult"
	},
	FallbackSeoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FallbackSeo",
		validation:"_ValidationResult"
	},
	FallbackSeoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FallbackSeo"
	},
	FallbackSeoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FallbackSeo",
		validation:"_ValidationResult"
	},
	FallbackSeoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FallbackSeo",
		validation:"_ValidationResult"
	},
	FooterCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer",
		validation:"_ValidationResult"
	},
	FooterDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer"
	},
	FooterUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer",
		validation:"_ValidationResult"
	},
	FooterUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer",
		validation:"_ValidationResult"
	},
	HeaderCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header",
		validation:"_ValidationResult"
	},
	HeaderDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header"
	},
	HeaderUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header",
		validation:"_ValidationResult"
	},
	HeaderUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header",
		validation:"_ValidationResult"
	},
	HeaderLinkCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLink",
		validation:"_ValidationResult"
	},
	HeaderLinkDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLink"
	},
	HeaderLinkUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLink",
		validation:"_ValidationResult"
	},
	HeaderLinkUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLink",
		validation:"_ValidationResult"
	},
	FrontPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FrontPage",
		validation:"_ValidationResult"
	},
	FrontPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FrontPage"
	},
	FrontPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FrontPage",
		validation:"_ValidationResult"
	},
	FrontPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FrontPage",
		validation:"_ValidationResult"
	},
	ImageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	ImageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image"
	},
	ImageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	ImageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	LinkCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link"
	},
	LinkUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkableCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	LinkableDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable"
	},
	LinkableUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	LinkableUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	SeoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	SeoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo"
	},
	SeoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	SeoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	SpecialEventCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SpecialEvent",
		validation:"_ValidationResult"
	},
	SpecialEventDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SpecialEvent"
	},
	SpecialEventUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SpecialEvent",
		validation:"_ValidationResult"
	},
	SpecialEventUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SpecialEvent",
		validation:"_ValidationResult"
	},
	TimelinePageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimelinePage",
		validation:"_ValidationResult"
	},
	TimelinePageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimelinePage"
	},
	TimelinePageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimelinePage",
		validation:"_ValidationResult"
	},
	TimelinePageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimelinePage",
		validation:"_ValidationResult"
	},
	TimelinePostCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimelinePost",
		validation:"_ValidationResult"
	},
	TimelinePostDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimelinePost"
	},
	TimelinePostUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimelinePost",
		validation:"_ValidationResult"
	},
	TimelinePostUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TimelinePost",
		validation:"_ValidationResult"
	},
	SourcePageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SourcePage",
		validation:"_ValidationResult"
	},
	SourcePageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SourcePage"
	},
	SourcePageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SourcePage",
		validation:"_ValidationResult"
	},
	SourcePageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SourcePage",
		validation:"_ValidationResult"
	},
	SourcePostLinkCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SourcePostLink",
		validation:"_ValidationResult"
	},
	SourcePostLinkDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SourcePostLink"
	},
	SourcePostLinkUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SourcePostLink",
		validation:"_ValidationResult"
	},
	SourcePostLinkUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SourcePostLink",
		validation:"_ValidationResult"
	},
	GalleryCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gallery",
		validation:"_ValidationResult"
	},
	GalleryDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gallery"
	},
	GalleryUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gallery",
		validation:"_ValidationResult"
	},
	GalleryUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gallery",
		validation:"_ValidationResult"
	},
	GalleryItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GalleryItem",
		validation:"_ValidationResult"
	},
	GalleryItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GalleryItem"
	},
	GalleryItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GalleryItem",
		validation:"_ValidationResult"
	},
	GalleryItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GalleryItem",
		validation:"_ValidationResult"
	},
	CardMediaCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CardMedia",
		validation:"_ValidationResult"
	},
	CardMediaDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CardMedia"
	},
	CardMediaUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CardMedia",
		validation:"_ValidationResult"
	},
	CardMediaUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CardMedia",
		validation:"_ValidationResult"
	},
	RedirectCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect",
		validation:"_ValidationResult"
	},
	RedirectDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect"
	},
	RedirectUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect",
		validation:"_ValidationResult"
	},
	RedirectUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect",
		validation:"_ValidationResult"
	},
	VenueCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Venue",
		validation:"_ValidationResult"
	},
	VenueDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Venue"
	},
	VenueUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Venue",
		validation:"_ValidationResult"
	},
	VenueUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Venue",
		validation:"_ValidationResult"
	},
	EventLabelCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EventLabel",
		validation:"_ValidationResult"
	},
	EventLabelDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EventLabel"
	},
	EventLabelUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EventLabel",
		validation:"_ValidationResult"
	},
	EventLabelUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EventLabel",
		validation:"_ValidationResult"
	},
	PageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Page",
		validation:"_ValidationResult"
	},
	PageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Page"
	},
	PageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Page",
		validation:"_ValidationResult"
	},
	PageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Page",
		validation:"_ValidationResult"
	},
	MutationTransaction:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		validation:"_ValidationResult",
		createContent:"ContentCreateResult",
		deleteContent:"ContentDeleteResult",
		updateContent:"ContentUpdateResult",
		upsertContent:"ContentUpsertResult",
		createContentBlock:"ContentBlockCreateResult",
		deleteContentBlock:"ContentBlockDeleteResult",
		updateContentBlock:"ContentBlockUpdateResult",
		upsertContentBlock:"ContentBlockUpsertResult",
		createContentReference:"ContentReferenceCreateResult",
		deleteContentReference:"ContentReferenceDeleteResult",
		updateContentReference:"ContentReferenceUpdateResult",
		upsertContentReference:"ContentReferenceUpsertResult",
		createEvent:"EventCreateResult",
		deleteEvent:"EventDeleteResult",
		updateEvent:"EventUpdateResult",
		upsertEvent:"EventUpsertResult",
		createFallbackSeo:"FallbackSeoCreateResult",
		deleteFallbackSeo:"FallbackSeoDeleteResult",
		updateFallbackSeo:"FallbackSeoUpdateResult",
		upsertFallbackSeo:"FallbackSeoUpsertResult",
		createFooter:"FooterCreateResult",
		deleteFooter:"FooterDeleteResult",
		updateFooter:"FooterUpdateResult",
		upsertFooter:"FooterUpsertResult",
		createHeader:"HeaderCreateResult",
		deleteHeader:"HeaderDeleteResult",
		updateHeader:"HeaderUpdateResult",
		upsertHeader:"HeaderUpsertResult",
		createHeaderLink:"HeaderLinkCreateResult",
		deleteHeaderLink:"HeaderLinkDeleteResult",
		updateHeaderLink:"HeaderLinkUpdateResult",
		upsertHeaderLink:"HeaderLinkUpsertResult",
		createFrontPage:"FrontPageCreateResult",
		deleteFrontPage:"FrontPageDeleteResult",
		updateFrontPage:"FrontPageUpdateResult",
		upsertFrontPage:"FrontPageUpsertResult",
		createImage:"ImageCreateResult",
		deleteImage:"ImageDeleteResult",
		updateImage:"ImageUpdateResult",
		upsertImage:"ImageUpsertResult",
		createLink:"LinkCreateResult",
		deleteLink:"LinkDeleteResult",
		updateLink:"LinkUpdateResult",
		upsertLink:"LinkUpsertResult",
		createLinkable:"LinkableCreateResult",
		deleteLinkable:"LinkableDeleteResult",
		updateLinkable:"LinkableUpdateResult",
		upsertLinkable:"LinkableUpsertResult",
		createSeo:"SeoCreateResult",
		deleteSeo:"SeoDeleteResult",
		updateSeo:"SeoUpdateResult",
		upsertSeo:"SeoUpsertResult",
		createSpecialEvent:"SpecialEventCreateResult",
		deleteSpecialEvent:"SpecialEventDeleteResult",
		updateSpecialEvent:"SpecialEventUpdateResult",
		upsertSpecialEvent:"SpecialEventUpsertResult",
		createTimelinePage:"TimelinePageCreateResult",
		deleteTimelinePage:"TimelinePageDeleteResult",
		updateTimelinePage:"TimelinePageUpdateResult",
		upsertTimelinePage:"TimelinePageUpsertResult",
		createTimelinePost:"TimelinePostCreateResult",
		deleteTimelinePost:"TimelinePostDeleteResult",
		updateTimelinePost:"TimelinePostUpdateResult",
		upsertTimelinePost:"TimelinePostUpsertResult",
		createSourcePage:"SourcePageCreateResult",
		deleteSourcePage:"SourcePageDeleteResult",
		updateSourcePage:"SourcePageUpdateResult",
		upsertSourcePage:"SourcePageUpsertResult",
		createSourcePostLink:"SourcePostLinkCreateResult",
		deleteSourcePostLink:"SourcePostLinkDeleteResult",
		updateSourcePostLink:"SourcePostLinkUpdateResult",
		upsertSourcePostLink:"SourcePostLinkUpsertResult",
		createGallery:"GalleryCreateResult",
		deleteGallery:"GalleryDeleteResult",
		updateGallery:"GalleryUpdateResult",
		upsertGallery:"GalleryUpsertResult",
		createGalleryItem:"GalleryItemCreateResult",
		deleteGalleryItem:"GalleryItemDeleteResult",
		updateGalleryItem:"GalleryItemUpdateResult",
		upsertGalleryItem:"GalleryItemUpsertResult",
		createCardMedia:"CardMediaCreateResult",
		deleteCardMedia:"CardMediaDeleteResult",
		updateCardMedia:"CardMediaUpdateResult",
		upsertCardMedia:"CardMediaUpsertResult",
		createRedirect:"RedirectCreateResult",
		deleteRedirect:"RedirectDeleteResult",
		updateRedirect:"RedirectUpdateResult",
		upsertRedirect:"RedirectUpsertResult",
		createVenue:"VenueCreateResult",
		deleteVenue:"VenueDeleteResult",
		updateVenue:"VenueUpdateResult",
		upsertVenue:"VenueUpsertResult",
		createEventLabel:"EventLabelCreateResult",
		deleteEventLabel:"EventLabelDeleteResult",
		updateEventLabel:"EventLabelUpdateResult",
		upsertEventLabel:"EventLabelUpsertResult",
		createPage:"PageCreateResult",
		deletePage:"PageDeleteResult",
		updatePage:"PageUpdateResult",
		upsertPage:"PageUpsertResult",
		query:"Query"
	},
	_Schema:{
		enums:"_Enum",
		entities:"_Entity"
	},
	_Entity:{
		name:"String",
		customPrimaryAllowed:"Boolean",
		fields:"_Field",
		unique:"_UniqueConstraint"
	},
	_UniqueConstraint:{
		fields:"String"
	},
	_Field:{
		"...on _Column": "_Column",
		"...on _Relation": "_Relation",
		name:"String",
		type:"String",
		nullable:"Boolean",
		rules:"_Rule",
		validators:"_Validator"
	},
	_Column:{
		name:"String",
		type:"String",
		enumName:"String",
		defaultValue:"Json",
		nullable:"Boolean",
		rules:"_Rule",
		validators:"_Validator"
	},
	_OrderBy:{
		path:"String",
		direction:"_OrderByDirection"
	},
	_Relation:{
		name:"String",
		type:"String",
		side:"_RelationSide",
		targetEntity:"String",
		ownedBy:"String",
		inversedBy:"String",
		nullable:"Boolean",
		onDelete:"_OnDeleteBehaviour",
		orphanRemoval:"Boolean",
		orderBy:"_OrderBy",
		rules:"_Rule",
		validators:"_Validator"
	},
	_Rule:{
		message:"_RuleMessage",
		validator:"Int"
	},
	_Validator:{
		operation:"String",
		arguments:"_Argument"
	},
	_Argument:{
		"...on _ValidatorArgument":"_ValidatorArgument",
		"...on _PathArgument":"_PathArgument",
		"...on _LiteralArgument":"_LiteralArgument"
	},
	_ValidatorArgument:{
		validator:"Int"
	},
	_PathArgument:{
		path:"String"
	},
	_LiteralArgument:{
		value:"Json"
	},
	_RuleMessage:{
		text:"String"
	},
	_Enum:{
		name:"String",
		values:"String"
	},
	S3SignedUpload:{
		url:"String",
		headers:"S3Header",
		method:"String",
		objectKey:"String",
		bucket:"String",
		publicUrl:"String"
	},
	S3Header:{
		key:"String",
		value:"String"
	},
	S3SignedRead:{
		url:"String",
		headers:"S3Header",
		method:"String",
		objectKey:"String",
		bucket:"String"
	}
}
type ZEUS_INTERFACES = GraphQLTypes["MutationResult"] | GraphQLTypes["_Field"]
type ZEUS_UNIONS = GraphQLTypes["_PathFragment"] | GraphQLTypes["_Argument"]

export type ValueTypes = {
    ["Query"]: AliasType<{
getContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
listContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Content"]],
paginateContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentConnection"]],
validateCreateContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	data:ValueTypes["ContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
listContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
listContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
paginateContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
validateCreateContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["_ValidationResult"]],
getEvent?: [{	by:ValueTypes["EventUniqueWhere"],	filter?:ValueTypes["EventWhere"] | null},ValueTypes["Event"]],
listEvent?: [{	filter?:ValueTypes["EventWhere"] | null,	orderBy?:ValueTypes["EventOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Event"]],
paginateEvent?: [{	filter?:ValueTypes["EventWhere"] | null,	orderBy?:ValueTypes["EventOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EventConnection"]],
validateCreateEvent?: [{	data:ValueTypes["EventCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEvent?: [{	by:ValueTypes["EventUniqueWhere"],	data:ValueTypes["EventUpdateInput"]},ValueTypes["_ValidationResult"]],
getFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	filter?:ValueTypes["FallbackSeoWhere"] | null},ValueTypes["FallbackSeo"]],
listFallbackSeo?: [{	filter?:ValueTypes["FallbackSeoWhere"] | null,	orderBy?:ValueTypes["FallbackSeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FallbackSeo"]],
paginateFallbackSeo?: [{	filter?:ValueTypes["FallbackSeoWhere"] | null,	orderBy?:ValueTypes["FallbackSeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FallbackSeoConnection"]],
validateCreateFallbackSeo?: [{	data:ValueTypes["FallbackSeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	data:ValueTypes["FallbackSeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["Footer"]],
listFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Footer"]],
paginateFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterConnection"]],
validateCreateFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	data:ValueTypes["FooterUpdateInput"]},ValueTypes["_ValidationResult"]],
getHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["Header"]],
listHeader?: [{	filter?:ValueTypes["HeaderWhere"] | null,	orderBy?:ValueTypes["HeaderOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Header"]],
paginateHeader?: [{	filter?:ValueTypes["HeaderWhere"] | null,	orderBy?:ValueTypes["HeaderOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderConnection"]],
validateCreateHeader?: [{	data:ValueTypes["HeaderCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	data:ValueTypes["HeaderUpdateInput"]},ValueTypes["_ValidationResult"]],
getHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	filter?:ValueTypes["HeaderLinkWhere"] | null},ValueTypes["HeaderLink"]],
listHeaderLink?: [{	filter?:ValueTypes["HeaderLinkWhere"] | null,	orderBy?:ValueTypes["HeaderLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HeaderLink"]],
paginateHeaderLink?: [{	filter?:ValueTypes["HeaderLinkWhere"] | null,	orderBy?:ValueTypes["HeaderLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderLinkConnection"]],
validateCreateHeaderLink?: [{	data:ValueTypes["HeaderLinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	data:ValueTypes["HeaderLinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getFrontPage?: [{	by:ValueTypes["FrontPageUniqueWhere"],	filter?:ValueTypes["FrontPageWhere"] | null},ValueTypes["FrontPage"]],
listFrontPage?: [{	filter?:ValueTypes["FrontPageWhere"] | null,	orderBy?:ValueTypes["FrontPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FrontPage"]],
paginateFrontPage?: [{	filter?:ValueTypes["FrontPageWhere"] | null,	orderBy?:ValueTypes["FrontPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FrontPageConnection"]],
validateCreateFrontPage?: [{	data:ValueTypes["FrontPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFrontPage?: [{	by:ValueTypes["FrontPageUniqueWhere"],	data:ValueTypes["FrontPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
listImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Image"]],
paginateImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageConnection"]],
validateCreateImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	data:ValueTypes["ImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
listLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Link"]],
paginateLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkConnection"]],
validateCreateLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	data:ValueTypes["LinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
listLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Linkable"]],
paginateLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
listSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Seo"]],
paginateSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoConnection"]],
validateCreateSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	data:ValueTypes["SeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getSpecialEvent?: [{	by:ValueTypes["SpecialEventUniqueWhere"],	filter?:ValueTypes["SpecialEventWhere"] | null},ValueTypes["SpecialEvent"]],
listSpecialEvent?: [{	filter?:ValueTypes["SpecialEventWhere"] | null,	orderBy?:ValueTypes["SpecialEventOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SpecialEvent"]],
paginateSpecialEvent?: [{	filter?:ValueTypes["SpecialEventWhere"] | null,	orderBy?:ValueTypes["SpecialEventOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SpecialEventConnection"]],
validateCreateSpecialEvent?: [{	data:ValueTypes["SpecialEventCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSpecialEvent?: [{	by:ValueTypes["SpecialEventUniqueWhere"],	data:ValueTypes["SpecialEventUpdateInput"]},ValueTypes["_ValidationResult"]],
getTimelinePage?: [{	by:ValueTypes["TimelinePageUniqueWhere"],	filter?:ValueTypes["TimelinePageWhere"] | null},ValueTypes["TimelinePage"]],
listTimelinePage?: [{	filter?:ValueTypes["TimelinePageWhere"] | null,	orderBy?:ValueTypes["TimelinePageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TimelinePage"]],
paginateTimelinePage?: [{	filter?:ValueTypes["TimelinePageWhere"] | null,	orderBy?:ValueTypes["TimelinePageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TimelinePageConnection"]],
validateCreateTimelinePage?: [{	data:ValueTypes["TimelinePageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTimelinePage?: [{	by:ValueTypes["TimelinePageUniqueWhere"],	data:ValueTypes["TimelinePageUpdateInput"]},ValueTypes["_ValidationResult"]],
getTimelinePost?: [{	by:ValueTypes["TimelinePostUniqueWhere"],	filter?:ValueTypes["TimelinePostWhere"] | null},ValueTypes["TimelinePost"]],
listTimelinePost?: [{	filter?:ValueTypes["TimelinePostWhere"] | null,	orderBy?:ValueTypes["TimelinePostOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TimelinePost"]],
paginateTimelinePost?: [{	filter?:ValueTypes["TimelinePostWhere"] | null,	orderBy?:ValueTypes["TimelinePostOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TimelinePostConnection"]],
validateCreateTimelinePost?: [{	data:ValueTypes["TimelinePostCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTimelinePost?: [{	by:ValueTypes["TimelinePostUniqueWhere"],	data:ValueTypes["TimelinePostUpdateInput"]},ValueTypes["_ValidationResult"]],
getSourcePage?: [{	by:ValueTypes["SourcePageUniqueWhere"],	filter?:ValueTypes["SourcePageWhere"] | null},ValueTypes["SourcePage"]],
listSourcePage?: [{	filter?:ValueTypes["SourcePageWhere"] | null,	orderBy?:ValueTypes["SourcePageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SourcePage"]],
paginateSourcePage?: [{	filter?:ValueTypes["SourcePageWhere"] | null,	orderBy?:ValueTypes["SourcePageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SourcePageConnection"]],
validateCreateSourcePage?: [{	data:ValueTypes["SourcePageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSourcePage?: [{	by:ValueTypes["SourcePageUniqueWhere"],	data:ValueTypes["SourcePageUpdateInput"]},ValueTypes["_ValidationResult"]],
getSourcePostLink?: [{	by:ValueTypes["SourcePostLinkUniqueWhere"],	filter?:ValueTypes["SourcePostLinkWhere"] | null},ValueTypes["SourcePostLink"]],
listSourcePostLink?: [{	filter?:ValueTypes["SourcePostLinkWhere"] | null,	orderBy?:ValueTypes["SourcePostLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SourcePostLink"]],
paginateSourcePostLink?: [{	filter?:ValueTypes["SourcePostLinkWhere"] | null,	orderBy?:ValueTypes["SourcePostLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SourcePostLinkConnection"]],
validateCreateSourcePostLink?: [{	data:ValueTypes["SourcePostLinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSourcePostLink?: [{	by:ValueTypes["SourcePostLinkUniqueWhere"],	data:ValueTypes["SourcePostLinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["Gallery"]],
listGallery?: [{	filter?:ValueTypes["GalleryWhere"] | null,	orderBy?:ValueTypes["GalleryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Gallery"]],
paginateGallery?: [{	filter?:ValueTypes["GalleryWhere"] | null,	orderBy?:ValueTypes["GalleryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GalleryConnection"]],
validateCreateGallery?: [{	data:ValueTypes["GalleryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	data:ValueTypes["GalleryUpdateInput"]},ValueTypes["_ValidationResult"]],
getGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null},ValueTypes["GalleryItem"]],
listGalleryItem?: [{	filter?:ValueTypes["GalleryItemWhere"] | null,	orderBy?:ValueTypes["GalleryItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["GalleryItem"]],
paginateGalleryItem?: [{	filter?:ValueTypes["GalleryItemWhere"] | null,	orderBy?:ValueTypes["GalleryItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GalleryItemConnection"]],
validateCreateGalleryItem?: [{	data:ValueTypes["GalleryItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	data:ValueTypes["GalleryItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getCardMedia?: [{	by:ValueTypes["CardMediaUniqueWhere"],	filter?:ValueTypes["CardMediaWhere"] | null},ValueTypes["CardMedia"]],
listCardMedia?: [{	filter?:ValueTypes["CardMediaWhere"] | null,	orderBy?:ValueTypes["CardMediaOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["CardMedia"]],
paginateCardMedia?: [{	filter?:ValueTypes["CardMediaWhere"] | null,	orderBy?:ValueTypes["CardMediaOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["CardMediaConnection"]],
validateCreateCardMedia?: [{	data:ValueTypes["CardMediaCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCardMedia?: [{	by:ValueTypes["CardMediaUniqueWhere"],	data:ValueTypes["CardMediaUpdateInput"]},ValueTypes["_ValidationResult"]],
getRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
listRedirect?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Redirect"]],
paginateRedirect?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RedirectConnection"]],
validateCreateRedirect?: [{	data:ValueTypes["RedirectCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	data:ValueTypes["RedirectUpdateInput"]},ValueTypes["_ValidationResult"]],
getVenue?: [{	by:ValueTypes["VenueUniqueWhere"],	filter?:ValueTypes["VenueWhere"] | null},ValueTypes["Venue"]],
listVenue?: [{	filter?:ValueTypes["VenueWhere"] | null,	orderBy?:ValueTypes["VenueOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Venue"]],
paginateVenue?: [{	filter?:ValueTypes["VenueWhere"] | null,	orderBy?:ValueTypes["VenueOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["VenueConnection"]],
validateCreateVenue?: [{	data:ValueTypes["VenueCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVenue?: [{	by:ValueTypes["VenueUniqueWhere"],	data:ValueTypes["VenueUpdateInput"]},ValueTypes["_ValidationResult"]],
getEventLabel?: [{	by:ValueTypes["EventLabelUniqueWhere"],	filter?:ValueTypes["EventLabelWhere"] | null},ValueTypes["EventLabel"]],
listEventLabel?: [{	filter?:ValueTypes["EventLabelWhere"] | null,	orderBy?:ValueTypes["EventLabelOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EventLabel"]],
paginateEventLabel?: [{	filter?:ValueTypes["EventLabelWhere"] | null,	orderBy?:ValueTypes["EventLabelOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EventLabelConnection"]],
validateCreateEventLabel?: [{	data:ValueTypes["EventLabelCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEventLabel?: [{	by:ValueTypes["EventLabelUniqueWhere"],	data:ValueTypes["EventLabelUpdateInput"]},ValueTypes["_ValidationResult"]],
getPage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null},ValueTypes["Page"]],
listPage?: [{	filter?:ValueTypes["PageWhere"] | null,	orderBy?:ValueTypes["PageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Page"]],
paginatePage?: [{	filter?:ValueTypes["PageWhere"] | null,	orderBy?:ValueTypes["PageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PageConnection"]],
validateCreatePage?: [{	data:ValueTypes["PageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePage?: [{	by:ValueTypes["PageUniqueWhere"],	data:ValueTypes["PageUpdateInput"]},ValueTypes["_ValidationResult"]],
	transaction?:ValueTypes["QueryTransaction"],
	_info?:ValueTypes["Info"],
	schema?:ValueTypes["_Schema"],
	s3DummyQuery?:true,
		__typename?: true
}>;
	["Content"]: AliasType<{
	_meta?:ValueTypes["ContentMeta"],
	id?:true,
blocks?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
blocksByReferences?: [{	by:ValueTypes["ContentBlocksByReferencesUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
paginateBlocks?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
		__typename?: true
}>;
	["ContentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	blocks?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["FieldMeta"]: AliasType<{
	readable?:true,
	updatable?:true,
		__typename?: true
}>;
	["UUID"]:string;
	["ContentBlock"]: AliasType<{
	_meta?:ValueTypes["ContentBlockMeta"],
	id?:true,
	order?:true,
	json?:true,
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
references?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
referencesByLink?: [{	by:ValueTypes["ContentBlockReferencesByLinkUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
paginateReferences?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
		__typename?: true
}>;
	["ContentBlockMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	json?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	references?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ContentWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	blocks?:ValueTypes["ContentBlockWhere"] | null,
	and?:(ValueTypes["ContentWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentWhere"] | undefined | null)[],
	not?:ValueTypes["ContentWhere"] | null
};
	["UUIDCondition"]: {
	and?:ValueTypes["UUIDCondition"][],
	or?:ValueTypes["UUIDCondition"][],
	not?:ValueTypes["UUIDCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["UUID"] | null,
	notEq?:ValueTypes["UUID"] | null,
	in?:ValueTypes["UUID"][],
	notIn?:ValueTypes["UUID"][],
	lt?:ValueTypes["UUID"] | null,
	lte?:ValueTypes["UUID"] | null,
	gt?:ValueTypes["UUID"] | null,
	gte?:ValueTypes["UUID"] | null
};
	["ContentBlockWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	json?:ValueTypes["StringCondition"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	references?:ValueTypes["ContentReferenceWhere"] | null,
	and?:(ValueTypes["ContentBlockWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentBlockWhere"] | undefined | null)[],
	not?:ValueTypes["ContentBlockWhere"] | null
};
	["IntCondition"]: {
	and?:ValueTypes["IntCondition"][],
	or?:ValueTypes["IntCondition"][],
	not?:ValueTypes["IntCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:number | null,
	notEq?:number | null,
	in?:number[],
	notIn?:number[],
	lt?:number | null,
	lte?:number | null,
	gt?:number | null,
	gte?:number | null
};
	["StringCondition"]: {
	and?:ValueTypes["StringCondition"][],
	or?:ValueTypes["StringCondition"][],
	not?:ValueTypes["StringCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:string | null,
	notEq?:string | null,
	in?:string[],
	notIn?:string[],
	lt?:string | null,
	lte?:string | null,
	gt?:string | null,
	gte?:string | null,
	contains?:string | null,
	startsWith?:string | null,
	endsWith?:string | null,
	containsCI?:string | null,
	startsWithCI?:string | null,
	endsWithCI?:string | null
};
	["ContentReferenceWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["ContentReferenceTypeCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	block?:ValueTypes["ContentBlockWhere"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	cardMedia?:ValueTypes["CardMediaWhere"] | null,
	and?:(ValueTypes["ContentReferenceWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentReferenceWhere"] | undefined | null)[],
	not?:ValueTypes["ContentReferenceWhere"] | null
};
	["ContentReferenceTypeCondition"]: {
	and?:ValueTypes["ContentReferenceTypeCondition"][],
	or?:ValueTypes["ContentReferenceTypeCondition"][],
	not?:ValueTypes["ContentReferenceTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ContentReferenceType"] | null,
	notEq?:ValueTypes["ContentReferenceType"] | null,
	in?:ValueTypes["ContentReferenceType"][],
	notIn?:ValueTypes["ContentReferenceType"][],
	lt?:ValueTypes["ContentReferenceType"] | null,
	lte?:ValueTypes["ContentReferenceType"] | null,
	gt?:ValueTypes["ContentReferenceType"] | null,
	gte?:ValueTypes["ContentReferenceType"] | null
};
	["ContentReferenceType"]:ContentReferenceType;
	["ImageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	width?:ValueTypes["IntCondition"] | null,
	height?:ValueTypes["IntCondition"] | null,
	size?:ValueTypes["IntCondition"] | null,
	type?:ValueTypes["StringCondition"] | null,
	alt?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ImageWhere"] | undefined | null)[],
	or?:(ValueTypes["ImageWhere"] | undefined | null)[],
	not?:ValueTypes["ImageWhere"] | null
};
	["LinkWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["LinkTypeCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	externalLink?:ValueTypes["StringCondition"] | null,
	internalLink?:ValueTypes["LinkableWhere"] | null,
	and?:(ValueTypes["LinkWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkWhere"] | undefined | null)[],
	not?:ValueTypes["LinkWhere"] | null
};
	["LinkTypeCondition"]: {
	and?:ValueTypes["LinkTypeCondition"][],
	or?:ValueTypes["LinkTypeCondition"][],
	not?:ValueTypes["LinkTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["LinkType"] | null,
	notEq?:ValueTypes["LinkType"] | null,
	in?:ValueTypes["LinkType"][],
	notIn?:ValueTypes["LinkType"][],
	lt?:ValueTypes["LinkType"] | null,
	lte?:ValueTypes["LinkType"] | null,
	gt?:ValueTypes["LinkType"] | null,
	gte?:ValueTypes["LinkType"] | null
};
	["LinkType"]:LinkType;
	["LinkableWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	event?:ValueTypes["EventWhere"] | null,
	frontPage?:ValueTypes["FrontPageWhere"] | null,
	specialEvent?:ValueTypes["SpecialEventWhere"] | null,
	timelinePage?:ValueTypes["TimelinePageWhere"] | null,
	sourcePage?:ValueTypes["SourcePageWhere"] | null,
	redirect?:ValueTypes["RedirectWhere"] | null,
	page?:ValueTypes["PageWhere"] | null,
	and?:(ValueTypes["LinkableWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkableWhere"] | undefined | null)[],
	not?:ValueTypes["LinkableWhere"] | null
};
	["EventWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	place?:ValueTypes["StringCondition"] | null,
	entrance?:ValueTypes["StringCondition"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	date?:ValueTypes["StringCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	linkForEvent?:ValueTypes["LinkWhere"] | null,
	venue?:ValueTypes["VenueWhere"] | null,
	pastEvent?:ValueTypes["BooleanCondition"] | null,
	eventLabels?:ValueTypes["EventLabelWhere"] | null,
	and?:(ValueTypes["EventWhere"] | undefined | null)[],
	or?:(ValueTypes["EventWhere"] | undefined | null)[],
	not?:ValueTypes["EventWhere"] | null
};
	["SeoWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	description?:ValueTypes["StringCondition"] | null,
	ogTitle?:ValueTypes["StringCondition"] | null,
	ogDescription?:ValueTypes["StringCondition"] | null,
	ogImage?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["SeoWhere"] | undefined | null)[],
	or?:(ValueTypes["SeoWhere"] | undefined | null)[],
	not?:ValueTypes["SeoWhere"] | null
};
	["VenueWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	and?:(ValueTypes["VenueWhere"] | undefined | null)[],
	or?:(ValueTypes["VenueWhere"] | undefined | null)[],
	not?:ValueTypes["VenueWhere"] | null
};
	["BooleanCondition"]: {
	and?:ValueTypes["BooleanCondition"][],
	or?:ValueTypes["BooleanCondition"][],
	not?:ValueTypes["BooleanCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:boolean | null,
	notEq?:boolean | null,
	in?:boolean[],
	notIn?:boolean[],
	lt?:boolean | null,
	lte?:boolean | null,
	gt?:boolean | null,
	gte?:boolean | null
};
	["EventLabelWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	event?:ValueTypes["EventWhere"] | null,
	and?:(ValueTypes["EventLabelWhere"] | undefined | null)[],
	or?:(ValueTypes["EventLabelWhere"] | undefined | null)[],
	not?:ValueTypes["EventLabelWhere"] | null
};
	["FrontPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	openingText?:ValueTypes["StringCondition"] | null,
	eventsTitle?:ValueTypes["StringCondition"] | null,
	firstLink?:ValueTypes["LinkWhere"] | null,
	secondLink?:ValueTypes["LinkWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	subtitle?:ValueTypes["StringCondition"] | null,
	projectSupport?:ValueTypes["StringCondition"] | null,
	projectAuspices?:ValueTypes["StringCondition"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	gallery?:ValueTypes["GalleryWhere"] | null,
	and?:(ValueTypes["FrontPageWhere"] | undefined | null)[],
	or?:(ValueTypes["FrontPageWhere"] | undefined | null)[],
	not?:ValueTypes["FrontPageWhere"] | null
};
	["OneCondition"]: {
	and?:ValueTypes["OneCondition"][],
	or?:ValueTypes["OneCondition"][],
	not?:ValueTypes["OneCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["One"] | null,
	notEq?:ValueTypes["One"] | null,
	in?:ValueTypes["One"][],
	notIn?:ValueTypes["One"][],
	lt?:ValueTypes["One"] | null,
	lte?:ValueTypes["One"] | null,
	gt?:ValueTypes["One"] | null,
	gte?:ValueTypes["One"] | null
};
	["One"]:One;
	["GalleryWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["GalleryItemWhere"] | null,
	and?:(ValueTypes["GalleryWhere"] | undefined | null)[],
	or?:(ValueTypes["GalleryWhere"] | undefined | null)[],
	not?:ValueTypes["GalleryWhere"] | null
};
	["GalleryItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["GalleryWhere"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["GalleryItemWhere"] | undefined | null)[],
	or?:(ValueTypes["GalleryItemWhere"] | undefined | null)[],
	not?:ValueTypes["GalleryItemWhere"] | null
};
	["SpecialEventWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	imageNote?:ValueTypes["StringCondition"] | null,
	openingText?:ValueTypes["StringCondition"] | null,
	subtitle?:ValueTypes["StringCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	and?:(ValueTypes["SpecialEventWhere"] | undefined | null)[],
	or?:(ValueTypes["SpecialEventWhere"] | undefined | null)[],
	not?:ValueTypes["SpecialEventWhere"] | null
};
	["TimelinePageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	and?:(ValueTypes["TimelinePageWhere"] | undefined | null)[],
	or?:(ValueTypes["TimelinePageWhere"] | undefined | null)[],
	not?:ValueTypes["TimelinePageWhere"] | null
};
	["SourcePageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	links?:ValueTypes["SourcePostLinkWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	and?:(ValueTypes["SourcePageWhere"] | undefined | null)[],
	or?:(ValueTypes["SourcePageWhere"] | undefined | null)[],
	not?:ValueTypes["SourcePageWhere"] | null
};
	["SourcePostLinkWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	and?:(ValueTypes["SourcePostLinkWhere"] | undefined | null)[],
	or?:(ValueTypes["SourcePostLinkWhere"] | undefined | null)[],
	not?:ValueTypes["SourcePostLinkWhere"] | null
};
	["RedirectWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	targetUrl?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	target?:ValueTypes["LinkableWhere"] | null,
	and?:(ValueTypes["RedirectWhere"] | undefined | null)[],
	or?:(ValueTypes["RedirectWhere"] | undefined | null)[],
	not?:ValueTypes["RedirectWhere"] | null
};
	["PageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	and?:(ValueTypes["PageWhere"] | undefined | null)[],
	or?:(ValueTypes["PageWhere"] | undefined | null)[],
	not?:ValueTypes["PageWhere"] | null
};
	["CardMediaWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	imageNote?:ValueTypes["StringCondition"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["CardMediaWhere"] | undefined | null)[],
	or?:(ValueTypes["CardMediaWhere"] | undefined | null)[],
	not?:ValueTypes["CardMediaWhere"] | null
};
	["ContentReference"]: AliasType<{
	_meta?:ValueTypes["ContentReferenceMeta"],
	id?:true,
	type?:true,
	text?:true,
block?: [{	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
cardMedia?: [{	filter?:ValueTypes["CardMediaWhere"] | null},ValueTypes["CardMedia"]],
		__typename?: true
}>;
	["ContentReferenceMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	block?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	cardMedia?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Image"]: AliasType<{
	_meta?:ValueTypes["ImageMeta"],
	id?:true,
	url?:true,
	width?:true,
	height?:true,
	size?:true,
	type?:true,
	alt?:true,
		__typename?: true
}>;
	["ImageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	width?:ValueTypes["FieldMeta"],
	height?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	alt?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Link"]: AliasType<{
	_meta?:ValueTypes["LinkMeta"],
	id?:true,
	type?:true,
	title?:true,
	externalLink?:true,
internalLink?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
		__typename?: true
}>;
	["LinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	externalLink?:ValueTypes["FieldMeta"],
	internalLink?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Linkable"]: AliasType<{
	_meta?:ValueTypes["LinkableMeta"],
	id?:true,
	url?:true,
event?: [{	filter?:ValueTypes["EventWhere"] | null},ValueTypes["Event"]],
frontPage?: [{	filter?:ValueTypes["FrontPageWhere"] | null},ValueTypes["FrontPage"]],
specialEvent?: [{	filter?:ValueTypes["SpecialEventWhere"] | null},ValueTypes["SpecialEvent"]],
timelinePage?: [{	filter?:ValueTypes["TimelinePageWhere"] | null},ValueTypes["TimelinePage"]],
sourcePage?: [{	filter?:ValueTypes["SourcePageWhere"] | null},ValueTypes["SourcePage"]],
redirect?: [{	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
page?: [{	filter?:ValueTypes["PageWhere"] | null},ValueTypes["Page"]],
		__typename?: true
}>;
	["LinkableMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	event?:ValueTypes["FieldMeta"],
	frontPage?:ValueTypes["FieldMeta"],
	specialEvent?:ValueTypes["FieldMeta"],
	timelinePage?:ValueTypes["FieldMeta"],
	sourcePage?:ValueTypes["FieldMeta"],
	redirect?:ValueTypes["FieldMeta"],
	page?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Event"]: AliasType<{
	_meta?:ValueTypes["EventMeta"],
	id?:true,
	title?:true,
	place?:true,
	entrance?:true,
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
	date?:true,
	order?:true,
linkForEvent?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
venue?: [{	filter?:ValueTypes["VenueWhere"] | null},ValueTypes["Venue"]],
	pastEvent?:true,
eventLabels?: [{	filter?:ValueTypes["EventLabelWhere"] | null,	orderBy?:ValueTypes["EventLabelOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EventLabel"]],
paginateEventLabels?: [{	filter?:ValueTypes["EventLabelWhere"] | null,	orderBy?:ValueTypes["EventLabelOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EventLabelConnection"]],
		__typename?: true
}>;
	["EventMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	place?:ValueTypes["FieldMeta"],
	entrance?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	date?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	linkForEvent?:ValueTypes["FieldMeta"],
	venue?:ValueTypes["FieldMeta"],
	pastEvent?:ValueTypes["FieldMeta"],
	eventLabels?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Seo"]: AliasType<{
	_meta?:ValueTypes["SeoMeta"],
	id?:true,
	title?:true,
	description?:true,
	ogTitle?:true,
	ogDescription?:true,
ogImage?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: true
}>;
	["SeoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	ogTitle?:ValueTypes["FieldMeta"],
	ogDescription?:ValueTypes["FieldMeta"],
	ogImage?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Venue"]: AliasType<{
	_meta?:ValueTypes["VenueMeta"],
	id?:true,
	name?:true,
	order?:true,
		__typename?: true
}>;
	["VenueMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["EventLabel"]: AliasType<{
	_meta?:ValueTypes["EventLabelMeta"],
	id?:true,
	order?:true,
	text?:true,
event?: [{	filter?:ValueTypes["EventWhere"] | null},ValueTypes["Event"]],
		__typename?: true
}>;
	["EventLabelMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	event?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["EventLabelOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	event?:ValueTypes["EventOrderBy"] | null
};
	["OrderDirection"]:OrderDirection;
	["EventOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	place?:ValueTypes["OrderDirection"] | null,
	entrance?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	date?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	linkForEvent?:ValueTypes["LinkOrderBy"] | null,
	venue?:ValueTypes["VenueOrderBy"] | null,
	pastEvent?:ValueTypes["OrderDirection"] | null
};
	["ImageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	width?:ValueTypes["OrderDirection"] | null,
	height?:ValueTypes["OrderDirection"] | null,
	size?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	alt?:ValueTypes["OrderDirection"] | null
};
	["SeoOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	description?:ValueTypes["OrderDirection"] | null,
	ogTitle?:ValueTypes["OrderDirection"] | null,
	ogDescription?:ValueTypes["OrderDirection"] | null,
	ogImage?:ValueTypes["ImageOrderBy"] | null
};
	["LinkableOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	event?:ValueTypes["EventOrderBy"] | null,
	frontPage?:ValueTypes["FrontPageOrderBy"] | null,
	specialEvent?:ValueTypes["SpecialEventOrderBy"] | null,
	timelinePage?:ValueTypes["TimelinePageOrderBy"] | null,
	sourcePage?:ValueTypes["SourcePageOrderBy"] | null,
	redirect?:ValueTypes["RedirectOrderBy"] | null,
	page?:ValueTypes["PageOrderBy"] | null
};
	["FrontPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	openingText?:ValueTypes["OrderDirection"] | null,
	eventsTitle?:ValueTypes["OrderDirection"] | null,
	firstLink?:ValueTypes["LinkOrderBy"] | null,
	secondLink?:ValueTypes["LinkOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	subtitle?:ValueTypes["OrderDirection"] | null,
	projectSupport?:ValueTypes["OrderDirection"] | null,
	projectAuspices?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	gallery?:ValueTypes["GalleryOrderBy"] | null
};
	["LinkOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	externalLink?:ValueTypes["OrderDirection"] | null,
	internalLink?:ValueTypes["LinkableOrderBy"] | null
};
	["GalleryOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["SpecialEventOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	imageNote?:ValueTypes["OrderDirection"] | null,
	openingText?:ValueTypes["OrderDirection"] | null,
	subtitle?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	content?:ValueTypes["ContentOrderBy"] | null
};
	["ContentOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["TimelinePageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	unique?:ValueTypes["OrderDirection"] | null
};
	["SourcePageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null
};
	["RedirectOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	targetUrl?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	target?:ValueTypes["LinkableOrderBy"] | null
};
	["PageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null
};
	["VenueOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null
};
	["EventLabelConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["EventLabelEdge"],
		__typename?: true
}>;
	["PageInfo"]: AliasType<{
	totalCount?:true,
		__typename?: true
}>;
	["EventLabelEdge"]: AliasType<{
	node?:ValueTypes["EventLabel"],
		__typename?: true
}>;
	["FrontPage"]: AliasType<{
	_meta?:ValueTypes["FrontPageMeta"],
	id?:true,
	unique?:true,
	title?:true,
	openingText?:true,
	eventsTitle?:true,
firstLink?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
secondLink?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
	subtitle?:true,
	projectSupport?:true,
	projectAuspices?:true,
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
gallery?: [{	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["Gallery"]],
		__typename?: true
}>;
	["FrontPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	openingText?:ValueTypes["FieldMeta"],
	eventsTitle?:ValueTypes["FieldMeta"],
	firstLink?:ValueTypes["FieldMeta"],
	secondLink?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	subtitle?:ValueTypes["FieldMeta"],
	projectSupport?:ValueTypes["FieldMeta"],
	projectAuspices?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	gallery?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Gallery"]: AliasType<{
	_meta?:ValueTypes["GalleryMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["GalleryItemWhere"] | null,	orderBy?:ValueTypes["GalleryItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["GalleryItem"]],
paginateItems?: [{	filter?:ValueTypes["GalleryItemWhere"] | null,	orderBy?:ValueTypes["GalleryItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GalleryItemConnection"]],
		__typename?: true
}>;
	["GalleryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["GalleryItem"]: AliasType<{
	_meta?:ValueTypes["GalleryItemMeta"],
	id?:true,
	order?:true,
list?: [{	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["Gallery"]],
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: true
}>;
	["GalleryItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["GalleryItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["GalleryOrderBy"] | null,
	image?:ValueTypes["ImageOrderBy"] | null
};
	["GalleryItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GalleryItemEdge"],
		__typename?: true
}>;
	["GalleryItemEdge"]: AliasType<{
	node?:ValueTypes["GalleryItem"],
		__typename?: true
}>;
	["SpecialEvent"]: AliasType<{
	_meta?:ValueTypes["SpecialEventMeta"],
	id?:true,
	title?:true,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
	imageNote?:true,
	openingText?:true,
	subtitle?:true,
	unique?:true,
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
		__typename?: true
}>;
	["SpecialEventMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	imageNote?:ValueTypes["FieldMeta"],
	openingText?:ValueTypes["FieldMeta"],
	subtitle?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["TimelinePage"]: AliasType<{
	_meta?:ValueTypes["TimelinePageMeta"],
	id?:true,
	title?:true,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
	unique?:true,
		__typename?: true
}>;
	["TimelinePageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["SourcePage"]: AliasType<{
	_meta?:ValueTypes["SourcePageMeta"],
	id?:true,
	unique?:true,
	title?:true,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
links?: [{	filter?:ValueTypes["SourcePostLinkWhere"] | null,	orderBy?:ValueTypes["SourcePostLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SourcePostLink"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
paginateLinks?: [{	filter?:ValueTypes["SourcePostLinkWhere"] | null,	orderBy?:ValueTypes["SourcePostLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SourcePostLinkConnection"]],
		__typename?: true
}>;
	["SourcePageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	links?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["SourcePostLink"]: AliasType<{
	_meta?:ValueTypes["SourcePostLinkMeta"],
	id?:true,
	title?:true,
	order?:true,
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
		__typename?: true
}>;
	["SourcePostLinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["SourcePostLinkOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkOrderBy"] | null
};
	["SourcePostLinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SourcePostLinkEdge"],
		__typename?: true
}>;
	["SourcePostLinkEdge"]: AliasType<{
	node?:ValueTypes["SourcePostLink"],
		__typename?: true
}>;
	["Redirect"]: AliasType<{
	_meta?:ValueTypes["RedirectMeta"],
	id?:true,
	targetUrl?:true,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
target?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
		__typename?: true
}>;
	["RedirectMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	targetUrl?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	target?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Page"]: AliasType<{
	_meta?:ValueTypes["PageMeta"],
	id?:true,
	order?:true,
	title?:true,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
		__typename?: true
}>;
	["PageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["CardMedia"]: AliasType<{
	_meta?:ValueTypes["CardMediaMeta"],
	id?:true,
	text?:true,
	imageNote?:true,
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: true
}>;
	["CardMediaMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	imageNote?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ContentReferenceOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	block?:ValueTypes["ContentBlockOrderBy"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	link?:ValueTypes["LinkOrderBy"] | null,
	cardMedia?:ValueTypes["CardMediaOrderBy"] | null
};
	["ContentBlockOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	json?:ValueTypes["OrderDirection"] | null,
	content?:ValueTypes["ContentOrderBy"] | null
};
	["CardMediaOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	imageNote?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null
};
	["ContentBlockReferencesByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["LinkUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ContentReferenceConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentReferenceEdge"],
		__typename?: true
}>;
	["ContentReferenceEdge"]: AliasType<{
	node?:ValueTypes["ContentReference"],
		__typename?: true
}>;
	["ContentBlocksByReferencesUniqueWhere"]: {
	references?:ValueTypes["ContentReferenceUniqueWhere"] | null
};
	["ContentReferenceUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["ContentBlockConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentBlockEdge"],
		__typename?: true
}>;
	["ContentBlockEdge"]: AliasType<{
	node?:ValueTypes["ContentBlock"],
		__typename?: true
}>;
	["ContentUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	blocks?:ValueTypes["ContentBlockUniqueWhere"] | null
};
	["ContentBlockUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	references?:ValueTypes["ContentReferenceUniqueWhere"] | null
};
	["ContentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentEdge"],
		__typename?: true
}>;
	["ContentEdge"]: AliasType<{
	node?:ValueTypes["Content"],
		__typename?: true
}>;
	["_ValidationResult"]: AliasType<{
	valid?:true,
	errors?:ValueTypes["_ValidationError"],
		__typename?: true
}>;
	["_ValidationError"]: AliasType<{
	path?:ValueTypes["_PathFragment"],
	message?:ValueTypes["_ValidationMessage"],
		__typename?: true
}>;
	["_PathFragment"]: AliasType<{		["...on _FieldPathFragment"] : ValueTypes["_FieldPathFragment"],
		["...on _IndexPathFragment"] : ValueTypes["_IndexPathFragment"]
		__typename?: true
}>;
	["_FieldPathFragment"]: AliasType<{
	field?:true,
		__typename?: true
}>;
	["_IndexPathFragment"]: AliasType<{
	index?:true,
	alias?:true,
		__typename?: true
}>;
	["_ValidationMessage"]: AliasType<{
	text?:true,
		__typename?: true
}>;
	["ContentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	blocks?:ValueTypes["ContentCreateBlocksEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentCreateBlocksEntityRelationInput"]: {
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	create?:ValueTypes["ContentBlockWithoutContentCreateInput"] | null,
	alias?:string | null
};
	["ContentBlockWithoutContentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	references?:ValueTypes["ContentBlockCreateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentBlockCreateReferencesEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceWithoutBlockCreateInput"] | null,
	alias?:string | null
};
	["ContentReferenceWithoutBlockCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	text?:string | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | null,
	cardMedia?:ValueTypes["ContentReferenceCreateCardMediaEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ImageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ImageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	width?:number | null,
	height?:number | null,
	size?:number | null,
	type?:string | null,
	alt?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["LinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["LinkType"] | null,
	title?:string | null,
	externalLink?:string | null,
	internalLink?:ValueTypes["LinkCreateInternalLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkCreateInternalLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["LinkableUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	event?:ValueTypes["EventUniqueWhere"] | null,
	frontPage?:ValueTypes["FrontPageUniqueWhere"] | null,
	specialEvent?:ValueTypes["SpecialEventUniqueWhere"] | null,
	timelinePage?:ValueTypes["TimelinePageUniqueWhere"] | null,
	sourcePage?:ValueTypes["SourcePageUniqueWhere"] | null,
	redirect?:ValueTypes["RedirectUniqueWhere"] | null,
	page?:ValueTypes["PageUniqueWhere"] | null
};
	["EventUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	image?:ValueTypes["ImageUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	linkForEvent?:ValueTypes["LinkUniqueWhere"] | null,
	eventLabels?:ValueTypes["EventLabelUniqueWhere"] | null
};
	["SeoUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	ogImage?:ValueTypes["ImageUniqueWhere"] | null
};
	["EventLabelUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["FrontPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	firstLink?:ValueTypes["LinkUniqueWhere"] | null,
	secondLink?:ValueTypes["LinkUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	image?:ValueTypes["ImageUniqueWhere"] | null,
	gallery?:ValueTypes["GalleryUniqueWhere"] | null
};
	["GalleryUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["GalleryItemUniqueWhere"] | null
};
	["GalleryItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["SpecialEventUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	image?:ValueTypes["ImageUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null
};
	["TimelinePageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["SourcePageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["RedirectUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["PageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["LinkableCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	event?:ValueTypes["LinkableCreateEventEntityRelationInput"] | null,
	frontPage?:ValueTypes["LinkableCreateFrontPageEntityRelationInput"] | null,
	specialEvent?:ValueTypes["LinkableCreateSpecialEventEntityRelationInput"] | null,
	timelinePage?:ValueTypes["LinkableCreateTimelinePageEntityRelationInput"] | null,
	sourcePage?:ValueTypes["LinkableCreateSourcePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	page?:ValueTypes["LinkableCreatePageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableCreateEventEntityRelationInput"]: {
	connect?:ValueTypes["EventUniqueWhere"] | null,
	create?:ValueTypes["EventWithoutLinkCreateInput"] | null
};
	["EventWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	place?:string | null,
	entrance?:string | null,
	image?:ValueTypes["EventCreateImageEntityRelationInput"] | null,
	seo?:ValueTypes["EventCreateSeoEntityRelationInput"] | null,
	content?:ValueTypes["EventCreateContentEntityRelationInput"] | null,
	date?:string | null,
	order?:number | null,
	linkForEvent?:ValueTypes["EventCreateLinkForEventEntityRelationInput"] | null,
	venue?:ValueTypes["EventCreateVenueEntityRelationInput"] | null,
	pastEvent?:boolean | null,
	eventLabels?:ValueTypes["EventCreateEventLabelsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["EventCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["EventCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["SeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoCreateOgImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoCreateOgImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["EventCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["EventCreateLinkForEventEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["EventCreateVenueEntityRelationInput"]: {
	connect?:ValueTypes["VenueUniqueWhere"] | null,
	create?:ValueTypes["VenueCreateInput"] | null
};
	["VenueUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["VenueCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["EventCreateEventLabelsEntityRelationInput"]: {
	connect?:ValueTypes["EventLabelUniqueWhere"] | null,
	create?:ValueTypes["EventLabelWithoutEventCreateInput"] | null,
	alias?:string | null
};
	["EventLabelWithoutEventCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	text?:string | null,
	_dummy_field_?:boolean | null
};
	["LinkableCreateFrontPageEntityRelationInput"]: {
	connect?:ValueTypes["FrontPageUniqueWhere"] | null,
	create?:ValueTypes["FrontPageWithoutLinkCreateInput"] | null
};
	["FrontPageWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	openingText?:string | null,
	eventsTitle?:string | null,
	firstLink?:ValueTypes["FrontPageCreateFirstLinkEntityRelationInput"] | null,
	secondLink?:ValueTypes["FrontPageCreateSecondLinkEntityRelationInput"] | null,
	seo?:ValueTypes["FrontPageCreateSeoEntityRelationInput"] | null,
	subtitle?:string | null,
	projectSupport?:string | null,
	projectAuspices?:string | null,
	image?:ValueTypes["FrontPageCreateImageEntityRelationInput"] | null,
	gallery?:ValueTypes["FrontPageCreateGalleryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FrontPageCreateFirstLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["FrontPageCreateSecondLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["FrontPageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["FrontPageCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["FrontPageCreateGalleryEntityRelationInput"]: {
	connect?:ValueTypes["GalleryUniqueWhere"] | null,
	create?:ValueTypes["GalleryCreateInput"] | null
};
	["GalleryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["GalleryCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["GalleryCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["GalleryItemUniqueWhere"] | null,
	create?:ValueTypes["GalleryItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["GalleryItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	image?:ValueTypes["GalleryItemCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GalleryItemCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["LinkableCreateSpecialEventEntityRelationInput"]: {
	connect?:ValueTypes["SpecialEventUniqueWhere"] | null,
	create?:ValueTypes["SpecialEventWithoutLinkCreateInput"] | null
};
	["SpecialEventWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	image?:ValueTypes["SpecialEventCreateImageEntityRelationInput"] | null,
	seo?:ValueTypes["SpecialEventCreateSeoEntityRelationInput"] | null,
	imageNote?:string | null,
	openingText?:string | null,
	subtitle?:string | null,
	unique?:ValueTypes["One"] | null,
	content?:ValueTypes["SpecialEventCreateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SpecialEventCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["SpecialEventCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["SpecialEventCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["LinkableCreateTimelinePageEntityRelationInput"]: {
	connect?:ValueTypes["TimelinePageUniqueWhere"] | null,
	create?:ValueTypes["TimelinePageWithoutLinkCreateInput"] | null
};
	["TimelinePageWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	seo?:ValueTypes["TimelinePageCreateSeoEntityRelationInput"] | null,
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["TimelinePageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LinkableCreateSourcePageEntityRelationInput"]: {
	connect?:ValueTypes["SourcePageUniqueWhere"] | null,
	create?:ValueTypes["SourcePageWithoutLinkCreateInput"] | null
};
	["SourcePageWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	links?:ValueTypes["SourcePageCreateLinksEntityRelationInput"][],
	seo?:ValueTypes["SourcePageCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SourcePageCreateLinksEntityRelationInput"]: {
	connect?:ValueTypes["SourcePostLinkUniqueWhere"] | null,
	create?:ValueTypes["SourcePostLinkCreateInput"] | null,
	alias?:string | null
};
	["SourcePostLinkUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["SourcePostLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	order?:number | null,
	link?:ValueTypes["SourcePostLinkCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SourcePostLinkCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["SourcePageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LinkableCreateRedirectEntityRelationInput"]: {
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	create?:ValueTypes["RedirectWithoutLinkCreateInput"] | null
};
	["RedirectWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	targetUrl?:string | null,
	target?:ValueTypes["RedirectCreateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectCreateTargetEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["LinkableCreatePageEntityRelationInput"]: {
	connect?:ValueTypes["PageUniqueWhere"] | null,
	create?:ValueTypes["PageWithoutLinkCreateInput"] | null
};
	["PageWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	title?:string | null,
	content?:ValueTypes["PageCreateContentEntityRelationInput"] | null,
	seo?:ValueTypes["PageCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PageCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["PageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["ContentReferenceCreateCardMediaEntityRelationInput"]: {
	connect?:ValueTypes["CardMediaUniqueWhere"] | null,
	create?:ValueTypes["CardMediaCreateInput"] | null
};
	["CardMediaUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["CardMediaCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	text?:string | null,
	imageNote?:string | null,
	image?:ValueTypes["CardMediaCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["CardMediaCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContentUpdateInput"]: {
	blocks?:ValueTypes["ContentUpdateBlocksEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentUpdateBlocksEntityRelationInput"]: {
	create?:ValueTypes["ContentBlockWithoutContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateBlocksRelationInput"] | null,
	upsert?:ValueTypes["ContentUpsertBlocksRelationInput"] | null,
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	delete?:ValueTypes["ContentBlockUniqueWhere"] | null,
	alias?:string | null
};
	["ContentUpdateBlocksRelationInput"]: {
	by?:ValueTypes["ContentBlockUniqueWhere"] | null,
	data?:ValueTypes["ContentBlockWithoutContentUpdateInput"] | null
};
	["ContentBlockWithoutContentUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	references?:ValueTypes["ContentBlockUpdateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentBlockUpdateReferencesEntityRelationInput"]: {
	create?:ValueTypes["ContentReferenceWithoutBlockCreateInput"] | null,
	update?:ValueTypes["ContentBlockUpdateReferencesRelationInput"] | null,
	upsert?:ValueTypes["ContentBlockUpsertReferencesRelationInput"] | null,
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	delete?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	alias?:string | null
};
	["ContentBlockUpdateReferencesRelationInput"]: {
	by?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	data?:ValueTypes["ContentReferenceWithoutBlockUpdateInput"] | null
};
	["ContentReferenceWithoutBlockUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	text?:string | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | null,
	cardMedia?:ValueTypes["ContentReferenceUpdateCardMediaEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ImageUpdateInput"]: {
	url?:string | null,
	width?:number | null,
	height?:number | null,
	size?:number | null,
	type?:string | null,
	alt?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContentReferenceUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkUpdateInput"]: {
	type?:ValueTypes["LinkType"] | null,
	title?:string | null,
	externalLink?:string | null,
	internalLink?:ValueTypes["LinkUpdateInternalLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkUpdateInternalLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableCreateInput"] | null,
	update?:ValueTypes["LinkableUpdateInput"] | null,
	upsert?:ValueTypes["LinkUpsertInternalLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableUpdateInput"]: {
	url?:string | null,
	event?:ValueTypes["LinkableUpdateEventEntityRelationInput"] | null,
	frontPage?:ValueTypes["LinkableUpdateFrontPageEntityRelationInput"] | null,
	specialEvent?:ValueTypes["LinkableUpdateSpecialEventEntityRelationInput"] | null,
	timelinePage?:ValueTypes["LinkableUpdateTimelinePageEntityRelationInput"] | null,
	sourcePage?:ValueTypes["LinkableUpdateSourcePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	page?:ValueTypes["LinkableUpdatePageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableUpdateEventEntityRelationInput"]: {
	create?:ValueTypes["EventWithoutLinkCreateInput"] | null,
	update?:ValueTypes["EventWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertEventRelationInput"] | null,
	connect?:ValueTypes["EventUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["EventWithoutLinkUpdateInput"]: {
	title?:string | null,
	place?:string | null,
	entrance?:string | null,
	image?:ValueTypes["EventUpdateImageEntityRelationInput"] | null,
	seo?:ValueTypes["EventUpdateSeoEntityRelationInput"] | null,
	content?:ValueTypes["EventUpdateContentEntityRelationInput"] | null,
	date?:string | null,
	order?:number | null,
	linkForEvent?:ValueTypes["EventUpdateLinkForEventEntityRelationInput"] | null,
	venue?:ValueTypes["EventUpdateVenueEntityRelationInput"] | null,
	pastEvent?:boolean | null,
	eventLabels?:ValueTypes["EventUpdateEventLabelsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["EventUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["EventUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["EventUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["EventUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["EventUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoUpdateOgImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoUpdateOgImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["SeoUpsertOgImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoUpsertOgImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["EventUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["EventUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["EventUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["EventUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentUpdateInput"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["EventUpdateLinkForEventEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["EventUpsertLinkForEventRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["EventUpsertLinkForEventRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["EventUpdateVenueEntityRelationInput"]: {
	create?:ValueTypes["VenueCreateInput"] | null,
	update?:ValueTypes["VenueUpdateInput"] | null,
	upsert?:ValueTypes["EventUpsertVenueRelationInput"] | null,
	connect?:ValueTypes["VenueUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["VenueUpdateInput"]: {
	name?:string | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["EventUpsertVenueRelationInput"]: {
	update?:ValueTypes["VenueUpdateInput"] | null,
	create?:ValueTypes["VenueCreateInput"] | null
};
	["EventUpdateEventLabelsEntityRelationInput"]: {
	create?:ValueTypes["EventLabelWithoutEventCreateInput"] | null,
	update?:ValueTypes["EventUpdateEventLabelsRelationInput"] | null,
	upsert?:ValueTypes["EventUpsertEventLabelsRelationInput"] | null,
	connect?:ValueTypes["EventLabelUniqueWhere"] | null,
	disconnect?:ValueTypes["EventLabelUniqueWhere"] | null,
	delete?:ValueTypes["EventLabelUniqueWhere"] | null,
	alias?:string | null
};
	["EventUpdateEventLabelsRelationInput"]: {
	by?:ValueTypes["EventLabelUniqueWhere"] | null,
	data?:ValueTypes["EventLabelWithoutEventUpdateInput"] | null
};
	["EventLabelWithoutEventUpdateInput"]: {
	order?:number | null,
	text?:string | null,
	_dummy_field_?:boolean | null
};
	["EventUpsertEventLabelsRelationInput"]: {
	by?:ValueTypes["EventLabelUniqueWhere"] | null,
	update?:ValueTypes["EventLabelWithoutEventUpdateInput"] | null,
	create?:ValueTypes["EventLabelWithoutEventCreateInput"] | null
};
	["LinkableUpsertEventRelationInput"]: {
	update?:ValueTypes["EventWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["EventWithoutLinkCreateInput"] | null
};
	["LinkableUpdateFrontPageEntityRelationInput"]: {
	create?:ValueTypes["FrontPageWithoutLinkCreateInput"] | null,
	update?:ValueTypes["FrontPageWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertFrontPageRelationInput"] | null,
	connect?:ValueTypes["FrontPageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FrontPageWithoutLinkUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	openingText?:string | null,
	eventsTitle?:string | null,
	firstLink?:ValueTypes["FrontPageUpdateFirstLinkEntityRelationInput"] | null,
	secondLink?:ValueTypes["FrontPageUpdateSecondLinkEntityRelationInput"] | null,
	seo?:ValueTypes["FrontPageUpdateSeoEntityRelationInput"] | null,
	subtitle?:string | null,
	projectSupport?:string | null,
	projectAuspices?:string | null,
	image?:ValueTypes["FrontPageUpdateImageEntityRelationInput"] | null,
	gallery?:ValueTypes["FrontPageUpdateGalleryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FrontPageUpdateFirstLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["FrontPageUpsertFirstLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FrontPageUpsertFirstLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["FrontPageUpdateSecondLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["FrontPageUpsertSecondLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FrontPageUpsertSecondLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["FrontPageUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["FrontPageUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FrontPageUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["FrontPageUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["FrontPageUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FrontPageUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["FrontPageUpdateGalleryEntityRelationInput"]: {
	create?:ValueTypes["GalleryCreateInput"] | null,
	update?:ValueTypes["GalleryUpdateInput"] | null,
	upsert?:ValueTypes["FrontPageUpsertGalleryRelationInput"] | null,
	connect?:ValueTypes["GalleryUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["GalleryUpdateInput"]: {
	items?:ValueTypes["GalleryUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["GalleryUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["GalleryItemWithoutListCreateInput"] | null,
	update?:ValueTypes["GalleryUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["GalleryUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["GalleryItemUniqueWhere"] | null,
	disconnect?:ValueTypes["GalleryItemUniqueWhere"] | null,
	delete?:ValueTypes["GalleryItemUniqueWhere"] | null,
	alias?:string | null
};
	["GalleryUpdateItemsRelationInput"]: {
	by?:ValueTypes["GalleryItemUniqueWhere"] | null,
	data?:ValueTypes["GalleryItemWithoutListUpdateInput"] | null
};
	["GalleryItemWithoutListUpdateInput"]: {
	order?:number | null,
	image?:ValueTypes["GalleryItemUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GalleryItemUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["GalleryItemUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["GalleryItemUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["GalleryUpsertItemsRelationInput"]: {
	by?:ValueTypes["GalleryItemUniqueWhere"] | null,
	update?:ValueTypes["GalleryItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["GalleryItemWithoutListCreateInput"] | null
};
	["FrontPageUpsertGalleryRelationInput"]: {
	update?:ValueTypes["GalleryUpdateInput"] | null,
	create?:ValueTypes["GalleryCreateInput"] | null
};
	["LinkableUpsertFrontPageRelationInput"]: {
	update?:ValueTypes["FrontPageWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["FrontPageWithoutLinkCreateInput"] | null
};
	["LinkableUpdateSpecialEventEntityRelationInput"]: {
	create?:ValueTypes["SpecialEventWithoutLinkCreateInput"] | null,
	update?:ValueTypes["SpecialEventWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertSpecialEventRelationInput"] | null,
	connect?:ValueTypes["SpecialEventUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SpecialEventWithoutLinkUpdateInput"]: {
	title?:string | null,
	image?:ValueTypes["SpecialEventUpdateImageEntityRelationInput"] | null,
	seo?:ValueTypes["SpecialEventUpdateSeoEntityRelationInput"] | null,
	imageNote?:string | null,
	openingText?:string | null,
	subtitle?:string | null,
	unique?:ValueTypes["One"] | null,
	content?:ValueTypes["SpecialEventUpdateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SpecialEventUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["SpecialEventUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SpecialEventUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["SpecialEventUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["SpecialEventUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SpecialEventUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["SpecialEventUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["SpecialEventUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SpecialEventUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentUpdateInput"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["LinkableUpsertSpecialEventRelationInput"]: {
	update?:ValueTypes["SpecialEventWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["SpecialEventWithoutLinkCreateInput"] | null
};
	["LinkableUpdateTimelinePageEntityRelationInput"]: {
	create?:ValueTypes["TimelinePageWithoutLinkCreateInput"] | null,
	update?:ValueTypes["TimelinePageWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertTimelinePageRelationInput"] | null,
	connect?:ValueTypes["TimelinePageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["TimelinePageWithoutLinkUpdateInput"]: {
	title?:string | null,
	seo?:ValueTypes["TimelinePageUpdateSeoEntityRelationInput"] | null,
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["TimelinePageUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["TimelinePageUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["TimelinePageUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LinkableUpsertTimelinePageRelationInput"]: {
	update?:ValueTypes["TimelinePageWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["TimelinePageWithoutLinkCreateInput"] | null
};
	["LinkableUpdateSourcePageEntityRelationInput"]: {
	create?:ValueTypes["SourcePageWithoutLinkCreateInput"] | null,
	update?:ValueTypes["SourcePageWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertSourcePageRelationInput"] | null,
	connect?:ValueTypes["SourcePageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SourcePageWithoutLinkUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	links?:ValueTypes["SourcePageUpdateLinksEntityRelationInput"][],
	seo?:ValueTypes["SourcePageUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SourcePageUpdateLinksEntityRelationInput"]: {
	create?:ValueTypes["SourcePostLinkCreateInput"] | null,
	update?:ValueTypes["SourcePageUpdateLinksRelationInput"] | null,
	upsert?:ValueTypes["SourcePageUpsertLinksRelationInput"] | null,
	connect?:ValueTypes["SourcePostLinkUniqueWhere"] | null,
	disconnect?:ValueTypes["SourcePostLinkUniqueWhere"] | null,
	delete?:ValueTypes["SourcePostLinkUniqueWhere"] | null,
	alias?:string | null
};
	["SourcePageUpdateLinksRelationInput"]: {
	by?:ValueTypes["SourcePostLinkUniqueWhere"] | null,
	data?:ValueTypes["SourcePostLinkUpdateInput"] | null
};
	["SourcePostLinkUpdateInput"]: {
	title?:string | null,
	order?:number | null,
	link?:ValueTypes["SourcePostLinkUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SourcePostLinkUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["SourcePostLinkUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SourcePostLinkUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["SourcePageUpsertLinksRelationInput"]: {
	by?:ValueTypes["SourcePostLinkUniqueWhere"] | null,
	update?:ValueTypes["SourcePostLinkUpdateInput"] | null,
	create?:ValueTypes["SourcePostLinkCreateInput"] | null
};
	["SourcePageUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["SourcePageUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SourcePageUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LinkableUpsertSourcePageRelationInput"]: {
	update?:ValueTypes["SourcePageWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["SourcePageWithoutLinkCreateInput"] | null
};
	["LinkableUpdateRedirectEntityRelationInput"]: {
	create?:ValueTypes["RedirectWithoutLinkCreateInput"] | null,
	update?:ValueTypes["RedirectWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertRedirectRelationInput"] | null,
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["RedirectWithoutLinkUpdateInput"]: {
	targetUrl?:string | null,
	target?:ValueTypes["RedirectUpdateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpdateTargetEntityRelationInput"]: {
	create?:ValueTypes["LinkableCreateInput"] | null,
	update?:ValueTypes["LinkableUpdateInput"] | null,
	upsert?:ValueTypes["RedirectUpsertTargetRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["RedirectUpsertTargetRelationInput"]: {
	update?:ValueTypes["LinkableUpdateInput"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["LinkableUpsertRedirectRelationInput"]: {
	update?:ValueTypes["RedirectWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["RedirectWithoutLinkCreateInput"] | null
};
	["LinkableUpdatePageEntityRelationInput"]: {
	create?:ValueTypes["PageWithoutLinkCreateInput"] | null,
	update?:ValueTypes["PageWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertPageRelationInput"] | null,
	connect?:ValueTypes["PageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PageWithoutLinkUpdateInput"]: {
	order?:number | null,
	title?:string | null,
	content?:ValueTypes["PageUpdateContentEntityRelationInput"] | null,
	seo?:ValueTypes["PageUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PageUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["PageUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PageUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentUpdateInput"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["PageUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["PageUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PageUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LinkableUpsertPageRelationInput"]: {
	update?:ValueTypes["PageWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["PageWithoutLinkCreateInput"] | null
};
	["LinkUpsertInternalLinkRelationInput"]: {
	update?:ValueTypes["LinkableUpdateInput"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["ContentReferenceUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ContentReferenceUpdateCardMediaEntityRelationInput"]: {
	create?:ValueTypes["CardMediaCreateInput"] | null,
	update?:ValueTypes["CardMediaUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertCardMediaRelationInput"] | null,
	connect?:ValueTypes["CardMediaUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["CardMediaUpdateInput"]: {
	text?:string | null,
	imageNote?:string | null,
	image?:ValueTypes["CardMediaUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["CardMediaUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["CardMediaUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["CardMediaUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContentReferenceUpsertCardMediaRelationInput"]: {
	update?:ValueTypes["CardMediaUpdateInput"] | null,
	create?:ValueTypes["CardMediaCreateInput"] | null
};
	["ContentBlockUpsertReferencesRelationInput"]: {
	by?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	update?:ValueTypes["ContentReferenceWithoutBlockUpdateInput"] | null,
	create?:ValueTypes["ContentReferenceWithoutBlockCreateInput"] | null
};
	["ContentUpsertBlocksRelationInput"]: {
	by?:ValueTypes["ContentBlockUniqueWhere"] | null,
	update?:ValueTypes["ContentBlockWithoutContentUpdateInput"] | null,
	create?:ValueTypes["ContentBlockWithoutContentCreateInput"] | null
};
	["ContentBlockCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentBlockCreateContentEntityRelationInput"] | null,
	references?:ValueTypes["ContentBlockCreateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentBlockCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentWithoutBlocksCreateInput"] | null
};
	["ContentWithoutBlocksCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["ContentBlockUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentBlockUpdateContentEntityRelationInput"] | null,
	references?:ValueTypes["ContentBlockUpdateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentBlockUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentWithoutBlocksCreateInput"] | null,
	update?:ValueTypes["ContentWithoutBlocksUpdateInput"] | null,
	upsert?:ValueTypes["ContentBlockUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	delete?:boolean | null
};
	["ContentWithoutBlocksUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["ContentBlockUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentWithoutBlocksUpdateInput"] | null,
	create?:ValueTypes["ContentWithoutBlocksCreateInput"] | null
};
	["ContentReferenceCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	text?:string | null,
	block?:ValueTypes["ContentReferenceCreateBlockEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | null,
	cardMedia?:ValueTypes["ContentReferenceCreateCardMediaEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateBlockEntityRelationInput"]: {
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	create?:ValueTypes["ContentBlockWithoutReferencesCreateInput"] | null
};
	["ContentBlockWithoutReferencesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentBlockCreateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	text?:string | null,
	block?:ValueTypes["ContentReferenceUpdateBlockEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | null,
	cardMedia?:ValueTypes["ContentReferenceUpdateCardMediaEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpdateBlockEntityRelationInput"]: {
	create?:ValueTypes["ContentBlockWithoutReferencesCreateInput"] | null,
	update?:ValueTypes["ContentBlockWithoutReferencesUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertBlockRelationInput"] | null,
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	delete?:boolean | null
};
	["ContentBlockWithoutReferencesUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentBlockUpdateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpsertBlockRelationInput"]: {
	update?:ValueTypes["ContentBlockWithoutReferencesUpdateInput"] | null,
	create?:ValueTypes["ContentBlockWithoutReferencesCreateInput"] | null
};
	["EventConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["EventEdge"],
		__typename?: true
}>;
	["EventEdge"]: AliasType<{
	node?:ValueTypes["Event"],
		__typename?: true
}>;
	["EventCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	place?:string | null,
	entrance?:string | null,
	image?:ValueTypes["EventCreateImageEntityRelationInput"] | null,
	seo?:ValueTypes["EventCreateSeoEntityRelationInput"] | null,
	link?:ValueTypes["EventCreateLinkEntityRelationInput"] | null,
	content?:ValueTypes["EventCreateContentEntityRelationInput"] | null,
	date?:string | null,
	order?:number | null,
	linkForEvent?:ValueTypes["EventCreateLinkForEventEntityRelationInput"] | null,
	venue?:ValueTypes["EventCreateVenueEntityRelationInput"] | null,
	pastEvent?:boolean | null,
	eventLabels?:ValueTypes["EventCreateEventLabelsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["EventCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutEventCreateInput"] | null
};
	["LinkableWithoutEventCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	frontPage?:ValueTypes["LinkableCreateFrontPageEntityRelationInput"] | null,
	specialEvent?:ValueTypes["LinkableCreateSpecialEventEntityRelationInput"] | null,
	timelinePage?:ValueTypes["LinkableCreateTimelinePageEntityRelationInput"] | null,
	sourcePage?:ValueTypes["LinkableCreateSourcePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	page?:ValueTypes["LinkableCreatePageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EventUpdateInput"]: {
	title?:string | null,
	place?:string | null,
	entrance?:string | null,
	image?:ValueTypes["EventUpdateImageEntityRelationInput"] | null,
	seo?:ValueTypes["EventUpdateSeoEntityRelationInput"] | null,
	link?:ValueTypes["EventUpdateLinkEntityRelationInput"] | null,
	content?:ValueTypes["EventUpdateContentEntityRelationInput"] | null,
	date?:string | null,
	order?:number | null,
	linkForEvent?:ValueTypes["EventUpdateLinkForEventEntityRelationInput"] | null,
	venue?:ValueTypes["EventUpdateVenueEntityRelationInput"] | null,
	pastEvent?:boolean | null,
	eventLabels?:ValueTypes["EventUpdateEventLabelsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["EventUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutEventCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutEventUpdateInput"] | null,
	upsert?:ValueTypes["EventUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutEventUpdateInput"]: {
	url?:string | null,
	frontPage?:ValueTypes["LinkableUpdateFrontPageEntityRelationInput"] | null,
	specialEvent?:ValueTypes["LinkableUpdateSpecialEventEntityRelationInput"] | null,
	timelinePage?:ValueTypes["LinkableUpdateTimelinePageEntityRelationInput"] | null,
	sourcePage?:ValueTypes["LinkableUpdateSourcePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	page?:ValueTypes["LinkableUpdatePageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EventUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutEventUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutEventCreateInput"] | null
};
	["FallbackSeo"]: AliasType<{
	_meta?:ValueTypes["FallbackSeoMeta"],
	id?:true,
	unique?:true,
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
		__typename?: true
}>;
	["FallbackSeoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["FallbackSeoUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["FallbackSeoWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	and?:(ValueTypes["FallbackSeoWhere"] | undefined | null)[],
	or?:(ValueTypes["FallbackSeoWhere"] | undefined | null)[],
	not?:ValueTypes["FallbackSeoWhere"] | null
};
	["FallbackSeoOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null
};
	["FallbackSeoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FallbackSeoEdge"],
		__typename?: true
}>;
	["FallbackSeoEdge"]: AliasType<{
	node?:ValueTypes["FallbackSeo"],
		__typename?: true
}>;
	["FallbackSeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["FallbackSeoCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FallbackSeoCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["FallbackSeoUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["FallbackSeoUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FallbackSeoUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["FallbackSeoUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FallbackSeoUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["Footer"]: AliasType<{
	_meta?:ValueTypes["FooterMeta"],
	id?:true,
	unique?:true,
	projectSupport?:true,
	projectAuspices?:true,
gallery?: [{	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["Gallery"]],
		__typename?: true
}>;
	["FooterMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	projectSupport?:ValueTypes["FieldMeta"],
	projectAuspices?:ValueTypes["FieldMeta"],
	gallery?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["FooterUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	gallery?:ValueTypes["GalleryUniqueWhere"] | null
};
	["FooterWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	projectSupport?:ValueTypes["StringCondition"] | null,
	projectAuspices?:ValueTypes["StringCondition"] | null,
	gallery?:ValueTypes["GalleryWhere"] | null,
	and?:(ValueTypes["FooterWhere"] | undefined | null)[],
	or?:(ValueTypes["FooterWhere"] | undefined | null)[],
	not?:ValueTypes["FooterWhere"] | null
};
	["FooterOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	projectSupport?:ValueTypes["OrderDirection"] | null,
	projectAuspices?:ValueTypes["OrderDirection"] | null,
	gallery?:ValueTypes["GalleryOrderBy"] | null
};
	["FooterConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FooterEdge"],
		__typename?: true
}>;
	["FooterEdge"]: AliasType<{
	node?:ValueTypes["Footer"],
		__typename?: true
}>;
	["FooterCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	projectSupport?:string | null,
	projectAuspices?:string | null,
	gallery?:ValueTypes["FooterCreateGalleryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterCreateGalleryEntityRelationInput"]: {
	connect?:ValueTypes["GalleryUniqueWhere"] | null,
	create?:ValueTypes["GalleryCreateInput"] | null
};
	["FooterUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	projectSupport?:string | null,
	projectAuspices?:string | null,
	gallery?:ValueTypes["FooterUpdateGalleryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterUpdateGalleryEntityRelationInput"]: {
	create?:ValueTypes["GalleryCreateInput"] | null,
	update?:ValueTypes["GalleryUpdateInput"] | null,
	upsert?:ValueTypes["FooterUpsertGalleryRelationInput"] | null,
	connect?:ValueTypes["GalleryUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FooterUpsertGalleryRelationInput"]: {
	update?:ValueTypes["GalleryUpdateInput"] | null,
	create?:ValueTypes["GalleryCreateInput"] | null
};
	["Header"]: AliasType<{
	_meta?:ValueTypes["HeaderMeta"],
	id?:true,
	unique?:true,
links?: [{	filter?:ValueTypes["HeaderLinkWhere"] | null,	orderBy?:ValueTypes["HeaderLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HeaderLink"]],
paginateLinks?: [{	filter?:ValueTypes["HeaderLinkWhere"] | null,	orderBy?:ValueTypes["HeaderLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderLinkConnection"]],
		__typename?: true
}>;
	["HeaderMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	links?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["HeaderLink"]: AliasType<{
	_meta?:ValueTypes["HeaderLinkMeta"],
	id?:true,
	order?:true,
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
		__typename?: true
}>;
	["HeaderLinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["HeaderLinkWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	and?:(ValueTypes["HeaderLinkWhere"] | undefined | null)[],
	or?:(ValueTypes["HeaderLinkWhere"] | undefined | null)[],
	not?:ValueTypes["HeaderLinkWhere"] | null
};
	["HeaderLinkOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkOrderBy"] | null
};
	["HeaderLinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HeaderLinkEdge"],
		__typename?: true
}>;
	["HeaderLinkEdge"]: AliasType<{
	node?:ValueTypes["HeaderLink"],
		__typename?: true
}>;
	["HeaderUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null
};
	["HeaderWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	links?:ValueTypes["HeaderLinkWhere"] | null,
	and?:(ValueTypes["HeaderWhere"] | undefined | null)[],
	or?:(ValueTypes["HeaderWhere"] | undefined | null)[],
	not?:ValueTypes["HeaderWhere"] | null
};
	["HeaderOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null
};
	["HeaderConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HeaderEdge"],
		__typename?: true
}>;
	["HeaderEdge"]: AliasType<{
	node?:ValueTypes["Header"],
		__typename?: true
}>;
	["HeaderCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	links?:ValueTypes["HeaderCreateLinksEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["HeaderCreateLinksEntityRelationInput"]: {
	connect?:ValueTypes["HeaderLinkUniqueWhere"] | null,
	create?:ValueTypes["HeaderLinkCreateInput"] | null,
	alias?:string | null
};
	["HeaderLinkUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["HeaderLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	link?:ValueTypes["HeaderLinkCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderLinkCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["HeaderUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	links?:ValueTypes["HeaderUpdateLinksEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["HeaderUpdateLinksEntityRelationInput"]: {
	create?:ValueTypes["HeaderLinkCreateInput"] | null,
	update?:ValueTypes["HeaderUpdateLinksRelationInput"] | null,
	upsert?:ValueTypes["HeaderUpsertLinksRelationInput"] | null,
	connect?:ValueTypes["HeaderLinkUniqueWhere"] | null,
	disconnect?:ValueTypes["HeaderLinkUniqueWhere"] | null,
	delete?:ValueTypes["HeaderLinkUniqueWhere"] | null,
	alias?:string | null
};
	["HeaderUpdateLinksRelationInput"]: {
	by?:ValueTypes["HeaderLinkUniqueWhere"] | null,
	data?:ValueTypes["HeaderLinkUpdateInput"] | null
};
	["HeaderLinkUpdateInput"]: {
	order?:number | null,
	link?:ValueTypes["HeaderLinkUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderLinkUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["HeaderLinkUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HeaderLinkUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["HeaderUpsertLinksRelationInput"]: {
	by?:ValueTypes["HeaderLinkUniqueWhere"] | null,
	update?:ValueTypes["HeaderLinkUpdateInput"] | null,
	create?:ValueTypes["HeaderLinkCreateInput"] | null
};
	["FrontPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FrontPageEdge"],
		__typename?: true
}>;
	["FrontPageEdge"]: AliasType<{
	node?:ValueTypes["FrontPage"],
		__typename?: true
}>;
	["FrontPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	openingText?:string | null,
	eventsTitle?:string | null,
	firstLink?:ValueTypes["FrontPageCreateFirstLinkEntityRelationInput"] | null,
	secondLink?:ValueTypes["FrontPageCreateSecondLinkEntityRelationInput"] | null,
	seo?:ValueTypes["FrontPageCreateSeoEntityRelationInput"] | null,
	link?:ValueTypes["FrontPageCreateLinkEntityRelationInput"] | null,
	subtitle?:string | null,
	projectSupport?:string | null,
	projectAuspices?:string | null,
	image?:ValueTypes["FrontPageCreateImageEntityRelationInput"] | null,
	gallery?:ValueTypes["FrontPageCreateGalleryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FrontPageCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutFrontPageCreateInput"] | null
};
	["LinkableWithoutFrontPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	event?:ValueTypes["LinkableCreateEventEntityRelationInput"] | null,
	specialEvent?:ValueTypes["LinkableCreateSpecialEventEntityRelationInput"] | null,
	timelinePage?:ValueTypes["LinkableCreateTimelinePageEntityRelationInput"] | null,
	sourcePage?:ValueTypes["LinkableCreateSourcePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	page?:ValueTypes["LinkableCreatePageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FrontPageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	openingText?:string | null,
	eventsTitle?:string | null,
	firstLink?:ValueTypes["FrontPageUpdateFirstLinkEntityRelationInput"] | null,
	secondLink?:ValueTypes["FrontPageUpdateSecondLinkEntityRelationInput"] | null,
	seo?:ValueTypes["FrontPageUpdateSeoEntityRelationInput"] | null,
	link?:ValueTypes["FrontPageUpdateLinkEntityRelationInput"] | null,
	subtitle?:string | null,
	projectSupport?:string | null,
	projectAuspices?:string | null,
	image?:ValueTypes["FrontPageUpdateImageEntityRelationInput"] | null,
	gallery?:ValueTypes["FrontPageUpdateGalleryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FrontPageUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutFrontPageCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutFrontPageUpdateInput"] | null,
	upsert?:ValueTypes["FrontPageUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutFrontPageUpdateInput"]: {
	url?:string | null,
	event?:ValueTypes["LinkableUpdateEventEntityRelationInput"] | null,
	specialEvent?:ValueTypes["LinkableUpdateSpecialEventEntityRelationInput"] | null,
	timelinePage?:ValueTypes["LinkableUpdateTimelinePageEntityRelationInput"] | null,
	sourcePage?:ValueTypes["LinkableUpdateSourcePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	page?:ValueTypes["LinkableUpdatePageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FrontPageUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutFrontPageUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutFrontPageCreateInput"] | null
};
	["ImageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageEdge"],
		__typename?: true
}>;
	["ImageEdge"]: AliasType<{
	node?:ValueTypes["Image"],
		__typename?: true
}>;
	["LinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkEdge"],
		__typename?: true
}>;
	["LinkEdge"]: AliasType<{
	node?:ValueTypes["Link"],
		__typename?: true
}>;
	["LinkableConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkableEdge"],
		__typename?: true
}>;
	["LinkableEdge"]: AliasType<{
	node?:ValueTypes["Linkable"],
		__typename?: true
}>;
	["SeoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SeoEdge"],
		__typename?: true
}>;
	["SeoEdge"]: AliasType<{
	node?:ValueTypes["Seo"],
		__typename?: true
}>;
	["SpecialEventConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SpecialEventEdge"],
		__typename?: true
}>;
	["SpecialEventEdge"]: AliasType<{
	node?:ValueTypes["SpecialEvent"],
		__typename?: true
}>;
	["SpecialEventCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	link?:ValueTypes["SpecialEventCreateLinkEntityRelationInput"] | null,
	image?:ValueTypes["SpecialEventCreateImageEntityRelationInput"] | null,
	seo?:ValueTypes["SpecialEventCreateSeoEntityRelationInput"] | null,
	imageNote?:string | null,
	openingText?:string | null,
	subtitle?:string | null,
	unique?:ValueTypes["One"] | null,
	content?:ValueTypes["SpecialEventCreateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SpecialEventCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutSpecialEventCreateInput"] | null
};
	["LinkableWithoutSpecialEventCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	event?:ValueTypes["LinkableCreateEventEntityRelationInput"] | null,
	frontPage?:ValueTypes["LinkableCreateFrontPageEntityRelationInput"] | null,
	timelinePage?:ValueTypes["LinkableCreateTimelinePageEntityRelationInput"] | null,
	sourcePage?:ValueTypes["LinkableCreateSourcePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	page?:ValueTypes["LinkableCreatePageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SpecialEventUpdateInput"]: {
	title?:string | null,
	link?:ValueTypes["SpecialEventUpdateLinkEntityRelationInput"] | null,
	image?:ValueTypes["SpecialEventUpdateImageEntityRelationInput"] | null,
	seo?:ValueTypes["SpecialEventUpdateSeoEntityRelationInput"] | null,
	imageNote?:string | null,
	openingText?:string | null,
	subtitle?:string | null,
	unique?:ValueTypes["One"] | null,
	content?:ValueTypes["SpecialEventUpdateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SpecialEventUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutSpecialEventCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutSpecialEventUpdateInput"] | null,
	upsert?:ValueTypes["SpecialEventUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutSpecialEventUpdateInput"]: {
	url?:string | null,
	event?:ValueTypes["LinkableUpdateEventEntityRelationInput"] | null,
	frontPage?:ValueTypes["LinkableUpdateFrontPageEntityRelationInput"] | null,
	timelinePage?:ValueTypes["LinkableUpdateTimelinePageEntityRelationInput"] | null,
	sourcePage?:ValueTypes["LinkableUpdateSourcePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	page?:ValueTypes["LinkableUpdatePageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SpecialEventUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutSpecialEventUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutSpecialEventCreateInput"] | null
};
	["TimelinePageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TimelinePageEdge"],
		__typename?: true
}>;
	["TimelinePageEdge"]: AliasType<{
	node?:ValueTypes["TimelinePage"],
		__typename?: true
}>;
	["TimelinePageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	link?:ValueTypes["TimelinePageCreateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["TimelinePageCreateSeoEntityRelationInput"] | null,
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["TimelinePageCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutTimelinePageCreateInput"] | null
};
	["LinkableWithoutTimelinePageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	event?:ValueTypes["LinkableCreateEventEntityRelationInput"] | null,
	frontPage?:ValueTypes["LinkableCreateFrontPageEntityRelationInput"] | null,
	specialEvent?:ValueTypes["LinkableCreateSpecialEventEntityRelationInput"] | null,
	sourcePage?:ValueTypes["LinkableCreateSourcePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	page?:ValueTypes["LinkableCreatePageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TimelinePageUpdateInput"]: {
	title?:string | null,
	link?:ValueTypes["TimelinePageUpdateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["TimelinePageUpdateSeoEntityRelationInput"] | null,
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["TimelinePageUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutTimelinePageCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutTimelinePageUpdateInput"] | null,
	upsert?:ValueTypes["TimelinePageUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutTimelinePageUpdateInput"]: {
	url?:string | null,
	event?:ValueTypes["LinkableUpdateEventEntityRelationInput"] | null,
	frontPage?:ValueTypes["LinkableUpdateFrontPageEntityRelationInput"] | null,
	specialEvent?:ValueTypes["LinkableUpdateSpecialEventEntityRelationInput"] | null,
	sourcePage?:ValueTypes["LinkableUpdateSourcePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	page?:ValueTypes["LinkableUpdatePageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TimelinePageUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutTimelinePageUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutTimelinePageCreateInput"] | null
};
	["TimelinePost"]: AliasType<{
	_meta?:ValueTypes["TimelinePostMeta"],
	id?:true,
	title?:true,
	text?:true,
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
	date?:true,
	additionalInfo?:true,
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
	order?:true,
		__typename?: true
}>;
	["TimelinePostMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	date?:ValueTypes["FieldMeta"],
	additionalInfo?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["TimelinePostUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	image?:ValueTypes["ImageUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["TimelinePostWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	date?:ValueTypes["StringCondition"] | null,
	additionalInfo?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	order?:ValueTypes["IntCondition"] | null,
	and?:(ValueTypes["TimelinePostWhere"] | undefined | null)[],
	or?:(ValueTypes["TimelinePostWhere"] | undefined | null)[],
	not?:ValueTypes["TimelinePostWhere"] | null
};
	["TimelinePostOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	date?:ValueTypes["OrderDirection"] | null,
	additionalInfo?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkOrderBy"] | null,
	order?:ValueTypes["OrderDirection"] | null
};
	["TimelinePostConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TimelinePostEdge"],
		__typename?: true
}>;
	["TimelinePostEdge"]: AliasType<{
	node?:ValueTypes["TimelinePost"],
		__typename?: true
}>;
	["TimelinePostCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	text?:string | null,
	image?:ValueTypes["TimelinePostCreateImageEntityRelationInput"] | null,
	seo?:ValueTypes["TimelinePostCreateSeoEntityRelationInput"] | null,
	date?:string | null,
	additionalInfo?:string | null,
	link?:ValueTypes["TimelinePostCreateLinkEntityRelationInput"] | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["TimelinePostCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["TimelinePostCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["TimelinePostCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["TimelinePostUpdateInput"]: {
	title?:string | null,
	text?:string | null,
	image?:ValueTypes["TimelinePostUpdateImageEntityRelationInput"] | null,
	seo?:ValueTypes["TimelinePostUpdateSeoEntityRelationInput"] | null,
	date?:string | null,
	additionalInfo?:string | null,
	link?:ValueTypes["TimelinePostUpdateLinkEntityRelationInput"] | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["TimelinePostUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["TimelinePostUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["TimelinePostUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["TimelinePostUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["TimelinePostUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["TimelinePostUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["TimelinePostUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["TimelinePostUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["TimelinePostUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["SourcePageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SourcePageEdge"],
		__typename?: true
}>;
	["SourcePageEdge"]: AliasType<{
	node?:ValueTypes["SourcePage"],
		__typename?: true
}>;
	["SourcePageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	link?:ValueTypes["SourcePageCreateLinkEntityRelationInput"] | null,
	links?:ValueTypes["SourcePageCreateLinksEntityRelationInput"][],
	seo?:ValueTypes["SourcePageCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SourcePageCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutSourcePageCreateInput"] | null
};
	["LinkableWithoutSourcePageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	event?:ValueTypes["LinkableCreateEventEntityRelationInput"] | null,
	frontPage?:ValueTypes["LinkableCreateFrontPageEntityRelationInput"] | null,
	specialEvent?:ValueTypes["LinkableCreateSpecialEventEntityRelationInput"] | null,
	timelinePage?:ValueTypes["LinkableCreateTimelinePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	page?:ValueTypes["LinkableCreatePageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SourcePageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	link?:ValueTypes["SourcePageUpdateLinkEntityRelationInput"] | null,
	links?:ValueTypes["SourcePageUpdateLinksEntityRelationInput"][],
	seo?:ValueTypes["SourcePageUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SourcePageUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutSourcePageCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutSourcePageUpdateInput"] | null,
	upsert?:ValueTypes["SourcePageUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutSourcePageUpdateInput"]: {
	url?:string | null,
	event?:ValueTypes["LinkableUpdateEventEntityRelationInput"] | null,
	frontPage?:ValueTypes["LinkableUpdateFrontPageEntityRelationInput"] | null,
	specialEvent?:ValueTypes["LinkableUpdateSpecialEventEntityRelationInput"] | null,
	timelinePage?:ValueTypes["LinkableUpdateTimelinePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	page?:ValueTypes["LinkableUpdatePageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SourcePageUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutSourcePageUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutSourcePageCreateInput"] | null
};
	["GalleryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GalleryEdge"],
		__typename?: true
}>;
	["GalleryEdge"]: AliasType<{
	node?:ValueTypes["Gallery"],
		__typename?: true
}>;
	["GalleryItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["GalleryItemCreateListEntityRelationInput"] | null,
	image?:ValueTypes["GalleryItemCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GalleryItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["GalleryUniqueWhere"] | null,
	create?:ValueTypes["GalleryWithoutItemsCreateInput"] | null
};
	["GalleryWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["GalleryItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["GalleryItemUpdateListEntityRelationInput"] | null,
	image?:ValueTypes["GalleryItemUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GalleryItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["GalleryWithoutItemsCreateInput"] | null,
	update?:ValueTypes["GalleryWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["GalleryItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["GalleryUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["GalleryWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["GalleryItemUpsertListRelationInput"]: {
	update?:ValueTypes["GalleryWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["GalleryWithoutItemsCreateInput"] | null
};
	["CardMediaConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CardMediaEdge"],
		__typename?: true
}>;
	["CardMediaEdge"]: AliasType<{
	node?:ValueTypes["CardMedia"],
		__typename?: true
}>;
	["RedirectConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RedirectEdge"],
		__typename?: true
}>;
	["RedirectEdge"]: AliasType<{
	node?:ValueTypes["Redirect"],
		__typename?: true
}>;
	["RedirectCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	targetUrl?:string | null,
	link?:ValueTypes["RedirectCreateLinkEntityRelationInput"] | null,
	target?:ValueTypes["RedirectCreateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutRedirectCreateInput"] | null
};
	["LinkableWithoutRedirectCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	event?:ValueTypes["LinkableCreateEventEntityRelationInput"] | null,
	frontPage?:ValueTypes["LinkableCreateFrontPageEntityRelationInput"] | null,
	specialEvent?:ValueTypes["LinkableCreateSpecialEventEntityRelationInput"] | null,
	timelinePage?:ValueTypes["LinkableCreateTimelinePageEntityRelationInput"] | null,
	sourcePage?:ValueTypes["LinkableCreateSourcePageEntityRelationInput"] | null,
	page?:ValueTypes["LinkableCreatePageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpdateInput"]: {
	targetUrl?:string | null,
	link?:ValueTypes["RedirectUpdateLinkEntityRelationInput"] | null,
	target?:ValueTypes["RedirectUpdateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutRedirectCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutRedirectUpdateInput"] | null,
	upsert?:ValueTypes["RedirectUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutRedirectUpdateInput"]: {
	url?:string | null,
	event?:ValueTypes["LinkableUpdateEventEntityRelationInput"] | null,
	frontPage?:ValueTypes["LinkableUpdateFrontPageEntityRelationInput"] | null,
	specialEvent?:ValueTypes["LinkableUpdateSpecialEventEntityRelationInput"] | null,
	timelinePage?:ValueTypes["LinkableUpdateTimelinePageEntityRelationInput"] | null,
	sourcePage?:ValueTypes["LinkableUpdateSourcePageEntityRelationInput"] | null,
	page?:ValueTypes["LinkableUpdatePageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutRedirectUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutRedirectCreateInput"] | null
};
	["VenueConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["VenueEdge"],
		__typename?: true
}>;
	["VenueEdge"]: AliasType<{
	node?:ValueTypes["Venue"],
		__typename?: true
}>;
	["EventLabelCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	text?:string | null,
	event?:ValueTypes["EventLabelCreateEventEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EventLabelCreateEventEntityRelationInput"]: {
	connect?:ValueTypes["EventUniqueWhere"] | null,
	create?:ValueTypes["EventWithoutEventLabelsCreateInput"] | null
};
	["EventWithoutEventLabelsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	place?:string | null,
	entrance?:string | null,
	image?:ValueTypes["EventCreateImageEntityRelationInput"] | null,
	seo?:ValueTypes["EventCreateSeoEntityRelationInput"] | null,
	link?:ValueTypes["EventCreateLinkEntityRelationInput"] | null,
	content?:ValueTypes["EventCreateContentEntityRelationInput"] | null,
	date?:string | null,
	order?:number | null,
	linkForEvent?:ValueTypes["EventCreateLinkForEventEntityRelationInput"] | null,
	venue?:ValueTypes["EventCreateVenueEntityRelationInput"] | null,
	pastEvent?:boolean | null,
	_dummy_field_?:boolean | null
};
	["EventLabelUpdateInput"]: {
	order?:number | null,
	text?:string | null,
	event?:ValueTypes["EventLabelUpdateEventEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EventLabelUpdateEventEntityRelationInput"]: {
	create?:ValueTypes["EventWithoutEventLabelsCreateInput"] | null,
	update?:ValueTypes["EventWithoutEventLabelsUpdateInput"] | null,
	upsert?:ValueTypes["EventLabelUpsertEventRelationInput"] | null,
	connect?:ValueTypes["EventUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["EventWithoutEventLabelsUpdateInput"]: {
	title?:string | null,
	place?:string | null,
	entrance?:string | null,
	image?:ValueTypes["EventUpdateImageEntityRelationInput"] | null,
	seo?:ValueTypes["EventUpdateSeoEntityRelationInput"] | null,
	link?:ValueTypes["EventUpdateLinkEntityRelationInput"] | null,
	content?:ValueTypes["EventUpdateContentEntityRelationInput"] | null,
	date?:string | null,
	order?:number | null,
	linkForEvent?:ValueTypes["EventUpdateLinkForEventEntityRelationInput"] | null,
	venue?:ValueTypes["EventUpdateVenueEntityRelationInput"] | null,
	pastEvent?:boolean | null,
	_dummy_field_?:boolean | null
};
	["EventLabelUpsertEventRelationInput"]: {
	update?:ValueTypes["EventWithoutEventLabelsUpdateInput"] | null,
	create?:ValueTypes["EventWithoutEventLabelsCreateInput"] | null
};
	["PageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PageEdge"],
		__typename?: true
}>;
	["PageEdge"]: AliasType<{
	node?:ValueTypes["Page"],
		__typename?: true
}>;
	["PageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	title?:string | null,
	link?:ValueTypes["PageCreateLinkEntityRelationInput"] | null,
	content?:ValueTypes["PageCreateContentEntityRelationInput"] | null,
	seo?:ValueTypes["PageCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PageCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutPageCreateInput"] | null
};
	["LinkableWithoutPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	event?:ValueTypes["LinkableCreateEventEntityRelationInput"] | null,
	frontPage?:ValueTypes["LinkableCreateFrontPageEntityRelationInput"] | null,
	specialEvent?:ValueTypes["LinkableCreateSpecialEventEntityRelationInput"] | null,
	timelinePage?:ValueTypes["LinkableCreateTimelinePageEntityRelationInput"] | null,
	sourcePage?:ValueTypes["LinkableCreateSourcePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PageUpdateInput"]: {
	order?:number | null,
	title?:string | null,
	link?:ValueTypes["PageUpdateLinkEntityRelationInput"] | null,
	content?:ValueTypes["PageUpdateContentEntityRelationInput"] | null,
	seo?:ValueTypes["PageUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PageUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutPageCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutPageUpdateInput"] | null,
	upsert?:ValueTypes["PageUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutPageUpdateInput"]: {
	url?:string | null,
	event?:ValueTypes["LinkableUpdateEventEntityRelationInput"] | null,
	frontPage?:ValueTypes["LinkableUpdateFrontPageEntityRelationInput"] | null,
	specialEvent?:ValueTypes["LinkableUpdateSpecialEventEntityRelationInput"] | null,
	timelinePage?:ValueTypes["LinkableUpdateTimelinePageEntityRelationInput"] | null,
	sourcePage?:ValueTypes["LinkableUpdateSourcePageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PageUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutPageUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutPageCreateInput"] | null
};
	["QueryTransaction"]: AliasType<{
getContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
listContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Content"]],
paginateContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentConnection"]],
validateCreateContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	data:ValueTypes["ContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
listContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
listContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
paginateContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
validateCreateContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["_ValidationResult"]],
getEvent?: [{	by:ValueTypes["EventUniqueWhere"],	filter?:ValueTypes["EventWhere"] | null},ValueTypes["Event"]],
listEvent?: [{	filter?:ValueTypes["EventWhere"] | null,	orderBy?:ValueTypes["EventOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Event"]],
paginateEvent?: [{	filter?:ValueTypes["EventWhere"] | null,	orderBy?:ValueTypes["EventOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EventConnection"]],
validateCreateEvent?: [{	data:ValueTypes["EventCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEvent?: [{	by:ValueTypes["EventUniqueWhere"],	data:ValueTypes["EventUpdateInput"]},ValueTypes["_ValidationResult"]],
getFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	filter?:ValueTypes["FallbackSeoWhere"] | null},ValueTypes["FallbackSeo"]],
listFallbackSeo?: [{	filter?:ValueTypes["FallbackSeoWhere"] | null,	orderBy?:ValueTypes["FallbackSeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FallbackSeo"]],
paginateFallbackSeo?: [{	filter?:ValueTypes["FallbackSeoWhere"] | null,	orderBy?:ValueTypes["FallbackSeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FallbackSeoConnection"]],
validateCreateFallbackSeo?: [{	data:ValueTypes["FallbackSeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	data:ValueTypes["FallbackSeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["Footer"]],
listFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Footer"]],
paginateFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterConnection"]],
validateCreateFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	data:ValueTypes["FooterUpdateInput"]},ValueTypes["_ValidationResult"]],
getHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["Header"]],
listHeader?: [{	filter?:ValueTypes["HeaderWhere"] | null,	orderBy?:ValueTypes["HeaderOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Header"]],
paginateHeader?: [{	filter?:ValueTypes["HeaderWhere"] | null,	orderBy?:ValueTypes["HeaderOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderConnection"]],
validateCreateHeader?: [{	data:ValueTypes["HeaderCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	data:ValueTypes["HeaderUpdateInput"]},ValueTypes["_ValidationResult"]],
getHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	filter?:ValueTypes["HeaderLinkWhere"] | null},ValueTypes["HeaderLink"]],
listHeaderLink?: [{	filter?:ValueTypes["HeaderLinkWhere"] | null,	orderBy?:ValueTypes["HeaderLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HeaderLink"]],
paginateHeaderLink?: [{	filter?:ValueTypes["HeaderLinkWhere"] | null,	orderBy?:ValueTypes["HeaderLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderLinkConnection"]],
validateCreateHeaderLink?: [{	data:ValueTypes["HeaderLinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	data:ValueTypes["HeaderLinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getFrontPage?: [{	by:ValueTypes["FrontPageUniqueWhere"],	filter?:ValueTypes["FrontPageWhere"] | null},ValueTypes["FrontPage"]],
listFrontPage?: [{	filter?:ValueTypes["FrontPageWhere"] | null,	orderBy?:ValueTypes["FrontPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FrontPage"]],
paginateFrontPage?: [{	filter?:ValueTypes["FrontPageWhere"] | null,	orderBy?:ValueTypes["FrontPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FrontPageConnection"]],
validateCreateFrontPage?: [{	data:ValueTypes["FrontPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFrontPage?: [{	by:ValueTypes["FrontPageUniqueWhere"],	data:ValueTypes["FrontPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
listImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Image"]],
paginateImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageConnection"]],
validateCreateImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	data:ValueTypes["ImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
listLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Link"]],
paginateLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkConnection"]],
validateCreateLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	data:ValueTypes["LinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
listLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Linkable"]],
paginateLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
listSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Seo"]],
paginateSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoConnection"]],
validateCreateSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	data:ValueTypes["SeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getSpecialEvent?: [{	by:ValueTypes["SpecialEventUniqueWhere"],	filter?:ValueTypes["SpecialEventWhere"] | null},ValueTypes["SpecialEvent"]],
listSpecialEvent?: [{	filter?:ValueTypes["SpecialEventWhere"] | null,	orderBy?:ValueTypes["SpecialEventOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SpecialEvent"]],
paginateSpecialEvent?: [{	filter?:ValueTypes["SpecialEventWhere"] | null,	orderBy?:ValueTypes["SpecialEventOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SpecialEventConnection"]],
validateCreateSpecialEvent?: [{	data:ValueTypes["SpecialEventCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSpecialEvent?: [{	by:ValueTypes["SpecialEventUniqueWhere"],	data:ValueTypes["SpecialEventUpdateInput"]},ValueTypes["_ValidationResult"]],
getTimelinePage?: [{	by:ValueTypes["TimelinePageUniqueWhere"],	filter?:ValueTypes["TimelinePageWhere"] | null},ValueTypes["TimelinePage"]],
listTimelinePage?: [{	filter?:ValueTypes["TimelinePageWhere"] | null,	orderBy?:ValueTypes["TimelinePageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TimelinePage"]],
paginateTimelinePage?: [{	filter?:ValueTypes["TimelinePageWhere"] | null,	orderBy?:ValueTypes["TimelinePageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TimelinePageConnection"]],
validateCreateTimelinePage?: [{	data:ValueTypes["TimelinePageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTimelinePage?: [{	by:ValueTypes["TimelinePageUniqueWhere"],	data:ValueTypes["TimelinePageUpdateInput"]},ValueTypes["_ValidationResult"]],
getTimelinePost?: [{	by:ValueTypes["TimelinePostUniqueWhere"],	filter?:ValueTypes["TimelinePostWhere"] | null},ValueTypes["TimelinePost"]],
listTimelinePost?: [{	filter?:ValueTypes["TimelinePostWhere"] | null,	orderBy?:ValueTypes["TimelinePostOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TimelinePost"]],
paginateTimelinePost?: [{	filter?:ValueTypes["TimelinePostWhere"] | null,	orderBy?:ValueTypes["TimelinePostOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TimelinePostConnection"]],
validateCreateTimelinePost?: [{	data:ValueTypes["TimelinePostCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTimelinePost?: [{	by:ValueTypes["TimelinePostUniqueWhere"],	data:ValueTypes["TimelinePostUpdateInput"]},ValueTypes["_ValidationResult"]],
getSourcePage?: [{	by:ValueTypes["SourcePageUniqueWhere"],	filter?:ValueTypes["SourcePageWhere"] | null},ValueTypes["SourcePage"]],
listSourcePage?: [{	filter?:ValueTypes["SourcePageWhere"] | null,	orderBy?:ValueTypes["SourcePageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SourcePage"]],
paginateSourcePage?: [{	filter?:ValueTypes["SourcePageWhere"] | null,	orderBy?:ValueTypes["SourcePageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SourcePageConnection"]],
validateCreateSourcePage?: [{	data:ValueTypes["SourcePageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSourcePage?: [{	by:ValueTypes["SourcePageUniqueWhere"],	data:ValueTypes["SourcePageUpdateInput"]},ValueTypes["_ValidationResult"]],
getSourcePostLink?: [{	by:ValueTypes["SourcePostLinkUniqueWhere"],	filter?:ValueTypes["SourcePostLinkWhere"] | null},ValueTypes["SourcePostLink"]],
listSourcePostLink?: [{	filter?:ValueTypes["SourcePostLinkWhere"] | null,	orderBy?:ValueTypes["SourcePostLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SourcePostLink"]],
paginateSourcePostLink?: [{	filter?:ValueTypes["SourcePostLinkWhere"] | null,	orderBy?:ValueTypes["SourcePostLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SourcePostLinkConnection"]],
validateCreateSourcePostLink?: [{	data:ValueTypes["SourcePostLinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSourcePostLink?: [{	by:ValueTypes["SourcePostLinkUniqueWhere"],	data:ValueTypes["SourcePostLinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["Gallery"]],
listGallery?: [{	filter?:ValueTypes["GalleryWhere"] | null,	orderBy?:ValueTypes["GalleryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Gallery"]],
paginateGallery?: [{	filter?:ValueTypes["GalleryWhere"] | null,	orderBy?:ValueTypes["GalleryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GalleryConnection"]],
validateCreateGallery?: [{	data:ValueTypes["GalleryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	data:ValueTypes["GalleryUpdateInput"]},ValueTypes["_ValidationResult"]],
getGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null},ValueTypes["GalleryItem"]],
listGalleryItem?: [{	filter?:ValueTypes["GalleryItemWhere"] | null,	orderBy?:ValueTypes["GalleryItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["GalleryItem"]],
paginateGalleryItem?: [{	filter?:ValueTypes["GalleryItemWhere"] | null,	orderBy?:ValueTypes["GalleryItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GalleryItemConnection"]],
validateCreateGalleryItem?: [{	data:ValueTypes["GalleryItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	data:ValueTypes["GalleryItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getCardMedia?: [{	by:ValueTypes["CardMediaUniqueWhere"],	filter?:ValueTypes["CardMediaWhere"] | null},ValueTypes["CardMedia"]],
listCardMedia?: [{	filter?:ValueTypes["CardMediaWhere"] | null,	orderBy?:ValueTypes["CardMediaOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["CardMedia"]],
paginateCardMedia?: [{	filter?:ValueTypes["CardMediaWhere"] | null,	orderBy?:ValueTypes["CardMediaOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["CardMediaConnection"]],
validateCreateCardMedia?: [{	data:ValueTypes["CardMediaCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCardMedia?: [{	by:ValueTypes["CardMediaUniqueWhere"],	data:ValueTypes["CardMediaUpdateInput"]},ValueTypes["_ValidationResult"]],
getRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
listRedirect?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Redirect"]],
paginateRedirect?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RedirectConnection"]],
validateCreateRedirect?: [{	data:ValueTypes["RedirectCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	data:ValueTypes["RedirectUpdateInput"]},ValueTypes["_ValidationResult"]],
getVenue?: [{	by:ValueTypes["VenueUniqueWhere"],	filter?:ValueTypes["VenueWhere"] | null},ValueTypes["Venue"]],
listVenue?: [{	filter?:ValueTypes["VenueWhere"] | null,	orderBy?:ValueTypes["VenueOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Venue"]],
paginateVenue?: [{	filter?:ValueTypes["VenueWhere"] | null,	orderBy?:ValueTypes["VenueOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["VenueConnection"]],
validateCreateVenue?: [{	data:ValueTypes["VenueCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVenue?: [{	by:ValueTypes["VenueUniqueWhere"],	data:ValueTypes["VenueUpdateInput"]},ValueTypes["_ValidationResult"]],
getEventLabel?: [{	by:ValueTypes["EventLabelUniqueWhere"],	filter?:ValueTypes["EventLabelWhere"] | null},ValueTypes["EventLabel"]],
listEventLabel?: [{	filter?:ValueTypes["EventLabelWhere"] | null,	orderBy?:ValueTypes["EventLabelOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EventLabel"]],
paginateEventLabel?: [{	filter?:ValueTypes["EventLabelWhere"] | null,	orderBy?:ValueTypes["EventLabelOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EventLabelConnection"]],
validateCreateEventLabel?: [{	data:ValueTypes["EventLabelCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEventLabel?: [{	by:ValueTypes["EventLabelUniqueWhere"],	data:ValueTypes["EventLabelUpdateInput"]},ValueTypes["_ValidationResult"]],
getPage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null},ValueTypes["Page"]],
listPage?: [{	filter?:ValueTypes["PageWhere"] | null,	orderBy?:ValueTypes["PageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Page"]],
paginatePage?: [{	filter?:ValueTypes["PageWhere"] | null,	orderBy?:ValueTypes["PageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PageConnection"]],
validateCreatePage?: [{	data:ValueTypes["PageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePage?: [{	by:ValueTypes["PageUniqueWhere"],	data:ValueTypes["PageUpdateInput"]},ValueTypes["_ValidationResult"]],
		__typename?: true
}>;
	["Info"]: AliasType<{
	description?:true,
		__typename?: true
}>;
	["Mutation"]: AliasType<{
createContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["ContentCreateResult"]],
deleteContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["ContentDeleteResult"]],
updateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	data:ValueTypes["ContentUpdateInput"]},ValueTypes["ContentUpdateResult"]],
upsertContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	update:ValueTypes["ContentUpdateInput"],	create:ValueTypes["ContentCreateInput"]},ValueTypes["ContentUpsertResult"]],
createContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	update:ValueTypes["ContentBlockUpdateInput"],	create:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockUpsertResult"]],
createContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceCreateResult"]],
deleteContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReferenceDeleteResult"]],
updateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["ContentReferenceUpdateResult"]],
upsertContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	update:ValueTypes["ContentReferenceUpdateInput"],	create:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceUpsertResult"]],
createEvent?: [{	data:ValueTypes["EventCreateInput"]},ValueTypes["EventCreateResult"]],
deleteEvent?: [{	by:ValueTypes["EventUniqueWhere"],	filter?:ValueTypes["EventWhere"] | null},ValueTypes["EventDeleteResult"]],
updateEvent?: [{	by:ValueTypes["EventUniqueWhere"],	filter?:ValueTypes["EventWhere"] | null,	data:ValueTypes["EventUpdateInput"]},ValueTypes["EventUpdateResult"]],
upsertEvent?: [{	by:ValueTypes["EventUniqueWhere"],	filter?:ValueTypes["EventWhere"] | null,	update:ValueTypes["EventUpdateInput"],	create:ValueTypes["EventCreateInput"]},ValueTypes["EventUpsertResult"]],
createFallbackSeo?: [{	data:ValueTypes["FallbackSeoCreateInput"]},ValueTypes["FallbackSeoCreateResult"]],
deleteFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	filter?:ValueTypes["FallbackSeoWhere"] | null},ValueTypes["FallbackSeoDeleteResult"]],
updateFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	filter?:ValueTypes["FallbackSeoWhere"] | null,	data:ValueTypes["FallbackSeoUpdateInput"]},ValueTypes["FallbackSeoUpdateResult"]],
upsertFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	filter?:ValueTypes["FallbackSeoWhere"] | null,	update:ValueTypes["FallbackSeoUpdateInput"],	create:ValueTypes["FallbackSeoCreateInput"]},ValueTypes["FallbackSeoUpsertResult"]],
createFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["FooterCreateResult"]],
deleteFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["FooterDeleteResult"]],
updateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	data:ValueTypes["FooterUpdateInput"]},ValueTypes["FooterUpdateResult"]],
upsertFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	update:ValueTypes["FooterUpdateInput"],	create:ValueTypes["FooterCreateInput"]},ValueTypes["FooterUpsertResult"]],
createHeader?: [{	data:ValueTypes["HeaderCreateInput"]},ValueTypes["HeaderCreateResult"]],
deleteHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["HeaderDeleteResult"]],
updateHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null,	data:ValueTypes["HeaderUpdateInput"]},ValueTypes["HeaderUpdateResult"]],
upsertHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null,	update:ValueTypes["HeaderUpdateInput"],	create:ValueTypes["HeaderCreateInput"]},ValueTypes["HeaderUpsertResult"]],
createHeaderLink?: [{	data:ValueTypes["HeaderLinkCreateInput"]},ValueTypes["HeaderLinkCreateResult"]],
deleteHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	filter?:ValueTypes["HeaderLinkWhere"] | null},ValueTypes["HeaderLinkDeleteResult"]],
updateHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	filter?:ValueTypes["HeaderLinkWhere"] | null,	data:ValueTypes["HeaderLinkUpdateInput"]},ValueTypes["HeaderLinkUpdateResult"]],
upsertHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	filter?:ValueTypes["HeaderLinkWhere"] | null,	update:ValueTypes["HeaderLinkUpdateInput"],	create:ValueTypes["HeaderLinkCreateInput"]},ValueTypes["HeaderLinkUpsertResult"]],
createFrontPage?: [{	data:ValueTypes["FrontPageCreateInput"]},ValueTypes["FrontPageCreateResult"]],
deleteFrontPage?: [{	by:ValueTypes["FrontPageUniqueWhere"],	filter?:ValueTypes["FrontPageWhere"] | null},ValueTypes["FrontPageDeleteResult"]],
updateFrontPage?: [{	by:ValueTypes["FrontPageUniqueWhere"],	filter?:ValueTypes["FrontPageWhere"] | null,	data:ValueTypes["FrontPageUpdateInput"]},ValueTypes["FrontPageUpdateResult"]],
upsertFrontPage?: [{	by:ValueTypes["FrontPageUniqueWhere"],	filter?:ValueTypes["FrontPageWhere"] | null,	update:ValueTypes["FrontPageUpdateInput"],	create:ValueTypes["FrontPageCreateInput"]},ValueTypes["FrontPageUpsertResult"]],
createImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["ImageCreateResult"]],
deleteImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["ImageDeleteResult"]],
updateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	data:ValueTypes["ImageUpdateInput"]},ValueTypes["ImageUpdateResult"]],
upsertImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	update:ValueTypes["ImageUpdateInput"],	create:ValueTypes["ImageCreateInput"]},ValueTypes["ImageUpsertResult"]],
createLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["LinkCreateResult"]],
deleteLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["LinkDeleteResult"]],
updateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	data:ValueTypes["LinkUpdateInput"]},ValueTypes["LinkUpdateResult"]],
upsertLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	update:ValueTypes["LinkUpdateInput"],	create:ValueTypes["LinkCreateInput"]},ValueTypes["LinkUpsertResult"]],
createLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	update:ValueTypes["LinkableUpdateInput"],	create:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableUpsertResult"]],
createSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["SeoCreateResult"]],
deleteSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["SeoDeleteResult"]],
updateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	data:ValueTypes["SeoUpdateInput"]},ValueTypes["SeoUpdateResult"]],
upsertSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	update:ValueTypes["SeoUpdateInput"],	create:ValueTypes["SeoCreateInput"]},ValueTypes["SeoUpsertResult"]],
createSpecialEvent?: [{	data:ValueTypes["SpecialEventCreateInput"]},ValueTypes["SpecialEventCreateResult"]],
deleteSpecialEvent?: [{	by:ValueTypes["SpecialEventUniqueWhere"],	filter?:ValueTypes["SpecialEventWhere"] | null},ValueTypes["SpecialEventDeleteResult"]],
updateSpecialEvent?: [{	by:ValueTypes["SpecialEventUniqueWhere"],	filter?:ValueTypes["SpecialEventWhere"] | null,	data:ValueTypes["SpecialEventUpdateInput"]},ValueTypes["SpecialEventUpdateResult"]],
upsertSpecialEvent?: [{	by:ValueTypes["SpecialEventUniqueWhere"],	filter?:ValueTypes["SpecialEventWhere"] | null,	update:ValueTypes["SpecialEventUpdateInput"],	create:ValueTypes["SpecialEventCreateInput"]},ValueTypes["SpecialEventUpsertResult"]],
createTimelinePage?: [{	data:ValueTypes["TimelinePageCreateInput"]},ValueTypes["TimelinePageCreateResult"]],
deleteTimelinePage?: [{	by:ValueTypes["TimelinePageUniqueWhere"],	filter?:ValueTypes["TimelinePageWhere"] | null},ValueTypes["TimelinePageDeleteResult"]],
updateTimelinePage?: [{	by:ValueTypes["TimelinePageUniqueWhere"],	filter?:ValueTypes["TimelinePageWhere"] | null,	data:ValueTypes["TimelinePageUpdateInput"]},ValueTypes["TimelinePageUpdateResult"]],
upsertTimelinePage?: [{	by:ValueTypes["TimelinePageUniqueWhere"],	filter?:ValueTypes["TimelinePageWhere"] | null,	update:ValueTypes["TimelinePageUpdateInput"],	create:ValueTypes["TimelinePageCreateInput"]},ValueTypes["TimelinePageUpsertResult"]],
createTimelinePost?: [{	data:ValueTypes["TimelinePostCreateInput"]},ValueTypes["TimelinePostCreateResult"]],
deleteTimelinePost?: [{	by:ValueTypes["TimelinePostUniqueWhere"],	filter?:ValueTypes["TimelinePostWhere"] | null},ValueTypes["TimelinePostDeleteResult"]],
updateTimelinePost?: [{	by:ValueTypes["TimelinePostUniqueWhere"],	filter?:ValueTypes["TimelinePostWhere"] | null,	data:ValueTypes["TimelinePostUpdateInput"]},ValueTypes["TimelinePostUpdateResult"]],
upsertTimelinePost?: [{	by:ValueTypes["TimelinePostUniqueWhere"],	filter?:ValueTypes["TimelinePostWhere"] | null,	update:ValueTypes["TimelinePostUpdateInput"],	create:ValueTypes["TimelinePostCreateInput"]},ValueTypes["TimelinePostUpsertResult"]],
createSourcePage?: [{	data:ValueTypes["SourcePageCreateInput"]},ValueTypes["SourcePageCreateResult"]],
deleteSourcePage?: [{	by:ValueTypes["SourcePageUniqueWhere"],	filter?:ValueTypes["SourcePageWhere"] | null},ValueTypes["SourcePageDeleteResult"]],
updateSourcePage?: [{	by:ValueTypes["SourcePageUniqueWhere"],	filter?:ValueTypes["SourcePageWhere"] | null,	data:ValueTypes["SourcePageUpdateInput"]},ValueTypes["SourcePageUpdateResult"]],
upsertSourcePage?: [{	by:ValueTypes["SourcePageUniqueWhere"],	filter?:ValueTypes["SourcePageWhere"] | null,	update:ValueTypes["SourcePageUpdateInput"],	create:ValueTypes["SourcePageCreateInput"]},ValueTypes["SourcePageUpsertResult"]],
createSourcePostLink?: [{	data:ValueTypes["SourcePostLinkCreateInput"]},ValueTypes["SourcePostLinkCreateResult"]],
deleteSourcePostLink?: [{	by:ValueTypes["SourcePostLinkUniqueWhere"],	filter?:ValueTypes["SourcePostLinkWhere"] | null},ValueTypes["SourcePostLinkDeleteResult"]],
updateSourcePostLink?: [{	by:ValueTypes["SourcePostLinkUniqueWhere"],	filter?:ValueTypes["SourcePostLinkWhere"] | null,	data:ValueTypes["SourcePostLinkUpdateInput"]},ValueTypes["SourcePostLinkUpdateResult"]],
upsertSourcePostLink?: [{	by:ValueTypes["SourcePostLinkUniqueWhere"],	filter?:ValueTypes["SourcePostLinkWhere"] | null,	update:ValueTypes["SourcePostLinkUpdateInput"],	create:ValueTypes["SourcePostLinkCreateInput"]},ValueTypes["SourcePostLinkUpsertResult"]],
createGallery?: [{	data:ValueTypes["GalleryCreateInput"]},ValueTypes["GalleryCreateResult"]],
deleteGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["GalleryDeleteResult"]],
updateGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null,	data:ValueTypes["GalleryUpdateInput"]},ValueTypes["GalleryUpdateResult"]],
upsertGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null,	update:ValueTypes["GalleryUpdateInput"],	create:ValueTypes["GalleryCreateInput"]},ValueTypes["GalleryUpsertResult"]],
createGalleryItem?: [{	data:ValueTypes["GalleryItemCreateInput"]},ValueTypes["GalleryItemCreateResult"]],
deleteGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null},ValueTypes["GalleryItemDeleteResult"]],
updateGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null,	data:ValueTypes["GalleryItemUpdateInput"]},ValueTypes["GalleryItemUpdateResult"]],
upsertGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null,	update:ValueTypes["GalleryItemUpdateInput"],	create:ValueTypes["GalleryItemCreateInput"]},ValueTypes["GalleryItemUpsertResult"]],
createCardMedia?: [{	data:ValueTypes["CardMediaCreateInput"]},ValueTypes["CardMediaCreateResult"]],
deleteCardMedia?: [{	by:ValueTypes["CardMediaUniqueWhere"],	filter?:ValueTypes["CardMediaWhere"] | null},ValueTypes["CardMediaDeleteResult"]],
updateCardMedia?: [{	by:ValueTypes["CardMediaUniqueWhere"],	filter?:ValueTypes["CardMediaWhere"] | null,	data:ValueTypes["CardMediaUpdateInput"]},ValueTypes["CardMediaUpdateResult"]],
upsertCardMedia?: [{	by:ValueTypes["CardMediaUniqueWhere"],	filter?:ValueTypes["CardMediaWhere"] | null,	update:ValueTypes["CardMediaUpdateInput"],	create:ValueTypes["CardMediaCreateInput"]},ValueTypes["CardMediaUpsertResult"]],
createRedirect?: [{	data:ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectCreateResult"]],
deleteRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["RedirectDeleteResult"]],
updateRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null,	data:ValueTypes["RedirectUpdateInput"]},ValueTypes["RedirectUpdateResult"]],
upsertRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null,	update:ValueTypes["RedirectUpdateInput"],	create:ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectUpsertResult"]],
createVenue?: [{	data:ValueTypes["VenueCreateInput"]},ValueTypes["VenueCreateResult"]],
deleteVenue?: [{	by:ValueTypes["VenueUniqueWhere"],	filter?:ValueTypes["VenueWhere"] | null},ValueTypes["VenueDeleteResult"]],
updateVenue?: [{	by:ValueTypes["VenueUniqueWhere"],	filter?:ValueTypes["VenueWhere"] | null,	data:ValueTypes["VenueUpdateInput"]},ValueTypes["VenueUpdateResult"]],
upsertVenue?: [{	by:ValueTypes["VenueUniqueWhere"],	filter?:ValueTypes["VenueWhere"] | null,	update:ValueTypes["VenueUpdateInput"],	create:ValueTypes["VenueCreateInput"]},ValueTypes["VenueUpsertResult"]],
createEventLabel?: [{	data:ValueTypes["EventLabelCreateInput"]},ValueTypes["EventLabelCreateResult"]],
deleteEventLabel?: [{	by:ValueTypes["EventLabelUniqueWhere"],	filter?:ValueTypes["EventLabelWhere"] | null},ValueTypes["EventLabelDeleteResult"]],
updateEventLabel?: [{	by:ValueTypes["EventLabelUniqueWhere"],	filter?:ValueTypes["EventLabelWhere"] | null,	data:ValueTypes["EventLabelUpdateInput"]},ValueTypes["EventLabelUpdateResult"]],
upsertEventLabel?: [{	by:ValueTypes["EventLabelUniqueWhere"],	filter?:ValueTypes["EventLabelWhere"] | null,	update:ValueTypes["EventLabelUpdateInput"],	create:ValueTypes["EventLabelCreateInput"]},ValueTypes["EventLabelUpsertResult"]],
createPage?: [{	data:ValueTypes["PageCreateInput"]},ValueTypes["PageCreateResult"]],
deletePage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null},ValueTypes["PageDeleteResult"]],
updatePage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null,	data:ValueTypes["PageUpdateInput"]},ValueTypes["PageUpdateResult"]],
upsertPage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null,	update:ValueTypes["PageUpdateInput"],	create:ValueTypes["PageCreateInput"]},ValueTypes["PageUpsertResult"]],
transaction?: [{	options?:ValueTypes["MutationTransactionOptions"] | null},ValueTypes["MutationTransaction"]],
	query?:ValueTypes["Query"],
generateUploadUrl?: [{	contentType:string,	expiration?:number | null,	prefix?:string | null},ValueTypes["S3SignedUpload"]],
generateReadUrl?: [{	objectKey:string,	expiration?:number | null},ValueTypes["S3SignedRead"]],
		__typename?: true
}>;
	["ContentCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MutationResult"]:AliasType<{
		ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"];
		['...on ContentCreateResult']?: Omit<ValueTypes["ContentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentDeleteResult']?: Omit<ValueTypes["ContentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentUpdateResult']?: Omit<ValueTypes["ContentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentUpsertResult']?: Omit<ValueTypes["ContentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockCreateResult']?: Omit<ValueTypes["ContentBlockCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockDeleteResult']?: Omit<ValueTypes["ContentBlockDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockUpdateResult']?: Omit<ValueTypes["ContentBlockUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockUpsertResult']?: Omit<ValueTypes["ContentBlockUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceCreateResult']?: Omit<ValueTypes["ContentReferenceCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceDeleteResult']?: Omit<ValueTypes["ContentReferenceDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceUpdateResult']?: Omit<ValueTypes["ContentReferenceUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceUpsertResult']?: Omit<ValueTypes["ContentReferenceUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventCreateResult']?: Omit<ValueTypes["EventCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventDeleteResult']?: Omit<ValueTypes["EventDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventUpdateResult']?: Omit<ValueTypes["EventUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventUpsertResult']?: Omit<ValueTypes["EventUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FallbackSeoCreateResult']?: Omit<ValueTypes["FallbackSeoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FallbackSeoDeleteResult']?: Omit<ValueTypes["FallbackSeoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FallbackSeoUpdateResult']?: Omit<ValueTypes["FallbackSeoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FallbackSeoUpsertResult']?: Omit<ValueTypes["FallbackSeoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterCreateResult']?: Omit<ValueTypes["FooterCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterDeleteResult']?: Omit<ValueTypes["FooterDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterUpdateResult']?: Omit<ValueTypes["FooterUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterUpsertResult']?: Omit<ValueTypes["FooterUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderCreateResult']?: Omit<ValueTypes["HeaderCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderDeleteResult']?: Omit<ValueTypes["HeaderDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderUpdateResult']?: Omit<ValueTypes["HeaderUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderUpsertResult']?: Omit<ValueTypes["HeaderUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLinkCreateResult']?: Omit<ValueTypes["HeaderLinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLinkDeleteResult']?: Omit<ValueTypes["HeaderLinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLinkUpdateResult']?: Omit<ValueTypes["HeaderLinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLinkUpsertResult']?: Omit<ValueTypes["HeaderLinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FrontPageCreateResult']?: Omit<ValueTypes["FrontPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FrontPageDeleteResult']?: Omit<ValueTypes["FrontPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FrontPageUpdateResult']?: Omit<ValueTypes["FrontPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FrontPageUpsertResult']?: Omit<ValueTypes["FrontPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageCreateResult']?: Omit<ValueTypes["ImageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageDeleteResult']?: Omit<ValueTypes["ImageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUpdateResult']?: Omit<ValueTypes["ImageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUpsertResult']?: Omit<ValueTypes["ImageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkCreateResult']?: Omit<ValueTypes["LinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkDeleteResult']?: Omit<ValueTypes["LinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkUpdateResult']?: Omit<ValueTypes["LinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkUpsertResult']?: Omit<ValueTypes["LinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableCreateResult']?: Omit<ValueTypes["LinkableCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableDeleteResult']?: Omit<ValueTypes["LinkableDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableUpdateResult']?: Omit<ValueTypes["LinkableUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableUpsertResult']?: Omit<ValueTypes["LinkableUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoCreateResult']?: Omit<ValueTypes["SeoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDeleteResult']?: Omit<ValueTypes["SeoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoUpdateResult']?: Omit<ValueTypes["SeoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoUpsertResult']?: Omit<ValueTypes["SeoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SpecialEventCreateResult']?: Omit<ValueTypes["SpecialEventCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SpecialEventDeleteResult']?: Omit<ValueTypes["SpecialEventDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SpecialEventUpdateResult']?: Omit<ValueTypes["SpecialEventUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SpecialEventUpsertResult']?: Omit<ValueTypes["SpecialEventUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimelinePageCreateResult']?: Omit<ValueTypes["TimelinePageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimelinePageDeleteResult']?: Omit<ValueTypes["TimelinePageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimelinePageUpdateResult']?: Omit<ValueTypes["TimelinePageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimelinePageUpsertResult']?: Omit<ValueTypes["TimelinePageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimelinePostCreateResult']?: Omit<ValueTypes["TimelinePostCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimelinePostDeleteResult']?: Omit<ValueTypes["TimelinePostDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimelinePostUpdateResult']?: Omit<ValueTypes["TimelinePostUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TimelinePostUpsertResult']?: Omit<ValueTypes["TimelinePostUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SourcePageCreateResult']?: Omit<ValueTypes["SourcePageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SourcePageDeleteResult']?: Omit<ValueTypes["SourcePageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SourcePageUpdateResult']?: Omit<ValueTypes["SourcePageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SourcePageUpsertResult']?: Omit<ValueTypes["SourcePageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SourcePostLinkCreateResult']?: Omit<ValueTypes["SourcePostLinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SourcePostLinkDeleteResult']?: Omit<ValueTypes["SourcePostLinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SourcePostLinkUpdateResult']?: Omit<ValueTypes["SourcePostLinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SourcePostLinkUpsertResult']?: Omit<ValueTypes["SourcePostLinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryCreateResult']?: Omit<ValueTypes["GalleryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryDeleteResult']?: Omit<ValueTypes["GalleryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryUpdateResult']?: Omit<ValueTypes["GalleryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryUpsertResult']?: Omit<ValueTypes["GalleryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryItemCreateResult']?: Omit<ValueTypes["GalleryItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryItemDeleteResult']?: Omit<ValueTypes["GalleryItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryItemUpdateResult']?: Omit<ValueTypes["GalleryItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryItemUpsertResult']?: Omit<ValueTypes["GalleryItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CardMediaCreateResult']?: Omit<ValueTypes["CardMediaCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CardMediaDeleteResult']?: Omit<ValueTypes["CardMediaDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CardMediaUpdateResult']?: Omit<ValueTypes["CardMediaUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CardMediaUpsertResult']?: Omit<ValueTypes["CardMediaUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectCreateResult']?: Omit<ValueTypes["RedirectCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectDeleteResult']?: Omit<ValueTypes["RedirectDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectUpdateResult']?: Omit<ValueTypes["RedirectUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectUpsertResult']?: Omit<ValueTypes["RedirectUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on VenueCreateResult']?: Omit<ValueTypes["VenueCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VenueDeleteResult']?: Omit<ValueTypes["VenueDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on VenueUpdateResult']?: Omit<ValueTypes["VenueUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VenueUpsertResult']?: Omit<ValueTypes["VenueUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventLabelCreateResult']?: Omit<ValueTypes["EventLabelCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventLabelDeleteResult']?: Omit<ValueTypes["EventLabelDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventLabelUpdateResult']?: Omit<ValueTypes["EventLabelUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventLabelUpsertResult']?: Omit<ValueTypes["EventLabelUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageCreateResult']?: Omit<ValueTypes["PageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageDeleteResult']?: Omit<ValueTypes["PageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageUpdateResult']?: Omit<ValueTypes["PageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageUpsertResult']?: Omit<ValueTypes["PageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		__typename?: true
}>;
	["_MutationError"]: AliasType<{
	path?:ValueTypes["_PathFragment"],
	paths?:ValueTypes["_PathFragment"],
	type?:true,
	message?:true,
		__typename?: true
}>;
	["_MutationErrorType"]:_MutationErrorType;
	["ContentDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
		__typename?: true
}>;
	["ContentUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentBlockCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentBlockDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
		__typename?: true
}>;
	["ContentBlockUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentBlockUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentReferenceCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentReferenceDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
		__typename?: true
}>;
	["ContentReferenceUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentReferenceUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EventCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Event"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EventDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Event"],
		__typename?: true
}>;
	["EventUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Event"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EventUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Event"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FallbackSeoCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FallbackSeo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FallbackSeoDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FallbackSeo"],
		__typename?: true
}>;
	["FallbackSeoUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FallbackSeo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FallbackSeoUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FallbackSeo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
		__typename?: true
}>;
	["FooterUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
		__typename?: true
}>;
	["HeaderUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderLinkCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderLinkDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLink"],
		__typename?: true
}>;
	["HeaderLinkUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderLinkUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FrontPageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FrontPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FrontPageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FrontPage"],
		__typename?: true
}>;
	["FrontPageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FrontPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FrontPageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FrontPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
		__typename?: true
}>;
	["ImageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
		__typename?: true
}>;
	["LinkUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkableCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkableDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
		__typename?: true
}>;
	["LinkableUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkableUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
		__typename?: true
}>;
	["SeoUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SpecialEventCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SpecialEvent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SpecialEventDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SpecialEvent"],
		__typename?: true
}>;
	["SpecialEventUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SpecialEvent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SpecialEventUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SpecialEvent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TimelinePageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimelinePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TimelinePageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimelinePage"],
		__typename?: true
}>;
	["TimelinePageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimelinePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TimelinePageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimelinePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TimelinePostCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimelinePost"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TimelinePostDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimelinePost"],
		__typename?: true
}>;
	["TimelinePostUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimelinePost"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TimelinePostUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TimelinePost"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SourcePageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SourcePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SourcePageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SourcePage"],
		__typename?: true
}>;
	["SourcePageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SourcePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SourcePageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SourcePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SourcePostLinkCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SourcePostLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SourcePostLinkDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SourcePostLink"],
		__typename?: true
}>;
	["SourcePostLinkUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SourcePostLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SourcePostLinkUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SourcePostLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GalleryCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gallery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GalleryDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gallery"],
		__typename?: true
}>;
	["GalleryUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gallery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GalleryUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gallery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GalleryItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GalleryItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GalleryItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GalleryItem"],
		__typename?: true
}>;
	["GalleryItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GalleryItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GalleryItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GalleryItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["CardMediaCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CardMedia"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["CardMediaDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CardMedia"],
		__typename?: true
}>;
	["CardMediaUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CardMedia"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["CardMediaUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CardMedia"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["RedirectCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["RedirectDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
		__typename?: true
}>;
	["RedirectUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["RedirectUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["VenueCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Venue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["VenueDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Venue"],
		__typename?: true
}>;
	["VenueUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Venue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["VenueUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Venue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EventLabelCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EventLabel"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EventLabelDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EventLabel"],
		__typename?: true
}>;
	["EventLabelUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EventLabel"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EventLabelUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EventLabel"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Page"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Page"],
		__typename?: true
}>;
	["PageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Page"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Page"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MutationTransaction"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	validation?:ValueTypes["_ValidationResult"],
createContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["ContentCreateResult"]],
deleteContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["ContentDeleteResult"]],
updateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	data:ValueTypes["ContentUpdateInput"]},ValueTypes["ContentUpdateResult"]],
upsertContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	update:ValueTypes["ContentUpdateInput"],	create:ValueTypes["ContentCreateInput"]},ValueTypes["ContentUpsertResult"]],
createContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	update:ValueTypes["ContentBlockUpdateInput"],	create:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockUpsertResult"]],
createContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceCreateResult"]],
deleteContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReferenceDeleteResult"]],
updateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["ContentReferenceUpdateResult"]],
upsertContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	update:ValueTypes["ContentReferenceUpdateInput"],	create:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceUpsertResult"]],
createEvent?: [{	data:ValueTypes["EventCreateInput"]},ValueTypes["EventCreateResult"]],
deleteEvent?: [{	by:ValueTypes["EventUniqueWhere"],	filter?:ValueTypes["EventWhere"] | null},ValueTypes["EventDeleteResult"]],
updateEvent?: [{	by:ValueTypes["EventUniqueWhere"],	filter?:ValueTypes["EventWhere"] | null,	data:ValueTypes["EventUpdateInput"]},ValueTypes["EventUpdateResult"]],
upsertEvent?: [{	by:ValueTypes["EventUniqueWhere"],	filter?:ValueTypes["EventWhere"] | null,	update:ValueTypes["EventUpdateInput"],	create:ValueTypes["EventCreateInput"]},ValueTypes["EventUpsertResult"]],
createFallbackSeo?: [{	data:ValueTypes["FallbackSeoCreateInput"]},ValueTypes["FallbackSeoCreateResult"]],
deleteFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	filter?:ValueTypes["FallbackSeoWhere"] | null},ValueTypes["FallbackSeoDeleteResult"]],
updateFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	filter?:ValueTypes["FallbackSeoWhere"] | null,	data:ValueTypes["FallbackSeoUpdateInput"]},ValueTypes["FallbackSeoUpdateResult"]],
upsertFallbackSeo?: [{	by:ValueTypes["FallbackSeoUniqueWhere"],	filter?:ValueTypes["FallbackSeoWhere"] | null,	update:ValueTypes["FallbackSeoUpdateInput"],	create:ValueTypes["FallbackSeoCreateInput"]},ValueTypes["FallbackSeoUpsertResult"]],
createFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["FooterCreateResult"]],
deleteFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["FooterDeleteResult"]],
updateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	data:ValueTypes["FooterUpdateInput"]},ValueTypes["FooterUpdateResult"]],
upsertFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	update:ValueTypes["FooterUpdateInput"],	create:ValueTypes["FooterCreateInput"]},ValueTypes["FooterUpsertResult"]],
createHeader?: [{	data:ValueTypes["HeaderCreateInput"]},ValueTypes["HeaderCreateResult"]],
deleteHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["HeaderDeleteResult"]],
updateHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null,	data:ValueTypes["HeaderUpdateInput"]},ValueTypes["HeaderUpdateResult"]],
upsertHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null,	update:ValueTypes["HeaderUpdateInput"],	create:ValueTypes["HeaderCreateInput"]},ValueTypes["HeaderUpsertResult"]],
createHeaderLink?: [{	data:ValueTypes["HeaderLinkCreateInput"]},ValueTypes["HeaderLinkCreateResult"]],
deleteHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	filter?:ValueTypes["HeaderLinkWhere"] | null},ValueTypes["HeaderLinkDeleteResult"]],
updateHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	filter?:ValueTypes["HeaderLinkWhere"] | null,	data:ValueTypes["HeaderLinkUpdateInput"]},ValueTypes["HeaderLinkUpdateResult"]],
upsertHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	filter?:ValueTypes["HeaderLinkWhere"] | null,	update:ValueTypes["HeaderLinkUpdateInput"],	create:ValueTypes["HeaderLinkCreateInput"]},ValueTypes["HeaderLinkUpsertResult"]],
createFrontPage?: [{	data:ValueTypes["FrontPageCreateInput"]},ValueTypes["FrontPageCreateResult"]],
deleteFrontPage?: [{	by:ValueTypes["FrontPageUniqueWhere"],	filter?:ValueTypes["FrontPageWhere"] | null},ValueTypes["FrontPageDeleteResult"]],
updateFrontPage?: [{	by:ValueTypes["FrontPageUniqueWhere"],	filter?:ValueTypes["FrontPageWhere"] | null,	data:ValueTypes["FrontPageUpdateInput"]},ValueTypes["FrontPageUpdateResult"]],
upsertFrontPage?: [{	by:ValueTypes["FrontPageUniqueWhere"],	filter?:ValueTypes["FrontPageWhere"] | null,	update:ValueTypes["FrontPageUpdateInput"],	create:ValueTypes["FrontPageCreateInput"]},ValueTypes["FrontPageUpsertResult"]],
createImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["ImageCreateResult"]],
deleteImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["ImageDeleteResult"]],
updateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	data:ValueTypes["ImageUpdateInput"]},ValueTypes["ImageUpdateResult"]],
upsertImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	update:ValueTypes["ImageUpdateInput"],	create:ValueTypes["ImageCreateInput"]},ValueTypes["ImageUpsertResult"]],
createLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["LinkCreateResult"]],
deleteLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["LinkDeleteResult"]],
updateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	data:ValueTypes["LinkUpdateInput"]},ValueTypes["LinkUpdateResult"]],
upsertLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	update:ValueTypes["LinkUpdateInput"],	create:ValueTypes["LinkCreateInput"]},ValueTypes["LinkUpsertResult"]],
createLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	update:ValueTypes["LinkableUpdateInput"],	create:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableUpsertResult"]],
createSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["SeoCreateResult"]],
deleteSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["SeoDeleteResult"]],
updateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	data:ValueTypes["SeoUpdateInput"]},ValueTypes["SeoUpdateResult"]],
upsertSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	update:ValueTypes["SeoUpdateInput"],	create:ValueTypes["SeoCreateInput"]},ValueTypes["SeoUpsertResult"]],
createSpecialEvent?: [{	data:ValueTypes["SpecialEventCreateInput"]},ValueTypes["SpecialEventCreateResult"]],
deleteSpecialEvent?: [{	by:ValueTypes["SpecialEventUniqueWhere"],	filter?:ValueTypes["SpecialEventWhere"] | null},ValueTypes["SpecialEventDeleteResult"]],
updateSpecialEvent?: [{	by:ValueTypes["SpecialEventUniqueWhere"],	filter?:ValueTypes["SpecialEventWhere"] | null,	data:ValueTypes["SpecialEventUpdateInput"]},ValueTypes["SpecialEventUpdateResult"]],
upsertSpecialEvent?: [{	by:ValueTypes["SpecialEventUniqueWhere"],	filter?:ValueTypes["SpecialEventWhere"] | null,	update:ValueTypes["SpecialEventUpdateInput"],	create:ValueTypes["SpecialEventCreateInput"]},ValueTypes["SpecialEventUpsertResult"]],
createTimelinePage?: [{	data:ValueTypes["TimelinePageCreateInput"]},ValueTypes["TimelinePageCreateResult"]],
deleteTimelinePage?: [{	by:ValueTypes["TimelinePageUniqueWhere"],	filter?:ValueTypes["TimelinePageWhere"] | null},ValueTypes["TimelinePageDeleteResult"]],
updateTimelinePage?: [{	by:ValueTypes["TimelinePageUniqueWhere"],	filter?:ValueTypes["TimelinePageWhere"] | null,	data:ValueTypes["TimelinePageUpdateInput"]},ValueTypes["TimelinePageUpdateResult"]],
upsertTimelinePage?: [{	by:ValueTypes["TimelinePageUniqueWhere"],	filter?:ValueTypes["TimelinePageWhere"] | null,	update:ValueTypes["TimelinePageUpdateInput"],	create:ValueTypes["TimelinePageCreateInput"]},ValueTypes["TimelinePageUpsertResult"]],
createTimelinePost?: [{	data:ValueTypes["TimelinePostCreateInput"]},ValueTypes["TimelinePostCreateResult"]],
deleteTimelinePost?: [{	by:ValueTypes["TimelinePostUniqueWhere"],	filter?:ValueTypes["TimelinePostWhere"] | null},ValueTypes["TimelinePostDeleteResult"]],
updateTimelinePost?: [{	by:ValueTypes["TimelinePostUniqueWhere"],	filter?:ValueTypes["TimelinePostWhere"] | null,	data:ValueTypes["TimelinePostUpdateInput"]},ValueTypes["TimelinePostUpdateResult"]],
upsertTimelinePost?: [{	by:ValueTypes["TimelinePostUniqueWhere"],	filter?:ValueTypes["TimelinePostWhere"] | null,	update:ValueTypes["TimelinePostUpdateInput"],	create:ValueTypes["TimelinePostCreateInput"]},ValueTypes["TimelinePostUpsertResult"]],
createSourcePage?: [{	data:ValueTypes["SourcePageCreateInput"]},ValueTypes["SourcePageCreateResult"]],
deleteSourcePage?: [{	by:ValueTypes["SourcePageUniqueWhere"],	filter?:ValueTypes["SourcePageWhere"] | null},ValueTypes["SourcePageDeleteResult"]],
updateSourcePage?: [{	by:ValueTypes["SourcePageUniqueWhere"],	filter?:ValueTypes["SourcePageWhere"] | null,	data:ValueTypes["SourcePageUpdateInput"]},ValueTypes["SourcePageUpdateResult"]],
upsertSourcePage?: [{	by:ValueTypes["SourcePageUniqueWhere"],	filter?:ValueTypes["SourcePageWhere"] | null,	update:ValueTypes["SourcePageUpdateInput"],	create:ValueTypes["SourcePageCreateInput"]},ValueTypes["SourcePageUpsertResult"]],
createSourcePostLink?: [{	data:ValueTypes["SourcePostLinkCreateInput"]},ValueTypes["SourcePostLinkCreateResult"]],
deleteSourcePostLink?: [{	by:ValueTypes["SourcePostLinkUniqueWhere"],	filter?:ValueTypes["SourcePostLinkWhere"] | null},ValueTypes["SourcePostLinkDeleteResult"]],
updateSourcePostLink?: [{	by:ValueTypes["SourcePostLinkUniqueWhere"],	filter?:ValueTypes["SourcePostLinkWhere"] | null,	data:ValueTypes["SourcePostLinkUpdateInput"]},ValueTypes["SourcePostLinkUpdateResult"]],
upsertSourcePostLink?: [{	by:ValueTypes["SourcePostLinkUniqueWhere"],	filter?:ValueTypes["SourcePostLinkWhere"] | null,	update:ValueTypes["SourcePostLinkUpdateInput"],	create:ValueTypes["SourcePostLinkCreateInput"]},ValueTypes["SourcePostLinkUpsertResult"]],
createGallery?: [{	data:ValueTypes["GalleryCreateInput"]},ValueTypes["GalleryCreateResult"]],
deleteGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["GalleryDeleteResult"]],
updateGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null,	data:ValueTypes["GalleryUpdateInput"]},ValueTypes["GalleryUpdateResult"]],
upsertGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null,	update:ValueTypes["GalleryUpdateInput"],	create:ValueTypes["GalleryCreateInput"]},ValueTypes["GalleryUpsertResult"]],
createGalleryItem?: [{	data:ValueTypes["GalleryItemCreateInput"]},ValueTypes["GalleryItemCreateResult"]],
deleteGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null},ValueTypes["GalleryItemDeleteResult"]],
updateGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null,	data:ValueTypes["GalleryItemUpdateInput"]},ValueTypes["GalleryItemUpdateResult"]],
upsertGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null,	update:ValueTypes["GalleryItemUpdateInput"],	create:ValueTypes["GalleryItemCreateInput"]},ValueTypes["GalleryItemUpsertResult"]],
createCardMedia?: [{	data:ValueTypes["CardMediaCreateInput"]},ValueTypes["CardMediaCreateResult"]],
deleteCardMedia?: [{	by:ValueTypes["CardMediaUniqueWhere"],	filter?:ValueTypes["CardMediaWhere"] | null},ValueTypes["CardMediaDeleteResult"]],
updateCardMedia?: [{	by:ValueTypes["CardMediaUniqueWhere"],	filter?:ValueTypes["CardMediaWhere"] | null,	data:ValueTypes["CardMediaUpdateInput"]},ValueTypes["CardMediaUpdateResult"]],
upsertCardMedia?: [{	by:ValueTypes["CardMediaUniqueWhere"],	filter?:ValueTypes["CardMediaWhere"] | null,	update:ValueTypes["CardMediaUpdateInput"],	create:ValueTypes["CardMediaCreateInput"]},ValueTypes["CardMediaUpsertResult"]],
createRedirect?: [{	data:ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectCreateResult"]],
deleteRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["RedirectDeleteResult"]],
updateRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null,	data:ValueTypes["RedirectUpdateInput"]},ValueTypes["RedirectUpdateResult"]],
upsertRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null,	update:ValueTypes["RedirectUpdateInput"],	create:ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectUpsertResult"]],
createVenue?: [{	data:ValueTypes["VenueCreateInput"]},ValueTypes["VenueCreateResult"]],
deleteVenue?: [{	by:ValueTypes["VenueUniqueWhere"],	filter?:ValueTypes["VenueWhere"] | null},ValueTypes["VenueDeleteResult"]],
updateVenue?: [{	by:ValueTypes["VenueUniqueWhere"],	filter?:ValueTypes["VenueWhere"] | null,	data:ValueTypes["VenueUpdateInput"]},ValueTypes["VenueUpdateResult"]],
upsertVenue?: [{	by:ValueTypes["VenueUniqueWhere"],	filter?:ValueTypes["VenueWhere"] | null,	update:ValueTypes["VenueUpdateInput"],	create:ValueTypes["VenueCreateInput"]},ValueTypes["VenueUpsertResult"]],
createEventLabel?: [{	data:ValueTypes["EventLabelCreateInput"]},ValueTypes["EventLabelCreateResult"]],
deleteEventLabel?: [{	by:ValueTypes["EventLabelUniqueWhere"],	filter?:ValueTypes["EventLabelWhere"] | null},ValueTypes["EventLabelDeleteResult"]],
updateEventLabel?: [{	by:ValueTypes["EventLabelUniqueWhere"],	filter?:ValueTypes["EventLabelWhere"] | null,	data:ValueTypes["EventLabelUpdateInput"]},ValueTypes["EventLabelUpdateResult"]],
upsertEventLabel?: [{	by:ValueTypes["EventLabelUniqueWhere"],	filter?:ValueTypes["EventLabelWhere"] | null,	update:ValueTypes["EventLabelUpdateInput"],	create:ValueTypes["EventLabelCreateInput"]},ValueTypes["EventLabelUpsertResult"]],
createPage?: [{	data:ValueTypes["PageCreateInput"]},ValueTypes["PageCreateResult"]],
deletePage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null},ValueTypes["PageDeleteResult"]],
updatePage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null,	data:ValueTypes["PageUpdateInput"]},ValueTypes["PageUpdateResult"]],
upsertPage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null,	update:ValueTypes["PageUpdateInput"],	create:ValueTypes["PageCreateInput"]},ValueTypes["PageUpsertResult"]],
	query?:ValueTypes["Query"],
		__typename?: true
}>;
	["MutationTransactionOptions"]: {
	deferForeignKeyConstraints?:boolean | null
};
	/** Json custom scalar type */
["Json"]:unknown;
	["_Schema"]: AliasType<{
	enums?:ValueTypes["_Enum"],
	entities?:ValueTypes["_Entity"],
		__typename?: true
}>;
	["_Entity"]: AliasType<{
	name?:true,
	customPrimaryAllowed?:true,
	fields?:ValueTypes["_Field"],
	unique?:ValueTypes["_UniqueConstraint"],
		__typename?: true
}>;
	["_UniqueConstraint"]: AliasType<{
	fields?:true,
		__typename?: true
}>;
	["_Field"]:AliasType<{
		name?:true,
	type?:true,
	nullable?:true,
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"];
		['...on _Column']?: Omit<ValueTypes["_Column"],keyof ValueTypes["_Field"]>;
		['...on _Relation']?: Omit<ValueTypes["_Relation"],keyof ValueTypes["_Field"]>;
		__typename?: true
}>;
	["_Column"]: AliasType<{
	name?:true,
	type?:true,
	enumName?:true,
	defaultValue?:true,
	nullable?:true,
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"],
		__typename?: true
}>;
	["_OnDeleteBehaviour"]:_OnDeleteBehaviour;
	["_RelationSide"]:_RelationSide;
	["_OrderByDirection"]:_OrderByDirection;
	["_OrderBy"]: AliasType<{
	path?:true,
	direction?:true,
		__typename?: true
}>;
	["_Relation"]: AliasType<{
	name?:true,
	type?:true,
	side?:true,
	targetEntity?:true,
	ownedBy?:true,
	inversedBy?:true,
	nullable?:true,
	onDelete?:true,
	orphanRemoval?:true,
	orderBy?:ValueTypes["_OrderBy"],
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"],
		__typename?: true
}>;
	["_Rule"]: AliasType<{
	message?:ValueTypes["_RuleMessage"],
	validator?:true,
		__typename?: true
}>;
	["_Validator"]: AliasType<{
	operation?:true,
	arguments?:ValueTypes["_Argument"],
		__typename?: true
}>;
	["_Argument"]: AliasType<{		["...on _ValidatorArgument"] : ValueTypes["_ValidatorArgument"],
		["...on _PathArgument"] : ValueTypes["_PathArgument"],
		["...on _LiteralArgument"] : ValueTypes["_LiteralArgument"]
		__typename?: true
}>;
	["_ValidatorArgument"]: AliasType<{
	validator?:true,
		__typename?: true
}>;
	["_PathArgument"]: AliasType<{
	path?:true,
		__typename?: true
}>;
	["_LiteralArgument"]: AliasType<{
	value?:true,
		__typename?: true
}>;
	["_RuleMessage"]: AliasType<{
	text?:true,
		__typename?: true
}>;
	["_Enum"]: AliasType<{
	name?:true,
	values?:true,
		__typename?: true
}>;
	["S3SignedUpload"]: AliasType<{
	url?:true,
	headers?:ValueTypes["S3Header"],
	method?:true,
	/** Allowed patterns:
** */
	objectKey?:true,
	bucket?:true,
	publicUrl?:true,
		__typename?: true
}>;
	["S3Header"]: AliasType<{
	key?:true,
	value?:true,
		__typename?: true
}>;
	["S3SignedRead"]: AliasType<{
	url?:true,
	headers?:ValueTypes["S3Header"],
	method?:true,
	/** Allowed patterns:
** */
	objectKey?:true,
	bucket?:true,
		__typename?: true
}>
  }

export type ModelTypes = {
    ["Query"]: {
		getContent?:ModelTypes["Content"],
	listContent:ModelTypes["Content"][],
	paginateContent:ModelTypes["ContentConnection"],
	validateCreateContent:ModelTypes["_ValidationResult"],
	validateUpdateContent:ModelTypes["_ValidationResult"],
	getContentBlock?:ModelTypes["ContentBlock"],
	listContentBlock:ModelTypes["ContentBlock"][],
	paginateContentBlock:ModelTypes["ContentBlockConnection"],
	validateCreateContentBlock:ModelTypes["_ValidationResult"],
	validateUpdateContentBlock:ModelTypes["_ValidationResult"],
	getContentReference?:ModelTypes["ContentReference"],
	listContentReference:ModelTypes["ContentReference"][],
	paginateContentReference:ModelTypes["ContentReferenceConnection"],
	validateCreateContentReference:ModelTypes["_ValidationResult"],
	validateUpdateContentReference:ModelTypes["_ValidationResult"],
	getEvent?:ModelTypes["Event"],
	listEvent:ModelTypes["Event"][],
	paginateEvent:ModelTypes["EventConnection"],
	validateCreateEvent:ModelTypes["_ValidationResult"],
	validateUpdateEvent:ModelTypes["_ValidationResult"],
	getFallbackSeo?:ModelTypes["FallbackSeo"],
	listFallbackSeo:ModelTypes["FallbackSeo"][],
	paginateFallbackSeo:ModelTypes["FallbackSeoConnection"],
	validateCreateFallbackSeo:ModelTypes["_ValidationResult"],
	validateUpdateFallbackSeo:ModelTypes["_ValidationResult"],
	getFooter?:ModelTypes["Footer"],
	listFooter:ModelTypes["Footer"][],
	paginateFooter:ModelTypes["FooterConnection"],
	validateCreateFooter:ModelTypes["_ValidationResult"],
	validateUpdateFooter:ModelTypes["_ValidationResult"],
	getHeader?:ModelTypes["Header"],
	listHeader:ModelTypes["Header"][],
	paginateHeader:ModelTypes["HeaderConnection"],
	validateCreateHeader:ModelTypes["_ValidationResult"],
	validateUpdateHeader:ModelTypes["_ValidationResult"],
	getHeaderLink?:ModelTypes["HeaderLink"],
	listHeaderLink:ModelTypes["HeaderLink"][],
	paginateHeaderLink:ModelTypes["HeaderLinkConnection"],
	validateCreateHeaderLink:ModelTypes["_ValidationResult"],
	validateUpdateHeaderLink:ModelTypes["_ValidationResult"],
	getFrontPage?:ModelTypes["FrontPage"],
	listFrontPage:ModelTypes["FrontPage"][],
	paginateFrontPage:ModelTypes["FrontPageConnection"],
	validateCreateFrontPage:ModelTypes["_ValidationResult"],
	validateUpdateFrontPage:ModelTypes["_ValidationResult"],
	getImage?:ModelTypes["Image"],
	listImage:ModelTypes["Image"][],
	paginateImage:ModelTypes["ImageConnection"],
	validateCreateImage:ModelTypes["_ValidationResult"],
	validateUpdateImage:ModelTypes["_ValidationResult"],
	getLink?:ModelTypes["Link"],
	listLink:ModelTypes["Link"][],
	paginateLink:ModelTypes["LinkConnection"],
	validateCreateLink:ModelTypes["_ValidationResult"],
	validateUpdateLink:ModelTypes["_ValidationResult"],
	getLinkable?:ModelTypes["Linkable"],
	listLinkable:ModelTypes["Linkable"][],
	paginateLinkable:ModelTypes["LinkableConnection"],
	validateCreateLinkable:ModelTypes["_ValidationResult"],
	validateUpdateLinkable:ModelTypes["_ValidationResult"],
	getSeo?:ModelTypes["Seo"],
	listSeo:ModelTypes["Seo"][],
	paginateSeo:ModelTypes["SeoConnection"],
	validateCreateSeo:ModelTypes["_ValidationResult"],
	validateUpdateSeo:ModelTypes["_ValidationResult"],
	getSpecialEvent?:ModelTypes["SpecialEvent"],
	listSpecialEvent:ModelTypes["SpecialEvent"][],
	paginateSpecialEvent:ModelTypes["SpecialEventConnection"],
	validateCreateSpecialEvent:ModelTypes["_ValidationResult"],
	validateUpdateSpecialEvent:ModelTypes["_ValidationResult"],
	getTimelinePage?:ModelTypes["TimelinePage"],
	listTimelinePage:ModelTypes["TimelinePage"][],
	paginateTimelinePage:ModelTypes["TimelinePageConnection"],
	validateCreateTimelinePage:ModelTypes["_ValidationResult"],
	validateUpdateTimelinePage:ModelTypes["_ValidationResult"],
	getTimelinePost?:ModelTypes["TimelinePost"],
	listTimelinePost:ModelTypes["TimelinePost"][],
	paginateTimelinePost:ModelTypes["TimelinePostConnection"],
	validateCreateTimelinePost:ModelTypes["_ValidationResult"],
	validateUpdateTimelinePost:ModelTypes["_ValidationResult"],
	getSourcePage?:ModelTypes["SourcePage"],
	listSourcePage:ModelTypes["SourcePage"][],
	paginateSourcePage:ModelTypes["SourcePageConnection"],
	validateCreateSourcePage:ModelTypes["_ValidationResult"],
	validateUpdateSourcePage:ModelTypes["_ValidationResult"],
	getSourcePostLink?:ModelTypes["SourcePostLink"],
	listSourcePostLink:ModelTypes["SourcePostLink"][],
	paginateSourcePostLink:ModelTypes["SourcePostLinkConnection"],
	validateCreateSourcePostLink:ModelTypes["_ValidationResult"],
	validateUpdateSourcePostLink:ModelTypes["_ValidationResult"],
	getGallery?:ModelTypes["Gallery"],
	listGallery:ModelTypes["Gallery"][],
	paginateGallery:ModelTypes["GalleryConnection"],
	validateCreateGallery:ModelTypes["_ValidationResult"],
	validateUpdateGallery:ModelTypes["_ValidationResult"],
	getGalleryItem?:ModelTypes["GalleryItem"],
	listGalleryItem:ModelTypes["GalleryItem"][],
	paginateGalleryItem:ModelTypes["GalleryItemConnection"],
	validateCreateGalleryItem:ModelTypes["_ValidationResult"],
	validateUpdateGalleryItem:ModelTypes["_ValidationResult"],
	getCardMedia?:ModelTypes["CardMedia"],
	listCardMedia:ModelTypes["CardMedia"][],
	paginateCardMedia:ModelTypes["CardMediaConnection"],
	validateCreateCardMedia:ModelTypes["_ValidationResult"],
	validateUpdateCardMedia:ModelTypes["_ValidationResult"],
	getRedirect?:ModelTypes["Redirect"],
	listRedirect:ModelTypes["Redirect"][],
	paginateRedirect:ModelTypes["RedirectConnection"],
	validateCreateRedirect:ModelTypes["_ValidationResult"],
	validateUpdateRedirect:ModelTypes["_ValidationResult"],
	getVenue?:ModelTypes["Venue"],
	listVenue:ModelTypes["Venue"][],
	paginateVenue:ModelTypes["VenueConnection"],
	validateCreateVenue:ModelTypes["_ValidationResult"],
	validateUpdateVenue:ModelTypes["_ValidationResult"],
	getEventLabel?:ModelTypes["EventLabel"],
	listEventLabel:ModelTypes["EventLabel"][],
	paginateEventLabel:ModelTypes["EventLabelConnection"],
	validateCreateEventLabel:ModelTypes["_ValidationResult"],
	validateUpdateEventLabel:ModelTypes["_ValidationResult"],
	getPage?:ModelTypes["Page"],
	listPage:ModelTypes["Page"][],
	paginatePage:ModelTypes["PageConnection"],
	validateCreatePage:ModelTypes["_ValidationResult"],
	validateUpdatePage:ModelTypes["_ValidationResult"],
	transaction?:ModelTypes["QueryTransaction"],
	_info?:ModelTypes["Info"],
	schema?:ModelTypes["_Schema"],
	s3DummyQuery?:string
};
	["Content"]: {
		_meta?:ModelTypes["ContentMeta"],
	id:ModelTypes["UUID"],
	blocks:ModelTypes["ContentBlock"][],
	blocksByReferences?:ModelTypes["ContentBlock"],
	paginateBlocks:ModelTypes["ContentBlockConnection"]
};
	["ContentMeta"]: {
		id?:ModelTypes["FieldMeta"],
	blocks?:ModelTypes["FieldMeta"]
};
	["FieldMeta"]: {
		readable?:boolean,
	updatable?:boolean
};
	["UUID"]:string;
	["ContentBlock"]: {
		_meta?:ModelTypes["ContentBlockMeta"],
	id:ModelTypes["UUID"],
	order:number,
	json:string,
	content?:ModelTypes["Content"],
	references:ModelTypes["ContentReference"][],
	referencesByLink?:ModelTypes["ContentReference"],
	paginateReferences:ModelTypes["ContentReferenceConnection"]
};
	["ContentBlockMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	json?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	references?:ModelTypes["FieldMeta"]
};
	["ContentWhere"]: GraphQLTypes["ContentWhere"];
	["UUIDCondition"]: GraphQLTypes["UUIDCondition"];
	["ContentBlockWhere"]: GraphQLTypes["ContentBlockWhere"];
	["IntCondition"]: GraphQLTypes["IntCondition"];
	["StringCondition"]: GraphQLTypes["StringCondition"];
	["ContentReferenceWhere"]: GraphQLTypes["ContentReferenceWhere"];
	["ContentReferenceTypeCondition"]: GraphQLTypes["ContentReferenceTypeCondition"];
	["ContentReferenceType"]: GraphQLTypes["ContentReferenceType"];
	["ImageWhere"]: GraphQLTypes["ImageWhere"];
	["LinkWhere"]: GraphQLTypes["LinkWhere"];
	["LinkTypeCondition"]: GraphQLTypes["LinkTypeCondition"];
	["LinkType"]: GraphQLTypes["LinkType"];
	["LinkableWhere"]: GraphQLTypes["LinkableWhere"];
	["EventWhere"]: GraphQLTypes["EventWhere"];
	["SeoWhere"]: GraphQLTypes["SeoWhere"];
	["VenueWhere"]: GraphQLTypes["VenueWhere"];
	["BooleanCondition"]: GraphQLTypes["BooleanCondition"];
	["EventLabelWhere"]: GraphQLTypes["EventLabelWhere"];
	["FrontPageWhere"]: GraphQLTypes["FrontPageWhere"];
	["OneCondition"]: GraphQLTypes["OneCondition"];
	["One"]: GraphQLTypes["One"];
	["GalleryWhere"]: GraphQLTypes["GalleryWhere"];
	["GalleryItemWhere"]: GraphQLTypes["GalleryItemWhere"];
	["SpecialEventWhere"]: GraphQLTypes["SpecialEventWhere"];
	["TimelinePageWhere"]: GraphQLTypes["TimelinePageWhere"];
	["SourcePageWhere"]: GraphQLTypes["SourcePageWhere"];
	["SourcePostLinkWhere"]: GraphQLTypes["SourcePostLinkWhere"];
	["RedirectWhere"]: GraphQLTypes["RedirectWhere"];
	["PageWhere"]: GraphQLTypes["PageWhere"];
	["CardMediaWhere"]: GraphQLTypes["CardMediaWhere"];
	["ContentReference"]: {
		_meta?:ModelTypes["ContentReferenceMeta"],
	id:ModelTypes["UUID"],
	type:ModelTypes["ContentReferenceType"],
	text?:string,
	block?:ModelTypes["ContentBlock"],
	image?:ModelTypes["Image"],
	link?:ModelTypes["Link"],
	cardMedia?:ModelTypes["CardMedia"]
};
	["ContentReferenceMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	block?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	cardMedia?:ModelTypes["FieldMeta"]
};
	["Image"]: {
		_meta?:ModelTypes["ImageMeta"],
	id:ModelTypes["UUID"],
	url:string,
	width?:number,
	height?:number,
	size?:number,
	type?:string,
	alt?:string
};
	["ImageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	width?:ModelTypes["FieldMeta"],
	height?:ModelTypes["FieldMeta"],
	size?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	alt?:ModelTypes["FieldMeta"]
};
	["Link"]: {
		_meta?:ModelTypes["LinkMeta"],
	id:ModelTypes["UUID"],
	type:ModelTypes["LinkType"],
	title?:string,
	externalLink?:string,
	internalLink?:ModelTypes["Linkable"]
};
	["LinkMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	externalLink?:ModelTypes["FieldMeta"],
	internalLink?:ModelTypes["FieldMeta"]
};
	["Linkable"]: {
		_meta?:ModelTypes["LinkableMeta"],
	id:ModelTypes["UUID"],
	url:string,
	event?:ModelTypes["Event"],
	frontPage?:ModelTypes["FrontPage"],
	specialEvent?:ModelTypes["SpecialEvent"],
	timelinePage?:ModelTypes["TimelinePage"],
	sourcePage?:ModelTypes["SourcePage"],
	redirect?:ModelTypes["Redirect"],
	page?:ModelTypes["Page"]
};
	["LinkableMeta"]: {
		id?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	event?:ModelTypes["FieldMeta"],
	frontPage?:ModelTypes["FieldMeta"],
	specialEvent?:ModelTypes["FieldMeta"],
	timelinePage?:ModelTypes["FieldMeta"],
	sourcePage?:ModelTypes["FieldMeta"],
	redirect?:ModelTypes["FieldMeta"],
	page?:ModelTypes["FieldMeta"]
};
	["Event"]: {
		_meta?:ModelTypes["EventMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	place?:string,
	entrance?:string,
	image?:ModelTypes["Image"],
	seo?:ModelTypes["Seo"],
	link?:ModelTypes["Linkable"],
	content?:ModelTypes["Content"],
	date?:string,
	order:number,
	linkForEvent?:ModelTypes["Link"],
	venue?:ModelTypes["Venue"],
	pastEvent?:boolean,
	eventLabels:ModelTypes["EventLabel"][],
	paginateEventLabels:ModelTypes["EventLabelConnection"]
};
	["EventMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	place?:ModelTypes["FieldMeta"],
	entrance?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	date?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	linkForEvent?:ModelTypes["FieldMeta"],
	venue?:ModelTypes["FieldMeta"],
	pastEvent?:ModelTypes["FieldMeta"],
	eventLabels?:ModelTypes["FieldMeta"]
};
	["Seo"]: {
		_meta?:ModelTypes["SeoMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	description?:string,
	ogTitle?:string,
	ogDescription?:string,
	ogImage?:ModelTypes["Image"]
};
	["SeoMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	description?:ModelTypes["FieldMeta"],
	ogTitle?:ModelTypes["FieldMeta"],
	ogDescription?:ModelTypes["FieldMeta"],
	ogImage?:ModelTypes["FieldMeta"]
};
	["Venue"]: {
		_meta?:ModelTypes["VenueMeta"],
	id:ModelTypes["UUID"],
	name?:string,
	order:number
};
	["VenueMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"]
};
	["EventLabel"]: {
		_meta?:ModelTypes["EventLabelMeta"],
	id:ModelTypes["UUID"],
	order:number,
	text?:string,
	event?:ModelTypes["Event"]
};
	["EventLabelMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	event?:ModelTypes["FieldMeta"]
};
	["EventLabelOrderBy"]: GraphQLTypes["EventLabelOrderBy"];
	["OrderDirection"]: GraphQLTypes["OrderDirection"];
	["EventOrderBy"]: GraphQLTypes["EventOrderBy"];
	["ImageOrderBy"]: GraphQLTypes["ImageOrderBy"];
	["SeoOrderBy"]: GraphQLTypes["SeoOrderBy"];
	["LinkableOrderBy"]: GraphQLTypes["LinkableOrderBy"];
	["FrontPageOrderBy"]: GraphQLTypes["FrontPageOrderBy"];
	["LinkOrderBy"]: GraphQLTypes["LinkOrderBy"];
	["GalleryOrderBy"]: GraphQLTypes["GalleryOrderBy"];
	["SpecialEventOrderBy"]: GraphQLTypes["SpecialEventOrderBy"];
	["ContentOrderBy"]: GraphQLTypes["ContentOrderBy"];
	["TimelinePageOrderBy"]: GraphQLTypes["TimelinePageOrderBy"];
	["SourcePageOrderBy"]: GraphQLTypes["SourcePageOrderBy"];
	["RedirectOrderBy"]: GraphQLTypes["RedirectOrderBy"];
	["PageOrderBy"]: GraphQLTypes["PageOrderBy"];
	["VenueOrderBy"]: GraphQLTypes["VenueOrderBy"];
	["EventLabelConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["EventLabelEdge"][]
};
	["PageInfo"]: {
		totalCount:number
};
	["EventLabelEdge"]: {
		node:ModelTypes["EventLabel"]
};
	["FrontPage"]: {
		_meta?:ModelTypes["FrontPageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	title?:string,
	openingText?:string,
	eventsTitle?:string,
	firstLink?:ModelTypes["Link"],
	secondLink?:ModelTypes["Link"],
	seo?:ModelTypes["Seo"],
	link?:ModelTypes["Linkable"],
	subtitle?:string,
	projectSupport?:string,
	projectAuspices?:string,
	image?:ModelTypes["Image"],
	gallery?:ModelTypes["Gallery"]
};
	["FrontPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	openingText?:ModelTypes["FieldMeta"],
	eventsTitle?:ModelTypes["FieldMeta"],
	firstLink?:ModelTypes["FieldMeta"],
	secondLink?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	subtitle?:ModelTypes["FieldMeta"],
	projectSupport?:ModelTypes["FieldMeta"],
	projectAuspices?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	gallery?:ModelTypes["FieldMeta"]
};
	["Gallery"]: {
		_meta?:ModelTypes["GalleryMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["GalleryItem"][],
	paginateItems:ModelTypes["GalleryItemConnection"]
};
	["GalleryMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["GalleryItem"]: {
		_meta?:ModelTypes["GalleryItemMeta"],
	id:ModelTypes["UUID"],
	order?:number,
	list?:ModelTypes["Gallery"],
	image?:ModelTypes["Image"]
};
	["GalleryItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"]
};
	["GalleryItemOrderBy"]: GraphQLTypes["GalleryItemOrderBy"];
	["GalleryItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["GalleryItemEdge"][]
};
	["GalleryItemEdge"]: {
		node:ModelTypes["GalleryItem"]
};
	["SpecialEvent"]: {
		_meta?:ModelTypes["SpecialEventMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	link?:ModelTypes["Linkable"],
	image?:ModelTypes["Image"],
	seo?:ModelTypes["Seo"],
	imageNote?:string,
	openingText?:string,
	subtitle?:string,
	unique:ModelTypes["One"],
	content?:ModelTypes["Content"]
};
	["SpecialEventMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	imageNote?:ModelTypes["FieldMeta"],
	openingText?:ModelTypes["FieldMeta"],
	subtitle?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"]
};
	["TimelinePage"]: {
		_meta?:ModelTypes["TimelinePageMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	link?:ModelTypes["Linkable"],
	seo?:ModelTypes["Seo"],
	unique:ModelTypes["One"]
};
	["TimelinePageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"]
};
	["SourcePage"]: {
		_meta?:ModelTypes["SourcePageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	title?:string,
	link?:ModelTypes["Linkable"],
	links:ModelTypes["SourcePostLink"][],
	seo?:ModelTypes["Seo"],
	paginateLinks:ModelTypes["SourcePostLinkConnection"]
};
	["SourcePageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	links?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"]
};
	["SourcePostLink"]: {
		_meta?:ModelTypes["SourcePostLinkMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	order:number,
	link?:ModelTypes["Link"]
};
	["SourcePostLinkMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"]
};
	["SourcePostLinkOrderBy"]: GraphQLTypes["SourcePostLinkOrderBy"];
	["SourcePostLinkConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SourcePostLinkEdge"][]
};
	["SourcePostLinkEdge"]: {
		node:ModelTypes["SourcePostLink"]
};
	["Redirect"]: {
		_meta?:ModelTypes["RedirectMeta"],
	id:ModelTypes["UUID"],
	targetUrl?:string,
	link?:ModelTypes["Linkable"],
	target?:ModelTypes["Linkable"]
};
	["RedirectMeta"]: {
		id?:ModelTypes["FieldMeta"],
	targetUrl?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	target?:ModelTypes["FieldMeta"]
};
	["Page"]: {
		_meta?:ModelTypes["PageMeta"],
	id:ModelTypes["UUID"],
	order:number,
	title?:string,
	link?:ModelTypes["Linkable"],
	content?:ModelTypes["Content"],
	seo?:ModelTypes["Seo"]
};
	["PageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"]
};
	["CardMedia"]: {
		_meta?:ModelTypes["CardMediaMeta"],
	id:ModelTypes["UUID"],
	text?:string,
	imageNote?:string,
	image?:ModelTypes["Image"]
};
	["CardMediaMeta"]: {
		id?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	imageNote?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"]
};
	["ContentReferenceOrderBy"]: GraphQLTypes["ContentReferenceOrderBy"];
	["ContentBlockOrderBy"]: GraphQLTypes["ContentBlockOrderBy"];
	["CardMediaOrderBy"]: GraphQLTypes["CardMediaOrderBy"];
	["ContentBlockReferencesByLinkUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByLinkUniqueWhere"];
	["LinkUniqueWhere"]: GraphQLTypes["LinkUniqueWhere"];
	["ContentReferenceConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentReferenceEdge"][]
};
	["ContentReferenceEdge"]: {
		node:ModelTypes["ContentReference"]
};
	["ContentBlocksByReferencesUniqueWhere"]: GraphQLTypes["ContentBlocksByReferencesUniqueWhere"];
	["ContentReferenceUniqueWhere"]: GraphQLTypes["ContentReferenceUniqueWhere"];
	["ContentBlockConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentBlockEdge"][]
};
	["ContentBlockEdge"]: {
		node:ModelTypes["ContentBlock"]
};
	["ContentUniqueWhere"]: GraphQLTypes["ContentUniqueWhere"];
	["ContentBlockUniqueWhere"]: GraphQLTypes["ContentBlockUniqueWhere"];
	["ContentConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentEdge"][]
};
	["ContentEdge"]: {
		node:ModelTypes["Content"]
};
	["_ValidationResult"]: {
		valid:boolean,
	errors:ModelTypes["_ValidationError"][]
};
	["_ValidationError"]: {
		path:ModelTypes["_PathFragment"][],
	message:ModelTypes["_ValidationMessage"]
};
	["_PathFragment"]:ModelTypes["_FieldPathFragment"] | ModelTypes["_IndexPathFragment"];
	["_FieldPathFragment"]: {
		field:string
};
	["_IndexPathFragment"]: {
		index:number,
	alias?:string
};
	["_ValidationMessage"]: {
		text:string
};
	["ContentCreateInput"]: GraphQLTypes["ContentCreateInput"];
	["ContentCreateBlocksEntityRelationInput"]: GraphQLTypes["ContentCreateBlocksEntityRelationInput"];
	["ContentBlockWithoutContentCreateInput"]: GraphQLTypes["ContentBlockWithoutContentCreateInput"];
	["ContentBlockCreateReferencesEntityRelationInput"]: GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"];
	["ContentReferenceWithoutBlockCreateInput"]: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"];
	["ContentReferenceCreateImageEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"];
	["ImageUniqueWhere"]: GraphQLTypes["ImageUniqueWhere"];
	["ImageCreateInput"]: GraphQLTypes["ImageCreateInput"];
	["ContentReferenceCreateLinkEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"];
	["LinkCreateInput"]: GraphQLTypes["LinkCreateInput"];
	["LinkCreateInternalLinkEntityRelationInput"]: GraphQLTypes["LinkCreateInternalLinkEntityRelationInput"];
	["LinkableUniqueWhere"]: GraphQLTypes["LinkableUniqueWhere"];
	["EventUniqueWhere"]: GraphQLTypes["EventUniqueWhere"];
	["SeoUniqueWhere"]: GraphQLTypes["SeoUniqueWhere"];
	["EventLabelUniqueWhere"]: GraphQLTypes["EventLabelUniqueWhere"];
	["FrontPageUniqueWhere"]: GraphQLTypes["FrontPageUniqueWhere"];
	["GalleryUniqueWhere"]: GraphQLTypes["GalleryUniqueWhere"];
	["GalleryItemUniqueWhere"]: GraphQLTypes["GalleryItemUniqueWhere"];
	["SpecialEventUniqueWhere"]: GraphQLTypes["SpecialEventUniqueWhere"];
	["TimelinePageUniqueWhere"]: GraphQLTypes["TimelinePageUniqueWhere"];
	["SourcePageUniqueWhere"]: GraphQLTypes["SourcePageUniqueWhere"];
	["RedirectUniqueWhere"]: GraphQLTypes["RedirectUniqueWhere"];
	["PageUniqueWhere"]: GraphQLTypes["PageUniqueWhere"];
	["LinkableCreateInput"]: GraphQLTypes["LinkableCreateInput"];
	["LinkableCreateEventEntityRelationInput"]: GraphQLTypes["LinkableCreateEventEntityRelationInput"];
	["EventWithoutLinkCreateInput"]: GraphQLTypes["EventWithoutLinkCreateInput"];
	["EventCreateImageEntityRelationInput"]: GraphQLTypes["EventCreateImageEntityRelationInput"];
	["EventCreateSeoEntityRelationInput"]: GraphQLTypes["EventCreateSeoEntityRelationInput"];
	["SeoCreateInput"]: GraphQLTypes["SeoCreateInput"];
	["SeoCreateOgImageEntityRelationInput"]: GraphQLTypes["SeoCreateOgImageEntityRelationInput"];
	["EventCreateContentEntityRelationInput"]: GraphQLTypes["EventCreateContentEntityRelationInput"];
	["EventCreateLinkForEventEntityRelationInput"]: GraphQLTypes["EventCreateLinkForEventEntityRelationInput"];
	["EventCreateVenueEntityRelationInput"]: GraphQLTypes["EventCreateVenueEntityRelationInput"];
	["VenueUniqueWhere"]: GraphQLTypes["VenueUniqueWhere"];
	["VenueCreateInput"]: GraphQLTypes["VenueCreateInput"];
	["EventCreateEventLabelsEntityRelationInput"]: GraphQLTypes["EventCreateEventLabelsEntityRelationInput"];
	["EventLabelWithoutEventCreateInput"]: GraphQLTypes["EventLabelWithoutEventCreateInput"];
	["LinkableCreateFrontPageEntityRelationInput"]: GraphQLTypes["LinkableCreateFrontPageEntityRelationInput"];
	["FrontPageWithoutLinkCreateInput"]: GraphQLTypes["FrontPageWithoutLinkCreateInput"];
	["FrontPageCreateFirstLinkEntityRelationInput"]: GraphQLTypes["FrontPageCreateFirstLinkEntityRelationInput"];
	["FrontPageCreateSecondLinkEntityRelationInput"]: GraphQLTypes["FrontPageCreateSecondLinkEntityRelationInput"];
	["FrontPageCreateSeoEntityRelationInput"]: GraphQLTypes["FrontPageCreateSeoEntityRelationInput"];
	["FrontPageCreateImageEntityRelationInput"]: GraphQLTypes["FrontPageCreateImageEntityRelationInput"];
	["FrontPageCreateGalleryEntityRelationInput"]: GraphQLTypes["FrontPageCreateGalleryEntityRelationInput"];
	["GalleryCreateInput"]: GraphQLTypes["GalleryCreateInput"];
	["GalleryCreateItemsEntityRelationInput"]: GraphQLTypes["GalleryCreateItemsEntityRelationInput"];
	["GalleryItemWithoutListCreateInput"]: GraphQLTypes["GalleryItemWithoutListCreateInput"];
	["GalleryItemCreateImageEntityRelationInput"]: GraphQLTypes["GalleryItemCreateImageEntityRelationInput"];
	["LinkableCreateSpecialEventEntityRelationInput"]: GraphQLTypes["LinkableCreateSpecialEventEntityRelationInput"];
	["SpecialEventWithoutLinkCreateInput"]: GraphQLTypes["SpecialEventWithoutLinkCreateInput"];
	["SpecialEventCreateImageEntityRelationInput"]: GraphQLTypes["SpecialEventCreateImageEntityRelationInput"];
	["SpecialEventCreateSeoEntityRelationInput"]: GraphQLTypes["SpecialEventCreateSeoEntityRelationInput"];
	["SpecialEventCreateContentEntityRelationInput"]: GraphQLTypes["SpecialEventCreateContentEntityRelationInput"];
	["LinkableCreateTimelinePageEntityRelationInput"]: GraphQLTypes["LinkableCreateTimelinePageEntityRelationInput"];
	["TimelinePageWithoutLinkCreateInput"]: GraphQLTypes["TimelinePageWithoutLinkCreateInput"];
	["TimelinePageCreateSeoEntityRelationInput"]: GraphQLTypes["TimelinePageCreateSeoEntityRelationInput"];
	["LinkableCreateSourcePageEntityRelationInput"]: GraphQLTypes["LinkableCreateSourcePageEntityRelationInput"];
	["SourcePageWithoutLinkCreateInput"]: GraphQLTypes["SourcePageWithoutLinkCreateInput"];
	["SourcePageCreateLinksEntityRelationInput"]: GraphQLTypes["SourcePageCreateLinksEntityRelationInput"];
	["SourcePostLinkUniqueWhere"]: GraphQLTypes["SourcePostLinkUniqueWhere"];
	["SourcePostLinkCreateInput"]: GraphQLTypes["SourcePostLinkCreateInput"];
	["SourcePostLinkCreateLinkEntityRelationInput"]: GraphQLTypes["SourcePostLinkCreateLinkEntityRelationInput"];
	["SourcePageCreateSeoEntityRelationInput"]: GraphQLTypes["SourcePageCreateSeoEntityRelationInput"];
	["LinkableCreateRedirectEntityRelationInput"]: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"];
	["RedirectWithoutLinkCreateInput"]: GraphQLTypes["RedirectWithoutLinkCreateInput"];
	["RedirectCreateTargetEntityRelationInput"]: GraphQLTypes["RedirectCreateTargetEntityRelationInput"];
	["LinkableCreatePageEntityRelationInput"]: GraphQLTypes["LinkableCreatePageEntityRelationInput"];
	["PageWithoutLinkCreateInput"]: GraphQLTypes["PageWithoutLinkCreateInput"];
	["PageCreateContentEntityRelationInput"]: GraphQLTypes["PageCreateContentEntityRelationInput"];
	["PageCreateSeoEntityRelationInput"]: GraphQLTypes["PageCreateSeoEntityRelationInput"];
	["ContentReferenceCreateCardMediaEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateCardMediaEntityRelationInput"];
	["CardMediaUniqueWhere"]: GraphQLTypes["CardMediaUniqueWhere"];
	["CardMediaCreateInput"]: GraphQLTypes["CardMediaCreateInput"];
	["CardMediaCreateImageEntityRelationInput"]: GraphQLTypes["CardMediaCreateImageEntityRelationInput"];
	["ContentUpdateInput"]: GraphQLTypes["ContentUpdateInput"];
	["ContentUpdateBlocksEntityRelationInput"]: GraphQLTypes["ContentUpdateBlocksEntityRelationInput"];
	["ContentUpdateBlocksRelationInput"]: GraphQLTypes["ContentUpdateBlocksRelationInput"];
	["ContentBlockWithoutContentUpdateInput"]: GraphQLTypes["ContentBlockWithoutContentUpdateInput"];
	["ContentBlockUpdateReferencesEntityRelationInput"]: GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"];
	["ContentBlockUpdateReferencesRelationInput"]: GraphQLTypes["ContentBlockUpdateReferencesRelationInput"];
	["ContentReferenceWithoutBlockUpdateInput"]: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"];
	["ContentReferenceUpdateImageEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"];
	["ImageUpdateInput"]: GraphQLTypes["ImageUpdateInput"];
	["ContentReferenceUpsertImageRelationInput"]: GraphQLTypes["ContentReferenceUpsertImageRelationInput"];
	["ContentReferenceUpdateLinkEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"];
	["LinkUpdateInput"]: GraphQLTypes["LinkUpdateInput"];
	["LinkUpdateInternalLinkEntityRelationInput"]: GraphQLTypes["LinkUpdateInternalLinkEntityRelationInput"];
	["LinkableUpdateInput"]: GraphQLTypes["LinkableUpdateInput"];
	["LinkableUpdateEventEntityRelationInput"]: GraphQLTypes["LinkableUpdateEventEntityRelationInput"];
	["EventWithoutLinkUpdateInput"]: GraphQLTypes["EventWithoutLinkUpdateInput"];
	["EventUpdateImageEntityRelationInput"]: GraphQLTypes["EventUpdateImageEntityRelationInput"];
	["EventUpsertImageRelationInput"]: GraphQLTypes["EventUpsertImageRelationInput"];
	["EventUpdateSeoEntityRelationInput"]: GraphQLTypes["EventUpdateSeoEntityRelationInput"];
	["SeoUpdateInput"]: GraphQLTypes["SeoUpdateInput"];
	["SeoUpdateOgImageEntityRelationInput"]: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"];
	["SeoUpsertOgImageRelationInput"]: GraphQLTypes["SeoUpsertOgImageRelationInput"];
	["EventUpsertSeoRelationInput"]: GraphQLTypes["EventUpsertSeoRelationInput"];
	["EventUpdateContentEntityRelationInput"]: GraphQLTypes["EventUpdateContentEntityRelationInput"];
	["EventUpsertContentRelationInput"]: GraphQLTypes["EventUpsertContentRelationInput"];
	["EventUpdateLinkForEventEntityRelationInput"]: GraphQLTypes["EventUpdateLinkForEventEntityRelationInput"];
	["EventUpsertLinkForEventRelationInput"]: GraphQLTypes["EventUpsertLinkForEventRelationInput"];
	["EventUpdateVenueEntityRelationInput"]: GraphQLTypes["EventUpdateVenueEntityRelationInput"];
	["VenueUpdateInput"]: GraphQLTypes["VenueUpdateInput"];
	["EventUpsertVenueRelationInput"]: GraphQLTypes["EventUpsertVenueRelationInput"];
	["EventUpdateEventLabelsEntityRelationInput"]: GraphQLTypes["EventUpdateEventLabelsEntityRelationInput"];
	["EventUpdateEventLabelsRelationInput"]: GraphQLTypes["EventUpdateEventLabelsRelationInput"];
	["EventLabelWithoutEventUpdateInput"]: GraphQLTypes["EventLabelWithoutEventUpdateInput"];
	["EventUpsertEventLabelsRelationInput"]: GraphQLTypes["EventUpsertEventLabelsRelationInput"];
	["LinkableUpsertEventRelationInput"]: GraphQLTypes["LinkableUpsertEventRelationInput"];
	["LinkableUpdateFrontPageEntityRelationInput"]: GraphQLTypes["LinkableUpdateFrontPageEntityRelationInput"];
	["FrontPageWithoutLinkUpdateInput"]: GraphQLTypes["FrontPageWithoutLinkUpdateInput"];
	["FrontPageUpdateFirstLinkEntityRelationInput"]: GraphQLTypes["FrontPageUpdateFirstLinkEntityRelationInput"];
	["FrontPageUpsertFirstLinkRelationInput"]: GraphQLTypes["FrontPageUpsertFirstLinkRelationInput"];
	["FrontPageUpdateSecondLinkEntityRelationInput"]: GraphQLTypes["FrontPageUpdateSecondLinkEntityRelationInput"];
	["FrontPageUpsertSecondLinkRelationInput"]: GraphQLTypes["FrontPageUpsertSecondLinkRelationInput"];
	["FrontPageUpdateSeoEntityRelationInput"]: GraphQLTypes["FrontPageUpdateSeoEntityRelationInput"];
	["FrontPageUpsertSeoRelationInput"]: GraphQLTypes["FrontPageUpsertSeoRelationInput"];
	["FrontPageUpdateImageEntityRelationInput"]: GraphQLTypes["FrontPageUpdateImageEntityRelationInput"];
	["FrontPageUpsertImageRelationInput"]: GraphQLTypes["FrontPageUpsertImageRelationInput"];
	["FrontPageUpdateGalleryEntityRelationInput"]: GraphQLTypes["FrontPageUpdateGalleryEntityRelationInput"];
	["GalleryUpdateInput"]: GraphQLTypes["GalleryUpdateInput"];
	["GalleryUpdateItemsEntityRelationInput"]: GraphQLTypes["GalleryUpdateItemsEntityRelationInput"];
	["GalleryUpdateItemsRelationInput"]: GraphQLTypes["GalleryUpdateItemsRelationInput"];
	["GalleryItemWithoutListUpdateInput"]: GraphQLTypes["GalleryItemWithoutListUpdateInput"];
	["GalleryItemUpdateImageEntityRelationInput"]: GraphQLTypes["GalleryItemUpdateImageEntityRelationInput"];
	["GalleryItemUpsertImageRelationInput"]: GraphQLTypes["GalleryItemUpsertImageRelationInput"];
	["GalleryUpsertItemsRelationInput"]: GraphQLTypes["GalleryUpsertItemsRelationInput"];
	["FrontPageUpsertGalleryRelationInput"]: GraphQLTypes["FrontPageUpsertGalleryRelationInput"];
	["LinkableUpsertFrontPageRelationInput"]: GraphQLTypes["LinkableUpsertFrontPageRelationInput"];
	["LinkableUpdateSpecialEventEntityRelationInput"]: GraphQLTypes["LinkableUpdateSpecialEventEntityRelationInput"];
	["SpecialEventWithoutLinkUpdateInput"]: GraphQLTypes["SpecialEventWithoutLinkUpdateInput"];
	["SpecialEventUpdateImageEntityRelationInput"]: GraphQLTypes["SpecialEventUpdateImageEntityRelationInput"];
	["SpecialEventUpsertImageRelationInput"]: GraphQLTypes["SpecialEventUpsertImageRelationInput"];
	["SpecialEventUpdateSeoEntityRelationInput"]: GraphQLTypes["SpecialEventUpdateSeoEntityRelationInput"];
	["SpecialEventUpsertSeoRelationInput"]: GraphQLTypes["SpecialEventUpsertSeoRelationInput"];
	["SpecialEventUpdateContentEntityRelationInput"]: GraphQLTypes["SpecialEventUpdateContentEntityRelationInput"];
	["SpecialEventUpsertContentRelationInput"]: GraphQLTypes["SpecialEventUpsertContentRelationInput"];
	["LinkableUpsertSpecialEventRelationInput"]: GraphQLTypes["LinkableUpsertSpecialEventRelationInput"];
	["LinkableUpdateTimelinePageEntityRelationInput"]: GraphQLTypes["LinkableUpdateTimelinePageEntityRelationInput"];
	["TimelinePageWithoutLinkUpdateInput"]: GraphQLTypes["TimelinePageWithoutLinkUpdateInput"];
	["TimelinePageUpdateSeoEntityRelationInput"]: GraphQLTypes["TimelinePageUpdateSeoEntityRelationInput"];
	["TimelinePageUpsertSeoRelationInput"]: GraphQLTypes["TimelinePageUpsertSeoRelationInput"];
	["LinkableUpsertTimelinePageRelationInput"]: GraphQLTypes["LinkableUpsertTimelinePageRelationInput"];
	["LinkableUpdateSourcePageEntityRelationInput"]: GraphQLTypes["LinkableUpdateSourcePageEntityRelationInput"];
	["SourcePageWithoutLinkUpdateInput"]: GraphQLTypes["SourcePageWithoutLinkUpdateInput"];
	["SourcePageUpdateLinksEntityRelationInput"]: GraphQLTypes["SourcePageUpdateLinksEntityRelationInput"];
	["SourcePageUpdateLinksRelationInput"]: GraphQLTypes["SourcePageUpdateLinksRelationInput"];
	["SourcePostLinkUpdateInput"]: GraphQLTypes["SourcePostLinkUpdateInput"];
	["SourcePostLinkUpdateLinkEntityRelationInput"]: GraphQLTypes["SourcePostLinkUpdateLinkEntityRelationInput"];
	["SourcePostLinkUpsertLinkRelationInput"]: GraphQLTypes["SourcePostLinkUpsertLinkRelationInput"];
	["SourcePageUpsertLinksRelationInput"]: GraphQLTypes["SourcePageUpsertLinksRelationInput"];
	["SourcePageUpdateSeoEntityRelationInput"]: GraphQLTypes["SourcePageUpdateSeoEntityRelationInput"];
	["SourcePageUpsertSeoRelationInput"]: GraphQLTypes["SourcePageUpsertSeoRelationInput"];
	["LinkableUpsertSourcePageRelationInput"]: GraphQLTypes["LinkableUpsertSourcePageRelationInput"];
	["LinkableUpdateRedirectEntityRelationInput"]: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"];
	["RedirectWithoutLinkUpdateInput"]: GraphQLTypes["RedirectWithoutLinkUpdateInput"];
	["RedirectUpdateTargetEntityRelationInput"]: GraphQLTypes["RedirectUpdateTargetEntityRelationInput"];
	["RedirectUpsertTargetRelationInput"]: GraphQLTypes["RedirectUpsertTargetRelationInput"];
	["LinkableUpsertRedirectRelationInput"]: GraphQLTypes["LinkableUpsertRedirectRelationInput"];
	["LinkableUpdatePageEntityRelationInput"]: GraphQLTypes["LinkableUpdatePageEntityRelationInput"];
	["PageWithoutLinkUpdateInput"]: GraphQLTypes["PageWithoutLinkUpdateInput"];
	["PageUpdateContentEntityRelationInput"]: GraphQLTypes["PageUpdateContentEntityRelationInput"];
	["PageUpsertContentRelationInput"]: GraphQLTypes["PageUpsertContentRelationInput"];
	["PageUpdateSeoEntityRelationInput"]: GraphQLTypes["PageUpdateSeoEntityRelationInput"];
	["PageUpsertSeoRelationInput"]: GraphQLTypes["PageUpsertSeoRelationInput"];
	["LinkableUpsertPageRelationInput"]: GraphQLTypes["LinkableUpsertPageRelationInput"];
	["LinkUpsertInternalLinkRelationInput"]: GraphQLTypes["LinkUpsertInternalLinkRelationInput"];
	["ContentReferenceUpsertLinkRelationInput"]: GraphQLTypes["ContentReferenceUpsertLinkRelationInput"];
	["ContentReferenceUpdateCardMediaEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateCardMediaEntityRelationInput"];
	["CardMediaUpdateInput"]: GraphQLTypes["CardMediaUpdateInput"];
	["CardMediaUpdateImageEntityRelationInput"]: GraphQLTypes["CardMediaUpdateImageEntityRelationInput"];
	["CardMediaUpsertImageRelationInput"]: GraphQLTypes["CardMediaUpsertImageRelationInput"];
	["ContentReferenceUpsertCardMediaRelationInput"]: GraphQLTypes["ContentReferenceUpsertCardMediaRelationInput"];
	["ContentBlockUpsertReferencesRelationInput"]: GraphQLTypes["ContentBlockUpsertReferencesRelationInput"];
	["ContentUpsertBlocksRelationInput"]: GraphQLTypes["ContentUpsertBlocksRelationInput"];
	["ContentBlockCreateInput"]: GraphQLTypes["ContentBlockCreateInput"];
	["ContentBlockCreateContentEntityRelationInput"]: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"];
	["ContentWithoutBlocksCreateInput"]: GraphQLTypes["ContentWithoutBlocksCreateInput"];
	["ContentBlockUpdateInput"]: GraphQLTypes["ContentBlockUpdateInput"];
	["ContentBlockUpdateContentEntityRelationInput"]: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"];
	["ContentWithoutBlocksUpdateInput"]: GraphQLTypes["ContentWithoutBlocksUpdateInput"];
	["ContentBlockUpsertContentRelationInput"]: GraphQLTypes["ContentBlockUpsertContentRelationInput"];
	["ContentReferenceCreateInput"]: GraphQLTypes["ContentReferenceCreateInput"];
	["ContentReferenceCreateBlockEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateBlockEntityRelationInput"];
	["ContentBlockWithoutReferencesCreateInput"]: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"];
	["ContentReferenceUpdateInput"]: GraphQLTypes["ContentReferenceUpdateInput"];
	["ContentReferenceUpdateBlockEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateBlockEntityRelationInput"];
	["ContentBlockWithoutReferencesUpdateInput"]: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"];
	["ContentReferenceUpsertBlockRelationInput"]: GraphQLTypes["ContentReferenceUpsertBlockRelationInput"];
	["EventConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["EventEdge"][]
};
	["EventEdge"]: {
		node:ModelTypes["Event"]
};
	["EventCreateInput"]: GraphQLTypes["EventCreateInput"];
	["EventCreateLinkEntityRelationInput"]: GraphQLTypes["EventCreateLinkEntityRelationInput"];
	["LinkableWithoutEventCreateInput"]: GraphQLTypes["LinkableWithoutEventCreateInput"];
	["EventUpdateInput"]: GraphQLTypes["EventUpdateInput"];
	["EventUpdateLinkEntityRelationInput"]: GraphQLTypes["EventUpdateLinkEntityRelationInput"];
	["LinkableWithoutEventUpdateInput"]: GraphQLTypes["LinkableWithoutEventUpdateInput"];
	["EventUpsertLinkRelationInput"]: GraphQLTypes["EventUpsertLinkRelationInput"];
	["FallbackSeo"]: {
		_meta?:ModelTypes["FallbackSeoMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	seo?:ModelTypes["Seo"]
};
	["FallbackSeoMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"]
};
	["FallbackSeoUniqueWhere"]: GraphQLTypes["FallbackSeoUniqueWhere"];
	["FallbackSeoWhere"]: GraphQLTypes["FallbackSeoWhere"];
	["FallbackSeoOrderBy"]: GraphQLTypes["FallbackSeoOrderBy"];
	["FallbackSeoConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FallbackSeoEdge"][]
};
	["FallbackSeoEdge"]: {
		node:ModelTypes["FallbackSeo"]
};
	["FallbackSeoCreateInput"]: GraphQLTypes["FallbackSeoCreateInput"];
	["FallbackSeoCreateSeoEntityRelationInput"]: GraphQLTypes["FallbackSeoCreateSeoEntityRelationInput"];
	["FallbackSeoUpdateInput"]: GraphQLTypes["FallbackSeoUpdateInput"];
	["FallbackSeoUpdateSeoEntityRelationInput"]: GraphQLTypes["FallbackSeoUpdateSeoEntityRelationInput"];
	["FallbackSeoUpsertSeoRelationInput"]: GraphQLTypes["FallbackSeoUpsertSeoRelationInput"];
	["Footer"]: {
		_meta?:ModelTypes["FooterMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	projectSupport?:string,
	projectAuspices?:string,
	gallery?:ModelTypes["Gallery"]
};
	["FooterMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	projectSupport?:ModelTypes["FieldMeta"],
	projectAuspices?:ModelTypes["FieldMeta"],
	gallery?:ModelTypes["FieldMeta"]
};
	["FooterUniqueWhere"]: GraphQLTypes["FooterUniqueWhere"];
	["FooterWhere"]: GraphQLTypes["FooterWhere"];
	["FooterOrderBy"]: GraphQLTypes["FooterOrderBy"];
	["FooterConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FooterEdge"][]
};
	["FooterEdge"]: {
		node:ModelTypes["Footer"]
};
	["FooterCreateInput"]: GraphQLTypes["FooterCreateInput"];
	["FooterCreateGalleryEntityRelationInput"]: GraphQLTypes["FooterCreateGalleryEntityRelationInput"];
	["FooterUpdateInput"]: GraphQLTypes["FooterUpdateInput"];
	["FooterUpdateGalleryEntityRelationInput"]: GraphQLTypes["FooterUpdateGalleryEntityRelationInput"];
	["FooterUpsertGalleryRelationInput"]: GraphQLTypes["FooterUpsertGalleryRelationInput"];
	["Header"]: {
		_meta?:ModelTypes["HeaderMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	links:ModelTypes["HeaderLink"][],
	paginateLinks:ModelTypes["HeaderLinkConnection"]
};
	["HeaderMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	links?:ModelTypes["FieldMeta"]
};
	["HeaderLink"]: {
		_meta?:ModelTypes["HeaderLinkMeta"],
	id:ModelTypes["UUID"],
	order:number,
	link?:ModelTypes["Link"]
};
	["HeaderLinkMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"]
};
	["HeaderLinkWhere"]: GraphQLTypes["HeaderLinkWhere"];
	["HeaderLinkOrderBy"]: GraphQLTypes["HeaderLinkOrderBy"];
	["HeaderLinkConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HeaderLinkEdge"][]
};
	["HeaderLinkEdge"]: {
		node:ModelTypes["HeaderLink"]
};
	["HeaderUniqueWhere"]: GraphQLTypes["HeaderUniqueWhere"];
	["HeaderWhere"]: GraphQLTypes["HeaderWhere"];
	["HeaderOrderBy"]: GraphQLTypes["HeaderOrderBy"];
	["HeaderConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HeaderEdge"][]
};
	["HeaderEdge"]: {
		node:ModelTypes["Header"]
};
	["HeaderCreateInput"]: GraphQLTypes["HeaderCreateInput"];
	["HeaderCreateLinksEntityRelationInput"]: GraphQLTypes["HeaderCreateLinksEntityRelationInput"];
	["HeaderLinkUniqueWhere"]: GraphQLTypes["HeaderLinkUniqueWhere"];
	["HeaderLinkCreateInput"]: GraphQLTypes["HeaderLinkCreateInput"];
	["HeaderLinkCreateLinkEntityRelationInput"]: GraphQLTypes["HeaderLinkCreateLinkEntityRelationInput"];
	["HeaderUpdateInput"]: GraphQLTypes["HeaderUpdateInput"];
	["HeaderUpdateLinksEntityRelationInput"]: GraphQLTypes["HeaderUpdateLinksEntityRelationInput"];
	["HeaderUpdateLinksRelationInput"]: GraphQLTypes["HeaderUpdateLinksRelationInput"];
	["HeaderLinkUpdateInput"]: GraphQLTypes["HeaderLinkUpdateInput"];
	["HeaderLinkUpdateLinkEntityRelationInput"]: GraphQLTypes["HeaderLinkUpdateLinkEntityRelationInput"];
	["HeaderLinkUpsertLinkRelationInput"]: GraphQLTypes["HeaderLinkUpsertLinkRelationInput"];
	["HeaderUpsertLinksRelationInput"]: GraphQLTypes["HeaderUpsertLinksRelationInput"];
	["FrontPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FrontPageEdge"][]
};
	["FrontPageEdge"]: {
		node:ModelTypes["FrontPage"]
};
	["FrontPageCreateInput"]: GraphQLTypes["FrontPageCreateInput"];
	["FrontPageCreateLinkEntityRelationInput"]: GraphQLTypes["FrontPageCreateLinkEntityRelationInput"];
	["LinkableWithoutFrontPageCreateInput"]: GraphQLTypes["LinkableWithoutFrontPageCreateInput"];
	["FrontPageUpdateInput"]: GraphQLTypes["FrontPageUpdateInput"];
	["FrontPageUpdateLinkEntityRelationInput"]: GraphQLTypes["FrontPageUpdateLinkEntityRelationInput"];
	["LinkableWithoutFrontPageUpdateInput"]: GraphQLTypes["LinkableWithoutFrontPageUpdateInput"];
	["FrontPageUpsertLinkRelationInput"]: GraphQLTypes["FrontPageUpsertLinkRelationInput"];
	["ImageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ImageEdge"][]
};
	["ImageEdge"]: {
		node:ModelTypes["Image"]
};
	["LinkConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkEdge"][]
};
	["LinkEdge"]: {
		node:ModelTypes["Link"]
};
	["LinkableConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkableEdge"][]
};
	["LinkableEdge"]: {
		node:ModelTypes["Linkable"]
};
	["SeoConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SeoEdge"][]
};
	["SeoEdge"]: {
		node:ModelTypes["Seo"]
};
	["SpecialEventConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SpecialEventEdge"][]
};
	["SpecialEventEdge"]: {
		node:ModelTypes["SpecialEvent"]
};
	["SpecialEventCreateInput"]: GraphQLTypes["SpecialEventCreateInput"];
	["SpecialEventCreateLinkEntityRelationInput"]: GraphQLTypes["SpecialEventCreateLinkEntityRelationInput"];
	["LinkableWithoutSpecialEventCreateInput"]: GraphQLTypes["LinkableWithoutSpecialEventCreateInput"];
	["SpecialEventUpdateInput"]: GraphQLTypes["SpecialEventUpdateInput"];
	["SpecialEventUpdateLinkEntityRelationInput"]: GraphQLTypes["SpecialEventUpdateLinkEntityRelationInput"];
	["LinkableWithoutSpecialEventUpdateInput"]: GraphQLTypes["LinkableWithoutSpecialEventUpdateInput"];
	["SpecialEventUpsertLinkRelationInput"]: GraphQLTypes["SpecialEventUpsertLinkRelationInput"];
	["TimelinePageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TimelinePageEdge"][]
};
	["TimelinePageEdge"]: {
		node:ModelTypes["TimelinePage"]
};
	["TimelinePageCreateInput"]: GraphQLTypes["TimelinePageCreateInput"];
	["TimelinePageCreateLinkEntityRelationInput"]: GraphQLTypes["TimelinePageCreateLinkEntityRelationInput"];
	["LinkableWithoutTimelinePageCreateInput"]: GraphQLTypes["LinkableWithoutTimelinePageCreateInput"];
	["TimelinePageUpdateInput"]: GraphQLTypes["TimelinePageUpdateInput"];
	["TimelinePageUpdateLinkEntityRelationInput"]: GraphQLTypes["TimelinePageUpdateLinkEntityRelationInput"];
	["LinkableWithoutTimelinePageUpdateInput"]: GraphQLTypes["LinkableWithoutTimelinePageUpdateInput"];
	["TimelinePageUpsertLinkRelationInput"]: GraphQLTypes["TimelinePageUpsertLinkRelationInput"];
	["TimelinePost"]: {
		_meta?:ModelTypes["TimelinePostMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	text?:string,
	image?:ModelTypes["Image"],
	seo?:ModelTypes["Seo"],
	date?:string,
	additionalInfo?:string,
	link?:ModelTypes["Link"],
	order:number
};
	["TimelinePostMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	date?:ModelTypes["FieldMeta"],
	additionalInfo?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"]
};
	["TimelinePostUniqueWhere"]: GraphQLTypes["TimelinePostUniqueWhere"];
	["TimelinePostWhere"]: GraphQLTypes["TimelinePostWhere"];
	["TimelinePostOrderBy"]: GraphQLTypes["TimelinePostOrderBy"];
	["TimelinePostConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TimelinePostEdge"][]
};
	["TimelinePostEdge"]: {
		node:ModelTypes["TimelinePost"]
};
	["TimelinePostCreateInput"]: GraphQLTypes["TimelinePostCreateInput"];
	["TimelinePostCreateImageEntityRelationInput"]: GraphQLTypes["TimelinePostCreateImageEntityRelationInput"];
	["TimelinePostCreateSeoEntityRelationInput"]: GraphQLTypes["TimelinePostCreateSeoEntityRelationInput"];
	["TimelinePostCreateLinkEntityRelationInput"]: GraphQLTypes["TimelinePostCreateLinkEntityRelationInput"];
	["TimelinePostUpdateInput"]: GraphQLTypes["TimelinePostUpdateInput"];
	["TimelinePostUpdateImageEntityRelationInput"]: GraphQLTypes["TimelinePostUpdateImageEntityRelationInput"];
	["TimelinePostUpsertImageRelationInput"]: GraphQLTypes["TimelinePostUpsertImageRelationInput"];
	["TimelinePostUpdateSeoEntityRelationInput"]: GraphQLTypes["TimelinePostUpdateSeoEntityRelationInput"];
	["TimelinePostUpsertSeoRelationInput"]: GraphQLTypes["TimelinePostUpsertSeoRelationInput"];
	["TimelinePostUpdateLinkEntityRelationInput"]: GraphQLTypes["TimelinePostUpdateLinkEntityRelationInput"];
	["TimelinePostUpsertLinkRelationInput"]: GraphQLTypes["TimelinePostUpsertLinkRelationInput"];
	["SourcePageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SourcePageEdge"][]
};
	["SourcePageEdge"]: {
		node:ModelTypes["SourcePage"]
};
	["SourcePageCreateInput"]: GraphQLTypes["SourcePageCreateInput"];
	["SourcePageCreateLinkEntityRelationInput"]: GraphQLTypes["SourcePageCreateLinkEntityRelationInput"];
	["LinkableWithoutSourcePageCreateInput"]: GraphQLTypes["LinkableWithoutSourcePageCreateInput"];
	["SourcePageUpdateInput"]: GraphQLTypes["SourcePageUpdateInput"];
	["SourcePageUpdateLinkEntityRelationInput"]: GraphQLTypes["SourcePageUpdateLinkEntityRelationInput"];
	["LinkableWithoutSourcePageUpdateInput"]: GraphQLTypes["LinkableWithoutSourcePageUpdateInput"];
	["SourcePageUpsertLinkRelationInput"]: GraphQLTypes["SourcePageUpsertLinkRelationInput"];
	["GalleryConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["GalleryEdge"][]
};
	["GalleryEdge"]: {
		node:ModelTypes["Gallery"]
};
	["GalleryItemCreateInput"]: GraphQLTypes["GalleryItemCreateInput"];
	["GalleryItemCreateListEntityRelationInput"]: GraphQLTypes["GalleryItemCreateListEntityRelationInput"];
	["GalleryWithoutItemsCreateInput"]: GraphQLTypes["GalleryWithoutItemsCreateInput"];
	["GalleryItemUpdateInput"]: GraphQLTypes["GalleryItemUpdateInput"];
	["GalleryItemUpdateListEntityRelationInput"]: GraphQLTypes["GalleryItemUpdateListEntityRelationInput"];
	["GalleryWithoutItemsUpdateInput"]: GraphQLTypes["GalleryWithoutItemsUpdateInput"];
	["GalleryItemUpsertListRelationInput"]: GraphQLTypes["GalleryItemUpsertListRelationInput"];
	["CardMediaConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["CardMediaEdge"][]
};
	["CardMediaEdge"]: {
		node:ModelTypes["CardMedia"]
};
	["RedirectConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["RedirectEdge"][]
};
	["RedirectEdge"]: {
		node:ModelTypes["Redirect"]
};
	["RedirectCreateInput"]: GraphQLTypes["RedirectCreateInput"];
	["RedirectCreateLinkEntityRelationInput"]: GraphQLTypes["RedirectCreateLinkEntityRelationInput"];
	["LinkableWithoutRedirectCreateInput"]: GraphQLTypes["LinkableWithoutRedirectCreateInput"];
	["RedirectUpdateInput"]: GraphQLTypes["RedirectUpdateInput"];
	["RedirectUpdateLinkEntityRelationInput"]: GraphQLTypes["RedirectUpdateLinkEntityRelationInput"];
	["LinkableWithoutRedirectUpdateInput"]: GraphQLTypes["LinkableWithoutRedirectUpdateInput"];
	["RedirectUpsertLinkRelationInput"]: GraphQLTypes["RedirectUpsertLinkRelationInput"];
	["VenueConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["VenueEdge"][]
};
	["VenueEdge"]: {
		node:ModelTypes["Venue"]
};
	["EventLabelCreateInput"]: GraphQLTypes["EventLabelCreateInput"];
	["EventLabelCreateEventEntityRelationInput"]: GraphQLTypes["EventLabelCreateEventEntityRelationInput"];
	["EventWithoutEventLabelsCreateInput"]: GraphQLTypes["EventWithoutEventLabelsCreateInput"];
	["EventLabelUpdateInput"]: GraphQLTypes["EventLabelUpdateInput"];
	["EventLabelUpdateEventEntityRelationInput"]: GraphQLTypes["EventLabelUpdateEventEntityRelationInput"];
	["EventWithoutEventLabelsUpdateInput"]: GraphQLTypes["EventWithoutEventLabelsUpdateInput"];
	["EventLabelUpsertEventRelationInput"]: GraphQLTypes["EventLabelUpsertEventRelationInput"];
	["PageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["PageEdge"][]
};
	["PageEdge"]: {
		node:ModelTypes["Page"]
};
	["PageCreateInput"]: GraphQLTypes["PageCreateInput"];
	["PageCreateLinkEntityRelationInput"]: GraphQLTypes["PageCreateLinkEntityRelationInput"];
	["LinkableWithoutPageCreateInput"]: GraphQLTypes["LinkableWithoutPageCreateInput"];
	["PageUpdateInput"]: GraphQLTypes["PageUpdateInput"];
	["PageUpdateLinkEntityRelationInput"]: GraphQLTypes["PageUpdateLinkEntityRelationInput"];
	["LinkableWithoutPageUpdateInput"]: GraphQLTypes["LinkableWithoutPageUpdateInput"];
	["PageUpsertLinkRelationInput"]: GraphQLTypes["PageUpsertLinkRelationInput"];
	["QueryTransaction"]: {
		getContent?:ModelTypes["Content"],
	listContent:ModelTypes["Content"][],
	paginateContent:ModelTypes["ContentConnection"],
	validateCreateContent:ModelTypes["_ValidationResult"],
	validateUpdateContent:ModelTypes["_ValidationResult"],
	getContentBlock?:ModelTypes["ContentBlock"],
	listContentBlock:ModelTypes["ContentBlock"][],
	paginateContentBlock:ModelTypes["ContentBlockConnection"],
	validateCreateContentBlock:ModelTypes["_ValidationResult"],
	validateUpdateContentBlock:ModelTypes["_ValidationResult"],
	getContentReference?:ModelTypes["ContentReference"],
	listContentReference:ModelTypes["ContentReference"][],
	paginateContentReference:ModelTypes["ContentReferenceConnection"],
	validateCreateContentReference:ModelTypes["_ValidationResult"],
	validateUpdateContentReference:ModelTypes["_ValidationResult"],
	getEvent?:ModelTypes["Event"],
	listEvent:ModelTypes["Event"][],
	paginateEvent:ModelTypes["EventConnection"],
	validateCreateEvent:ModelTypes["_ValidationResult"],
	validateUpdateEvent:ModelTypes["_ValidationResult"],
	getFallbackSeo?:ModelTypes["FallbackSeo"],
	listFallbackSeo:ModelTypes["FallbackSeo"][],
	paginateFallbackSeo:ModelTypes["FallbackSeoConnection"],
	validateCreateFallbackSeo:ModelTypes["_ValidationResult"],
	validateUpdateFallbackSeo:ModelTypes["_ValidationResult"],
	getFooter?:ModelTypes["Footer"],
	listFooter:ModelTypes["Footer"][],
	paginateFooter:ModelTypes["FooterConnection"],
	validateCreateFooter:ModelTypes["_ValidationResult"],
	validateUpdateFooter:ModelTypes["_ValidationResult"],
	getHeader?:ModelTypes["Header"],
	listHeader:ModelTypes["Header"][],
	paginateHeader:ModelTypes["HeaderConnection"],
	validateCreateHeader:ModelTypes["_ValidationResult"],
	validateUpdateHeader:ModelTypes["_ValidationResult"],
	getHeaderLink?:ModelTypes["HeaderLink"],
	listHeaderLink:ModelTypes["HeaderLink"][],
	paginateHeaderLink:ModelTypes["HeaderLinkConnection"],
	validateCreateHeaderLink:ModelTypes["_ValidationResult"],
	validateUpdateHeaderLink:ModelTypes["_ValidationResult"],
	getFrontPage?:ModelTypes["FrontPage"],
	listFrontPage:ModelTypes["FrontPage"][],
	paginateFrontPage:ModelTypes["FrontPageConnection"],
	validateCreateFrontPage:ModelTypes["_ValidationResult"],
	validateUpdateFrontPage:ModelTypes["_ValidationResult"],
	getImage?:ModelTypes["Image"],
	listImage:ModelTypes["Image"][],
	paginateImage:ModelTypes["ImageConnection"],
	validateCreateImage:ModelTypes["_ValidationResult"],
	validateUpdateImage:ModelTypes["_ValidationResult"],
	getLink?:ModelTypes["Link"],
	listLink:ModelTypes["Link"][],
	paginateLink:ModelTypes["LinkConnection"],
	validateCreateLink:ModelTypes["_ValidationResult"],
	validateUpdateLink:ModelTypes["_ValidationResult"],
	getLinkable?:ModelTypes["Linkable"],
	listLinkable:ModelTypes["Linkable"][],
	paginateLinkable:ModelTypes["LinkableConnection"],
	validateCreateLinkable:ModelTypes["_ValidationResult"],
	validateUpdateLinkable:ModelTypes["_ValidationResult"],
	getSeo?:ModelTypes["Seo"],
	listSeo:ModelTypes["Seo"][],
	paginateSeo:ModelTypes["SeoConnection"],
	validateCreateSeo:ModelTypes["_ValidationResult"],
	validateUpdateSeo:ModelTypes["_ValidationResult"],
	getSpecialEvent?:ModelTypes["SpecialEvent"],
	listSpecialEvent:ModelTypes["SpecialEvent"][],
	paginateSpecialEvent:ModelTypes["SpecialEventConnection"],
	validateCreateSpecialEvent:ModelTypes["_ValidationResult"],
	validateUpdateSpecialEvent:ModelTypes["_ValidationResult"],
	getTimelinePage?:ModelTypes["TimelinePage"],
	listTimelinePage:ModelTypes["TimelinePage"][],
	paginateTimelinePage:ModelTypes["TimelinePageConnection"],
	validateCreateTimelinePage:ModelTypes["_ValidationResult"],
	validateUpdateTimelinePage:ModelTypes["_ValidationResult"],
	getTimelinePost?:ModelTypes["TimelinePost"],
	listTimelinePost:ModelTypes["TimelinePost"][],
	paginateTimelinePost:ModelTypes["TimelinePostConnection"],
	validateCreateTimelinePost:ModelTypes["_ValidationResult"],
	validateUpdateTimelinePost:ModelTypes["_ValidationResult"],
	getSourcePage?:ModelTypes["SourcePage"],
	listSourcePage:ModelTypes["SourcePage"][],
	paginateSourcePage:ModelTypes["SourcePageConnection"],
	validateCreateSourcePage:ModelTypes["_ValidationResult"],
	validateUpdateSourcePage:ModelTypes["_ValidationResult"],
	getSourcePostLink?:ModelTypes["SourcePostLink"],
	listSourcePostLink:ModelTypes["SourcePostLink"][],
	paginateSourcePostLink:ModelTypes["SourcePostLinkConnection"],
	validateCreateSourcePostLink:ModelTypes["_ValidationResult"],
	validateUpdateSourcePostLink:ModelTypes["_ValidationResult"],
	getGallery?:ModelTypes["Gallery"],
	listGallery:ModelTypes["Gallery"][],
	paginateGallery:ModelTypes["GalleryConnection"],
	validateCreateGallery:ModelTypes["_ValidationResult"],
	validateUpdateGallery:ModelTypes["_ValidationResult"],
	getGalleryItem?:ModelTypes["GalleryItem"],
	listGalleryItem:ModelTypes["GalleryItem"][],
	paginateGalleryItem:ModelTypes["GalleryItemConnection"],
	validateCreateGalleryItem:ModelTypes["_ValidationResult"],
	validateUpdateGalleryItem:ModelTypes["_ValidationResult"],
	getCardMedia?:ModelTypes["CardMedia"],
	listCardMedia:ModelTypes["CardMedia"][],
	paginateCardMedia:ModelTypes["CardMediaConnection"],
	validateCreateCardMedia:ModelTypes["_ValidationResult"],
	validateUpdateCardMedia:ModelTypes["_ValidationResult"],
	getRedirect?:ModelTypes["Redirect"],
	listRedirect:ModelTypes["Redirect"][],
	paginateRedirect:ModelTypes["RedirectConnection"],
	validateCreateRedirect:ModelTypes["_ValidationResult"],
	validateUpdateRedirect:ModelTypes["_ValidationResult"],
	getVenue?:ModelTypes["Venue"],
	listVenue:ModelTypes["Venue"][],
	paginateVenue:ModelTypes["VenueConnection"],
	validateCreateVenue:ModelTypes["_ValidationResult"],
	validateUpdateVenue:ModelTypes["_ValidationResult"],
	getEventLabel?:ModelTypes["EventLabel"],
	listEventLabel:ModelTypes["EventLabel"][],
	paginateEventLabel:ModelTypes["EventLabelConnection"],
	validateCreateEventLabel:ModelTypes["_ValidationResult"],
	validateUpdateEventLabel:ModelTypes["_ValidationResult"],
	getPage?:ModelTypes["Page"],
	listPage:ModelTypes["Page"][],
	paginatePage:ModelTypes["PageConnection"],
	validateCreatePage:ModelTypes["_ValidationResult"],
	validateUpdatePage:ModelTypes["_ValidationResult"]
};
	["Info"]: {
		description?:string
};
	["Mutation"]: {
		createContent:ModelTypes["ContentCreateResult"],
	deleteContent:ModelTypes["ContentDeleteResult"],
	updateContent:ModelTypes["ContentUpdateResult"],
	upsertContent:ModelTypes["ContentUpsertResult"],
	createContentBlock:ModelTypes["ContentBlockCreateResult"],
	deleteContentBlock:ModelTypes["ContentBlockDeleteResult"],
	updateContentBlock:ModelTypes["ContentBlockUpdateResult"],
	upsertContentBlock:ModelTypes["ContentBlockUpsertResult"],
	createContentReference:ModelTypes["ContentReferenceCreateResult"],
	deleteContentReference:ModelTypes["ContentReferenceDeleteResult"],
	updateContentReference:ModelTypes["ContentReferenceUpdateResult"],
	upsertContentReference:ModelTypes["ContentReferenceUpsertResult"],
	createEvent:ModelTypes["EventCreateResult"],
	deleteEvent:ModelTypes["EventDeleteResult"],
	updateEvent:ModelTypes["EventUpdateResult"],
	upsertEvent:ModelTypes["EventUpsertResult"],
	createFallbackSeo:ModelTypes["FallbackSeoCreateResult"],
	deleteFallbackSeo:ModelTypes["FallbackSeoDeleteResult"],
	updateFallbackSeo:ModelTypes["FallbackSeoUpdateResult"],
	upsertFallbackSeo:ModelTypes["FallbackSeoUpsertResult"],
	createFooter:ModelTypes["FooterCreateResult"],
	deleteFooter:ModelTypes["FooterDeleteResult"],
	updateFooter:ModelTypes["FooterUpdateResult"],
	upsertFooter:ModelTypes["FooterUpsertResult"],
	createHeader:ModelTypes["HeaderCreateResult"],
	deleteHeader:ModelTypes["HeaderDeleteResult"],
	updateHeader:ModelTypes["HeaderUpdateResult"],
	upsertHeader:ModelTypes["HeaderUpsertResult"],
	createHeaderLink:ModelTypes["HeaderLinkCreateResult"],
	deleteHeaderLink:ModelTypes["HeaderLinkDeleteResult"],
	updateHeaderLink:ModelTypes["HeaderLinkUpdateResult"],
	upsertHeaderLink:ModelTypes["HeaderLinkUpsertResult"],
	createFrontPage:ModelTypes["FrontPageCreateResult"],
	deleteFrontPage:ModelTypes["FrontPageDeleteResult"],
	updateFrontPage:ModelTypes["FrontPageUpdateResult"],
	upsertFrontPage:ModelTypes["FrontPageUpsertResult"],
	createImage:ModelTypes["ImageCreateResult"],
	deleteImage:ModelTypes["ImageDeleteResult"],
	updateImage:ModelTypes["ImageUpdateResult"],
	upsertImage:ModelTypes["ImageUpsertResult"],
	createLink:ModelTypes["LinkCreateResult"],
	deleteLink:ModelTypes["LinkDeleteResult"],
	updateLink:ModelTypes["LinkUpdateResult"],
	upsertLink:ModelTypes["LinkUpsertResult"],
	createLinkable:ModelTypes["LinkableCreateResult"],
	deleteLinkable:ModelTypes["LinkableDeleteResult"],
	updateLinkable:ModelTypes["LinkableUpdateResult"],
	upsertLinkable:ModelTypes["LinkableUpsertResult"],
	createSeo:ModelTypes["SeoCreateResult"],
	deleteSeo:ModelTypes["SeoDeleteResult"],
	updateSeo:ModelTypes["SeoUpdateResult"],
	upsertSeo:ModelTypes["SeoUpsertResult"],
	createSpecialEvent:ModelTypes["SpecialEventCreateResult"],
	deleteSpecialEvent:ModelTypes["SpecialEventDeleteResult"],
	updateSpecialEvent:ModelTypes["SpecialEventUpdateResult"],
	upsertSpecialEvent:ModelTypes["SpecialEventUpsertResult"],
	createTimelinePage:ModelTypes["TimelinePageCreateResult"],
	deleteTimelinePage:ModelTypes["TimelinePageDeleteResult"],
	updateTimelinePage:ModelTypes["TimelinePageUpdateResult"],
	upsertTimelinePage:ModelTypes["TimelinePageUpsertResult"],
	createTimelinePost:ModelTypes["TimelinePostCreateResult"],
	deleteTimelinePost:ModelTypes["TimelinePostDeleteResult"],
	updateTimelinePost:ModelTypes["TimelinePostUpdateResult"],
	upsertTimelinePost:ModelTypes["TimelinePostUpsertResult"],
	createSourcePage:ModelTypes["SourcePageCreateResult"],
	deleteSourcePage:ModelTypes["SourcePageDeleteResult"],
	updateSourcePage:ModelTypes["SourcePageUpdateResult"],
	upsertSourcePage:ModelTypes["SourcePageUpsertResult"],
	createSourcePostLink:ModelTypes["SourcePostLinkCreateResult"],
	deleteSourcePostLink:ModelTypes["SourcePostLinkDeleteResult"],
	updateSourcePostLink:ModelTypes["SourcePostLinkUpdateResult"],
	upsertSourcePostLink:ModelTypes["SourcePostLinkUpsertResult"],
	createGallery:ModelTypes["GalleryCreateResult"],
	deleteGallery:ModelTypes["GalleryDeleteResult"],
	updateGallery:ModelTypes["GalleryUpdateResult"],
	upsertGallery:ModelTypes["GalleryUpsertResult"],
	createGalleryItem:ModelTypes["GalleryItemCreateResult"],
	deleteGalleryItem:ModelTypes["GalleryItemDeleteResult"],
	updateGalleryItem:ModelTypes["GalleryItemUpdateResult"],
	upsertGalleryItem:ModelTypes["GalleryItemUpsertResult"],
	createCardMedia:ModelTypes["CardMediaCreateResult"],
	deleteCardMedia:ModelTypes["CardMediaDeleteResult"],
	updateCardMedia:ModelTypes["CardMediaUpdateResult"],
	upsertCardMedia:ModelTypes["CardMediaUpsertResult"],
	createRedirect:ModelTypes["RedirectCreateResult"],
	deleteRedirect:ModelTypes["RedirectDeleteResult"],
	updateRedirect:ModelTypes["RedirectUpdateResult"],
	upsertRedirect:ModelTypes["RedirectUpsertResult"],
	createVenue:ModelTypes["VenueCreateResult"],
	deleteVenue:ModelTypes["VenueDeleteResult"],
	updateVenue:ModelTypes["VenueUpdateResult"],
	upsertVenue:ModelTypes["VenueUpsertResult"],
	createEventLabel:ModelTypes["EventLabelCreateResult"],
	deleteEventLabel:ModelTypes["EventLabelDeleteResult"],
	updateEventLabel:ModelTypes["EventLabelUpdateResult"],
	upsertEventLabel:ModelTypes["EventLabelUpsertResult"],
	createPage:ModelTypes["PageCreateResult"],
	deletePage:ModelTypes["PageDeleteResult"],
	updatePage:ModelTypes["PageUpdateResult"],
	upsertPage:ModelTypes["PageUpsertResult"],
	transaction:ModelTypes["MutationTransaction"],
	query:ModelTypes["Query"],
	generateUploadUrl:ModelTypes["S3SignedUpload"],
	generateReadUrl:ModelTypes["S3SignedRead"]
};
	["ContentCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"],
	validation:ModelTypes["_ValidationResult"]
};
	["MutationResult"]: ModelTypes["ContentCreateResult"] | ModelTypes["ContentDeleteResult"] | ModelTypes["ContentUpdateResult"] | ModelTypes["ContentUpsertResult"] | ModelTypes["ContentBlockCreateResult"] | ModelTypes["ContentBlockDeleteResult"] | ModelTypes["ContentBlockUpdateResult"] | ModelTypes["ContentBlockUpsertResult"] | ModelTypes["ContentReferenceCreateResult"] | ModelTypes["ContentReferenceDeleteResult"] | ModelTypes["ContentReferenceUpdateResult"] | ModelTypes["ContentReferenceUpsertResult"] | ModelTypes["EventCreateResult"] | ModelTypes["EventDeleteResult"] | ModelTypes["EventUpdateResult"] | ModelTypes["EventUpsertResult"] | ModelTypes["FallbackSeoCreateResult"] | ModelTypes["FallbackSeoDeleteResult"] | ModelTypes["FallbackSeoUpdateResult"] | ModelTypes["FallbackSeoUpsertResult"] | ModelTypes["FooterCreateResult"] | ModelTypes["FooterDeleteResult"] | ModelTypes["FooterUpdateResult"] | ModelTypes["FooterUpsertResult"] | ModelTypes["HeaderCreateResult"] | ModelTypes["HeaderDeleteResult"] | ModelTypes["HeaderUpdateResult"] | ModelTypes["HeaderUpsertResult"] | ModelTypes["HeaderLinkCreateResult"] | ModelTypes["HeaderLinkDeleteResult"] | ModelTypes["HeaderLinkUpdateResult"] | ModelTypes["HeaderLinkUpsertResult"] | ModelTypes["FrontPageCreateResult"] | ModelTypes["FrontPageDeleteResult"] | ModelTypes["FrontPageUpdateResult"] | ModelTypes["FrontPageUpsertResult"] | ModelTypes["ImageCreateResult"] | ModelTypes["ImageDeleteResult"] | ModelTypes["ImageUpdateResult"] | ModelTypes["ImageUpsertResult"] | ModelTypes["LinkCreateResult"] | ModelTypes["LinkDeleteResult"] | ModelTypes["LinkUpdateResult"] | ModelTypes["LinkUpsertResult"] | ModelTypes["LinkableCreateResult"] | ModelTypes["LinkableDeleteResult"] | ModelTypes["LinkableUpdateResult"] | ModelTypes["LinkableUpsertResult"] | ModelTypes["SeoCreateResult"] | ModelTypes["SeoDeleteResult"] | ModelTypes["SeoUpdateResult"] | ModelTypes["SeoUpsertResult"] | ModelTypes["SpecialEventCreateResult"] | ModelTypes["SpecialEventDeleteResult"] | ModelTypes["SpecialEventUpdateResult"] | ModelTypes["SpecialEventUpsertResult"] | ModelTypes["TimelinePageCreateResult"] | ModelTypes["TimelinePageDeleteResult"] | ModelTypes["TimelinePageUpdateResult"] | ModelTypes["TimelinePageUpsertResult"] | ModelTypes["TimelinePostCreateResult"] | ModelTypes["TimelinePostDeleteResult"] | ModelTypes["TimelinePostUpdateResult"] | ModelTypes["TimelinePostUpsertResult"] | ModelTypes["SourcePageCreateResult"] | ModelTypes["SourcePageDeleteResult"] | ModelTypes["SourcePageUpdateResult"] | ModelTypes["SourcePageUpsertResult"] | ModelTypes["SourcePostLinkCreateResult"] | ModelTypes["SourcePostLinkDeleteResult"] | ModelTypes["SourcePostLinkUpdateResult"] | ModelTypes["SourcePostLinkUpsertResult"] | ModelTypes["GalleryCreateResult"] | ModelTypes["GalleryDeleteResult"] | ModelTypes["GalleryUpdateResult"] | ModelTypes["GalleryUpsertResult"] | ModelTypes["GalleryItemCreateResult"] | ModelTypes["GalleryItemDeleteResult"] | ModelTypes["GalleryItemUpdateResult"] | ModelTypes["GalleryItemUpsertResult"] | ModelTypes["CardMediaCreateResult"] | ModelTypes["CardMediaDeleteResult"] | ModelTypes["CardMediaUpdateResult"] | ModelTypes["CardMediaUpsertResult"] | ModelTypes["RedirectCreateResult"] | ModelTypes["RedirectDeleteResult"] | ModelTypes["RedirectUpdateResult"] | ModelTypes["RedirectUpsertResult"] | ModelTypes["VenueCreateResult"] | ModelTypes["VenueDeleteResult"] | ModelTypes["VenueUpdateResult"] | ModelTypes["VenueUpsertResult"] | ModelTypes["EventLabelCreateResult"] | ModelTypes["EventLabelDeleteResult"] | ModelTypes["EventLabelUpdateResult"] | ModelTypes["EventLabelUpsertResult"] | ModelTypes["PageCreateResult"] | ModelTypes["PageDeleteResult"] | ModelTypes["PageUpdateResult"] | ModelTypes["PageUpsertResult"];
	["_MutationError"]: {
		path:ModelTypes["_PathFragment"][],
	paths:ModelTypes["_PathFragment"][],
	type:ModelTypes["_MutationErrorType"],
	message?:string
};
	["_MutationErrorType"]: GraphQLTypes["_MutationErrorType"];
	["ContentDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"]
};
	["ContentUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentBlockCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentBlockDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"]
};
	["ContentBlockUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentBlockUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"]
};
	["ContentReferenceUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"],
	validation:ModelTypes["_ValidationResult"]
};
	["EventCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Event"],
	validation:ModelTypes["_ValidationResult"]
};
	["EventDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Event"]
};
	["EventUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Event"],
	validation:ModelTypes["_ValidationResult"]
};
	["EventUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Event"],
	validation:ModelTypes["_ValidationResult"]
};
	["FallbackSeoCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FallbackSeo"],
	validation:ModelTypes["_ValidationResult"]
};
	["FallbackSeoDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FallbackSeo"]
};
	["FallbackSeoUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FallbackSeo"],
	validation:ModelTypes["_ValidationResult"]
};
	["FallbackSeoUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FallbackSeo"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"]
};
	["FooterUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Header"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Header"]
};
	["HeaderUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Header"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Header"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderLinkCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HeaderLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderLinkDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HeaderLink"]
};
	["HeaderLinkUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HeaderLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderLinkUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HeaderLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["FrontPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FrontPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["FrontPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FrontPage"]
};
	["FrontPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FrontPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["FrontPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FrontPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"]
};
	["ImageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"]
};
	["LinkUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkableCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkableDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"]
};
	["LinkableUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkableUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"]
};
	["SeoUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["SpecialEventCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SpecialEvent"],
	validation:ModelTypes["_ValidationResult"]
};
	["SpecialEventDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SpecialEvent"]
};
	["SpecialEventUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SpecialEvent"],
	validation:ModelTypes["_ValidationResult"]
};
	["SpecialEventUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SpecialEvent"],
	validation:ModelTypes["_ValidationResult"]
};
	["TimelinePageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TimelinePage"],
	validation:ModelTypes["_ValidationResult"]
};
	["TimelinePageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TimelinePage"]
};
	["TimelinePageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TimelinePage"],
	validation:ModelTypes["_ValidationResult"]
};
	["TimelinePageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TimelinePage"],
	validation:ModelTypes["_ValidationResult"]
};
	["TimelinePostCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TimelinePost"],
	validation:ModelTypes["_ValidationResult"]
};
	["TimelinePostDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TimelinePost"]
};
	["TimelinePostUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TimelinePost"],
	validation:ModelTypes["_ValidationResult"]
};
	["TimelinePostUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TimelinePost"],
	validation:ModelTypes["_ValidationResult"]
};
	["SourcePageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SourcePage"],
	validation:ModelTypes["_ValidationResult"]
};
	["SourcePageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SourcePage"]
};
	["SourcePageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SourcePage"],
	validation:ModelTypes["_ValidationResult"]
};
	["SourcePageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SourcePage"],
	validation:ModelTypes["_ValidationResult"]
};
	["SourcePostLinkCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SourcePostLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["SourcePostLinkDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SourcePostLink"]
};
	["SourcePostLinkUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SourcePostLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["SourcePostLinkUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SourcePostLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["GalleryCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Gallery"],
	validation:ModelTypes["_ValidationResult"]
};
	["GalleryDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Gallery"]
};
	["GalleryUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Gallery"],
	validation:ModelTypes["_ValidationResult"]
};
	["GalleryUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Gallery"],
	validation:ModelTypes["_ValidationResult"]
};
	["GalleryItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GalleryItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["GalleryItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GalleryItem"]
};
	["GalleryItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GalleryItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["GalleryItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GalleryItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["CardMediaCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["CardMedia"],
	validation:ModelTypes["_ValidationResult"]
};
	["CardMediaDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["CardMedia"]
};
	["CardMediaUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["CardMedia"],
	validation:ModelTypes["_ValidationResult"]
};
	["CardMediaUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["CardMedia"],
	validation:ModelTypes["_ValidationResult"]
};
	["RedirectCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Redirect"],
	validation:ModelTypes["_ValidationResult"]
};
	["RedirectDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Redirect"]
};
	["RedirectUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Redirect"],
	validation:ModelTypes["_ValidationResult"]
};
	["RedirectUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Redirect"],
	validation:ModelTypes["_ValidationResult"]
};
	["VenueCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Venue"],
	validation:ModelTypes["_ValidationResult"]
};
	["VenueDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Venue"]
};
	["VenueUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Venue"],
	validation:ModelTypes["_ValidationResult"]
};
	["VenueUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Venue"],
	validation:ModelTypes["_ValidationResult"]
};
	["EventLabelCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EventLabel"],
	validation:ModelTypes["_ValidationResult"]
};
	["EventLabelDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EventLabel"]
};
	["EventLabelUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EventLabel"],
	validation:ModelTypes["_ValidationResult"]
};
	["EventLabelUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EventLabel"],
	validation:ModelTypes["_ValidationResult"]
};
	["PageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Page"],
	validation:ModelTypes["_ValidationResult"]
};
	["PageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Page"]
};
	["PageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Page"],
	validation:ModelTypes["_ValidationResult"]
};
	["PageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Page"],
	validation:ModelTypes["_ValidationResult"]
};
	["MutationTransaction"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	validation:ModelTypes["_ValidationResult"],
	createContent:ModelTypes["ContentCreateResult"],
	deleteContent:ModelTypes["ContentDeleteResult"],
	updateContent:ModelTypes["ContentUpdateResult"],
	upsertContent:ModelTypes["ContentUpsertResult"],
	createContentBlock:ModelTypes["ContentBlockCreateResult"],
	deleteContentBlock:ModelTypes["ContentBlockDeleteResult"],
	updateContentBlock:ModelTypes["ContentBlockUpdateResult"],
	upsertContentBlock:ModelTypes["ContentBlockUpsertResult"],
	createContentReference:ModelTypes["ContentReferenceCreateResult"],
	deleteContentReference:ModelTypes["ContentReferenceDeleteResult"],
	updateContentReference:ModelTypes["ContentReferenceUpdateResult"],
	upsertContentReference:ModelTypes["ContentReferenceUpsertResult"],
	createEvent:ModelTypes["EventCreateResult"],
	deleteEvent:ModelTypes["EventDeleteResult"],
	updateEvent:ModelTypes["EventUpdateResult"],
	upsertEvent:ModelTypes["EventUpsertResult"],
	createFallbackSeo:ModelTypes["FallbackSeoCreateResult"],
	deleteFallbackSeo:ModelTypes["FallbackSeoDeleteResult"],
	updateFallbackSeo:ModelTypes["FallbackSeoUpdateResult"],
	upsertFallbackSeo:ModelTypes["FallbackSeoUpsertResult"],
	createFooter:ModelTypes["FooterCreateResult"],
	deleteFooter:ModelTypes["FooterDeleteResult"],
	updateFooter:ModelTypes["FooterUpdateResult"],
	upsertFooter:ModelTypes["FooterUpsertResult"],
	createHeader:ModelTypes["HeaderCreateResult"],
	deleteHeader:ModelTypes["HeaderDeleteResult"],
	updateHeader:ModelTypes["HeaderUpdateResult"],
	upsertHeader:ModelTypes["HeaderUpsertResult"],
	createHeaderLink:ModelTypes["HeaderLinkCreateResult"],
	deleteHeaderLink:ModelTypes["HeaderLinkDeleteResult"],
	updateHeaderLink:ModelTypes["HeaderLinkUpdateResult"],
	upsertHeaderLink:ModelTypes["HeaderLinkUpsertResult"],
	createFrontPage:ModelTypes["FrontPageCreateResult"],
	deleteFrontPage:ModelTypes["FrontPageDeleteResult"],
	updateFrontPage:ModelTypes["FrontPageUpdateResult"],
	upsertFrontPage:ModelTypes["FrontPageUpsertResult"],
	createImage:ModelTypes["ImageCreateResult"],
	deleteImage:ModelTypes["ImageDeleteResult"],
	updateImage:ModelTypes["ImageUpdateResult"],
	upsertImage:ModelTypes["ImageUpsertResult"],
	createLink:ModelTypes["LinkCreateResult"],
	deleteLink:ModelTypes["LinkDeleteResult"],
	updateLink:ModelTypes["LinkUpdateResult"],
	upsertLink:ModelTypes["LinkUpsertResult"],
	createLinkable:ModelTypes["LinkableCreateResult"],
	deleteLinkable:ModelTypes["LinkableDeleteResult"],
	updateLinkable:ModelTypes["LinkableUpdateResult"],
	upsertLinkable:ModelTypes["LinkableUpsertResult"],
	createSeo:ModelTypes["SeoCreateResult"],
	deleteSeo:ModelTypes["SeoDeleteResult"],
	updateSeo:ModelTypes["SeoUpdateResult"],
	upsertSeo:ModelTypes["SeoUpsertResult"],
	createSpecialEvent:ModelTypes["SpecialEventCreateResult"],
	deleteSpecialEvent:ModelTypes["SpecialEventDeleteResult"],
	updateSpecialEvent:ModelTypes["SpecialEventUpdateResult"],
	upsertSpecialEvent:ModelTypes["SpecialEventUpsertResult"],
	createTimelinePage:ModelTypes["TimelinePageCreateResult"],
	deleteTimelinePage:ModelTypes["TimelinePageDeleteResult"],
	updateTimelinePage:ModelTypes["TimelinePageUpdateResult"],
	upsertTimelinePage:ModelTypes["TimelinePageUpsertResult"],
	createTimelinePost:ModelTypes["TimelinePostCreateResult"],
	deleteTimelinePost:ModelTypes["TimelinePostDeleteResult"],
	updateTimelinePost:ModelTypes["TimelinePostUpdateResult"],
	upsertTimelinePost:ModelTypes["TimelinePostUpsertResult"],
	createSourcePage:ModelTypes["SourcePageCreateResult"],
	deleteSourcePage:ModelTypes["SourcePageDeleteResult"],
	updateSourcePage:ModelTypes["SourcePageUpdateResult"],
	upsertSourcePage:ModelTypes["SourcePageUpsertResult"],
	createSourcePostLink:ModelTypes["SourcePostLinkCreateResult"],
	deleteSourcePostLink:ModelTypes["SourcePostLinkDeleteResult"],
	updateSourcePostLink:ModelTypes["SourcePostLinkUpdateResult"],
	upsertSourcePostLink:ModelTypes["SourcePostLinkUpsertResult"],
	createGallery:ModelTypes["GalleryCreateResult"],
	deleteGallery:ModelTypes["GalleryDeleteResult"],
	updateGallery:ModelTypes["GalleryUpdateResult"],
	upsertGallery:ModelTypes["GalleryUpsertResult"],
	createGalleryItem:ModelTypes["GalleryItemCreateResult"],
	deleteGalleryItem:ModelTypes["GalleryItemDeleteResult"],
	updateGalleryItem:ModelTypes["GalleryItemUpdateResult"],
	upsertGalleryItem:ModelTypes["GalleryItemUpsertResult"],
	createCardMedia:ModelTypes["CardMediaCreateResult"],
	deleteCardMedia:ModelTypes["CardMediaDeleteResult"],
	updateCardMedia:ModelTypes["CardMediaUpdateResult"],
	upsertCardMedia:ModelTypes["CardMediaUpsertResult"],
	createRedirect:ModelTypes["RedirectCreateResult"],
	deleteRedirect:ModelTypes["RedirectDeleteResult"],
	updateRedirect:ModelTypes["RedirectUpdateResult"],
	upsertRedirect:ModelTypes["RedirectUpsertResult"],
	createVenue:ModelTypes["VenueCreateResult"],
	deleteVenue:ModelTypes["VenueDeleteResult"],
	updateVenue:ModelTypes["VenueUpdateResult"],
	upsertVenue:ModelTypes["VenueUpsertResult"],
	createEventLabel:ModelTypes["EventLabelCreateResult"],
	deleteEventLabel:ModelTypes["EventLabelDeleteResult"],
	updateEventLabel:ModelTypes["EventLabelUpdateResult"],
	upsertEventLabel:ModelTypes["EventLabelUpsertResult"],
	createPage:ModelTypes["PageCreateResult"],
	deletePage:ModelTypes["PageDeleteResult"],
	updatePage:ModelTypes["PageUpdateResult"],
	upsertPage:ModelTypes["PageUpsertResult"],
	query?:ModelTypes["Query"]
};
	["MutationTransactionOptions"]: GraphQLTypes["MutationTransactionOptions"];
	/** Json custom scalar type */
["Json"]:any;
	["_Schema"]: {
		enums:ModelTypes["_Enum"][],
	entities:ModelTypes["_Entity"][]
};
	["_Entity"]: {
		name:string,
	customPrimaryAllowed:boolean,
	fields:ModelTypes["_Field"][],
	unique:ModelTypes["_UniqueConstraint"][]
};
	["_UniqueConstraint"]: {
		fields:string[]
};
	["_Field"]: ModelTypes["_Column"] | ModelTypes["_Relation"];
	["_Column"]: {
		name:string,
	type:string,
	enumName?:string,
	defaultValue?:ModelTypes["Json"],
	nullable:boolean,
	rules:ModelTypes["_Rule"][],
	validators:ModelTypes["_Validator"][]
};
	["_OnDeleteBehaviour"]: GraphQLTypes["_OnDeleteBehaviour"];
	["_RelationSide"]: GraphQLTypes["_RelationSide"];
	["_OrderByDirection"]: GraphQLTypes["_OrderByDirection"];
	["_OrderBy"]: {
		path:string[],
	direction:ModelTypes["_OrderByDirection"]
};
	["_Relation"]: {
		name:string,
	type:string,
	side:ModelTypes["_RelationSide"],
	targetEntity:string,
	ownedBy?:string,
	inversedBy?:string,
	nullable?:boolean,
	onDelete?:ModelTypes["_OnDeleteBehaviour"],
	orphanRemoval?:boolean,
	orderBy?:ModelTypes["_OrderBy"][],
	rules:ModelTypes["_Rule"][],
	validators:ModelTypes["_Validator"][]
};
	["_Rule"]: {
		message?:ModelTypes["_RuleMessage"],
	validator:number
};
	["_Validator"]: {
		operation:string,
	arguments:ModelTypes["_Argument"][]
};
	["_Argument"]:ModelTypes["_ValidatorArgument"] | ModelTypes["_PathArgument"] | ModelTypes["_LiteralArgument"];
	["_ValidatorArgument"]: {
		validator:number
};
	["_PathArgument"]: {
		path:string[]
};
	["_LiteralArgument"]: {
		value?:ModelTypes["Json"]
};
	["_RuleMessage"]: {
		text?:string
};
	["_Enum"]: {
		name:string,
	values:string[]
};
	["S3SignedUpload"]: {
		url:string,
	headers:ModelTypes["S3Header"][],
	method:string,
	/** Allowed patterns:
** */
	objectKey:string,
	bucket:string,
	publicUrl:string
};
	["S3Header"]: {
		key:string,
	value:string
};
	["S3SignedRead"]: {
		url:string,
	headers:ModelTypes["S3Header"][],
	method:string,
	/** Allowed patterns:
** */
	objectKey:string,
	bucket:string
}
    }

export type GraphQLTypes = {
    ["Query"]: {
	__typename: "Query",
	getContent?: GraphQLTypes["Content"],
	listContent: Array<GraphQLTypes["Content"]>,
	paginateContent: GraphQLTypes["ContentConnection"],
	validateCreateContent: GraphQLTypes["_ValidationResult"],
	validateUpdateContent: GraphQLTypes["_ValidationResult"],
	getContentBlock?: GraphQLTypes["ContentBlock"],
	listContentBlock: Array<GraphQLTypes["ContentBlock"]>,
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	validateCreateContentBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentBlock: GraphQLTypes["_ValidationResult"],
	getContentReference?: GraphQLTypes["ContentReference"],
	listContentReference: Array<GraphQLTypes["ContentReference"]>,
	paginateContentReference: GraphQLTypes["ContentReferenceConnection"],
	validateCreateContentReference: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReference: GraphQLTypes["_ValidationResult"],
	getEvent?: GraphQLTypes["Event"],
	listEvent: Array<GraphQLTypes["Event"]>,
	paginateEvent: GraphQLTypes["EventConnection"],
	validateCreateEvent: GraphQLTypes["_ValidationResult"],
	validateUpdateEvent: GraphQLTypes["_ValidationResult"],
	getFallbackSeo?: GraphQLTypes["FallbackSeo"],
	listFallbackSeo: Array<GraphQLTypes["FallbackSeo"]>,
	paginateFallbackSeo: GraphQLTypes["FallbackSeoConnection"],
	validateCreateFallbackSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateFallbackSeo: GraphQLTypes["_ValidationResult"],
	getFooter?: GraphQLTypes["Footer"],
	listFooter: Array<GraphQLTypes["Footer"]>,
	paginateFooter: GraphQLTypes["FooterConnection"],
	validateCreateFooter: GraphQLTypes["_ValidationResult"],
	validateUpdateFooter: GraphQLTypes["_ValidationResult"],
	getHeader?: GraphQLTypes["Header"],
	listHeader: Array<GraphQLTypes["Header"]>,
	paginateHeader: GraphQLTypes["HeaderConnection"],
	validateCreateHeader: GraphQLTypes["_ValidationResult"],
	validateUpdateHeader: GraphQLTypes["_ValidationResult"],
	getHeaderLink?: GraphQLTypes["HeaderLink"],
	listHeaderLink: Array<GraphQLTypes["HeaderLink"]>,
	paginateHeaderLink: GraphQLTypes["HeaderLinkConnection"],
	validateCreateHeaderLink: GraphQLTypes["_ValidationResult"],
	validateUpdateHeaderLink: GraphQLTypes["_ValidationResult"],
	getFrontPage?: GraphQLTypes["FrontPage"],
	listFrontPage: Array<GraphQLTypes["FrontPage"]>,
	paginateFrontPage: GraphQLTypes["FrontPageConnection"],
	validateCreateFrontPage: GraphQLTypes["_ValidationResult"],
	validateUpdateFrontPage: GraphQLTypes["_ValidationResult"],
	getImage?: GraphQLTypes["Image"],
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"],
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getLinkable?: GraphQLTypes["Linkable"],
	listLinkable: Array<GraphQLTypes["Linkable"]>,
	paginateLinkable: GraphQLTypes["LinkableConnection"],
	validateCreateLinkable: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkable: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"],
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getSpecialEvent?: GraphQLTypes["SpecialEvent"],
	listSpecialEvent: Array<GraphQLTypes["SpecialEvent"]>,
	paginateSpecialEvent: GraphQLTypes["SpecialEventConnection"],
	validateCreateSpecialEvent: GraphQLTypes["_ValidationResult"],
	validateUpdateSpecialEvent: GraphQLTypes["_ValidationResult"],
	getTimelinePage?: GraphQLTypes["TimelinePage"],
	listTimelinePage: Array<GraphQLTypes["TimelinePage"]>,
	paginateTimelinePage: GraphQLTypes["TimelinePageConnection"],
	validateCreateTimelinePage: GraphQLTypes["_ValidationResult"],
	validateUpdateTimelinePage: GraphQLTypes["_ValidationResult"],
	getTimelinePost?: GraphQLTypes["TimelinePost"],
	listTimelinePost: Array<GraphQLTypes["TimelinePost"]>,
	paginateTimelinePost: GraphQLTypes["TimelinePostConnection"],
	validateCreateTimelinePost: GraphQLTypes["_ValidationResult"],
	validateUpdateTimelinePost: GraphQLTypes["_ValidationResult"],
	getSourcePage?: GraphQLTypes["SourcePage"],
	listSourcePage: Array<GraphQLTypes["SourcePage"]>,
	paginateSourcePage: GraphQLTypes["SourcePageConnection"],
	validateCreateSourcePage: GraphQLTypes["_ValidationResult"],
	validateUpdateSourcePage: GraphQLTypes["_ValidationResult"],
	getSourcePostLink?: GraphQLTypes["SourcePostLink"],
	listSourcePostLink: Array<GraphQLTypes["SourcePostLink"]>,
	paginateSourcePostLink: GraphQLTypes["SourcePostLinkConnection"],
	validateCreateSourcePostLink: GraphQLTypes["_ValidationResult"],
	validateUpdateSourcePostLink: GraphQLTypes["_ValidationResult"],
	getGallery?: GraphQLTypes["Gallery"],
	listGallery: Array<GraphQLTypes["Gallery"]>,
	paginateGallery: GraphQLTypes["GalleryConnection"],
	validateCreateGallery: GraphQLTypes["_ValidationResult"],
	validateUpdateGallery: GraphQLTypes["_ValidationResult"],
	getGalleryItem?: GraphQLTypes["GalleryItem"],
	listGalleryItem: Array<GraphQLTypes["GalleryItem"]>,
	paginateGalleryItem: GraphQLTypes["GalleryItemConnection"],
	validateCreateGalleryItem: GraphQLTypes["_ValidationResult"],
	validateUpdateGalleryItem: GraphQLTypes["_ValidationResult"],
	getCardMedia?: GraphQLTypes["CardMedia"],
	listCardMedia: Array<GraphQLTypes["CardMedia"]>,
	paginateCardMedia: GraphQLTypes["CardMediaConnection"],
	validateCreateCardMedia: GraphQLTypes["_ValidationResult"],
	validateUpdateCardMedia: GraphQLTypes["_ValidationResult"],
	getRedirect?: GraphQLTypes["Redirect"],
	listRedirect: Array<GraphQLTypes["Redirect"]>,
	paginateRedirect: GraphQLTypes["RedirectConnection"],
	validateCreateRedirect: GraphQLTypes["_ValidationResult"],
	validateUpdateRedirect: GraphQLTypes["_ValidationResult"],
	getVenue?: GraphQLTypes["Venue"],
	listVenue: Array<GraphQLTypes["Venue"]>,
	paginateVenue: GraphQLTypes["VenueConnection"],
	validateCreateVenue: GraphQLTypes["_ValidationResult"],
	validateUpdateVenue: GraphQLTypes["_ValidationResult"],
	getEventLabel?: GraphQLTypes["EventLabel"],
	listEventLabel: Array<GraphQLTypes["EventLabel"]>,
	paginateEventLabel: GraphQLTypes["EventLabelConnection"],
	validateCreateEventLabel: GraphQLTypes["_ValidationResult"],
	validateUpdateEventLabel: GraphQLTypes["_ValidationResult"],
	getPage?: GraphQLTypes["Page"],
	listPage: Array<GraphQLTypes["Page"]>,
	paginatePage: GraphQLTypes["PageConnection"],
	validateCreatePage: GraphQLTypes["_ValidationResult"],
	validateUpdatePage: GraphQLTypes["_ValidationResult"],
	transaction?: GraphQLTypes["QueryTransaction"],
	_info?: GraphQLTypes["Info"],
	schema?: GraphQLTypes["_Schema"],
	s3DummyQuery?: string
};
	["Content"]: {
	__typename: "Content",
	_meta?: GraphQLTypes["ContentMeta"],
	id: GraphQLTypes["UUID"],
	blocks: Array<GraphQLTypes["ContentBlock"]>,
	blocksByReferences?: GraphQLTypes["ContentBlock"],
	paginateBlocks: GraphQLTypes["ContentBlockConnection"]
};
	["ContentMeta"]: {
	__typename: "ContentMeta",
	id?: GraphQLTypes["FieldMeta"],
	blocks?: GraphQLTypes["FieldMeta"]
};
	["FieldMeta"]: {
	__typename: "FieldMeta",
	readable?: boolean,
	updatable?: boolean
};
	["UUID"]:string;
	["ContentBlock"]: {
	__typename: "ContentBlock",
	_meta?: GraphQLTypes["ContentBlockMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	json: string,
	content?: GraphQLTypes["Content"],
	references: Array<GraphQLTypes["ContentReference"]>,
	referencesByLink?: GraphQLTypes["ContentReference"],
	paginateReferences: GraphQLTypes["ContentReferenceConnection"]
};
	["ContentBlockMeta"]: {
	__typename: "ContentBlockMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	json?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	references?: GraphQLTypes["FieldMeta"]
};
	["ContentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	blocks?: GraphQLTypes["ContentBlockWhere"],
	and?: Array<GraphQLTypes["ContentWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentWhere"] | undefined>,
	not?: GraphQLTypes["ContentWhere"]
};
	["UUIDCondition"]: {
		and?: Array<GraphQLTypes["UUIDCondition"]>,
	or?: Array<GraphQLTypes["UUIDCondition"]>,
	not?: GraphQLTypes["UUIDCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["UUID"],
	notEq?: GraphQLTypes["UUID"],
	in?: Array<GraphQLTypes["UUID"]>,
	notIn?: Array<GraphQLTypes["UUID"]>,
	lt?: GraphQLTypes["UUID"],
	lte?: GraphQLTypes["UUID"],
	gt?: GraphQLTypes["UUID"],
	gte?: GraphQLTypes["UUID"]
};
	["ContentBlockWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	json?: GraphQLTypes["StringCondition"],
	content?: GraphQLTypes["ContentWhere"],
	references?: GraphQLTypes["ContentReferenceWhere"],
	and?: Array<GraphQLTypes["ContentBlockWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentBlockWhere"] | undefined>,
	not?: GraphQLTypes["ContentBlockWhere"]
};
	["IntCondition"]: {
		and?: Array<GraphQLTypes["IntCondition"]>,
	or?: Array<GraphQLTypes["IntCondition"]>,
	not?: GraphQLTypes["IntCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: number,
	notEq?: number,
	in?: Array<number>,
	notIn?: Array<number>,
	lt?: number,
	lte?: number,
	gt?: number,
	gte?: number
};
	["StringCondition"]: {
		and?: Array<GraphQLTypes["StringCondition"]>,
	or?: Array<GraphQLTypes["StringCondition"]>,
	not?: GraphQLTypes["StringCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: string,
	notEq?: string,
	in?: Array<string>,
	notIn?: Array<string>,
	lt?: string,
	lte?: string,
	gt?: string,
	gte?: string,
	contains?: string,
	startsWith?: string,
	endsWith?: string,
	containsCI?: string,
	startsWithCI?: string,
	endsWithCI?: string
};
	["ContentReferenceWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["ContentReferenceTypeCondition"],
	text?: GraphQLTypes["StringCondition"],
	block?: GraphQLTypes["ContentBlockWhere"],
	image?: GraphQLTypes["ImageWhere"],
	link?: GraphQLTypes["LinkWhere"],
	cardMedia?: GraphQLTypes["CardMediaWhere"],
	and?: Array<GraphQLTypes["ContentReferenceWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentReferenceWhere"] | undefined>,
	not?: GraphQLTypes["ContentReferenceWhere"]
};
	["ContentReferenceTypeCondition"]: {
		and?: Array<GraphQLTypes["ContentReferenceTypeCondition"]>,
	or?: Array<GraphQLTypes["ContentReferenceTypeCondition"]>,
	not?: GraphQLTypes["ContentReferenceTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ContentReferenceType"],
	notEq?: GraphQLTypes["ContentReferenceType"],
	in?: Array<GraphQLTypes["ContentReferenceType"]>,
	notIn?: Array<GraphQLTypes["ContentReferenceType"]>,
	lt?: GraphQLTypes["ContentReferenceType"],
	lte?: GraphQLTypes["ContentReferenceType"],
	gt?: GraphQLTypes["ContentReferenceType"],
	gte?: GraphQLTypes["ContentReferenceType"]
};
	["ContentReferenceType"]: ContentReferenceType;
	["ImageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	url?: GraphQLTypes["StringCondition"],
	width?: GraphQLTypes["IntCondition"],
	height?: GraphQLTypes["IntCondition"],
	size?: GraphQLTypes["IntCondition"],
	type?: GraphQLTypes["StringCondition"],
	alt?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ImageWhere"] | undefined>,
	or?: Array<GraphQLTypes["ImageWhere"] | undefined>,
	not?: GraphQLTypes["ImageWhere"]
};
	["LinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["LinkTypeCondition"],
	title?: GraphQLTypes["StringCondition"],
	externalLink?: GraphQLTypes["StringCondition"],
	internalLink?: GraphQLTypes["LinkableWhere"],
	and?: Array<GraphQLTypes["LinkWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkWhere"] | undefined>,
	not?: GraphQLTypes["LinkWhere"]
};
	["LinkTypeCondition"]: {
		and?: Array<GraphQLTypes["LinkTypeCondition"]>,
	or?: Array<GraphQLTypes["LinkTypeCondition"]>,
	not?: GraphQLTypes["LinkTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["LinkType"],
	notEq?: GraphQLTypes["LinkType"],
	in?: Array<GraphQLTypes["LinkType"]>,
	notIn?: Array<GraphQLTypes["LinkType"]>,
	lt?: GraphQLTypes["LinkType"],
	lte?: GraphQLTypes["LinkType"],
	gt?: GraphQLTypes["LinkType"],
	gte?: GraphQLTypes["LinkType"]
};
	["LinkType"]: LinkType;
	["LinkableWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	url?: GraphQLTypes["StringCondition"],
	event?: GraphQLTypes["EventWhere"],
	frontPage?: GraphQLTypes["FrontPageWhere"],
	specialEvent?: GraphQLTypes["SpecialEventWhere"],
	timelinePage?: GraphQLTypes["TimelinePageWhere"],
	sourcePage?: GraphQLTypes["SourcePageWhere"],
	redirect?: GraphQLTypes["RedirectWhere"],
	page?: GraphQLTypes["PageWhere"],
	and?: Array<GraphQLTypes["LinkableWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkableWhere"] | undefined>,
	not?: GraphQLTypes["LinkableWhere"]
};
	["EventWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	place?: GraphQLTypes["StringCondition"],
	entrance?: GraphQLTypes["StringCondition"],
	image?: GraphQLTypes["ImageWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	link?: GraphQLTypes["LinkableWhere"],
	content?: GraphQLTypes["ContentWhere"],
	date?: GraphQLTypes["StringCondition"],
	order?: GraphQLTypes["IntCondition"],
	linkForEvent?: GraphQLTypes["LinkWhere"],
	venue?: GraphQLTypes["VenueWhere"],
	pastEvent?: GraphQLTypes["BooleanCondition"],
	eventLabels?: GraphQLTypes["EventLabelWhere"],
	and?: Array<GraphQLTypes["EventWhere"] | undefined>,
	or?: Array<GraphQLTypes["EventWhere"] | undefined>,
	not?: GraphQLTypes["EventWhere"]
};
	["SeoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	description?: GraphQLTypes["StringCondition"],
	ogTitle?: GraphQLTypes["StringCondition"],
	ogDescription?: GraphQLTypes["StringCondition"],
	ogImage?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["SeoWhere"] | undefined>,
	or?: Array<GraphQLTypes["SeoWhere"] | undefined>,
	not?: GraphQLTypes["SeoWhere"]
};
	["VenueWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	order?: GraphQLTypes["IntCondition"],
	and?: Array<GraphQLTypes["VenueWhere"] | undefined>,
	or?: Array<GraphQLTypes["VenueWhere"] | undefined>,
	not?: GraphQLTypes["VenueWhere"]
};
	["BooleanCondition"]: {
		and?: Array<GraphQLTypes["BooleanCondition"]>,
	or?: Array<GraphQLTypes["BooleanCondition"]>,
	not?: GraphQLTypes["BooleanCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: boolean,
	notEq?: boolean,
	in?: Array<boolean>,
	notIn?: Array<boolean>,
	lt?: boolean,
	lte?: boolean,
	gt?: boolean,
	gte?: boolean
};
	["EventLabelWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	text?: GraphQLTypes["StringCondition"],
	event?: GraphQLTypes["EventWhere"],
	and?: Array<GraphQLTypes["EventLabelWhere"] | undefined>,
	or?: Array<GraphQLTypes["EventLabelWhere"] | undefined>,
	not?: GraphQLTypes["EventLabelWhere"]
};
	["FrontPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	title?: GraphQLTypes["StringCondition"],
	openingText?: GraphQLTypes["StringCondition"],
	eventsTitle?: GraphQLTypes["StringCondition"],
	firstLink?: GraphQLTypes["LinkWhere"],
	secondLink?: GraphQLTypes["LinkWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	link?: GraphQLTypes["LinkableWhere"],
	subtitle?: GraphQLTypes["StringCondition"],
	projectSupport?: GraphQLTypes["StringCondition"],
	projectAuspices?: GraphQLTypes["StringCondition"],
	image?: GraphQLTypes["ImageWhere"],
	gallery?: GraphQLTypes["GalleryWhere"],
	and?: Array<GraphQLTypes["FrontPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["FrontPageWhere"] | undefined>,
	not?: GraphQLTypes["FrontPageWhere"]
};
	["OneCondition"]: {
		and?: Array<GraphQLTypes["OneCondition"]>,
	or?: Array<GraphQLTypes["OneCondition"]>,
	not?: GraphQLTypes["OneCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["One"],
	notEq?: GraphQLTypes["One"],
	in?: Array<GraphQLTypes["One"]>,
	notIn?: Array<GraphQLTypes["One"]>,
	lt?: GraphQLTypes["One"],
	lte?: GraphQLTypes["One"],
	gt?: GraphQLTypes["One"],
	gte?: GraphQLTypes["One"]
};
	["One"]: One;
	["GalleryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["GalleryItemWhere"],
	and?: Array<GraphQLTypes["GalleryWhere"] | undefined>,
	or?: Array<GraphQLTypes["GalleryWhere"] | undefined>,
	not?: GraphQLTypes["GalleryWhere"]
};
	["GalleryItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["GalleryWhere"],
	image?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["GalleryItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["GalleryItemWhere"] | undefined>,
	not?: GraphQLTypes["GalleryItemWhere"]
};
	["SpecialEventWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	image?: GraphQLTypes["ImageWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	imageNote?: GraphQLTypes["StringCondition"],
	openingText?: GraphQLTypes["StringCondition"],
	subtitle?: GraphQLTypes["StringCondition"],
	unique?: GraphQLTypes["OneCondition"],
	content?: GraphQLTypes["ContentWhere"],
	and?: Array<GraphQLTypes["SpecialEventWhere"] | undefined>,
	or?: Array<GraphQLTypes["SpecialEventWhere"] | undefined>,
	not?: GraphQLTypes["SpecialEventWhere"]
};
	["TimelinePageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	unique?: GraphQLTypes["OneCondition"],
	and?: Array<GraphQLTypes["TimelinePageWhere"] | undefined>,
	or?: Array<GraphQLTypes["TimelinePageWhere"] | undefined>,
	not?: GraphQLTypes["TimelinePageWhere"]
};
	["SourcePageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	title?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	links?: GraphQLTypes["SourcePostLinkWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	and?: Array<GraphQLTypes["SourcePageWhere"] | undefined>,
	or?: Array<GraphQLTypes["SourcePageWhere"] | undefined>,
	not?: GraphQLTypes["SourcePageWhere"]
};
	["SourcePostLinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	order?: GraphQLTypes["IntCondition"],
	link?: GraphQLTypes["LinkWhere"],
	and?: Array<GraphQLTypes["SourcePostLinkWhere"] | undefined>,
	or?: Array<GraphQLTypes["SourcePostLinkWhere"] | undefined>,
	not?: GraphQLTypes["SourcePostLinkWhere"]
};
	["RedirectWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	targetUrl?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	target?: GraphQLTypes["LinkableWhere"],
	and?: Array<GraphQLTypes["RedirectWhere"] | undefined>,
	or?: Array<GraphQLTypes["RedirectWhere"] | undefined>,
	not?: GraphQLTypes["RedirectWhere"]
};
	["PageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	title?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	content?: GraphQLTypes["ContentWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	and?: Array<GraphQLTypes["PageWhere"] | undefined>,
	or?: Array<GraphQLTypes["PageWhere"] | undefined>,
	not?: GraphQLTypes["PageWhere"]
};
	["CardMediaWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	text?: GraphQLTypes["StringCondition"],
	imageNote?: GraphQLTypes["StringCondition"],
	image?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["CardMediaWhere"] | undefined>,
	or?: Array<GraphQLTypes["CardMediaWhere"] | undefined>,
	not?: GraphQLTypes["CardMediaWhere"]
};
	["ContentReference"]: {
	__typename: "ContentReference",
	_meta?: GraphQLTypes["ContentReferenceMeta"],
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["ContentReferenceType"],
	text?: string,
	block?: GraphQLTypes["ContentBlock"],
	image?: GraphQLTypes["Image"],
	link?: GraphQLTypes["Link"],
	cardMedia?: GraphQLTypes["CardMedia"]
};
	["ContentReferenceMeta"]: {
	__typename: "ContentReferenceMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	block?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	cardMedia?: GraphQLTypes["FieldMeta"]
};
	["Image"]: {
	__typename: "Image",
	_meta?: GraphQLTypes["ImageMeta"],
	id: GraphQLTypes["UUID"],
	url: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	alt?: string
};
	["ImageMeta"]: {
	__typename: "ImageMeta",
	id?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	width?: GraphQLTypes["FieldMeta"],
	height?: GraphQLTypes["FieldMeta"],
	size?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	alt?: GraphQLTypes["FieldMeta"]
};
	["Link"]: {
	__typename: "Link",
	_meta?: GraphQLTypes["LinkMeta"],
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["LinkType"],
	title?: string,
	externalLink?: string,
	internalLink?: GraphQLTypes["Linkable"]
};
	["LinkMeta"]: {
	__typename: "LinkMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	externalLink?: GraphQLTypes["FieldMeta"],
	internalLink?: GraphQLTypes["FieldMeta"]
};
	["Linkable"]: {
	__typename: "Linkable",
	_meta?: GraphQLTypes["LinkableMeta"],
	id: GraphQLTypes["UUID"],
	url: string,
	event?: GraphQLTypes["Event"],
	frontPage?: GraphQLTypes["FrontPage"],
	specialEvent?: GraphQLTypes["SpecialEvent"],
	timelinePage?: GraphQLTypes["TimelinePage"],
	sourcePage?: GraphQLTypes["SourcePage"],
	redirect?: GraphQLTypes["Redirect"],
	page?: GraphQLTypes["Page"]
};
	["LinkableMeta"]: {
	__typename: "LinkableMeta",
	id?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	event?: GraphQLTypes["FieldMeta"],
	frontPage?: GraphQLTypes["FieldMeta"],
	specialEvent?: GraphQLTypes["FieldMeta"],
	timelinePage?: GraphQLTypes["FieldMeta"],
	sourcePage?: GraphQLTypes["FieldMeta"],
	redirect?: GraphQLTypes["FieldMeta"],
	page?: GraphQLTypes["FieldMeta"]
};
	["Event"]: {
	__typename: "Event",
	_meta?: GraphQLTypes["EventMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	place?: string,
	entrance?: string,
	image?: GraphQLTypes["Image"],
	seo?: GraphQLTypes["Seo"],
	link?: GraphQLTypes["Linkable"],
	content?: GraphQLTypes["Content"],
	date?: string,
	order: number,
	linkForEvent?: GraphQLTypes["Link"],
	venue?: GraphQLTypes["Venue"],
	pastEvent?: boolean,
	eventLabels: Array<GraphQLTypes["EventLabel"]>,
	paginateEventLabels: GraphQLTypes["EventLabelConnection"]
};
	["EventMeta"]: {
	__typename: "EventMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	place?: GraphQLTypes["FieldMeta"],
	entrance?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	date?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	linkForEvent?: GraphQLTypes["FieldMeta"],
	venue?: GraphQLTypes["FieldMeta"],
	pastEvent?: GraphQLTypes["FieldMeta"],
	eventLabels?: GraphQLTypes["FieldMeta"]
};
	["Seo"]: {
	__typename: "Seo",
	_meta?: GraphQLTypes["SeoMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["Image"]
};
	["SeoMeta"]: {
	__typename: "SeoMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	description?: GraphQLTypes["FieldMeta"],
	ogTitle?: GraphQLTypes["FieldMeta"],
	ogDescription?: GraphQLTypes["FieldMeta"],
	ogImage?: GraphQLTypes["FieldMeta"]
};
	["Venue"]: {
	__typename: "Venue",
	_meta?: GraphQLTypes["VenueMeta"],
	id: GraphQLTypes["UUID"],
	name?: string,
	order: number
};
	["VenueMeta"]: {
	__typename: "VenueMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"]
};
	["EventLabel"]: {
	__typename: "EventLabel",
	_meta?: GraphQLTypes["EventLabelMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	text?: string,
	event?: GraphQLTypes["Event"]
};
	["EventLabelMeta"]: {
	__typename: "EventLabelMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	event?: GraphQLTypes["FieldMeta"]
};
	["EventLabelOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	event?: GraphQLTypes["EventOrderBy"]
};
	["OrderDirection"]: OrderDirection;
	["EventOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	place?: GraphQLTypes["OrderDirection"],
	entrance?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"],
	link?: GraphQLTypes["LinkableOrderBy"],
	content?: GraphQLTypes["ContentOrderBy"],
	date?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	linkForEvent?: GraphQLTypes["LinkOrderBy"],
	venue?: GraphQLTypes["VenueOrderBy"],
	pastEvent?: GraphQLTypes["OrderDirection"]
};
	["ImageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"],
	width?: GraphQLTypes["OrderDirection"],
	height?: GraphQLTypes["OrderDirection"],
	size?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	alt?: GraphQLTypes["OrderDirection"]
};
	["SeoOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	description?: GraphQLTypes["OrderDirection"],
	ogTitle?: GraphQLTypes["OrderDirection"],
	ogDescription?: GraphQLTypes["OrderDirection"],
	ogImage?: GraphQLTypes["ImageOrderBy"]
};
	["LinkableOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"],
	event?: GraphQLTypes["EventOrderBy"],
	frontPage?: GraphQLTypes["FrontPageOrderBy"],
	specialEvent?: GraphQLTypes["SpecialEventOrderBy"],
	timelinePage?: GraphQLTypes["TimelinePageOrderBy"],
	sourcePage?: GraphQLTypes["SourcePageOrderBy"],
	redirect?: GraphQLTypes["RedirectOrderBy"],
	page?: GraphQLTypes["PageOrderBy"]
};
	["FrontPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	openingText?: GraphQLTypes["OrderDirection"],
	eventsTitle?: GraphQLTypes["OrderDirection"],
	firstLink?: GraphQLTypes["LinkOrderBy"],
	secondLink?: GraphQLTypes["LinkOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"],
	link?: GraphQLTypes["LinkableOrderBy"],
	subtitle?: GraphQLTypes["OrderDirection"],
	projectSupport?: GraphQLTypes["OrderDirection"],
	projectAuspices?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"],
	gallery?: GraphQLTypes["GalleryOrderBy"]
};
	["LinkOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	externalLink?: GraphQLTypes["OrderDirection"],
	internalLink?: GraphQLTypes["LinkableOrderBy"]
};
	["GalleryOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["SpecialEventOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	image?: GraphQLTypes["ImageOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"],
	imageNote?: GraphQLTypes["OrderDirection"],
	openingText?: GraphQLTypes["OrderDirection"],
	subtitle?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	content?: GraphQLTypes["ContentOrderBy"]
};
	["ContentOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["TimelinePageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"],
	unique?: GraphQLTypes["OrderDirection"]
};
	["SourcePageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"]
};
	["RedirectOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	targetUrl?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	target?: GraphQLTypes["LinkableOrderBy"]
};
	["PageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	content?: GraphQLTypes["ContentOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"]
};
	["VenueOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"]
};
	["EventLabelConnection"]: {
	__typename: "EventLabelConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["EventLabelEdge"]>
};
	["PageInfo"]: {
	__typename: "PageInfo",
	totalCount: number
};
	["EventLabelEdge"]: {
	__typename: "EventLabelEdge",
	node: GraphQLTypes["EventLabel"]
};
	["FrontPage"]: {
	__typename: "FrontPage",
	_meta?: GraphQLTypes["FrontPageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	title?: string,
	openingText?: string,
	eventsTitle?: string,
	firstLink?: GraphQLTypes["Link"],
	secondLink?: GraphQLTypes["Link"],
	seo?: GraphQLTypes["Seo"],
	link?: GraphQLTypes["Linkable"],
	subtitle?: string,
	projectSupport?: string,
	projectAuspices?: string,
	image?: GraphQLTypes["Image"],
	gallery?: GraphQLTypes["Gallery"]
};
	["FrontPageMeta"]: {
	__typename: "FrontPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	openingText?: GraphQLTypes["FieldMeta"],
	eventsTitle?: GraphQLTypes["FieldMeta"],
	firstLink?: GraphQLTypes["FieldMeta"],
	secondLink?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	subtitle?: GraphQLTypes["FieldMeta"],
	projectSupport?: GraphQLTypes["FieldMeta"],
	projectAuspices?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	gallery?: GraphQLTypes["FieldMeta"]
};
	["Gallery"]: {
	__typename: "Gallery",
	_meta?: GraphQLTypes["GalleryMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["GalleryItem"]>,
	paginateItems: GraphQLTypes["GalleryItemConnection"]
};
	["GalleryMeta"]: {
	__typename: "GalleryMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["GalleryItem"]: {
	__typename: "GalleryItem",
	_meta?: GraphQLTypes["GalleryItemMeta"],
	id: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["Gallery"],
	image?: GraphQLTypes["Image"]
};
	["GalleryItemMeta"]: {
	__typename: "GalleryItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"]
};
	["GalleryItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["GalleryOrderBy"],
	image?: GraphQLTypes["ImageOrderBy"]
};
	["GalleryItemConnection"]: {
	__typename: "GalleryItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GalleryItemEdge"]>
};
	["GalleryItemEdge"]: {
	__typename: "GalleryItemEdge",
	node: GraphQLTypes["GalleryItem"]
};
	["SpecialEvent"]: {
	__typename: "SpecialEvent",
	_meta?: GraphQLTypes["SpecialEventMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["Linkable"],
	image?: GraphQLTypes["Image"],
	seo?: GraphQLTypes["Seo"],
	imageNote?: string,
	openingText?: string,
	subtitle?: string,
	unique: GraphQLTypes["One"],
	content?: GraphQLTypes["Content"]
};
	["SpecialEventMeta"]: {
	__typename: "SpecialEventMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	imageNote?: GraphQLTypes["FieldMeta"],
	openingText?: GraphQLTypes["FieldMeta"],
	subtitle?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"]
};
	["TimelinePage"]: {
	__typename: "TimelinePage",
	_meta?: GraphQLTypes["TimelinePageMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["Linkable"],
	seo?: GraphQLTypes["Seo"],
	unique: GraphQLTypes["One"]
};
	["TimelinePageMeta"]: {
	__typename: "TimelinePageMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"]
};
	["SourcePage"]: {
	__typename: "SourcePage",
	_meta?: GraphQLTypes["SourcePageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	title?: string,
	link?: GraphQLTypes["Linkable"],
	links: Array<GraphQLTypes["SourcePostLink"]>,
	seo?: GraphQLTypes["Seo"],
	paginateLinks: GraphQLTypes["SourcePostLinkConnection"]
};
	["SourcePageMeta"]: {
	__typename: "SourcePageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	links?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"]
};
	["SourcePostLink"]: {
	__typename: "SourcePostLink",
	_meta?: GraphQLTypes["SourcePostLinkMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	order: number,
	link?: GraphQLTypes["Link"]
};
	["SourcePostLinkMeta"]: {
	__typename: "SourcePostLinkMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"]
};
	["SourcePostLinkOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkOrderBy"]
};
	["SourcePostLinkConnection"]: {
	__typename: "SourcePostLinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SourcePostLinkEdge"]>
};
	["SourcePostLinkEdge"]: {
	__typename: "SourcePostLinkEdge",
	node: GraphQLTypes["SourcePostLink"]
};
	["Redirect"]: {
	__typename: "Redirect",
	_meta?: GraphQLTypes["RedirectMeta"],
	id: GraphQLTypes["UUID"],
	targetUrl?: string,
	link?: GraphQLTypes["Linkable"],
	target?: GraphQLTypes["Linkable"]
};
	["RedirectMeta"]: {
	__typename: "RedirectMeta",
	id?: GraphQLTypes["FieldMeta"],
	targetUrl?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	target?: GraphQLTypes["FieldMeta"]
};
	["Page"]: {
	__typename: "Page",
	_meta?: GraphQLTypes["PageMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	title?: string,
	link?: GraphQLTypes["Linkable"],
	content?: GraphQLTypes["Content"],
	seo?: GraphQLTypes["Seo"]
};
	["PageMeta"]: {
	__typename: "PageMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"]
};
	["CardMedia"]: {
	__typename: "CardMedia",
	_meta?: GraphQLTypes["CardMediaMeta"],
	id: GraphQLTypes["UUID"],
	text?: string,
	imageNote?: string,
	image?: GraphQLTypes["Image"]
};
	["CardMediaMeta"]: {
	__typename: "CardMediaMeta",
	id?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	imageNote?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"]
};
	["ContentReferenceOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	block?: GraphQLTypes["ContentBlockOrderBy"],
	image?: GraphQLTypes["ImageOrderBy"],
	link?: GraphQLTypes["LinkOrderBy"],
	cardMedia?: GraphQLTypes["CardMediaOrderBy"]
};
	["ContentBlockOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	json?: GraphQLTypes["OrderDirection"],
	content?: GraphQLTypes["ContentOrderBy"]
};
	["CardMediaOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	imageNote?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"]
};
	["ContentBlockReferencesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkUniqueWhere"]
};
	["LinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ContentReferenceConnection"]: {
	__typename: "ContentReferenceConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentReferenceEdge"]>
};
	["ContentReferenceEdge"]: {
	__typename: "ContentReferenceEdge",
	node: GraphQLTypes["ContentReference"]
};
	["ContentBlocksByReferencesUniqueWhere"]: {
		references?: GraphQLTypes["ContentReferenceUniqueWhere"]
};
	["ContentReferenceUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkUniqueWhere"]
};
	["ContentBlockConnection"]: {
	__typename: "ContentBlockConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentBlockEdge"]>
};
	["ContentBlockEdge"]: {
	__typename: "ContentBlockEdge",
	node: GraphQLTypes["ContentBlock"]
};
	["ContentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	blocks?: GraphQLTypes["ContentBlockUniqueWhere"]
};
	["ContentBlockUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	references?: GraphQLTypes["ContentReferenceUniqueWhere"]
};
	["ContentConnection"]: {
	__typename: "ContentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentEdge"]>
};
	["ContentEdge"]: {
	__typename: "ContentEdge",
	node: GraphQLTypes["Content"]
};
	["_ValidationResult"]: {
	__typename: "_ValidationResult",
	valid: boolean,
	errors: Array<GraphQLTypes["_ValidationError"]>
};
	["_ValidationError"]: {
	__typename: "_ValidationError",
	path: Array<GraphQLTypes["_PathFragment"]>,
	message: GraphQLTypes["_ValidationMessage"]
};
	["_PathFragment"]:{
	__typename:"_FieldPathFragment" | "_IndexPathFragment"
	['...on _FieldPathFragment']: '__union' & GraphQLTypes["_FieldPathFragment"];
	['...on _IndexPathFragment']: '__union' & GraphQLTypes["_IndexPathFragment"];
};
	["_FieldPathFragment"]: {
	__typename: "_FieldPathFragment",
	field: string
};
	["_IndexPathFragment"]: {
	__typename: "_IndexPathFragment",
	index: number,
	alias?: string
};
	["_ValidationMessage"]: {
	__typename: "_ValidationMessage",
	text: string
};
	["ContentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	blocks?: Array<GraphQLTypes["ContentCreateBlocksEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentCreateBlocksEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	create?: GraphQLTypes["ContentBlockWithoutContentCreateInput"],
	alias?: string
};
	["ContentBlockWithoutContentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	references?: Array<GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentBlockCreateReferencesEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"],
	alias?: string
};
	["ContentReferenceWithoutBlockCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	text?: string,
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"],
	cardMedia?: GraphQLTypes["ContentReferenceCreateCardMediaEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ImageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ImageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	alt?: string,
	_dummy_field_?: boolean
};
	["ContentReferenceCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["LinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["LinkType"],
	title?: string,
	externalLink?: string,
	internalLink?: GraphQLTypes["LinkCreateInternalLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkCreateInternalLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["LinkableUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	event?: GraphQLTypes["EventUniqueWhere"],
	frontPage?: GraphQLTypes["FrontPageUniqueWhere"],
	specialEvent?: GraphQLTypes["SpecialEventUniqueWhere"],
	timelinePage?: GraphQLTypes["TimelinePageUniqueWhere"],
	sourcePage?: GraphQLTypes["SourcePageUniqueWhere"],
	redirect?: GraphQLTypes["RedirectUniqueWhere"],
	page?: GraphQLTypes["PageUniqueWhere"]
};
	["EventUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	image?: GraphQLTypes["ImageUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	content?: GraphQLTypes["ContentUniqueWhere"],
	linkForEvent?: GraphQLTypes["LinkUniqueWhere"],
	eventLabels?: GraphQLTypes["EventLabelUniqueWhere"]
};
	["SeoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	ogImage?: GraphQLTypes["ImageUniqueWhere"]
};
	["EventLabelUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["FrontPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	firstLink?: GraphQLTypes["LinkUniqueWhere"],
	secondLink?: GraphQLTypes["LinkUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	image?: GraphQLTypes["ImageUniqueWhere"],
	gallery?: GraphQLTypes["GalleryUniqueWhere"]
};
	["GalleryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["GalleryItemUniqueWhere"]
};
	["GalleryItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["SpecialEventUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	image?: GraphQLTypes["ImageUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	content?: GraphQLTypes["ContentUniqueWhere"]
};
	["TimelinePageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["SourcePageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["RedirectUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["PageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	content?: GraphQLTypes["ContentUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["LinkableCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	event?: GraphQLTypes["LinkableCreateEventEntityRelationInput"],
	frontPage?: GraphQLTypes["LinkableCreateFrontPageEntityRelationInput"],
	specialEvent?: GraphQLTypes["LinkableCreateSpecialEventEntityRelationInput"],
	timelinePage?: GraphQLTypes["LinkableCreateTimelinePageEntityRelationInput"],
	sourcePage?: GraphQLTypes["LinkableCreateSourcePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	page?: GraphQLTypes["LinkableCreatePageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableCreateEventEntityRelationInput"]: {
		connect?: GraphQLTypes["EventUniqueWhere"],
	create?: GraphQLTypes["EventWithoutLinkCreateInput"]
};
	["EventWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	place?: string,
	entrance?: string,
	image?: GraphQLTypes["EventCreateImageEntityRelationInput"],
	seo?: GraphQLTypes["EventCreateSeoEntityRelationInput"],
	content?: GraphQLTypes["EventCreateContentEntityRelationInput"],
	date?: string,
	order?: number,
	linkForEvent?: GraphQLTypes["EventCreateLinkForEventEntityRelationInput"],
	venue?: GraphQLTypes["EventCreateVenueEntityRelationInput"],
	pastEvent?: boolean,
	eventLabels?: Array<GraphQLTypes["EventCreateEventLabelsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["EventCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["EventCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["SeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoCreateOgImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["EventCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["EventCreateLinkForEventEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["EventCreateVenueEntityRelationInput"]: {
		connect?: GraphQLTypes["VenueUniqueWhere"],
	create?: GraphQLTypes["VenueCreateInput"]
};
	["VenueUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["VenueCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	order?: number,
	_dummy_field_?: boolean
};
	["EventCreateEventLabelsEntityRelationInput"]: {
		connect?: GraphQLTypes["EventLabelUniqueWhere"],
	create?: GraphQLTypes["EventLabelWithoutEventCreateInput"],
	alias?: string
};
	["EventLabelWithoutEventCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	text?: string,
	_dummy_field_?: boolean
};
	["LinkableCreateFrontPageEntityRelationInput"]: {
		connect?: GraphQLTypes["FrontPageUniqueWhere"],
	create?: GraphQLTypes["FrontPageWithoutLinkCreateInput"]
};
	["FrontPageWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	openingText?: string,
	eventsTitle?: string,
	firstLink?: GraphQLTypes["FrontPageCreateFirstLinkEntityRelationInput"],
	secondLink?: GraphQLTypes["FrontPageCreateSecondLinkEntityRelationInput"],
	seo?: GraphQLTypes["FrontPageCreateSeoEntityRelationInput"],
	subtitle?: string,
	projectSupport?: string,
	projectAuspices?: string,
	image?: GraphQLTypes["FrontPageCreateImageEntityRelationInput"],
	gallery?: GraphQLTypes["FrontPageCreateGalleryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FrontPageCreateFirstLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["FrontPageCreateSecondLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["FrontPageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["FrontPageCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["FrontPageCreateGalleryEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryUniqueWhere"],
	create?: GraphQLTypes["GalleryCreateInput"]
};
	["GalleryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["GalleryCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["GalleryCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryItemUniqueWhere"],
	create?: GraphQLTypes["GalleryItemWithoutListCreateInput"],
	alias?: string
};
	["GalleryItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	image?: GraphQLTypes["GalleryItemCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GalleryItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["LinkableCreateSpecialEventEntityRelationInput"]: {
		connect?: GraphQLTypes["SpecialEventUniqueWhere"],
	create?: GraphQLTypes["SpecialEventWithoutLinkCreateInput"]
};
	["SpecialEventWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	image?: GraphQLTypes["SpecialEventCreateImageEntityRelationInput"],
	seo?: GraphQLTypes["SpecialEventCreateSeoEntityRelationInput"],
	imageNote?: string,
	openingText?: string,
	subtitle?: string,
	unique?: GraphQLTypes["One"],
	content?: GraphQLTypes["SpecialEventCreateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SpecialEventCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["SpecialEventCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["SpecialEventCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["LinkableCreateTimelinePageEntityRelationInput"]: {
		connect?: GraphQLTypes["TimelinePageUniqueWhere"],
	create?: GraphQLTypes["TimelinePageWithoutLinkCreateInput"]
};
	["TimelinePageWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	seo?: GraphQLTypes["TimelinePageCreateSeoEntityRelationInput"],
	unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["TimelinePageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LinkableCreateSourcePageEntityRelationInput"]: {
		connect?: GraphQLTypes["SourcePageUniqueWhere"],
	create?: GraphQLTypes["SourcePageWithoutLinkCreateInput"]
};
	["SourcePageWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	links?: Array<GraphQLTypes["SourcePageCreateLinksEntityRelationInput"]>,
	seo?: GraphQLTypes["SourcePageCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SourcePageCreateLinksEntityRelationInput"]: {
		connect?: GraphQLTypes["SourcePostLinkUniqueWhere"],
	create?: GraphQLTypes["SourcePostLinkCreateInput"],
	alias?: string
};
	["SourcePostLinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkUniqueWhere"]
};
	["SourcePostLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	order?: number,
	link?: GraphQLTypes["SourcePostLinkCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SourcePostLinkCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["SourcePageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LinkableCreateRedirectEntityRelationInput"]: {
		connect?: GraphQLTypes["RedirectUniqueWhere"],
	create?: GraphQLTypes["RedirectWithoutLinkCreateInput"]
};
	["RedirectWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	targetUrl?: string,
	target?: GraphQLTypes["RedirectCreateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectCreateTargetEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["LinkableCreatePageEntityRelationInput"]: {
		connect?: GraphQLTypes["PageUniqueWhere"],
	create?: GraphQLTypes["PageWithoutLinkCreateInput"]
};
	["PageWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	title?: string,
	content?: GraphQLTypes["PageCreateContentEntityRelationInput"],
	seo?: GraphQLTypes["PageCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PageCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["PageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["ContentReferenceCreateCardMediaEntityRelationInput"]: {
		connect?: GraphQLTypes["CardMediaUniqueWhere"],
	create?: GraphQLTypes["CardMediaCreateInput"]
};
	["CardMediaUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	image?: GraphQLTypes["ImageUniqueWhere"]
};
	["CardMediaCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	text?: string,
	imageNote?: string,
	image?: GraphQLTypes["CardMediaCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["CardMediaCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContentUpdateInput"]: {
		blocks?: Array<GraphQLTypes["ContentUpdateBlocksEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentUpdateBlocksEntityRelationInput"]: {
		create?: GraphQLTypes["ContentBlockWithoutContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateBlocksRelationInput"],
	upsert?: GraphQLTypes["ContentUpsertBlocksRelationInput"],
	connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	disconnect?: GraphQLTypes["ContentBlockUniqueWhere"],
	delete?: GraphQLTypes["ContentBlockUniqueWhere"],
	alias?: string
};
	["ContentUpdateBlocksRelationInput"]: {
		by?: GraphQLTypes["ContentBlockUniqueWhere"],
	data?: GraphQLTypes["ContentBlockWithoutContentUpdateInput"]
};
	["ContentBlockWithoutContentUpdateInput"]: {
		order?: number,
	json?: string,
	references?: Array<GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentBlockUpdateReferencesEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"],
	update?: GraphQLTypes["ContentBlockUpdateReferencesRelationInput"],
	upsert?: GraphQLTypes["ContentBlockUpsertReferencesRelationInput"],
	connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	disconnect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	delete?: GraphQLTypes["ContentReferenceUniqueWhere"],
	alias?: string
};
	["ContentBlockUpdateReferencesRelationInput"]: {
		by?: GraphQLTypes["ContentReferenceUniqueWhere"],
	data?: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"]
};
	["ContentReferenceWithoutBlockUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	text?: string,
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"],
	cardMedia?: GraphQLTypes["ContentReferenceUpdateCardMediaEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ImageUpdateInput"]: {
		url?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	alt?: string,
	_dummy_field_?: boolean
};
	["ContentReferenceUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkUpdateInput"]: {
		type?: GraphQLTypes["LinkType"],
	title?: string,
	externalLink?: string,
	internalLink?: GraphQLTypes["LinkUpdateInternalLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkUpdateInternalLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableCreateInput"],
	update?: GraphQLTypes["LinkableUpdateInput"],
	upsert?: GraphQLTypes["LinkUpsertInternalLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableUpdateInput"]: {
		url?: string,
	event?: GraphQLTypes["LinkableUpdateEventEntityRelationInput"],
	frontPage?: GraphQLTypes["LinkableUpdateFrontPageEntityRelationInput"],
	specialEvent?: GraphQLTypes["LinkableUpdateSpecialEventEntityRelationInput"],
	timelinePage?: GraphQLTypes["LinkableUpdateTimelinePageEntityRelationInput"],
	sourcePage?: GraphQLTypes["LinkableUpdateSourcePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	page?: GraphQLTypes["LinkableUpdatePageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableUpdateEventEntityRelationInput"]: {
		create?: GraphQLTypes["EventWithoutLinkCreateInput"],
	update?: GraphQLTypes["EventWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertEventRelationInput"],
	connect?: GraphQLTypes["EventUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["EventWithoutLinkUpdateInput"]: {
		title?: string,
	place?: string,
	entrance?: string,
	image?: GraphQLTypes["EventUpdateImageEntityRelationInput"],
	seo?: GraphQLTypes["EventUpdateSeoEntityRelationInput"],
	content?: GraphQLTypes["EventUpdateContentEntityRelationInput"],
	date?: string,
	order?: number,
	linkForEvent?: GraphQLTypes["EventUpdateLinkForEventEntityRelationInput"],
	venue?: GraphQLTypes["EventUpdateVenueEntityRelationInput"],
	pastEvent?: boolean,
	eventLabels?: Array<GraphQLTypes["EventUpdateEventLabelsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["EventUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["EventUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["EventUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["EventUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["EventUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoUpdateInput"]: {
		title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoUpdateOgImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["SeoUpsertOgImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoUpsertOgImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["EventUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["EventUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["EventUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["EventUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["EventUpdateLinkForEventEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["EventUpsertLinkForEventRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["EventUpsertLinkForEventRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["EventUpdateVenueEntityRelationInput"]: {
		create?: GraphQLTypes["VenueCreateInput"],
	update?: GraphQLTypes["VenueUpdateInput"],
	upsert?: GraphQLTypes["EventUpsertVenueRelationInput"],
	connect?: GraphQLTypes["VenueUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["VenueUpdateInput"]: {
		name?: string,
	order?: number,
	_dummy_field_?: boolean
};
	["EventUpsertVenueRelationInput"]: {
		update?: GraphQLTypes["VenueUpdateInput"],
	create?: GraphQLTypes["VenueCreateInput"]
};
	["EventUpdateEventLabelsEntityRelationInput"]: {
		create?: GraphQLTypes["EventLabelWithoutEventCreateInput"],
	update?: GraphQLTypes["EventUpdateEventLabelsRelationInput"],
	upsert?: GraphQLTypes["EventUpsertEventLabelsRelationInput"],
	connect?: GraphQLTypes["EventLabelUniqueWhere"],
	disconnect?: GraphQLTypes["EventLabelUniqueWhere"],
	delete?: GraphQLTypes["EventLabelUniqueWhere"],
	alias?: string
};
	["EventUpdateEventLabelsRelationInput"]: {
		by?: GraphQLTypes["EventLabelUniqueWhere"],
	data?: GraphQLTypes["EventLabelWithoutEventUpdateInput"]
};
	["EventLabelWithoutEventUpdateInput"]: {
		order?: number,
	text?: string,
	_dummy_field_?: boolean
};
	["EventUpsertEventLabelsRelationInput"]: {
		by?: GraphQLTypes["EventLabelUniqueWhere"],
	update?: GraphQLTypes["EventLabelWithoutEventUpdateInput"],
	create?: GraphQLTypes["EventLabelWithoutEventCreateInput"]
};
	["LinkableUpsertEventRelationInput"]: {
		update?: GraphQLTypes["EventWithoutLinkUpdateInput"],
	create?: GraphQLTypes["EventWithoutLinkCreateInput"]
};
	["LinkableUpdateFrontPageEntityRelationInput"]: {
		create?: GraphQLTypes["FrontPageWithoutLinkCreateInput"],
	update?: GraphQLTypes["FrontPageWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertFrontPageRelationInput"],
	connect?: GraphQLTypes["FrontPageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FrontPageWithoutLinkUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	openingText?: string,
	eventsTitle?: string,
	firstLink?: GraphQLTypes["FrontPageUpdateFirstLinkEntityRelationInput"],
	secondLink?: GraphQLTypes["FrontPageUpdateSecondLinkEntityRelationInput"],
	seo?: GraphQLTypes["FrontPageUpdateSeoEntityRelationInput"],
	subtitle?: string,
	projectSupport?: string,
	projectAuspices?: string,
	image?: GraphQLTypes["FrontPageUpdateImageEntityRelationInput"],
	gallery?: GraphQLTypes["FrontPageUpdateGalleryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FrontPageUpdateFirstLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["FrontPageUpsertFirstLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FrontPageUpsertFirstLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["FrontPageUpdateSecondLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["FrontPageUpsertSecondLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FrontPageUpsertSecondLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["FrontPageUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["FrontPageUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FrontPageUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["FrontPageUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["FrontPageUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FrontPageUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["FrontPageUpdateGalleryEntityRelationInput"]: {
		create?: GraphQLTypes["GalleryCreateInput"],
	update?: GraphQLTypes["GalleryUpdateInput"],
	upsert?: GraphQLTypes["FrontPageUpsertGalleryRelationInput"],
	connect?: GraphQLTypes["GalleryUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["GalleryUpdateInput"]: {
		items?: Array<GraphQLTypes["GalleryUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["GalleryUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["GalleryItemWithoutListCreateInput"],
	update?: GraphQLTypes["GalleryUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["GalleryUpsertItemsRelationInput"],
	connect?: GraphQLTypes["GalleryItemUniqueWhere"],
	disconnect?: GraphQLTypes["GalleryItemUniqueWhere"],
	delete?: GraphQLTypes["GalleryItemUniqueWhere"],
	alias?: string
};
	["GalleryUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["GalleryItemUniqueWhere"],
	data?: GraphQLTypes["GalleryItemWithoutListUpdateInput"]
};
	["GalleryItemWithoutListUpdateInput"]: {
		order?: number,
	image?: GraphQLTypes["GalleryItemUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GalleryItemUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["GalleryItemUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["GalleryItemUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["GalleryUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["GalleryItemUniqueWhere"],
	update?: GraphQLTypes["GalleryItemWithoutListUpdateInput"],
	create?: GraphQLTypes["GalleryItemWithoutListCreateInput"]
};
	["FrontPageUpsertGalleryRelationInput"]: {
		update?: GraphQLTypes["GalleryUpdateInput"],
	create?: GraphQLTypes["GalleryCreateInput"]
};
	["LinkableUpsertFrontPageRelationInput"]: {
		update?: GraphQLTypes["FrontPageWithoutLinkUpdateInput"],
	create?: GraphQLTypes["FrontPageWithoutLinkCreateInput"]
};
	["LinkableUpdateSpecialEventEntityRelationInput"]: {
		create?: GraphQLTypes["SpecialEventWithoutLinkCreateInput"],
	update?: GraphQLTypes["SpecialEventWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertSpecialEventRelationInput"],
	connect?: GraphQLTypes["SpecialEventUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SpecialEventWithoutLinkUpdateInput"]: {
		title?: string,
	image?: GraphQLTypes["SpecialEventUpdateImageEntityRelationInput"],
	seo?: GraphQLTypes["SpecialEventUpdateSeoEntityRelationInput"],
	imageNote?: string,
	openingText?: string,
	subtitle?: string,
	unique?: GraphQLTypes["One"],
	content?: GraphQLTypes["SpecialEventUpdateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SpecialEventUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["SpecialEventUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SpecialEventUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["SpecialEventUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["SpecialEventUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SpecialEventUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["SpecialEventUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["SpecialEventUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SpecialEventUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["LinkableUpsertSpecialEventRelationInput"]: {
		update?: GraphQLTypes["SpecialEventWithoutLinkUpdateInput"],
	create?: GraphQLTypes["SpecialEventWithoutLinkCreateInput"]
};
	["LinkableUpdateTimelinePageEntityRelationInput"]: {
		create?: GraphQLTypes["TimelinePageWithoutLinkCreateInput"],
	update?: GraphQLTypes["TimelinePageWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertTimelinePageRelationInput"],
	connect?: GraphQLTypes["TimelinePageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["TimelinePageWithoutLinkUpdateInput"]: {
		title?: string,
	seo?: GraphQLTypes["TimelinePageUpdateSeoEntityRelationInput"],
	unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["TimelinePageUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["TimelinePageUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["TimelinePageUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LinkableUpsertTimelinePageRelationInput"]: {
		update?: GraphQLTypes["TimelinePageWithoutLinkUpdateInput"],
	create?: GraphQLTypes["TimelinePageWithoutLinkCreateInput"]
};
	["LinkableUpdateSourcePageEntityRelationInput"]: {
		create?: GraphQLTypes["SourcePageWithoutLinkCreateInput"],
	update?: GraphQLTypes["SourcePageWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertSourcePageRelationInput"],
	connect?: GraphQLTypes["SourcePageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SourcePageWithoutLinkUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	links?: Array<GraphQLTypes["SourcePageUpdateLinksEntityRelationInput"]>,
	seo?: GraphQLTypes["SourcePageUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SourcePageUpdateLinksEntityRelationInput"]: {
		create?: GraphQLTypes["SourcePostLinkCreateInput"],
	update?: GraphQLTypes["SourcePageUpdateLinksRelationInput"],
	upsert?: GraphQLTypes["SourcePageUpsertLinksRelationInput"],
	connect?: GraphQLTypes["SourcePostLinkUniqueWhere"],
	disconnect?: GraphQLTypes["SourcePostLinkUniqueWhere"],
	delete?: GraphQLTypes["SourcePostLinkUniqueWhere"],
	alias?: string
};
	["SourcePageUpdateLinksRelationInput"]: {
		by?: GraphQLTypes["SourcePostLinkUniqueWhere"],
	data?: GraphQLTypes["SourcePostLinkUpdateInput"]
};
	["SourcePostLinkUpdateInput"]: {
		title?: string,
	order?: number,
	link?: GraphQLTypes["SourcePostLinkUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SourcePostLinkUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["SourcePostLinkUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SourcePostLinkUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["SourcePageUpsertLinksRelationInput"]: {
		by?: GraphQLTypes["SourcePostLinkUniqueWhere"],
	update?: GraphQLTypes["SourcePostLinkUpdateInput"],
	create?: GraphQLTypes["SourcePostLinkCreateInput"]
};
	["SourcePageUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["SourcePageUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SourcePageUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LinkableUpsertSourcePageRelationInput"]: {
		update?: GraphQLTypes["SourcePageWithoutLinkUpdateInput"],
	create?: GraphQLTypes["SourcePageWithoutLinkCreateInput"]
};
	["LinkableUpdateRedirectEntityRelationInput"]: {
		create?: GraphQLTypes["RedirectWithoutLinkCreateInput"],
	update?: GraphQLTypes["RedirectWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertRedirectRelationInput"],
	connect?: GraphQLTypes["RedirectUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["RedirectWithoutLinkUpdateInput"]: {
		targetUrl?: string,
	target?: GraphQLTypes["RedirectUpdateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpdateTargetEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableCreateInput"],
	update?: GraphQLTypes["LinkableUpdateInput"],
	upsert?: GraphQLTypes["RedirectUpsertTargetRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["RedirectUpsertTargetRelationInput"]: {
		update?: GraphQLTypes["LinkableUpdateInput"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["LinkableUpsertRedirectRelationInput"]: {
		update?: GraphQLTypes["RedirectWithoutLinkUpdateInput"],
	create?: GraphQLTypes["RedirectWithoutLinkCreateInput"]
};
	["LinkableUpdatePageEntityRelationInput"]: {
		create?: GraphQLTypes["PageWithoutLinkCreateInput"],
	update?: GraphQLTypes["PageWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertPageRelationInput"],
	connect?: GraphQLTypes["PageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PageWithoutLinkUpdateInput"]: {
		order?: number,
	title?: string,
	content?: GraphQLTypes["PageUpdateContentEntityRelationInput"],
	seo?: GraphQLTypes["PageUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PageUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["PageUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PageUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["PageUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["PageUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PageUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LinkableUpsertPageRelationInput"]: {
		update?: GraphQLTypes["PageWithoutLinkUpdateInput"],
	create?: GraphQLTypes["PageWithoutLinkCreateInput"]
};
	["LinkUpsertInternalLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableUpdateInput"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["ContentReferenceUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ContentReferenceUpdateCardMediaEntityRelationInput"]: {
		create?: GraphQLTypes["CardMediaCreateInput"],
	update?: GraphQLTypes["CardMediaUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertCardMediaRelationInput"],
	connect?: GraphQLTypes["CardMediaUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["CardMediaUpdateInput"]: {
		text?: string,
	imageNote?: string,
	image?: GraphQLTypes["CardMediaUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["CardMediaUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["CardMediaUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["CardMediaUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceUpsertCardMediaRelationInput"]: {
		update?: GraphQLTypes["CardMediaUpdateInput"],
	create?: GraphQLTypes["CardMediaCreateInput"]
};
	["ContentBlockUpsertReferencesRelationInput"]: {
		by?: GraphQLTypes["ContentReferenceUniqueWhere"],
	update?: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"],
	create?: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"]
};
	["ContentUpsertBlocksRelationInput"]: {
		by?: GraphQLTypes["ContentBlockUniqueWhere"],
	update?: GraphQLTypes["ContentBlockWithoutContentUpdateInput"],
	create?: GraphQLTypes["ContentBlockWithoutContentCreateInput"]
};
	["ContentBlockCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	content?: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"],
	references?: Array<GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentBlockCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentWithoutBlocksCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["ContentBlockUpdateInput"]: {
		order?: number,
	json?: string,
	content?: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"],
	references?: Array<GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentBlockUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentWithoutBlocksCreateInput"],
	update?: GraphQLTypes["ContentWithoutBlocksUpdateInput"],
	upsert?: GraphQLTypes["ContentBlockUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	delete?: boolean
};
	["ContentWithoutBlocksUpdateInput"]: {
		_dummy_field_?: boolean
};
	["ContentBlockUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentWithoutBlocksUpdateInput"],
	create?: GraphQLTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentReferenceCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	text?: string,
	block?: GraphQLTypes["ContentReferenceCreateBlockEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"],
	cardMedia?: GraphQLTypes["ContentReferenceCreateCardMediaEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceCreateBlockEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	create?: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["ContentBlockWithoutReferencesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	content?: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	text?: string,
	block?: GraphQLTypes["ContentReferenceUpdateBlockEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"],
	cardMedia?: GraphQLTypes["ContentReferenceUpdateCardMediaEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpdateBlockEntityRelationInput"]: {
		create?: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"],
	update?: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertBlockRelationInput"],
	connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	delete?: boolean
};
	["ContentBlockWithoutReferencesUpdateInput"]: {
		order?: number,
	json?: string,
	content?: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpsertBlockRelationInput"]: {
		update?: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"],
	create?: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["EventConnection"]: {
	__typename: "EventConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["EventEdge"]>
};
	["EventEdge"]: {
	__typename: "EventEdge",
	node: GraphQLTypes["Event"]
};
	["EventCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	place?: string,
	entrance?: string,
	image?: GraphQLTypes["EventCreateImageEntityRelationInput"],
	seo?: GraphQLTypes["EventCreateSeoEntityRelationInput"],
	link?: GraphQLTypes["EventCreateLinkEntityRelationInput"],
	content?: GraphQLTypes["EventCreateContentEntityRelationInput"],
	date?: string,
	order?: number,
	linkForEvent?: GraphQLTypes["EventCreateLinkForEventEntityRelationInput"],
	venue?: GraphQLTypes["EventCreateVenueEntityRelationInput"],
	pastEvent?: boolean,
	eventLabels?: Array<GraphQLTypes["EventCreateEventLabelsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["EventCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutEventCreateInput"]
};
	["LinkableWithoutEventCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	frontPage?: GraphQLTypes["LinkableCreateFrontPageEntityRelationInput"],
	specialEvent?: GraphQLTypes["LinkableCreateSpecialEventEntityRelationInput"],
	timelinePage?: GraphQLTypes["LinkableCreateTimelinePageEntityRelationInput"],
	sourcePage?: GraphQLTypes["LinkableCreateSourcePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	page?: GraphQLTypes["LinkableCreatePageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EventUpdateInput"]: {
		title?: string,
	place?: string,
	entrance?: string,
	image?: GraphQLTypes["EventUpdateImageEntityRelationInput"],
	seo?: GraphQLTypes["EventUpdateSeoEntityRelationInput"],
	link?: GraphQLTypes["EventUpdateLinkEntityRelationInput"],
	content?: GraphQLTypes["EventUpdateContentEntityRelationInput"],
	date?: string,
	order?: number,
	linkForEvent?: GraphQLTypes["EventUpdateLinkForEventEntityRelationInput"],
	venue?: GraphQLTypes["EventUpdateVenueEntityRelationInput"],
	pastEvent?: boolean,
	eventLabels?: Array<GraphQLTypes["EventUpdateEventLabelsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["EventUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutEventCreateInput"],
	update?: GraphQLTypes["LinkableWithoutEventUpdateInput"],
	upsert?: GraphQLTypes["EventUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutEventUpdateInput"]: {
		url?: string,
	frontPage?: GraphQLTypes["LinkableUpdateFrontPageEntityRelationInput"],
	specialEvent?: GraphQLTypes["LinkableUpdateSpecialEventEntityRelationInput"],
	timelinePage?: GraphQLTypes["LinkableUpdateTimelinePageEntityRelationInput"],
	sourcePage?: GraphQLTypes["LinkableUpdateSourcePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	page?: GraphQLTypes["LinkableUpdatePageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EventUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutEventUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutEventCreateInput"]
};
	["FallbackSeo"]: {
	__typename: "FallbackSeo",
	_meta?: GraphQLTypes["FallbackSeoMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	seo?: GraphQLTypes["Seo"]
};
	["FallbackSeoMeta"]: {
	__typename: "FallbackSeoMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"]
};
	["FallbackSeoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["FallbackSeoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	seo?: GraphQLTypes["SeoWhere"],
	and?: Array<GraphQLTypes["FallbackSeoWhere"] | undefined>,
	or?: Array<GraphQLTypes["FallbackSeoWhere"] | undefined>,
	not?: GraphQLTypes["FallbackSeoWhere"]
};
	["FallbackSeoOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"]
};
	["FallbackSeoConnection"]: {
	__typename: "FallbackSeoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FallbackSeoEdge"]>
};
	["FallbackSeoEdge"]: {
	__typename: "FallbackSeoEdge",
	node: GraphQLTypes["FallbackSeo"]
};
	["FallbackSeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["FallbackSeoCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FallbackSeoCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["FallbackSeoUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["FallbackSeoUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FallbackSeoUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["FallbackSeoUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FallbackSeoUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["Footer"]: {
	__typename: "Footer",
	_meta?: GraphQLTypes["FooterMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	projectSupport?: string,
	projectAuspices?: string,
	gallery?: GraphQLTypes["Gallery"]
};
	["FooterMeta"]: {
	__typename: "FooterMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	projectSupport?: GraphQLTypes["FieldMeta"],
	projectAuspices?: GraphQLTypes["FieldMeta"],
	gallery?: GraphQLTypes["FieldMeta"]
};
	["FooterUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	gallery?: GraphQLTypes["GalleryUniqueWhere"]
};
	["FooterWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	projectSupport?: GraphQLTypes["StringCondition"],
	projectAuspices?: GraphQLTypes["StringCondition"],
	gallery?: GraphQLTypes["GalleryWhere"],
	and?: Array<GraphQLTypes["FooterWhere"] | undefined>,
	or?: Array<GraphQLTypes["FooterWhere"] | undefined>,
	not?: GraphQLTypes["FooterWhere"]
};
	["FooterOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	projectSupport?: GraphQLTypes["OrderDirection"],
	projectAuspices?: GraphQLTypes["OrderDirection"],
	gallery?: GraphQLTypes["GalleryOrderBy"]
};
	["FooterConnection"]: {
	__typename: "FooterConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FooterEdge"]>
};
	["FooterEdge"]: {
	__typename: "FooterEdge",
	node: GraphQLTypes["Footer"]
};
	["FooterCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	projectSupport?: string,
	projectAuspices?: string,
	gallery?: GraphQLTypes["FooterCreateGalleryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterCreateGalleryEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryUniqueWhere"],
	create?: GraphQLTypes["GalleryCreateInput"]
};
	["FooterUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	projectSupport?: string,
	projectAuspices?: string,
	gallery?: GraphQLTypes["FooterUpdateGalleryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterUpdateGalleryEntityRelationInput"]: {
		create?: GraphQLTypes["GalleryCreateInput"],
	update?: GraphQLTypes["GalleryUpdateInput"],
	upsert?: GraphQLTypes["FooterUpsertGalleryRelationInput"],
	connect?: GraphQLTypes["GalleryUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FooterUpsertGalleryRelationInput"]: {
		update?: GraphQLTypes["GalleryUpdateInput"],
	create?: GraphQLTypes["GalleryCreateInput"]
};
	["Header"]: {
	__typename: "Header",
	_meta?: GraphQLTypes["HeaderMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	links: Array<GraphQLTypes["HeaderLink"]>,
	paginateLinks: GraphQLTypes["HeaderLinkConnection"]
};
	["HeaderMeta"]: {
	__typename: "HeaderMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	links?: GraphQLTypes["FieldMeta"]
};
	["HeaderLink"]: {
	__typename: "HeaderLink",
	_meta?: GraphQLTypes["HeaderLinkMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	link?: GraphQLTypes["Link"]
};
	["HeaderLinkMeta"]: {
	__typename: "HeaderLinkMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"]
};
	["HeaderLinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	link?: GraphQLTypes["LinkWhere"],
	and?: Array<GraphQLTypes["HeaderLinkWhere"] | undefined>,
	or?: Array<GraphQLTypes["HeaderLinkWhere"] | undefined>,
	not?: GraphQLTypes["HeaderLinkWhere"]
};
	["HeaderLinkOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkOrderBy"]
};
	["HeaderLinkConnection"]: {
	__typename: "HeaderLinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HeaderLinkEdge"]>
};
	["HeaderLinkEdge"]: {
	__typename: "HeaderLinkEdge",
	node: GraphQLTypes["HeaderLink"]
};
	["HeaderUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"]
};
	["HeaderWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	links?: GraphQLTypes["HeaderLinkWhere"],
	and?: Array<GraphQLTypes["HeaderWhere"] | undefined>,
	or?: Array<GraphQLTypes["HeaderWhere"] | undefined>,
	not?: GraphQLTypes["HeaderWhere"]
};
	["HeaderOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"]
};
	["HeaderConnection"]: {
	__typename: "HeaderConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HeaderEdge"]>
};
	["HeaderEdge"]: {
	__typename: "HeaderEdge",
	node: GraphQLTypes["Header"]
};
	["HeaderCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	links?: Array<GraphQLTypes["HeaderCreateLinksEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["HeaderCreateLinksEntityRelationInput"]: {
		connect?: GraphQLTypes["HeaderLinkUniqueWhere"],
	create?: GraphQLTypes["HeaderLinkCreateInput"],
	alias?: string
};
	["HeaderLinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkUniqueWhere"]
};
	["HeaderLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	link?: GraphQLTypes["HeaderLinkCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderLinkCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["HeaderUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	links?: Array<GraphQLTypes["HeaderUpdateLinksEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["HeaderUpdateLinksEntityRelationInput"]: {
		create?: GraphQLTypes["HeaderLinkCreateInput"],
	update?: GraphQLTypes["HeaderUpdateLinksRelationInput"],
	upsert?: GraphQLTypes["HeaderUpsertLinksRelationInput"],
	connect?: GraphQLTypes["HeaderLinkUniqueWhere"],
	disconnect?: GraphQLTypes["HeaderLinkUniqueWhere"],
	delete?: GraphQLTypes["HeaderLinkUniqueWhere"],
	alias?: string
};
	["HeaderUpdateLinksRelationInput"]: {
		by?: GraphQLTypes["HeaderLinkUniqueWhere"],
	data?: GraphQLTypes["HeaderLinkUpdateInput"]
};
	["HeaderLinkUpdateInput"]: {
		order?: number,
	link?: GraphQLTypes["HeaderLinkUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderLinkUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["HeaderLinkUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HeaderLinkUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["HeaderUpsertLinksRelationInput"]: {
		by?: GraphQLTypes["HeaderLinkUniqueWhere"],
	update?: GraphQLTypes["HeaderLinkUpdateInput"],
	create?: GraphQLTypes["HeaderLinkCreateInput"]
};
	["FrontPageConnection"]: {
	__typename: "FrontPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FrontPageEdge"]>
};
	["FrontPageEdge"]: {
	__typename: "FrontPageEdge",
	node: GraphQLTypes["FrontPage"]
};
	["FrontPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	openingText?: string,
	eventsTitle?: string,
	firstLink?: GraphQLTypes["FrontPageCreateFirstLinkEntityRelationInput"],
	secondLink?: GraphQLTypes["FrontPageCreateSecondLinkEntityRelationInput"],
	seo?: GraphQLTypes["FrontPageCreateSeoEntityRelationInput"],
	link?: GraphQLTypes["FrontPageCreateLinkEntityRelationInput"],
	subtitle?: string,
	projectSupport?: string,
	projectAuspices?: string,
	image?: GraphQLTypes["FrontPageCreateImageEntityRelationInput"],
	gallery?: GraphQLTypes["FrontPageCreateGalleryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FrontPageCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutFrontPageCreateInput"]
};
	["LinkableWithoutFrontPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	event?: GraphQLTypes["LinkableCreateEventEntityRelationInput"],
	specialEvent?: GraphQLTypes["LinkableCreateSpecialEventEntityRelationInput"],
	timelinePage?: GraphQLTypes["LinkableCreateTimelinePageEntityRelationInput"],
	sourcePage?: GraphQLTypes["LinkableCreateSourcePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	page?: GraphQLTypes["LinkableCreatePageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FrontPageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	openingText?: string,
	eventsTitle?: string,
	firstLink?: GraphQLTypes["FrontPageUpdateFirstLinkEntityRelationInput"],
	secondLink?: GraphQLTypes["FrontPageUpdateSecondLinkEntityRelationInput"],
	seo?: GraphQLTypes["FrontPageUpdateSeoEntityRelationInput"],
	link?: GraphQLTypes["FrontPageUpdateLinkEntityRelationInput"],
	subtitle?: string,
	projectSupport?: string,
	projectAuspices?: string,
	image?: GraphQLTypes["FrontPageUpdateImageEntityRelationInput"],
	gallery?: GraphQLTypes["FrontPageUpdateGalleryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FrontPageUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutFrontPageCreateInput"],
	update?: GraphQLTypes["LinkableWithoutFrontPageUpdateInput"],
	upsert?: GraphQLTypes["FrontPageUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutFrontPageUpdateInput"]: {
		url?: string,
	event?: GraphQLTypes["LinkableUpdateEventEntityRelationInput"],
	specialEvent?: GraphQLTypes["LinkableUpdateSpecialEventEntityRelationInput"],
	timelinePage?: GraphQLTypes["LinkableUpdateTimelinePageEntityRelationInput"],
	sourcePage?: GraphQLTypes["LinkableUpdateSourcePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	page?: GraphQLTypes["LinkableUpdatePageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FrontPageUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutFrontPageUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutFrontPageCreateInput"]
};
	["ImageConnection"]: {
	__typename: "ImageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageEdge"]>
};
	["ImageEdge"]: {
	__typename: "ImageEdge",
	node: GraphQLTypes["Image"]
};
	["LinkConnection"]: {
	__typename: "LinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkEdge"]>
};
	["LinkEdge"]: {
	__typename: "LinkEdge",
	node: GraphQLTypes["Link"]
};
	["LinkableConnection"]: {
	__typename: "LinkableConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkableEdge"]>
};
	["LinkableEdge"]: {
	__typename: "LinkableEdge",
	node: GraphQLTypes["Linkable"]
};
	["SeoConnection"]: {
	__typename: "SeoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SeoEdge"]>
};
	["SeoEdge"]: {
	__typename: "SeoEdge",
	node: GraphQLTypes["Seo"]
};
	["SpecialEventConnection"]: {
	__typename: "SpecialEventConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SpecialEventEdge"]>
};
	["SpecialEventEdge"]: {
	__typename: "SpecialEventEdge",
	node: GraphQLTypes["SpecialEvent"]
};
	["SpecialEventCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["SpecialEventCreateLinkEntityRelationInput"],
	image?: GraphQLTypes["SpecialEventCreateImageEntityRelationInput"],
	seo?: GraphQLTypes["SpecialEventCreateSeoEntityRelationInput"],
	imageNote?: string,
	openingText?: string,
	subtitle?: string,
	unique?: GraphQLTypes["One"],
	content?: GraphQLTypes["SpecialEventCreateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SpecialEventCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutSpecialEventCreateInput"]
};
	["LinkableWithoutSpecialEventCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	event?: GraphQLTypes["LinkableCreateEventEntityRelationInput"],
	frontPage?: GraphQLTypes["LinkableCreateFrontPageEntityRelationInput"],
	timelinePage?: GraphQLTypes["LinkableCreateTimelinePageEntityRelationInput"],
	sourcePage?: GraphQLTypes["LinkableCreateSourcePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	page?: GraphQLTypes["LinkableCreatePageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SpecialEventUpdateInput"]: {
		title?: string,
	link?: GraphQLTypes["SpecialEventUpdateLinkEntityRelationInput"],
	image?: GraphQLTypes["SpecialEventUpdateImageEntityRelationInput"],
	seo?: GraphQLTypes["SpecialEventUpdateSeoEntityRelationInput"],
	imageNote?: string,
	openingText?: string,
	subtitle?: string,
	unique?: GraphQLTypes["One"],
	content?: GraphQLTypes["SpecialEventUpdateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SpecialEventUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutSpecialEventCreateInput"],
	update?: GraphQLTypes["LinkableWithoutSpecialEventUpdateInput"],
	upsert?: GraphQLTypes["SpecialEventUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutSpecialEventUpdateInput"]: {
		url?: string,
	event?: GraphQLTypes["LinkableUpdateEventEntityRelationInput"],
	frontPage?: GraphQLTypes["LinkableUpdateFrontPageEntityRelationInput"],
	timelinePage?: GraphQLTypes["LinkableUpdateTimelinePageEntityRelationInput"],
	sourcePage?: GraphQLTypes["LinkableUpdateSourcePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	page?: GraphQLTypes["LinkableUpdatePageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SpecialEventUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutSpecialEventUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutSpecialEventCreateInput"]
};
	["TimelinePageConnection"]: {
	__typename: "TimelinePageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TimelinePageEdge"]>
};
	["TimelinePageEdge"]: {
	__typename: "TimelinePageEdge",
	node: GraphQLTypes["TimelinePage"]
};
	["TimelinePageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["TimelinePageCreateLinkEntityRelationInput"],
	seo?: GraphQLTypes["TimelinePageCreateSeoEntityRelationInput"],
	unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["TimelinePageCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutTimelinePageCreateInput"]
};
	["LinkableWithoutTimelinePageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	event?: GraphQLTypes["LinkableCreateEventEntityRelationInput"],
	frontPage?: GraphQLTypes["LinkableCreateFrontPageEntityRelationInput"],
	specialEvent?: GraphQLTypes["LinkableCreateSpecialEventEntityRelationInput"],
	sourcePage?: GraphQLTypes["LinkableCreateSourcePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	page?: GraphQLTypes["LinkableCreatePageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TimelinePageUpdateInput"]: {
		title?: string,
	link?: GraphQLTypes["TimelinePageUpdateLinkEntityRelationInput"],
	seo?: GraphQLTypes["TimelinePageUpdateSeoEntityRelationInput"],
	unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["TimelinePageUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutTimelinePageCreateInput"],
	update?: GraphQLTypes["LinkableWithoutTimelinePageUpdateInput"],
	upsert?: GraphQLTypes["TimelinePageUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutTimelinePageUpdateInput"]: {
		url?: string,
	event?: GraphQLTypes["LinkableUpdateEventEntityRelationInput"],
	frontPage?: GraphQLTypes["LinkableUpdateFrontPageEntityRelationInput"],
	specialEvent?: GraphQLTypes["LinkableUpdateSpecialEventEntityRelationInput"],
	sourcePage?: GraphQLTypes["LinkableUpdateSourcePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	page?: GraphQLTypes["LinkableUpdatePageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TimelinePageUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutTimelinePageUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutTimelinePageCreateInput"]
};
	["TimelinePost"]: {
	__typename: "TimelinePost",
	_meta?: GraphQLTypes["TimelinePostMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	text?: string,
	image?: GraphQLTypes["Image"],
	seo?: GraphQLTypes["Seo"],
	date?: string,
	additionalInfo?: string,
	link?: GraphQLTypes["Link"],
	order: number
};
	["TimelinePostMeta"]: {
	__typename: "TimelinePostMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	date?: GraphQLTypes["FieldMeta"],
	additionalInfo?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"]
};
	["TimelinePostUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	image?: GraphQLTypes["ImageUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	link?: GraphQLTypes["LinkUniqueWhere"]
};
	["TimelinePostWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	text?: GraphQLTypes["StringCondition"],
	image?: GraphQLTypes["ImageWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	date?: GraphQLTypes["StringCondition"],
	additionalInfo?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["LinkWhere"],
	order?: GraphQLTypes["IntCondition"],
	and?: Array<GraphQLTypes["TimelinePostWhere"] | undefined>,
	or?: Array<GraphQLTypes["TimelinePostWhere"] | undefined>,
	not?: GraphQLTypes["TimelinePostWhere"]
};
	["TimelinePostOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"],
	date?: GraphQLTypes["OrderDirection"],
	additionalInfo?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkOrderBy"],
	order?: GraphQLTypes["OrderDirection"]
};
	["TimelinePostConnection"]: {
	__typename: "TimelinePostConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TimelinePostEdge"]>
};
	["TimelinePostEdge"]: {
	__typename: "TimelinePostEdge",
	node: GraphQLTypes["TimelinePost"]
};
	["TimelinePostCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	text?: string,
	image?: GraphQLTypes["TimelinePostCreateImageEntityRelationInput"],
	seo?: GraphQLTypes["TimelinePostCreateSeoEntityRelationInput"],
	date?: string,
	additionalInfo?: string,
	link?: GraphQLTypes["TimelinePostCreateLinkEntityRelationInput"],
	order?: number,
	_dummy_field_?: boolean
};
	["TimelinePostCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["TimelinePostCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["TimelinePostCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["TimelinePostUpdateInput"]: {
		title?: string,
	text?: string,
	image?: GraphQLTypes["TimelinePostUpdateImageEntityRelationInput"],
	seo?: GraphQLTypes["TimelinePostUpdateSeoEntityRelationInput"],
	date?: string,
	additionalInfo?: string,
	link?: GraphQLTypes["TimelinePostUpdateLinkEntityRelationInput"],
	order?: number,
	_dummy_field_?: boolean
};
	["TimelinePostUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["TimelinePostUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["TimelinePostUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["TimelinePostUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["TimelinePostUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["TimelinePostUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["TimelinePostUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["TimelinePostUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["TimelinePostUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["SourcePageConnection"]: {
	__typename: "SourcePageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SourcePageEdge"]>
};
	["SourcePageEdge"]: {
	__typename: "SourcePageEdge",
	node: GraphQLTypes["SourcePage"]
};
	["SourcePageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	link?: GraphQLTypes["SourcePageCreateLinkEntityRelationInput"],
	links?: Array<GraphQLTypes["SourcePageCreateLinksEntityRelationInput"]>,
	seo?: GraphQLTypes["SourcePageCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SourcePageCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutSourcePageCreateInput"]
};
	["LinkableWithoutSourcePageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	event?: GraphQLTypes["LinkableCreateEventEntityRelationInput"],
	frontPage?: GraphQLTypes["LinkableCreateFrontPageEntityRelationInput"],
	specialEvent?: GraphQLTypes["LinkableCreateSpecialEventEntityRelationInput"],
	timelinePage?: GraphQLTypes["LinkableCreateTimelinePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	page?: GraphQLTypes["LinkableCreatePageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SourcePageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	link?: GraphQLTypes["SourcePageUpdateLinkEntityRelationInput"],
	links?: Array<GraphQLTypes["SourcePageUpdateLinksEntityRelationInput"]>,
	seo?: GraphQLTypes["SourcePageUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SourcePageUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutSourcePageCreateInput"],
	update?: GraphQLTypes["LinkableWithoutSourcePageUpdateInput"],
	upsert?: GraphQLTypes["SourcePageUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutSourcePageUpdateInput"]: {
		url?: string,
	event?: GraphQLTypes["LinkableUpdateEventEntityRelationInput"],
	frontPage?: GraphQLTypes["LinkableUpdateFrontPageEntityRelationInput"],
	specialEvent?: GraphQLTypes["LinkableUpdateSpecialEventEntityRelationInput"],
	timelinePage?: GraphQLTypes["LinkableUpdateTimelinePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	page?: GraphQLTypes["LinkableUpdatePageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SourcePageUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutSourcePageUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutSourcePageCreateInput"]
};
	["GalleryConnection"]: {
	__typename: "GalleryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GalleryEdge"]>
};
	["GalleryEdge"]: {
	__typename: "GalleryEdge",
	node: GraphQLTypes["Gallery"]
};
	["GalleryItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["GalleryItemCreateListEntityRelationInput"],
	image?: GraphQLTypes["GalleryItemCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GalleryItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryUniqueWhere"],
	create?: GraphQLTypes["GalleryWithoutItemsCreateInput"]
};
	["GalleryWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["GalleryItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["GalleryItemUpdateListEntityRelationInput"],
	image?: GraphQLTypes["GalleryItemUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GalleryItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["GalleryWithoutItemsCreateInput"],
	update?: GraphQLTypes["GalleryWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["GalleryItemUpsertListRelationInput"],
	connect?: GraphQLTypes["GalleryUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["GalleryWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["GalleryItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["GalleryWithoutItemsUpdateInput"],
	create?: GraphQLTypes["GalleryWithoutItemsCreateInput"]
};
	["CardMediaConnection"]: {
	__typename: "CardMediaConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CardMediaEdge"]>
};
	["CardMediaEdge"]: {
	__typename: "CardMediaEdge",
	node: GraphQLTypes["CardMedia"]
};
	["RedirectConnection"]: {
	__typename: "RedirectConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RedirectEdge"]>
};
	["RedirectEdge"]: {
	__typename: "RedirectEdge",
	node: GraphQLTypes["Redirect"]
};
	["RedirectCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	targetUrl?: string,
	link?: GraphQLTypes["RedirectCreateLinkEntityRelationInput"],
	target?: GraphQLTypes["RedirectCreateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutRedirectCreateInput"]
};
	["LinkableWithoutRedirectCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	event?: GraphQLTypes["LinkableCreateEventEntityRelationInput"],
	frontPage?: GraphQLTypes["LinkableCreateFrontPageEntityRelationInput"],
	specialEvent?: GraphQLTypes["LinkableCreateSpecialEventEntityRelationInput"],
	timelinePage?: GraphQLTypes["LinkableCreateTimelinePageEntityRelationInput"],
	sourcePage?: GraphQLTypes["LinkableCreateSourcePageEntityRelationInput"],
	page?: GraphQLTypes["LinkableCreatePageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpdateInput"]: {
		targetUrl?: string,
	link?: GraphQLTypes["RedirectUpdateLinkEntityRelationInput"],
	target?: GraphQLTypes["RedirectUpdateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutRedirectCreateInput"],
	update?: GraphQLTypes["LinkableWithoutRedirectUpdateInput"],
	upsert?: GraphQLTypes["RedirectUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutRedirectUpdateInput"]: {
		url?: string,
	event?: GraphQLTypes["LinkableUpdateEventEntityRelationInput"],
	frontPage?: GraphQLTypes["LinkableUpdateFrontPageEntityRelationInput"],
	specialEvent?: GraphQLTypes["LinkableUpdateSpecialEventEntityRelationInput"],
	timelinePage?: GraphQLTypes["LinkableUpdateTimelinePageEntityRelationInput"],
	sourcePage?: GraphQLTypes["LinkableUpdateSourcePageEntityRelationInput"],
	page?: GraphQLTypes["LinkableUpdatePageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutRedirectUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutRedirectCreateInput"]
};
	["VenueConnection"]: {
	__typename: "VenueConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["VenueEdge"]>
};
	["VenueEdge"]: {
	__typename: "VenueEdge",
	node: GraphQLTypes["Venue"]
};
	["EventLabelCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	text?: string,
	event?: GraphQLTypes["EventLabelCreateEventEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EventLabelCreateEventEntityRelationInput"]: {
		connect?: GraphQLTypes["EventUniqueWhere"],
	create?: GraphQLTypes["EventWithoutEventLabelsCreateInput"]
};
	["EventWithoutEventLabelsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	place?: string,
	entrance?: string,
	image?: GraphQLTypes["EventCreateImageEntityRelationInput"],
	seo?: GraphQLTypes["EventCreateSeoEntityRelationInput"],
	link?: GraphQLTypes["EventCreateLinkEntityRelationInput"],
	content?: GraphQLTypes["EventCreateContentEntityRelationInput"],
	date?: string,
	order?: number,
	linkForEvent?: GraphQLTypes["EventCreateLinkForEventEntityRelationInput"],
	venue?: GraphQLTypes["EventCreateVenueEntityRelationInput"],
	pastEvent?: boolean,
	_dummy_field_?: boolean
};
	["EventLabelUpdateInput"]: {
		order?: number,
	text?: string,
	event?: GraphQLTypes["EventLabelUpdateEventEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EventLabelUpdateEventEntityRelationInput"]: {
		create?: GraphQLTypes["EventWithoutEventLabelsCreateInput"],
	update?: GraphQLTypes["EventWithoutEventLabelsUpdateInput"],
	upsert?: GraphQLTypes["EventLabelUpsertEventRelationInput"],
	connect?: GraphQLTypes["EventUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["EventWithoutEventLabelsUpdateInput"]: {
		title?: string,
	place?: string,
	entrance?: string,
	image?: GraphQLTypes["EventUpdateImageEntityRelationInput"],
	seo?: GraphQLTypes["EventUpdateSeoEntityRelationInput"],
	link?: GraphQLTypes["EventUpdateLinkEntityRelationInput"],
	content?: GraphQLTypes["EventUpdateContentEntityRelationInput"],
	date?: string,
	order?: number,
	linkForEvent?: GraphQLTypes["EventUpdateLinkForEventEntityRelationInput"],
	venue?: GraphQLTypes["EventUpdateVenueEntityRelationInput"],
	pastEvent?: boolean,
	_dummy_field_?: boolean
};
	["EventLabelUpsertEventRelationInput"]: {
		update?: GraphQLTypes["EventWithoutEventLabelsUpdateInput"],
	create?: GraphQLTypes["EventWithoutEventLabelsCreateInput"]
};
	["PageConnection"]: {
	__typename: "PageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PageEdge"]>
};
	["PageEdge"]: {
	__typename: "PageEdge",
	node: GraphQLTypes["Page"]
};
	["PageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	title?: string,
	link?: GraphQLTypes["PageCreateLinkEntityRelationInput"],
	content?: GraphQLTypes["PageCreateContentEntityRelationInput"],
	seo?: GraphQLTypes["PageCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PageCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutPageCreateInput"]
};
	["LinkableWithoutPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	event?: GraphQLTypes["LinkableCreateEventEntityRelationInput"],
	frontPage?: GraphQLTypes["LinkableCreateFrontPageEntityRelationInput"],
	specialEvent?: GraphQLTypes["LinkableCreateSpecialEventEntityRelationInput"],
	timelinePage?: GraphQLTypes["LinkableCreateTimelinePageEntityRelationInput"],
	sourcePage?: GraphQLTypes["LinkableCreateSourcePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PageUpdateInput"]: {
		order?: number,
	title?: string,
	link?: GraphQLTypes["PageUpdateLinkEntityRelationInput"],
	content?: GraphQLTypes["PageUpdateContentEntityRelationInput"],
	seo?: GraphQLTypes["PageUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PageUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutPageCreateInput"],
	update?: GraphQLTypes["LinkableWithoutPageUpdateInput"],
	upsert?: GraphQLTypes["PageUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutPageUpdateInput"]: {
		url?: string,
	event?: GraphQLTypes["LinkableUpdateEventEntityRelationInput"],
	frontPage?: GraphQLTypes["LinkableUpdateFrontPageEntityRelationInput"],
	specialEvent?: GraphQLTypes["LinkableUpdateSpecialEventEntityRelationInput"],
	timelinePage?: GraphQLTypes["LinkableUpdateTimelinePageEntityRelationInput"],
	sourcePage?: GraphQLTypes["LinkableUpdateSourcePageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PageUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutPageUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutPageCreateInput"]
};
	["QueryTransaction"]: {
	__typename: "QueryTransaction",
	getContent?: GraphQLTypes["Content"],
	listContent: Array<GraphQLTypes["Content"]>,
	paginateContent: GraphQLTypes["ContentConnection"],
	validateCreateContent: GraphQLTypes["_ValidationResult"],
	validateUpdateContent: GraphQLTypes["_ValidationResult"],
	getContentBlock?: GraphQLTypes["ContentBlock"],
	listContentBlock: Array<GraphQLTypes["ContentBlock"]>,
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	validateCreateContentBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentBlock: GraphQLTypes["_ValidationResult"],
	getContentReference?: GraphQLTypes["ContentReference"],
	listContentReference: Array<GraphQLTypes["ContentReference"]>,
	paginateContentReference: GraphQLTypes["ContentReferenceConnection"],
	validateCreateContentReference: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReference: GraphQLTypes["_ValidationResult"],
	getEvent?: GraphQLTypes["Event"],
	listEvent: Array<GraphQLTypes["Event"]>,
	paginateEvent: GraphQLTypes["EventConnection"],
	validateCreateEvent: GraphQLTypes["_ValidationResult"],
	validateUpdateEvent: GraphQLTypes["_ValidationResult"],
	getFallbackSeo?: GraphQLTypes["FallbackSeo"],
	listFallbackSeo: Array<GraphQLTypes["FallbackSeo"]>,
	paginateFallbackSeo: GraphQLTypes["FallbackSeoConnection"],
	validateCreateFallbackSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateFallbackSeo: GraphQLTypes["_ValidationResult"],
	getFooter?: GraphQLTypes["Footer"],
	listFooter: Array<GraphQLTypes["Footer"]>,
	paginateFooter: GraphQLTypes["FooterConnection"],
	validateCreateFooter: GraphQLTypes["_ValidationResult"],
	validateUpdateFooter: GraphQLTypes["_ValidationResult"],
	getHeader?: GraphQLTypes["Header"],
	listHeader: Array<GraphQLTypes["Header"]>,
	paginateHeader: GraphQLTypes["HeaderConnection"],
	validateCreateHeader: GraphQLTypes["_ValidationResult"],
	validateUpdateHeader: GraphQLTypes["_ValidationResult"],
	getHeaderLink?: GraphQLTypes["HeaderLink"],
	listHeaderLink: Array<GraphQLTypes["HeaderLink"]>,
	paginateHeaderLink: GraphQLTypes["HeaderLinkConnection"],
	validateCreateHeaderLink: GraphQLTypes["_ValidationResult"],
	validateUpdateHeaderLink: GraphQLTypes["_ValidationResult"],
	getFrontPage?: GraphQLTypes["FrontPage"],
	listFrontPage: Array<GraphQLTypes["FrontPage"]>,
	paginateFrontPage: GraphQLTypes["FrontPageConnection"],
	validateCreateFrontPage: GraphQLTypes["_ValidationResult"],
	validateUpdateFrontPage: GraphQLTypes["_ValidationResult"],
	getImage?: GraphQLTypes["Image"],
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"],
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getLinkable?: GraphQLTypes["Linkable"],
	listLinkable: Array<GraphQLTypes["Linkable"]>,
	paginateLinkable: GraphQLTypes["LinkableConnection"],
	validateCreateLinkable: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkable: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"],
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getSpecialEvent?: GraphQLTypes["SpecialEvent"],
	listSpecialEvent: Array<GraphQLTypes["SpecialEvent"]>,
	paginateSpecialEvent: GraphQLTypes["SpecialEventConnection"],
	validateCreateSpecialEvent: GraphQLTypes["_ValidationResult"],
	validateUpdateSpecialEvent: GraphQLTypes["_ValidationResult"],
	getTimelinePage?: GraphQLTypes["TimelinePage"],
	listTimelinePage: Array<GraphQLTypes["TimelinePage"]>,
	paginateTimelinePage: GraphQLTypes["TimelinePageConnection"],
	validateCreateTimelinePage: GraphQLTypes["_ValidationResult"],
	validateUpdateTimelinePage: GraphQLTypes["_ValidationResult"],
	getTimelinePost?: GraphQLTypes["TimelinePost"],
	listTimelinePost: Array<GraphQLTypes["TimelinePost"]>,
	paginateTimelinePost: GraphQLTypes["TimelinePostConnection"],
	validateCreateTimelinePost: GraphQLTypes["_ValidationResult"],
	validateUpdateTimelinePost: GraphQLTypes["_ValidationResult"],
	getSourcePage?: GraphQLTypes["SourcePage"],
	listSourcePage: Array<GraphQLTypes["SourcePage"]>,
	paginateSourcePage: GraphQLTypes["SourcePageConnection"],
	validateCreateSourcePage: GraphQLTypes["_ValidationResult"],
	validateUpdateSourcePage: GraphQLTypes["_ValidationResult"],
	getSourcePostLink?: GraphQLTypes["SourcePostLink"],
	listSourcePostLink: Array<GraphQLTypes["SourcePostLink"]>,
	paginateSourcePostLink: GraphQLTypes["SourcePostLinkConnection"],
	validateCreateSourcePostLink: GraphQLTypes["_ValidationResult"],
	validateUpdateSourcePostLink: GraphQLTypes["_ValidationResult"],
	getGallery?: GraphQLTypes["Gallery"],
	listGallery: Array<GraphQLTypes["Gallery"]>,
	paginateGallery: GraphQLTypes["GalleryConnection"],
	validateCreateGallery: GraphQLTypes["_ValidationResult"],
	validateUpdateGallery: GraphQLTypes["_ValidationResult"],
	getGalleryItem?: GraphQLTypes["GalleryItem"],
	listGalleryItem: Array<GraphQLTypes["GalleryItem"]>,
	paginateGalleryItem: GraphQLTypes["GalleryItemConnection"],
	validateCreateGalleryItem: GraphQLTypes["_ValidationResult"],
	validateUpdateGalleryItem: GraphQLTypes["_ValidationResult"],
	getCardMedia?: GraphQLTypes["CardMedia"],
	listCardMedia: Array<GraphQLTypes["CardMedia"]>,
	paginateCardMedia: GraphQLTypes["CardMediaConnection"],
	validateCreateCardMedia: GraphQLTypes["_ValidationResult"],
	validateUpdateCardMedia: GraphQLTypes["_ValidationResult"],
	getRedirect?: GraphQLTypes["Redirect"],
	listRedirect: Array<GraphQLTypes["Redirect"]>,
	paginateRedirect: GraphQLTypes["RedirectConnection"],
	validateCreateRedirect: GraphQLTypes["_ValidationResult"],
	validateUpdateRedirect: GraphQLTypes["_ValidationResult"],
	getVenue?: GraphQLTypes["Venue"],
	listVenue: Array<GraphQLTypes["Venue"]>,
	paginateVenue: GraphQLTypes["VenueConnection"],
	validateCreateVenue: GraphQLTypes["_ValidationResult"],
	validateUpdateVenue: GraphQLTypes["_ValidationResult"],
	getEventLabel?: GraphQLTypes["EventLabel"],
	listEventLabel: Array<GraphQLTypes["EventLabel"]>,
	paginateEventLabel: GraphQLTypes["EventLabelConnection"],
	validateCreateEventLabel: GraphQLTypes["_ValidationResult"],
	validateUpdateEventLabel: GraphQLTypes["_ValidationResult"],
	getPage?: GraphQLTypes["Page"],
	listPage: Array<GraphQLTypes["Page"]>,
	paginatePage: GraphQLTypes["PageConnection"],
	validateCreatePage: GraphQLTypes["_ValidationResult"],
	validateUpdatePage: GraphQLTypes["_ValidationResult"]
};
	["Info"]: {
	__typename: "Info",
	description?: string
};
	["Mutation"]: {
	__typename: "Mutation",
	createContent: GraphQLTypes["ContentCreateResult"],
	deleteContent: GraphQLTypes["ContentDeleteResult"],
	updateContent: GraphQLTypes["ContentUpdateResult"],
	upsertContent: GraphQLTypes["ContentUpsertResult"],
	createContentBlock: GraphQLTypes["ContentBlockCreateResult"],
	deleteContentBlock: GraphQLTypes["ContentBlockDeleteResult"],
	updateContentBlock: GraphQLTypes["ContentBlockUpdateResult"],
	upsertContentBlock: GraphQLTypes["ContentBlockUpsertResult"],
	createContentReference: GraphQLTypes["ContentReferenceCreateResult"],
	deleteContentReference: GraphQLTypes["ContentReferenceDeleteResult"],
	updateContentReference: GraphQLTypes["ContentReferenceUpdateResult"],
	upsertContentReference: GraphQLTypes["ContentReferenceUpsertResult"],
	createEvent: GraphQLTypes["EventCreateResult"],
	deleteEvent: GraphQLTypes["EventDeleteResult"],
	updateEvent: GraphQLTypes["EventUpdateResult"],
	upsertEvent: GraphQLTypes["EventUpsertResult"],
	createFallbackSeo: GraphQLTypes["FallbackSeoCreateResult"],
	deleteFallbackSeo: GraphQLTypes["FallbackSeoDeleteResult"],
	updateFallbackSeo: GraphQLTypes["FallbackSeoUpdateResult"],
	upsertFallbackSeo: GraphQLTypes["FallbackSeoUpsertResult"],
	createFooter: GraphQLTypes["FooterCreateResult"],
	deleteFooter: GraphQLTypes["FooterDeleteResult"],
	updateFooter: GraphQLTypes["FooterUpdateResult"],
	upsertFooter: GraphQLTypes["FooterUpsertResult"],
	createHeader: GraphQLTypes["HeaderCreateResult"],
	deleteHeader: GraphQLTypes["HeaderDeleteResult"],
	updateHeader: GraphQLTypes["HeaderUpdateResult"],
	upsertHeader: GraphQLTypes["HeaderUpsertResult"],
	createHeaderLink: GraphQLTypes["HeaderLinkCreateResult"],
	deleteHeaderLink: GraphQLTypes["HeaderLinkDeleteResult"],
	updateHeaderLink: GraphQLTypes["HeaderLinkUpdateResult"],
	upsertHeaderLink: GraphQLTypes["HeaderLinkUpsertResult"],
	createFrontPage: GraphQLTypes["FrontPageCreateResult"],
	deleteFrontPage: GraphQLTypes["FrontPageDeleteResult"],
	updateFrontPage: GraphQLTypes["FrontPageUpdateResult"],
	upsertFrontPage: GraphQLTypes["FrontPageUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createLinkable: GraphQLTypes["LinkableCreateResult"],
	deleteLinkable: GraphQLTypes["LinkableDeleteResult"],
	updateLinkable: GraphQLTypes["LinkableUpdateResult"],
	upsertLinkable: GraphQLTypes["LinkableUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createSpecialEvent: GraphQLTypes["SpecialEventCreateResult"],
	deleteSpecialEvent: GraphQLTypes["SpecialEventDeleteResult"],
	updateSpecialEvent: GraphQLTypes["SpecialEventUpdateResult"],
	upsertSpecialEvent: GraphQLTypes["SpecialEventUpsertResult"],
	createTimelinePage: GraphQLTypes["TimelinePageCreateResult"],
	deleteTimelinePage: GraphQLTypes["TimelinePageDeleteResult"],
	updateTimelinePage: GraphQLTypes["TimelinePageUpdateResult"],
	upsertTimelinePage: GraphQLTypes["TimelinePageUpsertResult"],
	createTimelinePost: GraphQLTypes["TimelinePostCreateResult"],
	deleteTimelinePost: GraphQLTypes["TimelinePostDeleteResult"],
	updateTimelinePost: GraphQLTypes["TimelinePostUpdateResult"],
	upsertTimelinePost: GraphQLTypes["TimelinePostUpsertResult"],
	createSourcePage: GraphQLTypes["SourcePageCreateResult"],
	deleteSourcePage: GraphQLTypes["SourcePageDeleteResult"],
	updateSourcePage: GraphQLTypes["SourcePageUpdateResult"],
	upsertSourcePage: GraphQLTypes["SourcePageUpsertResult"],
	createSourcePostLink: GraphQLTypes["SourcePostLinkCreateResult"],
	deleteSourcePostLink: GraphQLTypes["SourcePostLinkDeleteResult"],
	updateSourcePostLink: GraphQLTypes["SourcePostLinkUpdateResult"],
	upsertSourcePostLink: GraphQLTypes["SourcePostLinkUpsertResult"],
	createGallery: GraphQLTypes["GalleryCreateResult"],
	deleteGallery: GraphQLTypes["GalleryDeleteResult"],
	updateGallery: GraphQLTypes["GalleryUpdateResult"],
	upsertGallery: GraphQLTypes["GalleryUpsertResult"],
	createGalleryItem: GraphQLTypes["GalleryItemCreateResult"],
	deleteGalleryItem: GraphQLTypes["GalleryItemDeleteResult"],
	updateGalleryItem: GraphQLTypes["GalleryItemUpdateResult"],
	upsertGalleryItem: GraphQLTypes["GalleryItemUpsertResult"],
	createCardMedia: GraphQLTypes["CardMediaCreateResult"],
	deleteCardMedia: GraphQLTypes["CardMediaDeleteResult"],
	updateCardMedia: GraphQLTypes["CardMediaUpdateResult"],
	upsertCardMedia: GraphQLTypes["CardMediaUpsertResult"],
	createRedirect: GraphQLTypes["RedirectCreateResult"],
	deleteRedirect: GraphQLTypes["RedirectDeleteResult"],
	updateRedirect: GraphQLTypes["RedirectUpdateResult"],
	upsertRedirect: GraphQLTypes["RedirectUpsertResult"],
	createVenue: GraphQLTypes["VenueCreateResult"],
	deleteVenue: GraphQLTypes["VenueDeleteResult"],
	updateVenue: GraphQLTypes["VenueUpdateResult"],
	upsertVenue: GraphQLTypes["VenueUpsertResult"],
	createEventLabel: GraphQLTypes["EventLabelCreateResult"],
	deleteEventLabel: GraphQLTypes["EventLabelDeleteResult"],
	updateEventLabel: GraphQLTypes["EventLabelUpdateResult"],
	upsertEventLabel: GraphQLTypes["EventLabelUpsertResult"],
	createPage: GraphQLTypes["PageCreateResult"],
	deletePage: GraphQLTypes["PageDeleteResult"],
	updatePage: GraphQLTypes["PageUpdateResult"],
	upsertPage: GraphQLTypes["PageUpsertResult"],
	transaction: GraphQLTypes["MutationTransaction"],
	query: GraphQLTypes["Query"],
	generateUploadUrl: GraphQLTypes["S3SignedUpload"],
	generateReadUrl: GraphQLTypes["S3SignedRead"]
};
	["ContentCreateResult"]: {
	__typename: "ContentCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationResult"]: {
	__typename:"ContentCreateResult" | "ContentDeleteResult" | "ContentUpdateResult" | "ContentUpsertResult" | "ContentBlockCreateResult" | "ContentBlockDeleteResult" | "ContentBlockUpdateResult" | "ContentBlockUpsertResult" | "ContentReferenceCreateResult" | "ContentReferenceDeleteResult" | "ContentReferenceUpdateResult" | "ContentReferenceUpsertResult" | "EventCreateResult" | "EventDeleteResult" | "EventUpdateResult" | "EventUpsertResult" | "FallbackSeoCreateResult" | "FallbackSeoDeleteResult" | "FallbackSeoUpdateResult" | "FallbackSeoUpsertResult" | "FooterCreateResult" | "FooterDeleteResult" | "FooterUpdateResult" | "FooterUpsertResult" | "HeaderCreateResult" | "HeaderDeleteResult" | "HeaderUpdateResult" | "HeaderUpsertResult" | "HeaderLinkCreateResult" | "HeaderLinkDeleteResult" | "HeaderLinkUpdateResult" | "HeaderLinkUpsertResult" | "FrontPageCreateResult" | "FrontPageDeleteResult" | "FrontPageUpdateResult" | "FrontPageUpsertResult" | "ImageCreateResult" | "ImageDeleteResult" | "ImageUpdateResult" | "ImageUpsertResult" | "LinkCreateResult" | "LinkDeleteResult" | "LinkUpdateResult" | "LinkUpsertResult" | "LinkableCreateResult" | "LinkableDeleteResult" | "LinkableUpdateResult" | "LinkableUpsertResult" | "SeoCreateResult" | "SeoDeleteResult" | "SeoUpdateResult" | "SeoUpsertResult" | "SpecialEventCreateResult" | "SpecialEventDeleteResult" | "SpecialEventUpdateResult" | "SpecialEventUpsertResult" | "TimelinePageCreateResult" | "TimelinePageDeleteResult" | "TimelinePageUpdateResult" | "TimelinePageUpsertResult" | "TimelinePostCreateResult" | "TimelinePostDeleteResult" | "TimelinePostUpdateResult" | "TimelinePostUpsertResult" | "SourcePageCreateResult" | "SourcePageDeleteResult" | "SourcePageUpdateResult" | "SourcePageUpsertResult" | "SourcePostLinkCreateResult" | "SourcePostLinkDeleteResult" | "SourcePostLinkUpdateResult" | "SourcePostLinkUpsertResult" | "GalleryCreateResult" | "GalleryDeleteResult" | "GalleryUpdateResult" | "GalleryUpsertResult" | "GalleryItemCreateResult" | "GalleryItemDeleteResult" | "GalleryItemUpdateResult" | "GalleryItemUpsertResult" | "CardMediaCreateResult" | "CardMediaDeleteResult" | "CardMediaUpdateResult" | "CardMediaUpsertResult" | "RedirectCreateResult" | "RedirectDeleteResult" | "RedirectUpdateResult" | "RedirectUpsertResult" | "VenueCreateResult" | "VenueDeleteResult" | "VenueUpdateResult" | "VenueUpsertResult" | "EventLabelCreateResult" | "EventLabelDeleteResult" | "EventLabelUpdateResult" | "EventLabelUpsertResult" | "PageCreateResult" | "PageDeleteResult" | "PageUpdateResult" | "PageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>
	['...on ContentCreateResult']: '__union' & GraphQLTypes["ContentCreateResult"];
	['...on ContentDeleteResult']: '__union' & GraphQLTypes["ContentDeleteResult"];
	['...on ContentUpdateResult']: '__union' & GraphQLTypes["ContentUpdateResult"];
	['...on ContentUpsertResult']: '__union' & GraphQLTypes["ContentUpsertResult"];
	['...on ContentBlockCreateResult']: '__union' & GraphQLTypes["ContentBlockCreateResult"];
	['...on ContentBlockDeleteResult']: '__union' & GraphQLTypes["ContentBlockDeleteResult"];
	['...on ContentBlockUpdateResult']: '__union' & GraphQLTypes["ContentBlockUpdateResult"];
	['...on ContentBlockUpsertResult']: '__union' & GraphQLTypes["ContentBlockUpsertResult"];
	['...on ContentReferenceCreateResult']: '__union' & GraphQLTypes["ContentReferenceCreateResult"];
	['...on ContentReferenceDeleteResult']: '__union' & GraphQLTypes["ContentReferenceDeleteResult"];
	['...on ContentReferenceUpdateResult']: '__union' & GraphQLTypes["ContentReferenceUpdateResult"];
	['...on ContentReferenceUpsertResult']: '__union' & GraphQLTypes["ContentReferenceUpsertResult"];
	['...on EventCreateResult']: '__union' & GraphQLTypes["EventCreateResult"];
	['...on EventDeleteResult']: '__union' & GraphQLTypes["EventDeleteResult"];
	['...on EventUpdateResult']: '__union' & GraphQLTypes["EventUpdateResult"];
	['...on EventUpsertResult']: '__union' & GraphQLTypes["EventUpsertResult"];
	['...on FallbackSeoCreateResult']: '__union' & GraphQLTypes["FallbackSeoCreateResult"];
	['...on FallbackSeoDeleteResult']: '__union' & GraphQLTypes["FallbackSeoDeleteResult"];
	['...on FallbackSeoUpdateResult']: '__union' & GraphQLTypes["FallbackSeoUpdateResult"];
	['...on FallbackSeoUpsertResult']: '__union' & GraphQLTypes["FallbackSeoUpsertResult"];
	['...on FooterCreateResult']: '__union' & GraphQLTypes["FooterCreateResult"];
	['...on FooterDeleteResult']: '__union' & GraphQLTypes["FooterDeleteResult"];
	['...on FooterUpdateResult']: '__union' & GraphQLTypes["FooterUpdateResult"];
	['...on FooterUpsertResult']: '__union' & GraphQLTypes["FooterUpsertResult"];
	['...on HeaderCreateResult']: '__union' & GraphQLTypes["HeaderCreateResult"];
	['...on HeaderDeleteResult']: '__union' & GraphQLTypes["HeaderDeleteResult"];
	['...on HeaderUpdateResult']: '__union' & GraphQLTypes["HeaderUpdateResult"];
	['...on HeaderUpsertResult']: '__union' & GraphQLTypes["HeaderUpsertResult"];
	['...on HeaderLinkCreateResult']: '__union' & GraphQLTypes["HeaderLinkCreateResult"];
	['...on HeaderLinkDeleteResult']: '__union' & GraphQLTypes["HeaderLinkDeleteResult"];
	['...on HeaderLinkUpdateResult']: '__union' & GraphQLTypes["HeaderLinkUpdateResult"];
	['...on HeaderLinkUpsertResult']: '__union' & GraphQLTypes["HeaderLinkUpsertResult"];
	['...on FrontPageCreateResult']: '__union' & GraphQLTypes["FrontPageCreateResult"];
	['...on FrontPageDeleteResult']: '__union' & GraphQLTypes["FrontPageDeleteResult"];
	['...on FrontPageUpdateResult']: '__union' & GraphQLTypes["FrontPageUpdateResult"];
	['...on FrontPageUpsertResult']: '__union' & GraphQLTypes["FrontPageUpsertResult"];
	['...on ImageCreateResult']: '__union' & GraphQLTypes["ImageCreateResult"];
	['...on ImageDeleteResult']: '__union' & GraphQLTypes["ImageDeleteResult"];
	['...on ImageUpdateResult']: '__union' & GraphQLTypes["ImageUpdateResult"];
	['...on ImageUpsertResult']: '__union' & GraphQLTypes["ImageUpsertResult"];
	['...on LinkCreateResult']: '__union' & GraphQLTypes["LinkCreateResult"];
	['...on LinkDeleteResult']: '__union' & GraphQLTypes["LinkDeleteResult"];
	['...on LinkUpdateResult']: '__union' & GraphQLTypes["LinkUpdateResult"];
	['...on LinkUpsertResult']: '__union' & GraphQLTypes["LinkUpsertResult"];
	['...on LinkableCreateResult']: '__union' & GraphQLTypes["LinkableCreateResult"];
	['...on LinkableDeleteResult']: '__union' & GraphQLTypes["LinkableDeleteResult"];
	['...on LinkableUpdateResult']: '__union' & GraphQLTypes["LinkableUpdateResult"];
	['...on LinkableUpsertResult']: '__union' & GraphQLTypes["LinkableUpsertResult"];
	['...on SeoCreateResult']: '__union' & GraphQLTypes["SeoCreateResult"];
	['...on SeoDeleteResult']: '__union' & GraphQLTypes["SeoDeleteResult"];
	['...on SeoUpdateResult']: '__union' & GraphQLTypes["SeoUpdateResult"];
	['...on SeoUpsertResult']: '__union' & GraphQLTypes["SeoUpsertResult"];
	['...on SpecialEventCreateResult']: '__union' & GraphQLTypes["SpecialEventCreateResult"];
	['...on SpecialEventDeleteResult']: '__union' & GraphQLTypes["SpecialEventDeleteResult"];
	['...on SpecialEventUpdateResult']: '__union' & GraphQLTypes["SpecialEventUpdateResult"];
	['...on SpecialEventUpsertResult']: '__union' & GraphQLTypes["SpecialEventUpsertResult"];
	['...on TimelinePageCreateResult']: '__union' & GraphQLTypes["TimelinePageCreateResult"];
	['...on TimelinePageDeleteResult']: '__union' & GraphQLTypes["TimelinePageDeleteResult"];
	['...on TimelinePageUpdateResult']: '__union' & GraphQLTypes["TimelinePageUpdateResult"];
	['...on TimelinePageUpsertResult']: '__union' & GraphQLTypes["TimelinePageUpsertResult"];
	['...on TimelinePostCreateResult']: '__union' & GraphQLTypes["TimelinePostCreateResult"];
	['...on TimelinePostDeleteResult']: '__union' & GraphQLTypes["TimelinePostDeleteResult"];
	['...on TimelinePostUpdateResult']: '__union' & GraphQLTypes["TimelinePostUpdateResult"];
	['...on TimelinePostUpsertResult']: '__union' & GraphQLTypes["TimelinePostUpsertResult"];
	['...on SourcePageCreateResult']: '__union' & GraphQLTypes["SourcePageCreateResult"];
	['...on SourcePageDeleteResult']: '__union' & GraphQLTypes["SourcePageDeleteResult"];
	['...on SourcePageUpdateResult']: '__union' & GraphQLTypes["SourcePageUpdateResult"];
	['...on SourcePageUpsertResult']: '__union' & GraphQLTypes["SourcePageUpsertResult"];
	['...on SourcePostLinkCreateResult']: '__union' & GraphQLTypes["SourcePostLinkCreateResult"];
	['...on SourcePostLinkDeleteResult']: '__union' & GraphQLTypes["SourcePostLinkDeleteResult"];
	['...on SourcePostLinkUpdateResult']: '__union' & GraphQLTypes["SourcePostLinkUpdateResult"];
	['...on SourcePostLinkUpsertResult']: '__union' & GraphQLTypes["SourcePostLinkUpsertResult"];
	['...on GalleryCreateResult']: '__union' & GraphQLTypes["GalleryCreateResult"];
	['...on GalleryDeleteResult']: '__union' & GraphQLTypes["GalleryDeleteResult"];
	['...on GalleryUpdateResult']: '__union' & GraphQLTypes["GalleryUpdateResult"];
	['...on GalleryUpsertResult']: '__union' & GraphQLTypes["GalleryUpsertResult"];
	['...on GalleryItemCreateResult']: '__union' & GraphQLTypes["GalleryItemCreateResult"];
	['...on GalleryItemDeleteResult']: '__union' & GraphQLTypes["GalleryItemDeleteResult"];
	['...on GalleryItemUpdateResult']: '__union' & GraphQLTypes["GalleryItemUpdateResult"];
	['...on GalleryItemUpsertResult']: '__union' & GraphQLTypes["GalleryItemUpsertResult"];
	['...on CardMediaCreateResult']: '__union' & GraphQLTypes["CardMediaCreateResult"];
	['...on CardMediaDeleteResult']: '__union' & GraphQLTypes["CardMediaDeleteResult"];
	['...on CardMediaUpdateResult']: '__union' & GraphQLTypes["CardMediaUpdateResult"];
	['...on CardMediaUpsertResult']: '__union' & GraphQLTypes["CardMediaUpsertResult"];
	['...on RedirectCreateResult']: '__union' & GraphQLTypes["RedirectCreateResult"];
	['...on RedirectDeleteResult']: '__union' & GraphQLTypes["RedirectDeleteResult"];
	['...on RedirectUpdateResult']: '__union' & GraphQLTypes["RedirectUpdateResult"];
	['...on RedirectUpsertResult']: '__union' & GraphQLTypes["RedirectUpsertResult"];
	['...on VenueCreateResult']: '__union' & GraphQLTypes["VenueCreateResult"];
	['...on VenueDeleteResult']: '__union' & GraphQLTypes["VenueDeleteResult"];
	['...on VenueUpdateResult']: '__union' & GraphQLTypes["VenueUpdateResult"];
	['...on VenueUpsertResult']: '__union' & GraphQLTypes["VenueUpsertResult"];
	['...on EventLabelCreateResult']: '__union' & GraphQLTypes["EventLabelCreateResult"];
	['...on EventLabelDeleteResult']: '__union' & GraphQLTypes["EventLabelDeleteResult"];
	['...on EventLabelUpdateResult']: '__union' & GraphQLTypes["EventLabelUpdateResult"];
	['...on EventLabelUpsertResult']: '__union' & GraphQLTypes["EventLabelUpsertResult"];
	['...on PageCreateResult']: '__union' & GraphQLTypes["PageCreateResult"];
	['...on PageDeleteResult']: '__union' & GraphQLTypes["PageDeleteResult"];
	['...on PageUpdateResult']: '__union' & GraphQLTypes["PageUpdateResult"];
	['...on PageUpsertResult']: '__union' & GraphQLTypes["PageUpsertResult"];
};
	["_MutationError"]: {
	__typename: "_MutationError",
	path: Array<GraphQLTypes["_PathFragment"]>,
	paths: Array<GraphQLTypes["_PathFragment"]>,
	type: GraphQLTypes["_MutationErrorType"],
	message?: string
};
	["_MutationErrorType"]: _MutationErrorType;
	["ContentDeleteResult"]: {
	__typename: "ContentDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"]
};
	["ContentUpdateResult"]: {
	__typename: "ContentUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentUpsertResult"]: {
	__typename: "ContentUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockCreateResult"]: {
	__typename: "ContentBlockCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockDeleteResult"]: {
	__typename: "ContentBlockDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"]
};
	["ContentBlockUpdateResult"]: {
	__typename: "ContentBlockUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockUpsertResult"]: {
	__typename: "ContentBlockUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceCreateResult"]: {
	__typename: "ContentReferenceCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceDeleteResult"]: {
	__typename: "ContentReferenceDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"]
};
	["ContentReferenceUpdateResult"]: {
	__typename: "ContentReferenceUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceUpsertResult"]: {
	__typename: "ContentReferenceUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EventCreateResult"]: {
	__typename: "EventCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Event"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EventDeleteResult"]: {
	__typename: "EventDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Event"]
};
	["EventUpdateResult"]: {
	__typename: "EventUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Event"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EventUpsertResult"]: {
	__typename: "EventUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Event"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FallbackSeoCreateResult"]: {
	__typename: "FallbackSeoCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FallbackSeo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FallbackSeoDeleteResult"]: {
	__typename: "FallbackSeoDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FallbackSeo"]
};
	["FallbackSeoUpdateResult"]: {
	__typename: "FallbackSeoUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FallbackSeo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FallbackSeoUpsertResult"]: {
	__typename: "FallbackSeoUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FallbackSeo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterCreateResult"]: {
	__typename: "FooterCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterDeleteResult"]: {
	__typename: "FooterDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"]
};
	["FooterUpdateResult"]: {
	__typename: "FooterUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterUpsertResult"]: {
	__typename: "FooterUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderCreateResult"]: {
	__typename: "HeaderCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderDeleteResult"]: {
	__typename: "HeaderDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"]
};
	["HeaderUpdateResult"]: {
	__typename: "HeaderUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderUpsertResult"]: {
	__typename: "HeaderUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderLinkCreateResult"]: {
	__typename: "HeaderLinkCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderLinkDeleteResult"]: {
	__typename: "HeaderLinkDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLink"]
};
	["HeaderLinkUpdateResult"]: {
	__typename: "HeaderLinkUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderLinkUpsertResult"]: {
	__typename: "HeaderLinkUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FrontPageCreateResult"]: {
	__typename: "FrontPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FrontPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FrontPageDeleteResult"]: {
	__typename: "FrontPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FrontPage"]
};
	["FrontPageUpdateResult"]: {
	__typename: "FrontPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FrontPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FrontPageUpsertResult"]: {
	__typename: "FrontPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FrontPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageCreateResult"]: {
	__typename: "ImageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageDeleteResult"]: {
	__typename: "ImageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"]
};
	["ImageUpdateResult"]: {
	__typename: "ImageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageUpsertResult"]: {
	__typename: "ImageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkCreateResult"]: {
	__typename: "LinkCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkDeleteResult"]: {
	__typename: "LinkDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"]
};
	["LinkUpdateResult"]: {
	__typename: "LinkUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkUpsertResult"]: {
	__typename: "LinkUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableCreateResult"]: {
	__typename: "LinkableCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableDeleteResult"]: {
	__typename: "LinkableDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"]
};
	["LinkableUpdateResult"]: {
	__typename: "LinkableUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableUpsertResult"]: {
	__typename: "LinkableUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoCreateResult"]: {
	__typename: "SeoCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDeleteResult"]: {
	__typename: "SeoDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"]
};
	["SeoUpdateResult"]: {
	__typename: "SeoUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoUpsertResult"]: {
	__typename: "SeoUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SpecialEventCreateResult"]: {
	__typename: "SpecialEventCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SpecialEvent"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SpecialEventDeleteResult"]: {
	__typename: "SpecialEventDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SpecialEvent"]
};
	["SpecialEventUpdateResult"]: {
	__typename: "SpecialEventUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SpecialEvent"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SpecialEventUpsertResult"]: {
	__typename: "SpecialEventUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SpecialEvent"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimelinePageCreateResult"]: {
	__typename: "TimelinePageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimelinePage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimelinePageDeleteResult"]: {
	__typename: "TimelinePageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimelinePage"]
};
	["TimelinePageUpdateResult"]: {
	__typename: "TimelinePageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimelinePage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimelinePageUpsertResult"]: {
	__typename: "TimelinePageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimelinePage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimelinePostCreateResult"]: {
	__typename: "TimelinePostCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimelinePost"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimelinePostDeleteResult"]: {
	__typename: "TimelinePostDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimelinePost"]
};
	["TimelinePostUpdateResult"]: {
	__typename: "TimelinePostUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimelinePost"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TimelinePostUpsertResult"]: {
	__typename: "TimelinePostUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TimelinePost"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SourcePageCreateResult"]: {
	__typename: "SourcePageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SourcePage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SourcePageDeleteResult"]: {
	__typename: "SourcePageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SourcePage"]
};
	["SourcePageUpdateResult"]: {
	__typename: "SourcePageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SourcePage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SourcePageUpsertResult"]: {
	__typename: "SourcePageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SourcePage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SourcePostLinkCreateResult"]: {
	__typename: "SourcePostLinkCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SourcePostLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SourcePostLinkDeleteResult"]: {
	__typename: "SourcePostLinkDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SourcePostLink"]
};
	["SourcePostLinkUpdateResult"]: {
	__typename: "SourcePostLinkUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SourcePostLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SourcePostLinkUpsertResult"]: {
	__typename: "SourcePostLinkUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SourcePostLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryCreateResult"]: {
	__typename: "GalleryCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryDeleteResult"]: {
	__typename: "GalleryDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"]
};
	["GalleryUpdateResult"]: {
	__typename: "GalleryUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryUpsertResult"]: {
	__typename: "GalleryUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryItemCreateResult"]: {
	__typename: "GalleryItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryItemDeleteResult"]: {
	__typename: "GalleryItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"]
};
	["GalleryItemUpdateResult"]: {
	__typename: "GalleryItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryItemUpsertResult"]: {
	__typename: "GalleryItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CardMediaCreateResult"]: {
	__typename: "CardMediaCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CardMedia"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CardMediaDeleteResult"]: {
	__typename: "CardMediaDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CardMedia"]
};
	["CardMediaUpdateResult"]: {
	__typename: "CardMediaUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CardMedia"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CardMediaUpsertResult"]: {
	__typename: "CardMediaUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CardMedia"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectCreateResult"]: {
	__typename: "RedirectCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectDeleteResult"]: {
	__typename: "RedirectDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"]
};
	["RedirectUpdateResult"]: {
	__typename: "RedirectUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectUpsertResult"]: {
	__typename: "RedirectUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["VenueCreateResult"]: {
	__typename: "VenueCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Venue"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["VenueDeleteResult"]: {
	__typename: "VenueDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Venue"]
};
	["VenueUpdateResult"]: {
	__typename: "VenueUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Venue"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["VenueUpsertResult"]: {
	__typename: "VenueUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Venue"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EventLabelCreateResult"]: {
	__typename: "EventLabelCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EventLabel"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EventLabelDeleteResult"]: {
	__typename: "EventLabelDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EventLabel"]
};
	["EventLabelUpdateResult"]: {
	__typename: "EventLabelUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EventLabel"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EventLabelUpsertResult"]: {
	__typename: "EventLabelUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EventLabel"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageCreateResult"]: {
	__typename: "PageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageDeleteResult"]: {
	__typename: "PageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"]
};
	["PageUpdateResult"]: {
	__typename: "PageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageUpsertResult"]: {
	__typename: "PageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationTransaction"]: {
	__typename: "MutationTransaction",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	validation: GraphQLTypes["_ValidationResult"],
	createContent: GraphQLTypes["ContentCreateResult"],
	deleteContent: GraphQLTypes["ContentDeleteResult"],
	updateContent: GraphQLTypes["ContentUpdateResult"],
	upsertContent: GraphQLTypes["ContentUpsertResult"],
	createContentBlock: GraphQLTypes["ContentBlockCreateResult"],
	deleteContentBlock: GraphQLTypes["ContentBlockDeleteResult"],
	updateContentBlock: GraphQLTypes["ContentBlockUpdateResult"],
	upsertContentBlock: GraphQLTypes["ContentBlockUpsertResult"],
	createContentReference: GraphQLTypes["ContentReferenceCreateResult"],
	deleteContentReference: GraphQLTypes["ContentReferenceDeleteResult"],
	updateContentReference: GraphQLTypes["ContentReferenceUpdateResult"],
	upsertContentReference: GraphQLTypes["ContentReferenceUpsertResult"],
	createEvent: GraphQLTypes["EventCreateResult"],
	deleteEvent: GraphQLTypes["EventDeleteResult"],
	updateEvent: GraphQLTypes["EventUpdateResult"],
	upsertEvent: GraphQLTypes["EventUpsertResult"],
	createFallbackSeo: GraphQLTypes["FallbackSeoCreateResult"],
	deleteFallbackSeo: GraphQLTypes["FallbackSeoDeleteResult"],
	updateFallbackSeo: GraphQLTypes["FallbackSeoUpdateResult"],
	upsertFallbackSeo: GraphQLTypes["FallbackSeoUpsertResult"],
	createFooter: GraphQLTypes["FooterCreateResult"],
	deleteFooter: GraphQLTypes["FooterDeleteResult"],
	updateFooter: GraphQLTypes["FooterUpdateResult"],
	upsertFooter: GraphQLTypes["FooterUpsertResult"],
	createHeader: GraphQLTypes["HeaderCreateResult"],
	deleteHeader: GraphQLTypes["HeaderDeleteResult"],
	updateHeader: GraphQLTypes["HeaderUpdateResult"],
	upsertHeader: GraphQLTypes["HeaderUpsertResult"],
	createHeaderLink: GraphQLTypes["HeaderLinkCreateResult"],
	deleteHeaderLink: GraphQLTypes["HeaderLinkDeleteResult"],
	updateHeaderLink: GraphQLTypes["HeaderLinkUpdateResult"],
	upsertHeaderLink: GraphQLTypes["HeaderLinkUpsertResult"],
	createFrontPage: GraphQLTypes["FrontPageCreateResult"],
	deleteFrontPage: GraphQLTypes["FrontPageDeleteResult"],
	updateFrontPage: GraphQLTypes["FrontPageUpdateResult"],
	upsertFrontPage: GraphQLTypes["FrontPageUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createLinkable: GraphQLTypes["LinkableCreateResult"],
	deleteLinkable: GraphQLTypes["LinkableDeleteResult"],
	updateLinkable: GraphQLTypes["LinkableUpdateResult"],
	upsertLinkable: GraphQLTypes["LinkableUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createSpecialEvent: GraphQLTypes["SpecialEventCreateResult"],
	deleteSpecialEvent: GraphQLTypes["SpecialEventDeleteResult"],
	updateSpecialEvent: GraphQLTypes["SpecialEventUpdateResult"],
	upsertSpecialEvent: GraphQLTypes["SpecialEventUpsertResult"],
	createTimelinePage: GraphQLTypes["TimelinePageCreateResult"],
	deleteTimelinePage: GraphQLTypes["TimelinePageDeleteResult"],
	updateTimelinePage: GraphQLTypes["TimelinePageUpdateResult"],
	upsertTimelinePage: GraphQLTypes["TimelinePageUpsertResult"],
	createTimelinePost: GraphQLTypes["TimelinePostCreateResult"],
	deleteTimelinePost: GraphQLTypes["TimelinePostDeleteResult"],
	updateTimelinePost: GraphQLTypes["TimelinePostUpdateResult"],
	upsertTimelinePost: GraphQLTypes["TimelinePostUpsertResult"],
	createSourcePage: GraphQLTypes["SourcePageCreateResult"],
	deleteSourcePage: GraphQLTypes["SourcePageDeleteResult"],
	updateSourcePage: GraphQLTypes["SourcePageUpdateResult"],
	upsertSourcePage: GraphQLTypes["SourcePageUpsertResult"],
	createSourcePostLink: GraphQLTypes["SourcePostLinkCreateResult"],
	deleteSourcePostLink: GraphQLTypes["SourcePostLinkDeleteResult"],
	updateSourcePostLink: GraphQLTypes["SourcePostLinkUpdateResult"],
	upsertSourcePostLink: GraphQLTypes["SourcePostLinkUpsertResult"],
	createGallery: GraphQLTypes["GalleryCreateResult"],
	deleteGallery: GraphQLTypes["GalleryDeleteResult"],
	updateGallery: GraphQLTypes["GalleryUpdateResult"],
	upsertGallery: GraphQLTypes["GalleryUpsertResult"],
	createGalleryItem: GraphQLTypes["GalleryItemCreateResult"],
	deleteGalleryItem: GraphQLTypes["GalleryItemDeleteResult"],
	updateGalleryItem: GraphQLTypes["GalleryItemUpdateResult"],
	upsertGalleryItem: GraphQLTypes["GalleryItemUpsertResult"],
	createCardMedia: GraphQLTypes["CardMediaCreateResult"],
	deleteCardMedia: GraphQLTypes["CardMediaDeleteResult"],
	updateCardMedia: GraphQLTypes["CardMediaUpdateResult"],
	upsertCardMedia: GraphQLTypes["CardMediaUpsertResult"],
	createRedirect: GraphQLTypes["RedirectCreateResult"],
	deleteRedirect: GraphQLTypes["RedirectDeleteResult"],
	updateRedirect: GraphQLTypes["RedirectUpdateResult"],
	upsertRedirect: GraphQLTypes["RedirectUpsertResult"],
	createVenue: GraphQLTypes["VenueCreateResult"],
	deleteVenue: GraphQLTypes["VenueDeleteResult"],
	updateVenue: GraphQLTypes["VenueUpdateResult"],
	upsertVenue: GraphQLTypes["VenueUpsertResult"],
	createEventLabel: GraphQLTypes["EventLabelCreateResult"],
	deleteEventLabel: GraphQLTypes["EventLabelDeleteResult"],
	updateEventLabel: GraphQLTypes["EventLabelUpdateResult"],
	upsertEventLabel: GraphQLTypes["EventLabelUpsertResult"],
	createPage: GraphQLTypes["PageCreateResult"],
	deletePage: GraphQLTypes["PageDeleteResult"],
	updatePage: GraphQLTypes["PageUpdateResult"],
	upsertPage: GraphQLTypes["PageUpsertResult"],
	query?: GraphQLTypes["Query"]
};
	["MutationTransactionOptions"]: {
		deferForeignKeyConstraints?: boolean
};
	/** Json custom scalar type */
["Json"]:any;
	["_Schema"]: {
	__typename: "_Schema",
	enums: Array<GraphQLTypes["_Enum"]>,
	entities: Array<GraphQLTypes["_Entity"]>
};
	["_Entity"]: {
	__typename: "_Entity",
	name: string,
	customPrimaryAllowed: boolean,
	fields: Array<GraphQLTypes["_Field"]>,
	unique: Array<GraphQLTypes["_UniqueConstraint"]>
};
	["_UniqueConstraint"]: {
	__typename: "_UniqueConstraint",
	fields: Array<string>
};
	["_Field"]: {
	__typename:"_Column" | "_Relation",
	name: string,
	type: string,
	nullable?: boolean,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
	['...on _Column']: '__union' & GraphQLTypes["_Column"];
	['...on _Relation']: '__union' & GraphQLTypes["_Relation"];
};
	["_Column"]: {
	__typename: "_Column",
	name: string,
	type: string,
	enumName?: string,
	defaultValue?: GraphQLTypes["Json"],
	nullable: boolean,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_OnDeleteBehaviour"]: _OnDeleteBehaviour;
	["_RelationSide"]: _RelationSide;
	["_OrderByDirection"]: _OrderByDirection;
	["_OrderBy"]: {
	__typename: "_OrderBy",
	path: Array<string>,
	direction: GraphQLTypes["_OrderByDirection"]
};
	["_Relation"]: {
	__typename: "_Relation",
	name: string,
	type: string,
	side: GraphQLTypes["_RelationSide"],
	targetEntity: string,
	ownedBy?: string,
	inversedBy?: string,
	nullable?: boolean,
	onDelete?: GraphQLTypes["_OnDeleteBehaviour"],
	orphanRemoval?: boolean,
	orderBy?: Array<GraphQLTypes["_OrderBy"]>,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_Rule"]: {
	__typename: "_Rule",
	message?: GraphQLTypes["_RuleMessage"],
	validator: number
};
	["_Validator"]: {
	__typename: "_Validator",
	operation: string,
	arguments: Array<GraphQLTypes["_Argument"]>
};
	["_Argument"]:{
	__typename:"_ValidatorArgument" | "_PathArgument" | "_LiteralArgument"
	['...on _ValidatorArgument']: '__union' & GraphQLTypes["_ValidatorArgument"];
	['...on _PathArgument']: '__union' & GraphQLTypes["_PathArgument"];
	['...on _LiteralArgument']: '__union' & GraphQLTypes["_LiteralArgument"];
};
	["_ValidatorArgument"]: {
	__typename: "_ValidatorArgument",
	validator: number
};
	["_PathArgument"]: {
	__typename: "_PathArgument",
	path: Array<string>
};
	["_LiteralArgument"]: {
	__typename: "_LiteralArgument",
	value?: GraphQLTypes["Json"]
};
	["_RuleMessage"]: {
	__typename: "_RuleMessage",
	text?: string
};
	["_Enum"]: {
	__typename: "_Enum",
	name: string,
	values: Array<string>
};
	["S3SignedUpload"]: {
	__typename: "S3SignedUpload",
	url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	/** Allowed patterns:
** */
	objectKey: string,
	bucket: string,
	publicUrl: string
};
	["S3Header"]: {
	__typename: "S3Header",
	key: string,
	value: string
};
	["S3SignedRead"]: {
	__typename: "S3SignedRead",
	url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	/** Allowed patterns:
** */
	objectKey: string,
	bucket: string
}
    }
export const enum ContentReferenceType {
	image = "image",
	cardMedia = "cardMedia"
}
export const enum LinkType {
	internal = "internal",
	external = "external"
}
export const enum One {
	One = "One"
}
export const enum OrderDirection {
	asc = "asc",
	desc = "desc"
}
export const enum _MutationErrorType {
	NotNullConstraintViolation = "NotNullConstraintViolation",
	UniqueConstraintViolation = "UniqueConstraintViolation",
	ForeignKeyConstraintViolation = "ForeignKeyConstraintViolation",
	NotFoundOrDenied = "NotFoundOrDenied",
	NonUniqueWhereInput = "NonUniqueWhereInput",
	InvalidDataInput = "InvalidDataInput",
	SqlError = "SqlError"
}
export const enum _OnDeleteBehaviour {
	restrict = "restrict",
	cascade = "cascade",
	setNull = "setNull"
}
export const enum _RelationSide {
	owning = "owning",
	inverse = "inverse"
}
export const enum _OrderByDirection {
	asc = "asc",
	desc = "desc"
}
export class GraphQLError extends Error {
    constructor(public response: GraphQLResponse) {
      super("");
      console.error(response);
    }
    override toString() {
      return "GraphQL Response Error";
    }
  }


export type UnwrapPromise<T> = T extends Promise<infer R> ? R : T;
export type ZeusState<T extends (...args: any[]) => Promise<any>> = NonNullable<
  UnwrapPromise<ReturnType<T>>
>;
export type ZeusHook<
  T extends (
    ...args: any[]
  ) => Record<string, (...args: any[]) => Promise<any>>,
  N extends keyof ReturnType<T>
> = ZeusState<ReturnType<T>[N]>;

type WithTypeNameValue<T> = T & {
  __typename?: true;
};
type AliasType<T> = WithTypeNameValue<T> & {
  __alias?: Record<string, WithTypeNameValue<T>>;
};
export interface GraphQLResponse {
  data?: Record<string, any>;
  errors?: Array<{
    message: string;
  }>;
}
type DeepAnify<T> = {
  [P in keyof T]?: any;
};
type IsPayLoad<T> = T extends [any, infer PayLoad] ? PayLoad : T;
type IsArray<T, U> = T extends Array<infer R> ? InputType<R, U>[] : InputType<T, U>;
type FlattenArray<T> = T extends Array<infer R> ? R : T;

type IsInterfaced<SRC extends DeepAnify<DST>, DST> = FlattenArray<SRC> extends ZEUS_INTERFACES | ZEUS_UNIONS
  ? {
      [P in keyof SRC]: SRC[P] extends '__union' & infer R
        ? P extends keyof DST
          ? IsArray<R, '__typename' extends keyof DST ? DST[P] & { __typename: true } : DST[P]>
          : {}
        : never;
    }[keyof DST] &
      {
        [P in keyof Omit<
          Pick<
            SRC,
            {
              [P in keyof DST]: SRC[P] extends '__union' & infer R ? never : P;
            }[keyof DST]
          >,
          '__typename'
        >]: IsPayLoad<DST[P]> extends true ? SRC[P] : IsArray<SRC[P], DST[P]>;
      }
  : {
      [P in keyof Pick<SRC, keyof DST>]: IsPayLoad<DST[P]> extends true ? SRC[P] : IsArray<SRC[P], DST[P]>;
    };

export type MapType<SRC, DST> = SRC extends DeepAnify<DST> ? IsInterfaced<SRC, DST> : never;
export type InputType<SRC, DST> = IsPayLoad<DST> extends { __alias: infer R }
  ? {
      [P in keyof R]: MapType<SRC, R[P]>;
    } &
      MapType<SRC, Omit<IsPayLoad<DST>, '__alias'>>
  : MapType<SRC, IsPayLoad<DST>>;
type Func<P extends any[], R> = (...args: P) => R;
type AnyFunc = Func<any, any>;
export type ArgsType<F extends AnyFunc> = F extends Func<infer P, any> ? P : never;
export type OperationOptions = {
  variables?: Record<string, any>;
  operationName?: string;
};
export type OperationToGraphQL<V, T> = <Z extends V>(o: Z | V, options?: OperationOptions) => Promise<InputType<T, Z>>;
export type SubscriptionToGraphQL<V, T> = <Z extends V>(
  o: Z | V,
  options?: OperationOptions,
) => {
  ws: WebSocket;
  on: (fn: (args: InputType<T, Z>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z>; errors?:string[] }) => void) => void;
  open: () => void;
};
export type SelectionFunction<V> = <T>(t: T | V) => T;
export type fetchOptions = ArgsType<typeof fetch>;
type websocketOptions = typeof WebSocket extends new (
  ...args: infer R
) => WebSocket
  ? R
  : never;
export type chainOptions =
  | [fetchOptions[0], fetchOptions[1] & {websocket?: websocketOptions}]
  | [fetchOptions[0]];
export type FetchFunction = (
  query: string,
  variables?: Record<string, any>,
) => Promise<any>;
export type SubscriptionFunction = (query: string) => void;
type NotUndefined<T> = T extends undefined ? never : T;
export type ResolverType<F> = NotUndefined<F extends [infer ARGS, any] ? ARGS : undefined>;



export const ZeusSelect = <T>() => ((t: any) => t) as SelectionFunction<T>;

export const ScalarResolver = (scalar: string, value: any) => {
  switch (scalar) {
    case 'String':
      return  `${JSON.stringify(value)}`;
    case 'Int':
      return `${value}`;
    case 'Float':
      return `${value}`;
    case 'Boolean':
      return `${value}`;
    case 'ID':
      return `"${value}"`;
    case 'enum':
      return `${value}`;
    case 'scalar':
      return `${value}`;
    default:
      return false;
  }
};


export const TypesPropsResolver = ({
    value,
    type,
    name,
    key,
    blockArrays
}: {
    value: any;
    type: string;
    name: string;
    key?: string;
    blockArrays?: boolean;
}): string => {
    if (value === null) {
        return `null`;
    }
    let resolvedValue = AllTypesProps[type][name];
    if (key) {
        resolvedValue = resolvedValue[key];
    }
    if (!resolvedValue) {
        throw new Error(`Cannot resolve ${type} ${name}${key ? ` ${key}` : ''}`)
    }
    const typeResolved = resolvedValue.type;
    const isArray = resolvedValue.array;
    const isArrayRequired = resolvedValue.arrayRequired;
    if (typeof value === 'string' && value.startsWith(`ZEUS_VAR$`)) {
        const isRequired = resolvedValue.required ? '!' : '';
        let t = `${typeResolved}`;
        if (isArray) {
          if (isRequired) {
              t = `${t}!`;
          }
          t = `[${t}]`;
          if(isArrayRequired){
            t = `${t}!`;
          }
        }else{
          if (isRequired) {
                t = `${t}!`;
          }
        }
        return `\$${value.split(`ZEUS_VAR$`)[1]}__ZEUS_VAR__${t}`;
    }
    if (isArray && !blockArrays) {
        return `[${value
        .map((v: any) => TypesPropsResolver({ value: v, type, name, key, blockArrays: true }))
        .join(',')}]`;
    }
    const reslovedScalar = ScalarResolver(typeResolved, value);
    if (!reslovedScalar) {
        const resolvedType = AllTypesProps[typeResolved];
        if (typeof resolvedType === 'object') {
        const argsKeys = Object.keys(resolvedType);
        return `{${argsKeys
            .filter((ak) => value[ak] !== undefined)
            .map(
            (ak) => `${ak}:${TypesPropsResolver({ value: value[ak], type: typeResolved, name: ak })}`
            )}}`;
        }
        return ScalarResolver(AllTypesProps[typeResolved], value) as string;
    }
    return reslovedScalar;
};


const isArrayFunction = (
  parent: string[],
  a: any[]
) => {
  const [values, r] = a;
  const [mainKey, key, ...keys] = parent;
  const keyValues = Object.keys(values).filter((k) => typeof values[k] !== 'undefined');

  if (!keys.length) {
      return keyValues.length > 0
        ? `(${keyValues
            .map(
              (v) =>
                `${v}:${TypesPropsResolver({
                  value: values[v],
                  type: mainKey,
                  name: key,
                  key: v
                })}`
            )
            .join(',')})${r ? traverseToSeekArrays(parent, r) : ''}`
        : traverseToSeekArrays(parent, r);
    }

  const [typeResolverKey] = keys.splice(keys.length - 1, 1);
  let valueToResolve = ReturnTypes[mainKey][key];
  for (const k of keys) {
    valueToResolve = ReturnTypes[valueToResolve][k];
  }

  const argumentString =
    keyValues.length > 0
      ? `(${keyValues
          .map(
            (v) =>
              `${v}:${TypesPropsResolver({
                value: values[v],
                type: valueToResolve,
                name: typeResolverKey,
                key: v
              })}`
          )
          .join(',')})${r ? traverseToSeekArrays(parent, r) : ''}`
      : traverseToSeekArrays(parent, r);
  return argumentString;
};


const resolveKV = (k: string, v: boolean | string | { [x: string]: boolean | string }) =>
  typeof v === 'boolean' ? k : typeof v === 'object' ? `${k}{${objectToTree(v)}}` : `${k}${v}`;


const objectToTree = (o: { [x: string]: boolean | string }): string =>
  `{${Object.keys(o).map((k) => `${resolveKV(k, o[k])}`).join(' ')}}`;


const traverseToSeekArrays = (parent: string[], a?: any): string => {
  if (!a) return '';
  if (Object.keys(a).length === 0) {
    return '';
  }
  let b: Record<string, any> = {};
  if (Array.isArray(a)) {
    return isArrayFunction([...parent], a);
  } else {
    if (typeof a === 'object') {
      Object.keys(a)
        .filter((k) => typeof a[k] !== 'undefined')
        .forEach((k) => {
        if (k === '__alias') {
          Object.keys(a[k]).forEach((aliasKey) => {
            const aliasOperations = a[k][aliasKey];
            const aliasOperationName = Object.keys(aliasOperations)[0];
            const aliasOperation = aliasOperations[aliasOperationName];
            b[
              `${aliasOperationName}__alias__${aliasKey}: ${aliasOperationName}`
            ] = traverseToSeekArrays([...parent, aliasOperationName], aliasOperation);
          });
        } else {
          b[k] = traverseToSeekArrays([...parent, k], a[k]);
        }
      });
    } else {
      return '';
    }
  }
  return objectToTree(b);
};  


const buildQuery = (type: string, a?: Record<any, any>) => 
  traverseToSeekArrays([type], a);


const inspectVariables = (query: string) => {
  const regex = /\$\b\w*__ZEUS_VAR__\[?[^!^\]^\s^,^\)^\}]*[!]?[\]]?[!]?/g;
  let result;
  const AllVariables: string[] = [];
  while ((result = regex.exec(query))) {
    if (AllVariables.includes(result[0])) {
      continue;
    }
    AllVariables.push(result[0]);
  }
  if (!AllVariables.length) {
    return query;
  }
  let filteredQuery = query;
  AllVariables.forEach((variable) => {
    while (filteredQuery.includes(variable)) {
      filteredQuery = filteredQuery.replace(variable, variable.split('__ZEUS_VAR__')[0]);
    }
  });
  return `(${AllVariables.map((a) => a.split('__ZEUS_VAR__'))
    .map(([variableName, variableType]) => `${variableName}:${variableType}`)
    .join(', ')})${filteredQuery}`;
};


export const queryConstruct = (t: 'query' | 'mutation' | 'subscription', tName: string, operationName?: string) => (o: Record<any, any>) =>
  `${t.toLowerCase()}${operationName ? ' ' + operationName : ''}${inspectVariables(buildQuery(tName, o))}`;
  

const fullChainConstruct = (fn: FetchFunction) => (t: 'query' | 'mutation' | 'subscription', tName: string) => (
  o: Record<any, any>,
  options?: OperationOptions,
) => fn(queryConstruct(t, tName, options?.operationName)(o), options?.variables).then((r:any) => { 
  seekForAliases(r)
  return r
});

export const fullChainConstructor = <F extends FetchFunction, R extends keyof ValueTypes>(
  fn: F,
  operation: 'query' | 'mutation' | 'subscription',
  key: R,
) =>
  ((o, options) => fullChainConstruct(fn)(operation, key)(o as any, options)) as OperationToGraphQL<
    ValueTypes[R],
    GraphQLTypes[R]
  >;


const fullSubscriptionConstruct = (fn: SubscriptionFunction) => (
  t: 'query' | 'mutation' | 'subscription',
  tName: string,
) => (o: Record<any, any>, options?: OperationOptions) =>
  fn(queryConstruct(t, tName, options?.operationName)(o));

export const fullSubscriptionConstructor = <F extends SubscriptionFunction, R extends keyof ValueTypes>(
  fn: F,
  operation: 'query' | 'mutation' | 'subscription',
  key: R,
) =>
  ((o, options) => fullSubscriptionConstruct(fn)(operation, key)(o as any, options)) as SubscriptionToGraphQL<
    ValueTypes[R],
    GraphQLTypes[R]
  >;


const seekForAliases = (response: any) => {
  const traverseAlias = (value: any) => {
    if (Array.isArray(value)) {
      value.forEach(seekForAliases);
    } else {
      if (typeof value === 'object') {
        seekForAliases(value);
      }
    }
  };
  if (typeof response === 'object' && response) {
    const keys = Object.keys(response);
    if (keys.length < 1) {
      return;
    }
    keys.forEach((k) => {
      const value = response[k];
      if (k.indexOf('__alias__') !== -1) {
        const [operation, alias] = k.split('__alias__');
        response[alias] = {
          [operation]: value,
        };
        delete response[k];
      }
      traverseAlias(value);
    });
  }
};


export const $ = (t: TemplateStringsArray): any => `ZEUS_VAR$${t.join('')}`;


export const resolverFor = <
  X,
  T extends keyof ValueTypes,
  Z extends keyof ValueTypes[T],
>(
  type: T,
  field: Z,
  fn: (
    args: Required<ValueTypes[T]>[Z] extends [infer Input, any] ? Input : any,
    source: any,
  ) => Z extends keyof ModelTypes[T] ? ModelTypes[T][Z] | Promise<ModelTypes[T][Z]> | X : any,
) => fn as (args?: any,source?: any) => any;


const handleFetchResponse = (
  response: Parameters<Extract<Parameters<ReturnType<typeof fetch>['then']>[0], Function>>[0]
): Promise<GraphQLResponse> => {
  if (!response.ok) {
    return new Promise((_, reject) => {
      response.text().then(text => {
        try { reject(JSON.parse(text)); }
        catch (err) { reject(text); }
      }).catch(reject);
    });
  }
  return response.json();
};

export const apiFetch = (options: fetchOptions) => (query: string, variables: Record<string, any> = {}) => {
    let fetchFunction = fetch;
    let queryString = query;
    let fetchOptions = options[1] || {};
    if (fetchOptions.method && fetchOptions.method === 'GET') {
      queryString = encodeURIComponent(query);
      return fetchFunction(`${options[0]}?query=${queryString}`, fetchOptions)
        .then(handleFetchResponse)
        .then((response: GraphQLResponse) => {
          if (response.errors) {
            throw new GraphQLError(response);
          }
          return response.data;
        });
    }
    return fetchFunction(`${options[0]}`, {
      body: JSON.stringify({ query: queryString, variables }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      ...fetchOptions
    })
      .then(handleFetchResponse)
      .then((response: GraphQLResponse) => {
        if (response.errors) {
          throw new GraphQLError(response);
        }
        return response.data;
      });
  };
  

export const apiSubscription = (options: chainOptions) => (
    query: string,
  ) => {
    try {
      const queryString = options[0] + '?query=' + encodeURIComponent(query);
      const wsString = queryString.replace('http', 'ws');
      const host = (options.length > 1 && options[1]?.websocket?.[0]) || wsString;
      const webSocketOptions = options[1]?.websocket || [host];
      const ws = new WebSocket(...webSocketOptions);
      return {
        ws,
        on: (e: (args: any) => void) => {
          ws.onmessage = (event:any) => {
            if(event.data){
              const parsed = JSON.parse(event.data)
              const data = parsed.data
              if (data) {
                seekForAliases(data);
              }
              return e(data);
            }
          };
        },
        off: (e: (args: any) => void) => {
          ws.onclose = e;
        },
        error: (e: (args: any) => void) => {
          ws.onerror = e;
        },
        open: (e: () => void) => {
          ws.onopen = e;
        },
      };
    } catch {
      throw new Error('No websockets implemented');
    }
  };


export const Thunder = (fn: FetchFunction, subscriptionFn: SubscriptionFunction) => ({
  query: fullChainConstructor(fn,'query', 'Query'),
mutation: fullChainConstructor(fn,'mutation', 'Mutation')
});

export const Chain = (...options: chainOptions) => ({
  query: fullChainConstructor(apiFetch(options),'query', 'Query'),
mutation: fullChainConstructor(apiFetch(options),'mutation', 'Mutation')
});
export const Zeus = {
  query: (o:ValueTypes["Query"], operationName?: string) => queryConstruct('query', 'Query', operationName)(o),
mutation: (o:ValueTypes["Mutation"], operationName?: string) => queryConstruct('mutation', 'Mutation', operationName)(o)
};
export const Selectors = {
  query: ZeusSelect<ValueTypes["Query"]>(),
mutation: ZeusSelect<ValueTypes["Mutation"]>()
};
  
export type FragmentResult<K extends keyof ModelTypes, Q extends (...args: any) => any> = MapType<
	ModelTypes[K],
	ReturnType<Q>
>